import feSdk__default, { methods, ApiError } from '@streamlabs-core/sl-one-fe-sdk';
import { n, _ as __awaiter, a as __decorate, C as Component, P as Prop, b as normalizeComponent, E as Emit, c as createInjector, d as createDecorator, m as mixins, W as Watch, M as ModelSync, V as VModel, e as copyToClipboard, f as Model, R as Ref, g as __vue_component__$1f, h as ClickOutside, i as encode, j as __rest } from './vendor.es.js';
import i18next from 'i18next';
import Vue from 'vue';
import { e as enUS } from './i18n/en-US.es.js';
import { c as csCZ } from './i18n/cs-CZ.es.js';
import { d as daDK } from './i18n/da-DK.es.js';
import { d as deDE } from './i18n/de-DE.es.js';
import { e as esES } from './i18n/es-ES.es.js';
import { f as frFR } from './i18n/fr-FR.es.js';
import { i as idID } from './i18n/id-ID.es.js';
import { i as itIT } from './i18n/it-IT.es.js';
import { j as jaJP } from './i18n/ja-JP.es.js';
import { k as koKR } from './i18n/ko-KR.es.js';
import { n as nlNL } from './i18n/nl-NL.es.js';
import { p as plPL } from './i18n/pl-PL.es.js';
import { p as ptBR } from './i18n/pt-BR.es.js';
import { p as ptPT } from './i18n/pt-PT.es.js';
import { r as ruRU } from './i18n/ru-RU.es.js';
import { t as trTR } from './i18n/tr-TR.es.js';
import { z as zhCN } from './i18n/zh-CN.es.js';
import { z as zhTW } from './i18n/zh-TW.es.js';
import { camelCase, debounce } from 'lodash-es';
import QRCode from 'qrcode';

var css = "@import url(\"https://fonts.googleapis.com/css?family=Roboto:300,400,500,700.css\");@import url(\"https://fonts.googleapis.com/css2?family=Caveat:wght@400;500&display=swap\");.sl-one-component *,.sl-one-component :after,.sl-one-component :before{border:0 solid #e5e7eb;box-sizing:border-box}\n/*! tailwindcss v3.1.8 | MIT License | https://tailwindcss.com*/.sl-one-component :after,.sl-one-component :before{--tw-content:\"\"}.sl-one-component html{-webkit-text-size-adjust:100%;font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;line-height:1.5;-moz-tab-size:4;-o-tab-size:4;tab-size:4}.sl-one-component body{line-height:inherit;margin:0}.sl-one-component hr{border-top-width:1px;color:inherit;height:0}.sl-one-component abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}.sl-one-component h1,.sl-one-component h2,.sl-one-component h3,.sl-one-component h4,.sl-one-component h5,.sl-one-component h6{font-size:inherit;font-weight:inherit}.sl-one-component a{color:inherit;text-decoration:inherit}.sl-one-component b,.sl-one-component strong{font-weight:bolder}.sl-one-component code,.sl-one-component kbd,.sl-one-component pre,.sl-one-component samp{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}.sl-one-component small{font-size:80%}.sl-one-component sub,.sl-one-component sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}.sl-one-component sub{bottom:-.25em}.sl-one-component sup{top:-.5em}.sl-one-component table{border-collapse:collapse;border-color:inherit;text-indent:0}.sl-one-component button,.sl-one-component input,.sl-one-component optgroup,.sl-one-component select,.sl-one-component textarea{color:inherit;font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;margin:0;padding:0}.sl-one-component button,.sl-one-component select{text-transform:none}.sl-one-component [type=button],.sl-one-component [type=reset],.sl-one-component [type=submit],.sl-one-component button{-webkit-appearance:button;background-color:transparent;background-image:none}.sl-one-component :-moz-focusring{outline:auto}.sl-one-component :-moz-ui-invalid{box-shadow:none}.sl-one-component progress{vertical-align:baseline}.sl-one-component ::-webkit-inner-spin-button,.sl-one-component ::-webkit-outer-spin-button{height:auto}.sl-one-component [type=search]{-webkit-appearance:textfield;outline-offset:-2px}.sl-one-component ::-webkit-search-decoration{-webkit-appearance:none}.sl-one-component ::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}.sl-one-component summary{display:list-item}.sl-one-component blockquote,.sl-one-component dd,.sl-one-component dl,.sl-one-component figure,.sl-one-component h1,.sl-one-component h2,.sl-one-component h3,.sl-one-component h4,.sl-one-component h5,.sl-one-component h6,.sl-one-component hr,.sl-one-component p,.sl-one-component pre{margin:0}.sl-one-component fieldset{margin:0;padding:0}.sl-one-component legend{padding:0}.sl-one-component menu,.sl-one-component ol,.sl-one-component ul{list-style:none;margin:0;padding:0}.sl-one-component textarea{resize:vertical}.sl-one-component input::-moz-placeholder,.sl-one-component textarea::-moz-placeholder{color:#9ca3af;opacity:1}.sl-one-component input::placeholder,.sl-one-component textarea::placeholder{color:#9ca3af;opacity:1}.sl-one-component [role=button],.sl-one-component button{cursor:pointer}.sl-one-component :disabled{cursor:default}.sl-one-component audio,.sl-one-component canvas,.sl-one-component embed,.sl-one-component iframe,.sl-one-component img,.sl-one-component object,.sl-one-component svg,.sl-one-component video{display:block;vertical-align:middle}.sl-one-component img,.sl-one-component video{height:auto;max-width:100%}.sl-one-component [multiple],.sl-one-component [type=date],.sl-one-component [type=datetime-local],.sl-one-component [type=email],.sl-one-component [type=month],.sl-one-component [type=number],.sl-one-component [type=password],.sl-one-component [type=search],.sl-one-component [type=tel],.sl-one-component [type=text],.sl-one-component [type=time],.sl-one-component [type=url],.sl-one-component [type=week],.sl-one-component select,.sl-one-component textarea{--tw-shadow:0 0 #0000;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff;border-color:#6b7280;border-radius:0;border-width:1px;font-size:1rem;line-height:1.5rem;padding:.5rem .75rem}.sl-one-component [multiple]:focus,.sl-one-component [type=date]:focus,.sl-one-component [type=datetime-local]:focus,.sl-one-component [type=email]:focus,.sl-one-component [type=month]:focus,.sl-one-component [type=number]:focus,.sl-one-component [type=password]:focus,.sl-one-component [type=search]:focus,.sl-one-component [type=tel]:focus,.sl-one-component [type=text]:focus,.sl-one-component [type=time]:focus,.sl-one-component [type=url]:focus,.sl-one-component [type=week]:focus,.sl-one-component select:focus,.sl-one-component textarea:focus{--tw-ring-inset:var(--tw-empty,/*!*/ /*!*/);--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:#2563eb;--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);border-color:#2563eb;box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow);outline:2px solid transparent;outline-offset:2px}.sl-one-component input::-moz-placeholder,.sl-one-component textarea::-moz-placeholder{color:#6b7280;opacity:1}.sl-one-component input::placeholder,.sl-one-component textarea::placeholder{color:#6b7280;opacity:1}.sl-one-component ::-webkit-datetime-edit-fields-wrapper{padding:0}.sl-one-component ::-webkit-date-and-time-value{min-height:1.5em}.sl-one-component ::-webkit-datetime-edit,.sl-one-component ::-webkit-datetime-edit-day-field,.sl-one-component ::-webkit-datetime-edit-hour-field,.sl-one-component ::-webkit-datetime-edit-meridiem-field,.sl-one-component ::-webkit-datetime-edit-millisecond-field,.sl-one-component ::-webkit-datetime-edit-minute-field,.sl-one-component ::-webkit-datetime-edit-month-field,.sl-one-component ::-webkit-datetime-edit-second-field,.sl-one-component ::-webkit-datetime-edit-year-field{padding-bottom:0;padding-top:0}.sl-one-component select{color-adjust:exact;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3E%3C/svg%3E\");background-position:right .5rem center;background-repeat:no-repeat;background-size:1.5em 1.5em;padding-right:2.5rem;-webkit-print-color-adjust:exact;print-color-adjust:exact}.sl-one-component [multiple]{color-adjust:unset;background-image:none;background-position:0 0;background-repeat:unset;background-size:initial;padding-right:.75rem;-webkit-print-color-adjust:unset;print-color-adjust:unset}.sl-one-component [type=checkbox],.sl-one-component [type=radio]{color-adjust:exact;--tw-shadow:0 0 #0000;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff;background-origin:border-box;border-color:#6b7280;border-width:1px;color:#2563eb;display:inline-block;flex-shrink:0;height:1rem;padding:0;-webkit-print-color-adjust:exact;print-color-adjust:exact;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle;width:1rem}.sl-one-component [type=checkbox]{border-radius:0}.sl-one-component [type=radio]{border-radius:100%}.sl-one-component [type=checkbox]:focus,.sl-one-component [type=radio]:focus{--tw-ring-inset:var(--tw-empty,/*!*/ /*!*/);--tw-ring-offset-width:2px;--tw-ring-offset-color:#fff;--tw-ring-color:#2563eb;--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow);outline:2px solid transparent;outline-offset:2px}.sl-one-component [type=checkbox]:checked,.sl-one-component [type=radio]:checked{background-color:currentColor;background-position:50%;background-repeat:no-repeat;background-size:100% 100%;border-color:transparent}.sl-one-component [type=checkbox]:checked{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 16 16' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.207 4.793a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L6.5 9.086l4.293-4.293a1 1 0 0 1 1.414 0z'/%3E%3C/svg%3E\")}.sl-one-component [type=radio]:checked{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 16 16' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='8' cy='8' r='3'/%3E%3C/svg%3E\")}.sl-one-component [type=checkbox]:checked:focus,.sl-one-component [type=checkbox]:checked:hover,.sl-one-component [type=radio]:checked:focus,.sl-one-component [type=radio]:checked:hover{background-color:currentColor;border-color:transparent}.sl-one-component [type=checkbox]:indeterminate{background-color:currentColor;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16'%3E%3Cpath stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M4 8h8'/%3E%3C/svg%3E\");background-position:50%;background-repeat:no-repeat;background-size:100% 100%;border-color:transparent}.sl-one-component [type=checkbox]:indeterminate:focus,.sl-one-component [type=checkbox]:indeterminate:hover{background-color:currentColor;border-color:transparent}.sl-one-component [type=file]{background:unset;border-color:inherit;border-radius:0;border-width:0;font-size:unset;line-height:inherit;padding:0}.sl-one-component [type=file]:focus{outline:1px solid ButtonText;outline:1px auto -webkit-focus-ring-color}.sl-one-component *,.sl-one-component :after,.sl-one-component :before{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgba(59,130,246,.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.sl-one-component ::-webkit-backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgba(59,130,246,.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.sl-one-component ::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgba(59,130,246,.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.sl-one-component{font-family:Roboto,-apple-system,BlinkMacSystemFont,Segoe UI,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif}.sl-one-component .sl-btn-active:active{box-shadow:inset 0 0 25px 50px rgba(0,0,0,.2)}.sl-one-component .sl-center-y{top:50%;transform:translateY(-50)}.sl-one-component .sl-center-x{left:50%;transform:translateX(-50%)}.sl-one-component .sl-center-x.sl-center-y{transform:translate(-50%,-50%)}.sl-one-component .container{width:100%}@media (min-width:600px){.sl-one-component .container{max-width:600px}}@media (min-width:640px){.sl-one-component .container{max-width:640px}}@media (min-width:768px){.sl-one-component .container{max-width:768px}}@media (min-width:1024px){.sl-one-component .container{max-width:1024px}}@media (min-width:1280px){.sl-one-component .container{max-width:1280px}}@media (min-width:1536px){.sl-one-component .container{max-width:1536px}}.sl-one-component .font-caveat{font-family:Caveat,cursive}.sl-one-component .sl-icon{display:inline-block}.sl-one-component .sl-icon svg{fill:currentColor;display:block}.sl-one-component .sl-btn{border-radius:.5rem;cursor:pointer;padding-bottom:.75rem;padding-left:1.25rem;padding-right:1.25rem;padding-top:.75rem;text-align:center}.sl-one-component .sl-btn:disabled{cursor:not-allowed}.sl-one-component .sl-btn.\\!loading,.sl-one-component .sl-btn.loading{cursor:progress}.sl-one-component .sl-btn-dark{--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(31 41 55/var(--tw-bg-opacity));color:rgb(255 255 255/var(--tw-text-opacity))}.sl-one-component .sl-btn-dark:hover{--tw-bg-opacity:1;background-color:rgb(17 24 39/var(--tw-bg-opacity))}.sl-one-component .sl-btn-dark:disabled{--tw-bg-opacity:1;background-color:rgb(75 85 99/var(--tw-bg-opacity))}.sl-one-component .dark .sl-btn-dark{--tw-border-opacity:1;--tw-bg-opacity:1;background-color:rgb(31 41 55/var(--tw-bg-opacity));border-color:rgb(55 65 81/var(--tw-border-opacity))}.sl-one-component .dark .sl-btn-dark:hover{--tw-bg-opacity:1;background-color:rgb(55 65 81/var(--tw-bg-opacity))}.sl-one-component .dark .sl-btn-dark:disabled{--tw-bg-opacity:1;background-color:rgb(75 85 99/var(--tw-bg-opacity))}.sl-one-component .sl-btn-one-dark{--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(14 16 17/var(--tw-bg-opacity));color:rgb(255 255 255/var(--tw-text-opacity))}.sl-one-component .sl-btn-one-dark:hover{--tw-bg-opacity:1;background-color:rgb(0 0 0/var(--tw-bg-opacity))}.sl-one-component .sl-btn-one-dark:disabled{--tw-bg-opacity:1;background-color:rgb(159 159 160/var(--tw-bg-opacity))}.sl-one-component .dark .sl-btn-one-dark{--tw-bg-opacity:1;background-color:rgb(0 0 0/var(--tw-bg-opacity))}.sl-one-component .dark .sl-btn-one-dark:hover{--tw-bg-opacity:1;background-color:rgb(14 16 17/var(--tw-bg-opacity))}.sl-one-component .dark .sl-btn-one-dark:disabled{--tw-bg-opacity:1;background-color:rgb(97 97 105/var(--tw-bg-opacity))}.sl-one-component .sl-btn-link{background-image:none;border-style:none;display:inline-block;padding-left:.5rem;padding-right:.5rem}.sl-one-component .sl-btn-link:hover{-webkit-text-decoration-line:underline;text-decoration-line:underline}.sl-one-component .sl-btn-outline{--tw-border-opacity:1;--tw-text-opacity:1;border-color:rgb(189 194 196/var(--tw-border-opacity));border-style:solid;border-width:1px;color:rgb(79 94 101/var(--tw-text-opacity))}.sl-one-component .sl-btn-outline:hover{--tw-border-opacity:1;--tw-text-opacity:1;border-color:rgb(145 151 154/var(--tw-border-opacity));color:rgb(43 56 63/var(--tw-text-opacity))}.sl-one-component .sl-btn-outline:active{--tw-border-opacity:1;--tw-text-opacity:1;border-color:rgb(145 151 154/var(--tw-border-opacity));color:rgb(43 56 63/var(--tw-text-opacity))}.sl-one-component .dark .sl-btn-outline{--tw-border-opacity:1;--tw-text-opacity:1;border-color:rgb(79 94 101/var(--tw-border-opacity));color:rgb(227 232 235/var(--tw-text-opacity))}.sl-one-component .dark .sl-btn-outline:hover{--tw-border-opacity:1;--tw-text-opacity:1;border-color:rgb(145 151 154/var(--tw-border-opacity));color:rgb(255 255 255/var(--tw-text-opacity))}.sl-one-component .dark .sl-btn-outline:active{--tw-border-opacity:1;--tw-text-opacity:1;border-color:rgb(145 151 154/var(--tw-border-opacity));color:rgb(255 255 255/var(--tw-text-opacity))}.sl-one-component .sl-btn-solid{--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(227 232 235/var(--tw-bg-opacity));color:rgb(79 94 101/var(--tw-text-opacity));font-weight:600}.sl-one-component .sl-btn-solid:hover{--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(189 194 196/var(--tw-bg-opacity));color:rgb(23 36 45/var(--tw-text-opacity))}.sl-one-component .dark .sl-btn-solid{--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(79 94 101/var(--tw-bg-opacity));color:rgb(227 232 235/var(--tw-text-opacity))}.sl-one-component .dark .sl-btn-solid:hover{--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(145 151 154/var(--tw-bg-opacity));color:rgb(255 255 255/var(--tw-text-opacity))}.sl-one-component .sl-btn-link-dark-5{--tw-text-opacity:1;color:rgb(79 94 101/var(--tw-text-opacity))}.sl-one-component .sl-btn-link-dark-5:hover{--tw-text-opacity:1;color:rgb(23 36 45/var(--tw-text-opacity))}.sl-one-component .dark .sl-btn-link-dark-5{--tw-text-opacity:1;color:rgb(227 232 235/var(--tw-text-opacity))}.sl-one-component .dark .sl-btn-link-dark-5:hover{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.sl-one-component .sl-form-control,.sl-one-component .sl-form-input,.sl-one-component .sl-form-select{--tw-border-opacity:1;border-color:rgb(189 194 196/var(--tw-border-opacity));border-radius:.25rem;border-width:1px;line-height:1}.sl-one-component .sl-form-control::-moz-placeholder,.sl-one-component .sl-form-input::-moz-placeholder,.sl-one-component .sl-form-select::-moz-placeholder{--tw-text-opacity:1;color:rgb(145 151 154/var(--tw-text-opacity))}.sl-one-component .sl-form-control::placeholder,.sl-one-component .sl-form-input::placeholder,.sl-one-component .sl-form-select::placeholder{--tw-text-opacity:1;color:rgb(145 151 154/var(--tw-text-opacity))}.sl-one-component .sl-form-control:focus,.sl-one-component .sl-form-control:hover,.sl-one-component .sl-form-input:focus,.sl-one-component .sl-form-input:hover,.sl-one-component .sl-form-select:focus,.sl-one-component .sl-form-select:hover{--tw-border-opacity:1;border-color:rgb(23 36 45/var(--tw-border-opacity))}.sl-one-component .sl-form-control:focus,.sl-one-component .sl-form-control:hover,.sl-one-component .sl-form-input:focus,.sl-one-component .sl-form-input:hover,.sl-one-component .sl-form-select:focus,.sl-one-component .sl-form-select:hover{box-shadow:0 0 2px border-dark-3}.sl-one-component .sl-form-control[disabled],.sl-one-component .sl-form-input[disabled],.sl-one-component .sl-form-select[disabled]{--tw-bg-opacity:1;background-color:rgb(227 232 235/var(--tw-bg-opacity));cursor:not-allowed}.sl-one-component .sl-form-control[disabled]:hover,.sl-one-component .sl-form-input[disabled]:hover,.sl-one-component .sl-form-select[disabled]:hover{--tw-border-opacity:1;border-color:rgb(189 194 196/var(--tw-border-opacity))}.sl-one-component .sl-form-control,.sl-one-component .sl-form-select{padding:14px 12px}.sl-one-component .dark .sl-form-control.theme-dark,.sl-one-component .dark .sl-form-input.theme-dark,.sl-one-component .dark .sl-form-select.theme-dark{--tw-text-opacity:1;background:transparent;border-color:#4f5e65;color:rgb(145 151 154/var(--tw-text-opacity));color-scheme:dark}.sl-one-component .dark .sl-form-control.theme-dark:focus,.sl-one-component .dark .sl-form-control.theme-dark:hover,.sl-one-component .dark .sl-form-input.theme-dark:focus,.sl-one-component .dark .sl-form-input.theme-dark:hover,.sl-one-component .dark .sl-form-select.theme-dark:focus,.sl-one-component .dark .sl-form-select.theme-dark:hover{--tw-text-opacity:1;box-shadow:0 0 2px #80f5d2;color:rgb(255 255 255/var(--tw-text-opacity));outline:0}.sl-one-component .dark .sl-form-control.theme-dark[disabled],.sl-one-component .dark .sl-form-input.theme-dark[disabled],.sl-one-component .dark .sl-form-select.theme-dark[disabled]{--tw-border-opacity:1;--tw-bg-opacity:1;background-color:rgb(23 36 45/var(--tw-bg-opacity));border-color:rgb(43 56 63/var(--tw-border-opacity));cursor:not-allowed}.sl-one-component .dark .sl-form-control.theme-dark[disabled]:hover,.sl-one-component .dark .sl-form-input.theme-dark[disabled]:hover,.sl-one-component .dark .sl-form-select.theme-dark[disabled]:hover{--tw-border-opacity:1;border-color:rgb(43 56 63/var(--tw-border-opacity))}.sl-one-component .sl-checkbox{--tw-text-opacity:1;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:4px;color:rgb(5 13 18/var(--tw-text-opacity))}.sl-one-component .sl-checkbox:focus{background-color:#e0edff;border-color:#333;box-shadow:0 0 3px 1px rgba(0,0,0,.5);outline:0}.sl-one-component .sl-checkbox:checked~span{--tw-text-opacity:1;color:rgb(5 13 18/var(--tw-text-opacity))}.sl-one-component .ultra-card{background:linear-gradient(123.53deg,#2de8b0 25.56%,#cbe953 60.27%,#ffab48 79.52%,#ff5151 96.69%);border-radius:16px;padding:1px}.sl-one-component .ultra-card:before{background:linear-gradient(123.53deg,rgba(45,232,176,.5) 25.56%,rgba(203,233,83,.5) 60.27%,rgba(255,171,72,.5) 79.52%,rgba(255,81,81,.5) 96.69%);border-radius:inherit;bottom:-2px;content:\"\";left:-2px;opacity:.65;position:absolute;right:-2px;top:-2px;z-index:-1}.sl-one-component .ultra-card__inner{background:#fff;border-radius:15px}.sl-one-component .ultra-card__inner-bg{background:linear-gradient(123.53deg,rgba(45,232,176,.15) 25.56%,rgba(203,233,83,.1) 60.27%,rgba(255,171,72,.05) 79.52%,rgba(255,81,81,0) 96.69%);border-radius:15px}.sl-one-component .ultra-card__icon{--tw-text-opacity:1;background:linear-gradient(123.53deg,#2de8b0 25.56%,#cbe953 60.27%,#ffab48 79.52%,#ff5151 96.69%);border-radius:16px;color:rgb(9 22 29/var(--tw-text-opacity));padding:1px;width:62px}.sl-one-component .ultra-card__icon-content{--tw-bg-opacity:1;align-items:center;background-color:rgb(255 255 255/var(--tw-bg-opacity));border-radius:15px;display:flex;height:60px;justify-content:center;width:60px}.sl-one-component .ultra-card__title-inner,.sl-one-component .ultra-card__title-inner span{font-size:1.25rem;font-weight:400;line-height:1.75rem}.sl-one-component .ultra-card__description{--tw-text-opacity:1;color:rgb(43 56 63/var(--tw-text-opacity));font-size:1rem;line-height:1.5rem;text-align:left}.sl-one-component .ultra-card__price{align-items:center;-moz-column-gap:.75rem;column-gap:.75rem;display:flex}.sl-one-component .ultra-card__price .price__current{--tw-text-opacity:1;color:rgb(9 22 29/var(--tw-text-opacity));font-size:1.25rem;line-height:1.75rem}.sl-one-component .ultra-card__price .price__old{--tw-text-opacity:1;color:rgb(9 22 29/var(--tw-text-opacity));font-family:Caveat,cursive;font-size:1.125rem;line-height:1.75rem;padding-top:.25rem;white-space:nowrap}.ultra-card__price .price__old{font-family:Caveat,cursive}.sl-one-component .ultra-card__price .price__old{opacity:.56}.sl-one-component .ultra-card__badge{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity));border:.5px solid;border-radius:9999px;padding-left:.5rem;padding-right:.5rem;white-space:nowrap}.sl-one-component .ultra-card__badge,.sl-one-component .ultra-card__badge span{font-family:Caveat,cursive;font-size:1.125rem;line-height:1.75rem}.ultra-card__badge,.ultra-card__badge span{font-family:Caveat,cursive}.sl-one-component .ultra-card__badge,.sl-one-component .ultra-card__badge span{color:var(--badge-color)}.sl-one-component .ultra-card__badge b{font-weight:700}.sl-one-component .ultra-card__buy-btn{--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(0 0 0/var(--tw-bg-opacity));border-radius:.5rem;color:rgb(255 255 255/var(--tw-text-opacity));cursor:pointer;font-size:1rem;font-weight:500;line-height:1.5rem;padding-bottom:.75rem;padding-left:1rem;padding-right:1rem;padding-top:.75rem;position:relative;text-align:center;white-space:nowrap}.sl-one-component .ultra-card__buy-btn:disabled{--tw-bg-opacity:1;background-color:rgb(79 94 101/var(--tw-bg-opacity))}.sl-one-component .ultra-card__buy-btn .loading{left:50%;position:absolute;top:50%;transform:translate(-50%,-45%);visibility:hidden}.sl-one-component .ultra-card__buy-btn .\\!loading{left:50%!important;position:absolute!important;top:50%!important;transform:translate(-50%,-45%)!important;visibility:hidden!important}.sl-one-component .ultra-card__buy-btn--loading .loading{visibility:visible}.sl-one-component .ultra-card__buy-btn--loading .\\!loading{visibility:visible!important}.sl-one-component .ultra-card__buy-btn--loading .text{visibility:hidden}.sl-one-component .ultra-card__included-link{--tw-text-opacity:1;align-items:center;color:rgb(9 22 29/var(--tw-text-opacity));-moz-column-gap:.5rem;column-gap:.5rem;cursor:pointer;display:flex;font-weight:500}.sl-one-component .ultra-card__included-link:hover{-webkit-text-decoration-line:underline;text-decoration-line:underline}.sl-one-component .dark .ultra-card__icon-content,.sl-one-component .dark .ultra-card__inner{--tw-bg-opacity:1;background-color:rgb(0 0 0/var(--tw-bg-opacity))}.sl-one-component .dark .ultra-card__icon-content,.sl-one-component .dark .ultra-card__title-inner,.sl-one-component .dark .ultra-card__title-inner span{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.sl-one-component .dark .ultra-card__badge{--tw-bg-opacity:1;background-color:rgb(0 0 0/var(--tw-bg-opacity))}.sl-one-component .dark .ultra-card__price .price__current,.sl-one-component .dark .ultra-card__price .price__old{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.sl-one-component .dark .ultra-card__description,.sl-one-component .dark .ultra-card__description span{--tw-text-opacity:1;color:rgb(189 194 196/var(--tw-text-opacity))}.sl-one-component .dark .ultra-card__included-link{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.sl-one-component .dark .ultra-card__buy-btn{--tw-bg-opacity:1;--tw-text-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity));color:rgb(9 22 29/var(--tw-text-opacity))}.sl-one-component .dark .ultra-card__buy-btn:disabled{--tw-bg-opacity:1;background-color:rgb(145 151 154/var(--tw-bg-opacity))}.sl-one-component .max-w-card,.sl-one-component.max-w-card{max-width:90vw;max-width:calc(100vw - 20px)}.sl-one-component .visible{visibility:visible}.sl-one-component .invisible{visibility:hidden}.sl-one-component .fixed{position:fixed}.sl-one-component .absolute{position:absolute}.sl-one-component .relative{position:relative}.sl-one-component .top-0{top:0}.sl-one-component .left-0{left:0}.sl-one-component .m-10{margin:2.5rem}.sl-one-component .mx-auto{margin-left:auto;margin-right:auto}.sl-one-component .my-6{margin-bottom:1.5rem;margin-top:1.5rem}.sl-one-component .-mx-6{margin-left:-1.5rem;margin-right:-1.5rem}.sl-one-component .mx-3{margin-left:.75rem;margin-right:.75rem}.sl-one-component .-mx-4{margin-left:-1rem;margin-right:-1rem}.sl-one-component .mx-6{margin-left:1.5rem;margin-right:1.5rem}.sl-one-component .my-10{margin-bottom:2.5rem;margin-top:2.5rem}.sl-one-component .mx-4{margin-left:1rem;margin-right:1rem}.sl-one-component .mt-2{margin-top:.5rem}.sl-one-component .ml-3{margin-left:.75rem}.sl-one-component .mr-3{margin-right:.75rem}.sl-one-component .mr-2{margin-right:.5rem}.sl-one-component .mb-4{margin-bottom:1rem}.sl-one-component .ml-auto{margin-left:auto}.sl-one-component .mt-auto{margin-top:auto}.sl-one-component .mr-\\[-100px\\]{margin-right:-100px}.sl-one-component .mb-8{margin-bottom:2rem}.sl-one-component .mb-1{margin-bottom:.25rem}.sl-one-component .mb-6{margin-bottom:1.5rem}.sl-one-component .mb-5{margin-bottom:1.25rem}.sl-one-component .mt-4{margin-top:1rem}.sl-one-component .mb-7{margin-bottom:1.75rem}.sl-one-component .mb-2{margin-bottom:.5rem}.sl-one-component .mt-1{margin-top:.25rem}.sl-one-component .-mt-2{margin-top:-.5rem}.sl-one-component .-mb-4{margin-bottom:-1rem}.sl-one-component .mb-3{margin-bottom:.75rem}.sl-one-component .mb-10{margin-bottom:2.5rem}.sl-one-component .ml-4{margin-left:1rem}.sl-one-component .mt-20{margin-top:5rem}.sl-one-component .mt-6{margin-top:1.5rem}.sl-one-component .mt-10{margin-top:2.5rem}.sl-one-component .block{display:block}.sl-one-component .inline-block{display:inline-block}.sl-one-component .flex{display:flex}.sl-one-component .table{display:table}.sl-one-component .grid{display:grid}.sl-one-component .hidden{display:none}.sl-one-component .aspect-square{aspect-ratio:1/1}.sl-one-component .h-full{height:100%}.sl-one-component .h-0{height:0}.sl-one-component .h-10{height:2.5rem}.sl-one-component .h-32{height:8rem}.sl-one-component .h-8{height:2rem}.sl-one-component .h-5{height:1.25rem}.sl-one-component .max-h-\\[60px\\]{max-height:60px}.sl-one-component .min-h-\\[256px\\]{min-height:256px}.sl-one-component .min-h-\\[500px\\]{min-height:500px}.sl-one-component .min-h-\\[50px\\]{min-height:50px}.sl-one-component .w-full{width:100%}.sl-one-component .w-\\[300px\\]{width:300px}.sl-one-component .w-\\[600px\\]{width:600px}.sl-one-component .w-10{width:2.5rem}.sl-one-component .w-\\[375px\\]{width:375px}.sl-one-component .w-8{width:2rem}.sl-one-component .w-\\[495px\\]{width:495px}.sl-one-component .w-\\[240px\\]{width:240px}.sl-one-component .w-12{width:3rem}.sl-one-component .w-1\\/2{width:50%}.sl-one-component .w-3\\/5{width:60%}.sl-one-component .w-3\\/4{width:75%}.sl-one-component .w-32{width:8rem}.sl-one-component .w-\\[400px\\]{width:400px}.sl-one-component .min-w-\\[300px\\]{min-width:300px}.sl-one-component .min-w-\\[500px\\]{min-width:500px}.sl-one-component .max-w-full{max-width:100%}.sl-one-component .max-w-\\[400px\\]{max-width:400px}.sl-one-component .max-w-\\[288px\\]{max-width:288px}.sl-one-component .max-w-\\[350px\\]{max-width:350px}.sl-one-component .max-w-\\[600px\\]{max-width:600px}.sl-one-component .max-w-\\[250px\\]{max-width:250px}.sl-one-component .shrink{flex-shrink:1}.sl-one-component .grow{flex-grow:1}.sl-one-component .table-auto{table-layout:auto}.sl-one-component .transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@-webkit-keyframes spin{to{transform:rotate(1turn)}}@keyframes spin{to{transform:rotate(1turn)}}.sl-one-component .animate-spin{-webkit-animation:spin 1s linear infinite;animation:spin 1s linear infinite}.sl-one-component .cursor-pointer{cursor:pointer}.sl-one-component .select-none{-webkit-user-select:none;-moz-user-select:none;user-select:none}.sl-one-component .resize{resize:both}.sl-one-component .list-disc{list-style-type:disc}.sl-one-component .list-decimal{list-style-type:decimal}.sl-one-component .grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.sl-one-component .grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.sl-one-component .flex-col{flex-direction:column}.sl-one-component .flex-wrap{flex-wrap:wrap}.sl-one-component .items-start{align-items:flex-start}.sl-one-component .items-center{align-items:center}.sl-one-component .items-stretch{align-items:stretch}.sl-one-component .justify-end{justify-content:flex-end}.sl-one-component .justify-center{justify-content:center}.sl-one-component .justify-between{justify-content:space-between}.sl-one-component .gap-2{gap:.5rem}.sl-one-component .gap-4{gap:1rem}.sl-one-component .gap-x-3{-moz-column-gap:.75rem;column-gap:.75rem}.sl-one-component .gap-x-4{-moz-column-gap:1rem;column-gap:1rem}.sl-one-component .gap-x-2{-moz-column-gap:.5rem;column-gap:.5rem}.sl-one-component .gap-y-4{row-gap:1rem}.sl-one-component .gap-x-8{-moz-column-gap:2rem;column-gap:2rem}.sl-one-component .gap-y-2{row-gap:.5rem}.sl-one-component .space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(.5rem*(1 - var(--tw-space-x-reverse)));margin-right:calc(.5rem*var(--tw-space-x-reverse))}.sl-one-component .divide-y>:not([hidden])~:not([hidden]){--tw-divide-y-reverse:0;border-bottom-width:calc(1px*var(--tw-divide-y-reverse));border-top-width:calc(1px*(1 - var(--tw-divide-y-reverse)))}.sl-one-component .divide-light-4>:not([hidden])~:not([hidden]){--tw-divide-opacity:1;border-color:rgb(189 194 196/var(--tw-divide-opacity))}.sl-one-component .overflow-hidden{overflow:hidden}.sl-one-component .text-ellipsis{text-overflow:ellipsis}.sl-one-component .whitespace-nowrap{white-space:nowrap}.sl-one-component .rounded{border-radius:.25rem}.sl-one-component .rounded-2xl{border-radius:1rem}.sl-one-component .rounded-full{border-radius:9999px}.sl-one-component .rounded-lg{border-radius:.5rem}.sl-one-component .rounded-t-lg{border-top-left-radius:.5rem;border-top-right-radius:.5rem}.sl-one-component .rounded-b-lg{border-bottom-left-radius:.5rem;border-bottom-right-radius:.5rem}.sl-one-component .rounded-t{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.sl-one-component .border{border-width:1px}.sl-one-component .border-t{border-top-width:1px}.sl-one-component .border-b{border-bottom-width:1px}.sl-one-component .border-b-0{border-bottom-width:0}.sl-one-component .border-none{border-style:none}.sl-one-component .border-light-3{--tw-border-opacity:1;border-color:rgb(227 232 235/var(--tw-border-opacity))}.sl-one-component .border-gray-300{--tw-border-opacity:1;border-color:rgb(209 213 219/var(--tw-border-opacity))}.sl-one-component .border-slate-100{--tw-border-opacity:1;border-color:rgb(241 245 249/var(--tw-border-opacity))}.sl-one-component .border-slate-200{--tw-border-opacity:1;border-color:rgb(226 232 240/var(--tw-border-opacity))}.sl-one-component .border-slate-300{--tw-border-opacity:1;border-color:rgb(203 213 225/var(--tw-border-opacity))}.sl-one-component .border-slate-400{--tw-border-opacity:1;border-color:rgb(148 163 184/var(--tw-border-opacity))}.sl-one-component .border-t-dark-2{--tw-border-opacity:1;border-top-color:rgb(9 22 29/var(--tw-border-opacity))}.sl-one-component .bg-white{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}.sl-one-component .bg-gray-300{--tw-bg-opacity:1;background-color:rgb(209 213 219/var(--tw-bg-opacity))}.sl-one-component .bg-info-light{--tw-bg-opacity:1;background-color:rgb(238 242 252/var(--tw-bg-opacity))}.sl-one-component .bg-gray-500{--tw-bg-opacity:1;background-color:rgb(107 114 128/var(--tw-bg-opacity))}.sl-one-component .bg-dark-teal{--tw-bg-opacity:1;background-color:rgb(18 128 121/var(--tw-bg-opacity))}.sl-one-component .bg-dark-1{--tw-bg-opacity:1;background-color:rgb(5 13 18/var(--tw-bg-opacity))}.sl-one-component .bg-light-3{--tw-bg-opacity:1;background-color:rgb(227 232 235/var(--tw-bg-opacity))}.sl-one-component .bg-sky-100{--tw-bg-opacity:1;background-color:rgb(224 242 254/var(--tw-bg-opacity))}.sl-one-component .bg-light-2{--tw-bg-opacity:1;background-color:rgb(245 248 250/var(--tw-bg-opacity))}.sl-one-component .bg-slate-700{--tw-bg-opacity:1;background-color:rgb(51 65 85/var(--tw-bg-opacity))}.sl-one-component .bg-slate-100{--tw-bg-opacity:1;background-color:rgb(241 245 249/var(--tw-bg-opacity))}.sl-one-component .bg-sky-300{--tw-bg-opacity:1;background-color:rgb(125 211 252/var(--tw-bg-opacity))}.sl-one-component .bg-sky-600{--tw-bg-opacity:1;background-color:rgb(2 132 199/var(--tw-bg-opacity))}.sl-one-component .bg-indigo-600{--tw-bg-opacity:1;background-color:rgb(79 70 229/var(--tw-bg-opacity))}.sl-one-component .bg-blue-200{--tw-bg-opacity:1;background-color:rgb(191 219 254/var(--tw-bg-opacity))}.sl-one-component .bg-red-200{--tw-bg-opacity:1;background-color:rgb(254 202 202/var(--tw-bg-opacity))}.sl-one-component .bg-yellow-200{--tw-bg-opacity:1;background-color:rgb(254 240 138/var(--tw-bg-opacity))}.sl-one-component .bg-orange-600{--tw-bg-opacity:1;background-color:rgb(234 88 12/var(--tw-bg-opacity))}.sl-one-component .bg-yellow-600{--tw-bg-opacity:1;background-color:rgb(202 138 4/var(--tw-bg-opacity))}.sl-one-component .bg-green-600{--tw-bg-opacity:1;background-color:rgb(22 163 74/var(--tw-bg-opacity))}.sl-one-component .bg-red-300{--tw-bg-opacity:1;background-color:rgb(252 165 165/var(--tw-bg-opacity))}.sl-one-component .bg-none{background-image:none}.sl-one-component .p-5{padding:1.25rem}.sl-one-component .p-2{padding:.5rem}.sl-one-component .p-6{padding:1.5rem}.sl-one-component .p-4{padding:1rem}.sl-one-component .p-10{padding:2.5rem}.sl-one-component .py-3{padding-bottom:.75rem;padding-top:.75rem}.sl-one-component .px-6{padding-left:1.5rem;padding-right:1.5rem}.sl-one-component .px-3{padding-left:.75rem;padding-right:.75rem}.sl-one-component .px-9{padding-left:2.25rem;padding-right:2.25rem}.sl-one-component .py-4{padding-bottom:1rem;padding-top:1rem}.sl-one-component .py-2{padding-bottom:.5rem;padding-top:.5rem}.sl-one-component .py-1{padding-bottom:.25rem;padding-top:.25rem}.sl-one-component .py-\\[14px\\]{padding-bottom:14px;padding-top:14px}.sl-one-component .px-2{padding-left:.5rem;padding-right:.5rem}.sl-one-component .px-5{padding-left:1.25rem;padding-right:1.25rem}.sl-one-component .py-6{padding-bottom:1.5rem;padding-top:1.5rem}.sl-one-component .py-10{padding-bottom:2.5rem;padding-top:2.5rem}.sl-one-component .px-4{padding-left:1rem;padding-right:1rem}.sl-one-component .py-3\\.5{padding-bottom:.875rem;padding-top:.875rem}.sl-one-component .px-10{padding-left:2.5rem;padding-right:2.5rem}.sl-one-component .pl-3{padding-left:.75rem}.sl-one-component .pr-3{padding-right:.75rem}.sl-one-component .pb-2{padding-bottom:.5rem}.sl-one-component .pt-3{padding-top:.75rem}.sl-one-component .pb-1{padding-bottom:.25rem}.sl-one-component .pb-4{padding-bottom:1rem}.sl-one-component .pt-6{padding-top:1.5rem}.sl-one-component .pb-3{padding-bottom:.75rem}.sl-one-component .pl-0\\.5{padding-left:.125rem}.sl-one-component .pl-0{padding-left:0}.sl-one-component .pl-1{padding-left:.25rem}.sl-one-component .pl-2{padding-left:.5rem}.sl-one-component .pt-2{padding-top:.5rem}.sl-one-component .pl-6{padding-left:1.5rem}.sl-one-component .pb-7{padding-bottom:1.75rem}.sl-one-component .pt-\\[2px\\]{padding-top:2px}.sl-one-component .pt-4{padding-top:1rem}.sl-one-component .pb-6{padding-bottom:1.5rem}.sl-one-component .pt-1{padding-top:.25rem}.sl-one-component .pt-0\\.5{padding-top:.125rem}.sl-one-component .pt-0{padding-top:0}.sl-one-component .pt-\\[2\\.5px\\]{padding-top:2.5px}.sl-one-component .pr-10{padding-right:2.5rem}.sl-one-component .pt-16{padding-top:4rem}.sl-one-component .pb-8{padding-bottom:2rem}.sl-one-component .pt-10{padding-top:2.5rem}.sl-one-component .text-left{text-align:left}.sl-one-component .text-center{text-align:center}.sl-one-component .text-right{text-align:right}.sl-one-component .text-lg{font-size:1.125rem;line-height:1.75rem}.sl-one-component .text-sm{font-size:.875rem;line-height:1.25rem}.sl-one-component .text-2xl{font-size:1.5rem;line-height:2rem}.sl-one-component .text-\\[11px\\]{font-size:11px}.sl-one-component .text-3xl{font-size:1.875rem;line-height:2.25rem}.sl-one-component .text-xl{font-size:1.25rem;line-height:1.75rem}.sl-one-component .font-medium{font-weight:500}.sl-one-component .font-semibold{font-weight:600}.sl-one-component .font-normal{font-weight:400}.sl-one-component .font-light{font-weight:300}.sl-one-component .font-bold{font-weight:700}.sl-one-component .leading-none{line-height:1}.sl-one-component .leading-7{line-height:1.75rem}.sl-one-component .leading-normal{line-height:1.5}.sl-one-component .leading-relaxed{line-height:1.625}.sl-one-component .text-gray-900{--tw-text-opacity:1;color:rgb(17 24 39/var(--tw-text-opacity))}.sl-one-component .text-emerald-900{--tw-text-opacity:1;color:rgb(6 78 59/var(--tw-text-opacity))}.sl-one-component .text-dark-2{--tw-text-opacity:1;color:rgb(9 22 29/var(--tw-text-opacity))}.sl-one-component .text-emerald-700{--tw-text-opacity:1;color:rgb(4 120 87/var(--tw-text-opacity))}.sl-one-component .text-dark-5{--tw-text-opacity:1;color:rgb(79 94 101/var(--tw-text-opacity))}.sl-one-component .text-dark-1{--tw-text-opacity:1;color:rgb(5 13 18/var(--tw-text-opacity))}.sl-one-component .text-light-5{--tw-text-opacity:1;color:rgb(145 151 154/var(--tw-text-opacity))}.sl-one-component .text-gray-500{--tw-text-opacity:1;color:rgb(107 114 128/var(--tw-text-opacity))}.sl-one-component .text-sky-700{--tw-text-opacity:1;color:rgb(3 105 161/var(--tw-text-opacity))}.sl-one-component .text-info{--tw-text-opacity:1;color:rgb(43 91 215/var(--tw-text-opacity))}.sl-one-component .text-one-black{--tw-text-opacity:1;color:rgb(14 16 17/var(--tw-text-opacity))}.sl-one-component .text-white{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.sl-one-component .text-error{--tw-text-opacity:1;color:rgb(177 67 52/var(--tw-text-opacity))}.sl-one-component .text-dark-3{--tw-text-opacity:1;color:rgb(23 36 45/var(--tw-text-opacity))}.sl-one-component .text-gray-700{--tw-text-opacity:1;color:rgb(55 65 81/var(--tw-text-opacity))}.sl-one-component .text-apple,.sl-one-component .text-black{--tw-text-opacity:1;color:rgb(0 0 0/var(--tw-text-opacity))}.sl-one-component .text-facebook{--tw-text-opacity:1;color:rgb(23 120 242/var(--tw-text-opacity))}.sl-one-component .text-paypal{--tw-text-opacity:1;color:rgb(57 114 177/var(--tw-text-opacity))}.sl-one-component .text-picarto{--tw-text-opacity:1;color:rgb(45 167 95/var(--tw-text-opacity))}.sl-one-component .text-tiktok{--tw-text-opacity:1;color:rgb(0 0 0/var(--tw-text-opacity))}.sl-one-component .text-trovo{--tw-text-opacity:1;color:rgb(25 214 107/var(--tw-text-opacity))}.sl-one-component .text-twitch{--tw-text-opacity:1;color:rgb(145 71 254/var(--tw-text-opacity))}.sl-one-component .text-youtube{--tw-text-opacity:1;color:rgb(211 57 41/var(--tw-text-opacity))}.sl-one-component .text-twitter{--tw-text-opacity:1;color:rgb(0 0 0/var(--tw-text-opacity))}.sl-one-component .text-linkedin{--tw-text-opacity:1;color:rgb(0 122 182/var(--tw-text-opacity))}.sl-one-component .text-dark-teal{--tw-text-opacity:1;color:rgb(18 128 121/var(--tw-text-opacity))}.sl-one-component .text-slate-900{--tw-text-opacity:1;color:rgb(15 23 42/var(--tw-text-opacity))}.sl-one-component .text-sky-500{--tw-text-opacity:1;color:rgb(14 165 233/var(--tw-text-opacity))}.sl-one-component .text-slate-600{--tw-text-opacity:1;color:rgb(71 85 105/var(--tw-text-opacity))}.sl-one-component .text-light-2{--tw-text-opacity:1;color:rgb(245 248 250/var(--tw-text-opacity))}.sl-one-component .text-red-900{--tw-text-opacity:1;color:rgb(127 29 29/var(--tw-text-opacity))}.sl-one-component .underline{-webkit-text-decoration-line:underline;text-decoration-line:underline}.sl-one-component .opacity-\\[0\\.08\\]{opacity:.08}.sl-one-component .shadow-md{--tw-shadow:0 4px 6px -1px rgba(0,0,0,.1),0 2px 4px -2px rgba(0,0,0,.1);--tw-shadow-colored:0 4px 6px -1px var(--tw-shadow-color),0 2px 4px -2px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.sl-one-component .blur{--tw-blur:blur(8px)}.sl-one-component .blur,.sl-one-component .filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.sl-one-component .transition{transition-duration:.15s;transition-property:color,background-color,border-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-text-decoration-color,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-text-decoration-color,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1)}.sl-one-component .ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.sl-one-component .hover\\:cursor-pointer:hover{cursor:pointer}.sl-one-component .hover\\:bg-light-3:hover{--tw-bg-opacity:1;background-color:rgb(227 232 235/var(--tw-bg-opacity))}.sl-one-component .hover\\:bg-gray-600:hover{--tw-bg-opacity:1;background-color:rgb(75 85 99/var(--tw-bg-opacity))}.sl-one-component .hover\\:bg-light-3\\/25:hover{background-color:rgba(227,232,235,.25)}.sl-one-component .hover\\:bg-light-4:hover{--tw-bg-opacity:1;background-color:rgb(189 194 196/var(--tw-bg-opacity))}.sl-one-component .hover\\:bg-indigo-700:hover{--tw-bg-opacity:1;background-color:rgb(67 56 202/var(--tw-bg-opacity))}.sl-one-component .hover\\:text-sky-900:hover{--tw-text-opacity:1;color:rgb(12 74 110/var(--tw-text-opacity))}.sl-one-component .hover\\:text-dark-1:hover{--tw-text-opacity:1;color:rgb(5 13 18/var(--tw-text-opacity))}.sl-one-component .hover\\:text-info-dark:hover{--tw-text-opacity:1;color:rgb(0 44 155/var(--tw-text-opacity))}.sl-one-component .hover\\:text-dark-4:hover{--tw-text-opacity:1;color:rgb(43 56 63/var(--tw-text-opacity))}.sl-one-component .hover\\:text-black:hover{--tw-text-opacity:1;color:rgb(0 0 0/var(--tw-text-opacity))}.sl-one-component .hover\\:text-dark-3:hover{--tw-text-opacity:1;color:rgb(23 36 45/var(--tw-text-opacity))}.sl-one-component .hover\\:text-dark-5:hover{--tw-text-opacity:1;color:rgb(79 94 101/var(--tw-text-opacity))}.sl-one-component .hover\\:underline:hover{-webkit-text-decoration-line:underline;text-decoration-line:underline}.sl-one-component .hover\\:brightness-90:hover{--tw-brightness:brightness(.9)}.sl-one-component .hover\\:brightness-90:hover,.sl-one-component .hover\\:drop-shadow:hover{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.sl-one-component .hover\\:drop-shadow:hover{--tw-drop-shadow:drop-shadow(0 1px 2px rgba(0,0,0,.1)) drop-shadow(0 1px 1px rgba(0,0,0,.06))}.sl-one-component .hover\\:drop-shadow-md:hover{--tw-drop-shadow:drop-shadow(0 4px 3px rgba(0,0,0,.07)) drop-shadow(0 2px 2px rgba(0,0,0,.06));filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.sl-one-component .focus\\:border-dark-5:focus{--tw-border-opacity:1;border-color:rgb(79 94 101/var(--tw-border-opacity))}.sl-one-component .focus\\:bg-light-1:focus{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}.sl-one-component .focus\\:bg-light-3:focus{--tw-bg-opacity:1;background-color:rgb(227 232 235/var(--tw-bg-opacity))}.sl-one-component .focus\\:text-dark-3:focus{--tw-text-opacity:1;color:rgb(23 36 45/var(--tw-text-opacity))}.sl-one-component .focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.sl-one-component .disabled\\:pointer-events-none:disabled{pointer-events:none}.sl-one-component .disabled\\:cursor-not-allowed:disabled{cursor:not-allowed}.sl-one-component .disabled\\:bg-gray-100:disabled{--tw-bg-opacity:1;background-color:rgb(243 244 246/var(--tw-bg-opacity))}.sl-one-component .disabled\\:text-gray-500:disabled{--tw-text-opacity:1;color:rgb(107 114 128/var(--tw-text-opacity))}.sl-one-component .dark .dark\\:border-gray-700{--tw-border-opacity:1;border-color:rgb(55 65 81/var(--tw-border-opacity))}.sl-one-component .dark .dark\\:border-t-white{--tw-border-opacity:1;border-top-color:rgb(255 255 255/var(--tw-border-opacity))}.sl-one-component .dark .dark\\:bg-dark-2{--tw-bg-opacity:1;background-color:rgb(9 22 29/var(--tw-bg-opacity))}.sl-one-component .dark .dark\\:bg-dark-3{--tw-bg-opacity:1;background-color:rgb(23 36 45/var(--tw-bg-opacity))}.sl-one-component .dark .dark\\:bg-gray-800{--tw-bg-opacity:1;background-color:rgb(31 41 55/var(--tw-bg-opacity))}.sl-one-component .dark .dark\\:text-light-3{--tw-text-opacity:1;color:rgb(227 232 235/var(--tw-text-opacity))}.sl-one-component .dark .dark\\:text-light-1{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.sl-one-component .dark .dark\\:text-light-5{--tw-text-opacity:1;color:rgb(145 151 154/var(--tw-text-opacity))}.sl-one-component .dark .dark\\:text-light-2{--tw-text-opacity:1;color:rgb(245 248 250/var(--tw-text-opacity))}.sl-one-component .dark .dark\\:text-light-4{--tw-text-opacity:1;color:rgb(189 194 196/var(--tw-text-opacity))}.sl-one-component .dark .dark\\:text-gray-300{--tw-text-opacity:1;color:rgb(209 213 219/var(--tw-text-opacity))}.sl-one-component .dark .dark\\:text-white{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.sl-one-component .dark .dark\\:text-teal{--tw-text-opacity:1;color:rgb(128 245 210/var(--tw-text-opacity))}.sl-one-component .dark .dark\\:hover\\:bg-dark-4:hover{--tw-bg-opacity:1;background-color:rgb(43 56 63/var(--tw-bg-opacity))}.sl-one-component .dark .dark\\:hover\\:bg-black\\/25:hover{background-color:rgba(0,0,0,.25)}.sl-one-component .dark .dark\\:hover\\:text-light-1:hover{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}.sl-one-component .dark .dark\\:hover\\:text-light-4:hover{--tw-text-opacity:1;color:rgb(189 194 196/var(--tw-text-opacity))}@media (min-width:640px){.sl-one-component .sm\\:w-12{width:3rem}.sl-one-component .sm\\:text-lg{font-size:1.125rem;line-height:1.75rem}}@media (min-width:768px){.sl-one-component .md\\:mx-0{margin-left:0;margin-right:0}.sl-one-component .md\\:mr-2{margin-right:.5rem}.sl-one-component .md\\:inline-block{display:inline-block}.sl-one-component .md\\:w-full{width:100%}.sl-one-component .md\\:w-\\[360px\\]{width:360px}.sl-one-component .md\\:w-1\\/4{width:25%}.sl-one-component .md\\:gap-x-6{-moz-column-gap:1.5rem;column-gap:1.5rem}.sl-one-component .md\\:p-10{padding:2.5rem}}@media (min-width:1024px){.sl-one-component .lg\\:flex{display:flex}.sl-one-component .lg\\:w-2\\/5{width:40%}.sl-one-component .lg\\:w-3\\/5{width:60%}.sl-one-component .lg\\:max-w-\\[65\\%\\]{max-width:65%}}@media (min-width:1280px){.sl-one-component .xl\\:w-full{width:100%}.sl-one-component .xl\\:flex-auto{flex:1 1 auto}}@media (min-width:600px){.sl-one-component .xs\\:block{display:block}.sl-one-component .xs\\:w-\\[360px\\]{width:360px}.sl-one-component .xs\\:w-\\[240px\\]{width:240px}.sl-one-component .xs\\:gap-x-4{-moz-column-gap:1rem;column-gap:1rem}}";
n(css,{});

class ComponentStateGetter {
    constructor(component, path) {
        Object.defineProperty(this, "component", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "path", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.component = component;
        this.path = path;
    }
    get state() {
        return this.component[this.path];
    }
}
class ComponentStateProxy {
    constructor() {
        Object.defineProperty(this, "isReady", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stateClass", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        this.state = this.makeStateProxy();
    }
    makeStateProxy() {
        const state = new Proxy(this.stateClass || {}, {
            get: (target, property) => {
                if (this.isReady) {
                    return target.state[property];
                }
                if (this.methodKeys.includes(property.toString())) {
                    return () => {
                        console.warn('Called ComponentStateProxy before initialization');
                    };
                }
                return undefined;
            },
            set: (target, property, value) => {
                if (this.isReady) {
                    target.component[property] = value;
                }
                return true;
            },
        });
        return state;
    }
    setState(stateClass) {
        this.stateClass = stateClass;
        this.state = this.makeStateProxy();
        this.isReady = true;
    }
}

class AgeGateFormStateProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'setValid',
                'setSubmitting',
                'resetForm',
                'resetErrors',
                'validateForm',
                'onSubmit',
            ]
        });
    }
}

class ChangePasswordCardProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ['setErrorMessage', 'setHasSuccess', 'onSuccess', 'onError']
        });
    }
}

class CheckTfaCardProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ['setErrorMessage', 'setHasSuccess', 'onSuccess', 'onError']
        });
    }
}

class ConnectCardStateProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'init',
                'setHasSuccess',
                'setErrorMessage',
                'setIsLoading',
                'setIsConnecting',
                'setView',
                'onCancel',
                'onConnect',
                'onLoginRequired',
                'onSuccess',
                'onError',
            ]
        });
    }
}

class ConnectUpgradeCardProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ['setErrorMessage', 'setHasSuccess', 'onSuccess', 'onError']
        });
    }
}

class ConnectConfirmCardProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ['setErrorMessage', 'setHasSuccess', 'onSuccess', 'onError']
        });
    }
}

class ConnectUpgradeConfirmCardProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ['setErrorMessage', 'setHasSuccess', 'onSuccess', 'onError']
        });
    }
}

class ConnectOneClickStateProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'init',
                'setIsConnecting',
                'onClose',
                'onError',
                'onConnect',
                'onRedirect',
                'onTimeout',
                'onClosed',
                'onSuccess',
                'onStartOauth',
            ]
        });
    }
}

class CreateTfaCardStateProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'setStep',
                'setRecoveryCodes',
                'onScanComplete',
                'onScanError',
                'onScanReady',
                'onConfirmComplete',
                'onConfirmError',
                'onSaveDownload',
                'onSaveComplete',
            ]
        });
    }
}

class ForgotPasswordCardProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ['setErrorMessage', 'setHasSuccess', 'onSuccess', 'onError']
        });
    }
}

class LoginCardStateProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'setErrorMessage',
                'setHasSuccess',
                'onSuccess',
                'onError',
                'onForgotPassword',
            ]
        });
    }
}

class LoginSourcesCardProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ['setErrorMessage', 'onSuccess', 'onError']
        });
    }
}

class RemoveTfaCardProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ['setErrorMessage', 'setHasSuccess', 'onSuccess', 'onError']
        });
    }
}

class SignupCardStateProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ['setErrorMessage', 'setHasSuccess', 'onSuccess', 'onError']
        });
    }
}

class SignupSourcesCardProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ['setErrorMessage', 'onSuccess', 'onError']
        });
    }
}

class VerifyEmailCardProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ['setErrorMessage', 'setHasSuccess', 'onSuccess', 'onError']
        });
    }
}

class ServicesDropdownProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'close',
                'open',
                'toggleOpen',
                'showMore',
                'showLess',
                'toggleShowAll',
            ]
        });
    }
}

class UltraCheckoutCardStateProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ['onByNow', 'onSeeIncluded']
        });
    }
}

class UltraCheckoutBannerStateProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ['onByNow', 'onSeeIncluded']
        });
    }
}

class ChangePasswordFormProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'setValid',
                'setHasSuccess',
                'setSubmitting',
                'validate',
                'onSubmit',
                'resetForm',
                'resetErrors',
            ]
        });
    }
}

class CheckTfaFormStateProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'setValid',
                'setSubmitting',
                'resetForm',
                'resetErrors',
                'validateForm',
                'onSubmit',
            ]
        });
    }
}

class EmailLoginScopedStateProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'setValid',
                'setSubmitting',
                'resetForm',
                'resetErrors',
                'validateForm',
                'onSubmit',
            ]
        });
    }
}

class EmailSignupScopedStateProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'setValid',
                'setSubmitting',
                'resetForm',
                'resetErrors',
                'validateForm',
                'onSubmit',
            ]
        });
    }
}

class ForgotPasswordFormStateProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'setValid',
                'setSubmitting',
                'resetForm',
                'resetErrors',
                'validateForm',
                'onSubmit',
            ]
        });
    }
}

class ResetPasswordFormProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'setValid',
                'setSubmitting',
                'resetForm',
                'resetErrors',
                'validateForm',
                'onSubmit',
                'setHasSuccess',
                'setContext',
            ]
        });
    }
}

class RemoveTfaFormStateProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'setValid',
                'setHasSuccess',
                'setSubmitting',
                'resetForm',
                'resetErrors',
                'validate',
                'onSubmit',
            ]
        });
    }
}

class VerifyEmailFormProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'setValid',
                'setSubmitting',
                'resetForm',
                'resetErrors',
                'validateForm',
                'onSubmit',
                'setHasSuccess',
                'setContext',
            ]
        });
    }
}

class ChangeEmailWizardProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'onCompleteWizard',
                'onBackToEmail',
                'onBackFromTfa',
                'onUpdateUser',
                'getNextStep',
                'onStep1Success',
                'onStep2Success',
                'onStep3Success',
                'on2faStepSuccess',
                'onValidationError',
            ]
        });
    }
}

class VerifyPasswordCardStateProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'setErrorMessage',
                'setHasSuccess',
                'onSubmit',
                'onSuccess',
                'onError',
            ]
        });
    }
}

class VerifyNewEmailCardStateProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'setErrorMessage',
                'setHasSuccess',
                'onSuccess',
                'onError',
                'onSubmit',
            ]
        });
    }
}

class VerifyNewEmailOwnershipCardProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'setErrorMessage',
                'setHasSuccess',
                'onSuccess',
                'onError',
                'onSubmit',
                'getPayloadData',
            ]
        });
    }
}

class VerifyTfaCardProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'setErrorMessage',
                'setHasSuccess',
                'onSuccess',
                'onSubmit',
                'onError',
                'getSubmitData',
            ]
        });
    }
}

class EmailChangeScopedStateProxy extends ComponentStateProxy {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "methodKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                'setValid',
                'setSubmitting',
                'resetForm',
                'resetErrors',
                'validate',
                'onSubmit',
            ]
        });
    }
}

const resources = {
    'en-US': { translation: enUS },
    'cs-CZ': { translation: csCZ },
    'da-DK': { translation: daDK },
    'de-DE': { translation: deDE },
    'es-ES': { translation: esES },
    'fr-FR': { translation: frFR },
    'id-ID': { translation: idID },
    'it-IT': { translation: itIT },
    'ja-JP': { translation: jaJP },
    'ko-KR': { translation: koKR },
    'nl-NL': { translation: nlNL },
    'pl-PL': { translation: plPL },
    'pt-BR': { translation: ptBR },
    'pt-PT': { translation: ptPT },
    'ru-RU': { translation: ruRU },
    'tr-TR': { translation: trTR },
    'zh-CN': { translation: zhCN },
    'zh-TW': { translation: zhTW },
};
const SUPPORTED_LANGUAGES = Object.freeze({
    'cs-CZ': 'čeština, český jazyk',
    'da-DK': 'Danish',
    'de-DE': 'Deutsch',
    'en-US': 'English',
    'es-ES': 'Español',
    'fr-FR': 'Français',
    'id-ID': 'Indonesian',
    'it-IT': 'Italiano',
    'ja-JP': '日本語',
    'ko-KR': '한국어',
    'nl-NL': 'Deutsch',
    'pl-PL': 'Język polski',
    'pt-BR': 'Português (Brazil)',
    'pt-PT': 'Português',
    'ru-RU': 'Русский',
    'tr-TR': 'Türkçe',
    'zh-CN': '简体中文 (Chinese Simplified)',
    'zh-TW': '繁體中文 （Chinese Traditional）',
});
const i18n = i18next.createInstance();
const vueI18nService = new Vue({
    data() {
        return {
            currentLang: (process.env.VUE_APP_DEFAULT_LANG || 'en-US'),
            client: i18n,
        };
    },
    created() {
        this.client.init({
            interpolation: {
                prefix: '{',
                suffix: '}',
                nestingPrefix: '@(',
                nestingSuffix: ')',
            },
            lng: this.currentLang,
            debug: false,
            load: 'currentOnly',
            supportedLngs: Object.keys(SUPPORTED_LANGUAGES),
            fallbackLng: 'en-US',
            partialBundledLanguages: true,
            resources,
        });
    },
    methods: {
        setLocale(lang) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.client.changeLanguage(lang);
                this.currentLang = lang;
            });
        },
    },
});

const bus = new Vue({
    data() {
        return {
            companyId: 'streamlabs',
            suggestedEmail: '',
            suggestedName: '',
            forceVerify: true,
            currency: 'USD',
        };
    },
});
const getCompanyId = () => {
    return bus.companyId;
};
const setCompanyId = (companyId) => {
    bus.companyId = companyId;
};
const getSuggestedUser = () => {
    return {
        suggestedEmail: bus.suggestedEmail,
        suggestedName: bus.suggestedName,
    };
};
const setSuggestedUser = ({ name = '', email = '', }) => {
    bus.suggestedEmail = email;
    bus.suggestedName = name;
};
const getLang = () => {
    return vueI18nService.currentLang;
};
const setLang = (lang) => {
    return vueI18nService.setLocale(lang);
};
const getForceVerify = () => {
    return bus.forceVerify;
};
const setForceVerify = (forceVerify) => {
    bus.forceVerify = forceVerify;
};
const getCurrency = () => {
    return bus.currency;
};
const setCurrency = (currency) => {
    bus.currency = currency;
};

var componentDefaults = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getCompanyId: getCompanyId,
  setCompanyId: setCompanyId,
  getSuggestedUser: getSuggestedUser,
  setSuggestedUser: setSuggestedUser,
  getLang: getLang,
  setLang: setLang,
  getForceVerify: getForceVerify,
  setForceVerify: setForceVerify,
  getCurrency: getCurrency,
  setCurrency: setCurrency
});

const { connect: connect$2, openView } = methods;
const componentConnect = (data) => {
    const suggestedUser = getSuggestedUser();
    const config = Object.assign({ companyId: getCompanyId(), lang: getLang(), suggestedName: suggestedUser.suggestedName, suggestedEmail: suggestedUser.suggestedEmail }, data);
    return connect$2(config);
};
const componentOpenView = (data) => {
    const suggestedUser = getSuggestedUser();
    const config = Object.assign({ companyId: getCompanyId(), lang: getLang(), suggestedName: suggestedUser.suggestedName, suggestedEmail: suggestedUser.suggestedEmail }, data);
    return openView(config);
};

var global$1 = (typeof global !== "undefined" ? global :
  typeof self !== "undefined" ? self :
  typeof window !== "undefined" ? window : {});

// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
var cachedSetTimeout = defaultSetTimout;
var cachedClearTimeout = defaultClearTimeout;
if (typeof global$1.setTimeout === 'function') {
    cachedSetTimeout = setTimeout;
}
if (typeof global$1.clearTimeout === 'function') {
    cachedClearTimeout = clearTimeout;
}

function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
function nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
}
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
var title = 'browser';
var platform = 'browser';
var browser = true;
var env = {};
var argv = [];
var version = ''; // empty string to avoid regexp issues
var versions = {};
var release = {};
var config = {};

function noop() {}

var on = noop;
var addListener = noop;
var once = noop;
var off = noop;
var removeListener = noop;
var removeAllListeners = noop;
var emit = noop;

function binding(name) {
    throw new Error('process.binding is not supported');
}

function cwd () { return '/' }
function chdir (dir) {
    throw new Error('process.chdir is not supported');
}function umask() { return 0; }

// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var performance = global$1.performance || {};
var performanceNow =
  performance.now        ||
  performance.mozNow     ||
  performance.msNow      ||
  performance.oNow       ||
  performance.webkitNow  ||
  function(){ return (new Date()).getTime() };

// generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime
function hrtime(previousTimestamp){
  var clocktime = performanceNow.call(performance)*1e-3;
  var seconds = Math.floor(clocktime);
  var nanoseconds = Math.floor((clocktime%1)*1e9);
  if (previousTimestamp) {
    seconds = seconds - previousTimestamp[0];
    nanoseconds = nanoseconds - previousTimestamp[1];
    if (nanoseconds<0) {
      seconds--;
      nanoseconds += 1e9;
    }
  }
  return [seconds,nanoseconds]
}

var startTime = new Date();
function uptime() {
  var currentTime = new Date();
  var dif = currentTime - startTime;
  return dif / 1000;
}

var browser$1 = {
  nextTick: nextTick,
  title: title,
  browser: browser,
  env: env,
  argv: argv,
  version: version,
  versions: versions,
  on: on,
  addListener: addListener,
  once: once,
  off: off,
  removeListener: removeListener,
  removeAllListeners: removeAllListeners,
  emit: emit,
  binding: binding,
  cwd: cwd,
  chdir: chdir,
  umask: umask,
  hrtime: hrtime,
  platform: platform,
  release: release,
  config: config,
  uptime: uptime
};

let IconMixin = class IconMixin extends Vue {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    Prop({ type: Number, default: 16 })
], IconMixin.prototype, "size", void 0);
IconMixin = __decorate([
    Component({})
], IconMixin);
var IconMixin$1 = IconMixin;

let CircleNotch = class CircleNotch extends IconMixin$1 {
};
CircleNotch = __decorate([
    Component({})
], CircleNotch);
var script$1c = CircleNotch;

const __vue_script__$1c = script$1c;
var __vue_render__$1e = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: _vm.size,
            width: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M222.7 32.15C227.7 49.08 218.1 66.9 201.1 71.94C121.8 95.55 64 169.1 64 255.1C64 362 149.1 447.1 256 447.1C362 447.1 448 362 448 255.1C448 169.1 390.2 95.55 310.9 71.94C293.9 66.9 284.3 49.08 289.3 32.15C294.4 15.21 312.2 5.562 329.1 10.6C434.9 42.07 512 139.1 512 255.1C512 397.4 397.4 511.1 256 511.1C114.6 511.1 0 397.4 0 255.1C0 139.1 77.15 42.07 182.9 10.6C199.8 5.562 217.6 15.21 222.7 32.15V32.15z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$1e = [];
__vue_render__$1e._withStripped = true;
  const __vue_inject_styles__$1e = undefined;
  const __vue_scope_id__$1e = undefined;
  const __vue_module_identifier__$1e = undefined;
  const __vue_is_functional_template__$1e = false;
  const __vue_component__$1e = normalizeComponent(
    { render: __vue_render__$1e, staticRenderFns: __vue_staticRenderFns__$1e },
    __vue_inject_styles__$1e,
    __vue_script__$1c,
    __vue_scope_id__$1e,
    __vue_is_functional_template__$1e,
    __vue_module_identifier__$1e,
    false,
    undefined,
    undefined,
    undefined
  );

let RightArrow$5 = class RightArrow extends IconMixin$1 {
};
RightArrow$5 = __decorate([
    Component({})
], RightArrow$5);
var script$1b = RightArrow$5;

const __vue_script__$1b = script$1b;
var __vue_render__$1d = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: _vm.size,
            width: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M438.6 278.6l-160 160C272.4 444.9 264.2 448 256 448s-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L338.8 288H32C14.33 288 .0016 273.7 .0016 256S14.33 224 32 224h306.8l-105.4-105.4c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160C451.1 245.9 451.1 266.1 438.6 278.6z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$1d = [];
__vue_render__$1d._withStripped = true;
  const __vue_inject_styles__$1d = undefined;
  const __vue_scope_id__$1d = undefined;
  const __vue_module_identifier__$1d = undefined;
  const __vue_is_functional_template__$1d = false;
  const __vue_component__$1d = normalizeComponent(
    { render: __vue_render__$1d, staticRenderFns: __vue_staticRenderFns__$1d },
    __vue_inject_styles__$1d,
    __vue_script__$1b,
    __vue_scope_id__$1d,
    __vue_is_functional_template__$1d,
    __vue_module_identifier__$1d,
    false,
    undefined,
    undefined,
    undefined
  );

function createVNode(node, h, scopedSlots) {
    if (node.nodeName === '#text') {
        return node.textContent;
    }
    const slotName = camelCase(node.nodeName);
    const slot = scopedSlots[slotName];
    if (slot) {
        return slot(node.textContent);
    }
    return h(node.nodeName, node.textContent);
}
function parseMessage(message) {
    const doc = new DOMParser().parseFromString(`<root>${message}</root>`, 'text/xml');
    return [...doc.childNodes[0].childNodes];
}
var I18n = Vue.extend({
    functional: true,
    props: {
        message: {
            type: String,
            required: true,
        },
        tag: {
            type: String,
            default: 'span',
        },
    },
    render(createElement, context) {
        const { props: { message, tag }, scopedSlots, } = context;
        const { attrs, staticClass } = context.data;
        const nodes = parseMessage(message);
        const slots = nodes.reduce((list, node) => {
            const name = camelCase(node.nodeName);
            return Object.assign(Object.assign({}, list), { [name]: node.textContent });
        }, {});
        if (scopedSlots.default) {
            return scopedSlots.default(slots);
        }
        const vNodes = nodes.map((node) => createVNode(node, createElement, scopedSlots));
        return createElement(tag, { attrs, staticClass }, vNodes);
    },
});

let BaseMixin = class BaseMixin extends Vue {
    t(key, values = {}, defaultValue = null) {
        return vueI18nService.client.t(key, defaultValue === null ? key : defaultValue, Object.assign({ lang: vueI18nService.currentLang }, values));
    }
    tp(key, values = {}) {
        return vueI18nService.client.t(key, Object.assign({ lang: vueI18nService.currentLang }, values));
    }
};
BaseMixin = __decorate([
    Component({
        components: {
            i18n: I18n,
        },
    })
], BaseMixin);
var BaseMixin$1 = BaseMixin;

let RightArrow$4 = class RightArrow extends IconMixin$1 {
};
RightArrow$4 = __decorate([
    Component({})
], RightArrow$4);
var script$1a = RightArrow$4;

const __vue_script__$1a = script$1a;
var __vue_render__$1c = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: _vm.size,
            width: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 490 512",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$1c = [];
__vue_render__$1c._withStripped = true;
  const __vue_inject_styles__$1c = undefined;
  const __vue_scope_id__$1c = undefined;
  const __vue_module_identifier__$1c = undefined;
  const __vue_is_functional_template__$1c = false;
  const __vue_component__$1c = normalizeComponent(
    { render: __vue_render__$1c, staticRenderFns: __vue_staticRenderFns__$1c },
    __vue_inject_styles__$1c,
    __vue_script__$1a,
    __vue_scope_id__$1c,
    __vue_is_functional_template__$1c,
    __vue_module_identifier__$1c,
    false,
    undefined,
    undefined,
    undefined
  );

let Facebook = class Facebook extends IconMixin$1 {
};
Facebook = __decorate([
    Component({})
], Facebook);
var script$19 = Facebook;

const __vue_script__$19 = script$19;
var __vue_render__$1b = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: _vm.size,
            width: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$1b = [];
__vue_render__$1b._withStripped = true;
  const __vue_inject_styles__$1b = undefined;
  const __vue_scope_id__$1b = undefined;
  const __vue_module_identifier__$1b = undefined;
  const __vue_is_functional_template__$1b = false;
  const __vue_component__$1b = normalizeComponent(
    { render: __vue_render__$1b, staticRenderFns: __vue_staticRenderFns__$1b },
    __vue_inject_styles__$1b,
    __vue_script__$19,
    __vue_scope_id__$1b,
    __vue_is_functional_template__$1b,
    __vue_module_identifier__$1b,
    false,
    undefined,
    undefined,
    undefined
  );

let RightArrow$3 = class RightArrow extends IconMixin$1 {
};
RightArrow$3 = __decorate([
    Component({})
], RightArrow$3);
var script$18 = RightArrow$3;

const __vue_script__$18 = script$18;
var __vue_render__$1a = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            viewBox: "0 0 24 24",
            width: _vm.size,
            height: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _c(
            "g",
            {
              attrs: { transform: "matrix(1, 0, 0, 1, 27.009001, -39.238998)" },
            },
            [
              _c("path", {
                attrs: {
                  fill: "#4285F4",
                  d: "M -3.264 51.509 C -3.264 50.719 -3.334 49.969 -3.454 49.239 L -14.754 49.239 L -14.754 53.749 L -8.284 53.749 C -8.574 55.229 -9.424 56.479 -10.684 57.329 L -10.684 60.329 L -6.824 60.329 C -4.564 58.239 -3.264 55.159 -3.264 51.509 Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#34A853",
                  d: "M -14.754 63.239 C -11.514 63.239 -8.804 62.159 -6.824 60.329 L -10.684 57.329 C -11.764 58.049 -13.134 58.489 -14.754 58.489 C -17.884 58.489 -20.534 56.379 -21.484 53.529 L -25.464 53.529 L -25.464 56.619 C -23.494 60.539 -19.444 63.239 -14.754 63.239 Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#FBBC05",
                  d: "M -21.484 53.529 C -21.734 52.809 -21.864 52.039 -21.864 51.239 C -21.864 50.439 -21.724 49.669 -21.484 48.949 L -21.484 45.859 L -25.464 45.859 C -26.284 47.479 -26.754 49.299 -26.754 51.239 C -26.754 53.179 -26.284 54.999 -25.464 56.619 L -21.484 53.529 Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#EA4335",
                  d: "M -14.754 43.989 C -12.984 43.989 -11.404 44.599 -10.154 45.789 L -6.734 42.369 C -8.804 40.429 -11.514 39.239 -14.754 39.239 C -19.444 39.239 -23.494 41.939 -25.464 45.859 L -21.484 48.949 C -20.534 46.099 -17.884 43.989 -14.754 43.989 Z",
                },
              }),
            ]
          ),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$1a = [];
__vue_render__$1a._withStripped = true;
  const __vue_inject_styles__$1a = undefined;
  const __vue_scope_id__$1a = undefined;
  const __vue_module_identifier__$1a = undefined;
  const __vue_is_functional_template__$1a = false;
  const __vue_component__$1a = normalizeComponent(
    { render: __vue_render__$1a, staticRenderFns: __vue_staticRenderFns__$1a },
    __vue_inject_styles__$1a,
    __vue_script__$18,
    __vue_scope_id__$1a,
    __vue_is_functional_template__$1a,
    __vue_module_identifier__$1a,
    false,
    undefined,
    undefined,
    undefined
  );

let Paypal = class Paypal extends IconMixin$1 {
};
Paypal = __decorate([
    Component({})
], Paypal);
var script$17 = Paypal;

const __vue_script__$17 = script$17;
var __vue_render__$19 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: _vm.size,
            width: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4.7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9.7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$19 = [];
__vue_render__$19._withStripped = true;
  const __vue_inject_styles__$19 = undefined;
  const __vue_scope_id__$19 = undefined;
  const __vue_module_identifier__$19 = undefined;
  const __vue_is_functional_template__$19 = false;
  const __vue_component__$19 = normalizeComponent(
    { render: __vue_render__$19, staticRenderFns: __vue_staticRenderFns__$19 },
    __vue_inject_styles__$19,
    __vue_script__$17,
    __vue_scope_id__$19,
    __vue_is_functional_template__$19,
    __vue_module_identifier__$19,
    false,
    undefined,
    undefined,
    undefined
  );

let Picarto = class Picarto extends IconMixin$1 {
};
Picarto = __decorate([
    Component({})
], Picarto);
var script$16 = Picarto;

const __vue_script__$16 = script$16;
var __vue_render__$18 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: _vm.size,
            width: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 1024 1024",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M512 0c-282.752 0-512 229.248-512 512s229.248 512 512 512c282.795 0 512-229.248 512-512s-229.205-512-512-512zM302.080 178.432h118.656c9.941 0 17.92 8.96 17.92 20.053v627.029c0 11.093-7.979 20.053-17.92 20.053h-118.613c-9.941 0-17.92-8.96-17.92-20.053v-627.029c0-11.093 7.979-20.053 17.877-20.053zM501.077 178.432c0.019 0 0.042 0 0.065 0 5.119 0 9.901 1.445 13.959 3.949l-0.115-0.066c15.147 8.917 317.909 188.587 343.765 203.947 7.611 4.572 12.624 12.783 12.624 22.165s-5.014 17.593-12.508 22.1l-0.116 0.065c-18.603 11.264-322.475 191.787-344.491 204.331-3.609 2.194-7.973 3.493-12.64 3.493-13.597 0-24.619-11.022-24.619-24.619 0-0.253 0.004-0.505 0.011-0.756l-0.001 0.037v-77.312c0-73.045 126.379-93.909 144.981-105.173 7.631-4.568 12.66-12.79 12.66-22.187s-5.029-17.619-12.543-22.122l-0.117-0.065c-25.813-15.36-144.981-31.829-144.981-104.619v-77.227c0-14.251 10.709-25.813 24.064-25.941z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$18 = [];
__vue_render__$18._withStripped = true;
  const __vue_inject_styles__$18 = undefined;
  const __vue_scope_id__$18 = undefined;
  const __vue_module_identifier__$18 = undefined;
  const __vue_is_functional_template__$18 = false;
  const __vue_component__$18 = normalizeComponent(
    { render: __vue_render__$18, staticRenderFns: __vue_staticRenderFns__$18 },
    __vue_inject_styles__$18,
    __vue_script__$16,
    __vue_scope_id__$18,
    __vue_is_functional_template__$18,
    __vue_module_identifier__$18,
    false,
    undefined,
    undefined,
    undefined
  );

let Tiktok = class Tiktok extends IconMixin$1 {
};
Tiktok = __decorate([
    Component({})
], Tiktok);
var script$15 = Tiktok;

const __vue_script__$15 = script$15;
var __vue_render__$17 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: _vm.size,
            width: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 10 448 512",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$17 = [];
__vue_render__$17._withStripped = true;
  const __vue_inject_styles__$17 = undefined;
  const __vue_scope_id__$17 = undefined;
  const __vue_module_identifier__$17 = undefined;
  const __vue_is_functional_template__$17 = false;
  const __vue_component__$17 = normalizeComponent(
    { render: __vue_render__$17, staticRenderFns: __vue_staticRenderFns__$17 },
    __vue_inject_styles__$17,
    __vue_script__$15,
    __vue_scope_id__$17,
    __vue_is_functional_template__$17,
    __vue_module_identifier__$17,
    false,
    undefined,
    undefined,
    undefined
  );

let Trovo = class Trovo extends IconMixin$1 {
};
Trovo = __decorate([
    Component({})
], Trovo);
var script$14 = Trovo;

const __vue_script__$14 = script$14;
var __vue_render__$16 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: _vm.size,
            width: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 16 16",
          },
        },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M6.01749 0.105127C5.96504 0.116805 5.91128 0.135193 5.87161 0.155034C5.74329 0.21919 5.63375 0.338241 5.5843 0.467259C5.57297 0.496837 5.44734 1.01345 5.2952 1.65613C4.9935 2.93048 5.01477 2.85537 4.93188 2.93906C4.88366 2.98774 4.83704 3.01706 4.76897 3.04149L4.72487 3.05732L3.09636 3.0609C1.54756 3.0643 1.46586 3.06508 1.42714 3.0768C1.22816 3.13709 1.07352 3.28228 1.01426 3.46445C0.990373 3.53789 0.00458469 7.93786 0.000859486 7.98765C-0.0062313 8.08253 0.0310411 8.19376 0.0945799 8.26733C0.136175 8.31549 0.209498 8.3641 0.273091 8.38566L0.327904 8.40425L3.62563 8.41103L3.67181 8.43361C3.73138 8.46274 3.78378 8.51508 3.81323 8.57487C3.83491 8.61889 3.83597 8.62457 3.83583 8.69586C3.83571 8.75621 3.82953 8.80305 3.80382 8.93838C3.73797 9.28498 3.68919 9.65499 3.65239 10.087C3.6378 10.2583 3.63171 10.7309 3.64189 10.9013C3.67437 11.4445 3.76737 11.9301 3.93078 12.4095C4.18656 13.1598 4.60792 13.8326 5.16006 14.3722C6.09458 15.2855 7.42633 15.8204 8.96237 15.8994C9.15375 15.9093 9.62175 15.9035 9.80377 15.889C10.3953 15.842 10.9102 15.7395 11.4187 15.5674C12.0279 15.3611 12.5314 15.0814 12.9922 14.6932C13.1006 14.6018 13.3611 14.3405 13.4544 14.2295C13.9354 13.6576 14.2142 13.0292 14.3004 12.3228C14.3177 12.181 14.3176 11.8111 14.3002 11.668C14.2351 11.1328 14.0426 10.6532 13.7405 10.2736C13.678 10.1951 13.5326 10.0453 13.4543 9.97881C12.9897 9.58408 12.3821 9.40855 11.7173 9.47698C11.3286 9.51697 10.9667 9.66222 10.6993 9.88553C10.3768 10.1548 10.1788 10.5218 10.1146 10.9691C10.1092 11.0064 10.1059 11.095 10.1061 11.1965C10.1063 11.3364 10.1088 11.3766 10.1215 11.4509C10.1979 11.8975 10.4269 12.214 10.7571 12.3295C10.918 12.3857 11.0739 12.3788 11.2069 12.3096C11.3609 12.2294 11.4591 12.0863 11.4593 11.9414C11.4595 11.8718 11.4405 11.8292 11.3817 11.7672C11.2427 11.6206 11.2018 11.5356 11.2017 11.3932C11.2016 11.2383 11.2415 11.1279 11.3339 11.0279C11.4097 10.9458 11.5193 10.8896 11.6474 10.8673C11.7231 10.8541 11.8763 10.8542 11.9463 10.8674C12.2551 10.926 12.4751 11.1621 12.5684 11.5348C12.6913 12.0262 12.549 12.5434 12.1893 12.9122C12.0623 13.0425 11.9412 13.1305 11.7817 13.2085C11.632 13.2817 11.4871 13.3246 11.2866 13.3552C11.1722 13.3727 10.9188 13.3796 10.797 13.3685C10.0538 13.3011 9.40204 12.8764 9.08839 12.255C8.96397 12.0085 8.89161 11.754 8.84921 11.4136C8.83174 11.2734 8.83162 10.8702 8.849 10.7283C8.87715 10.4983 8.91717 10.3149 8.98227 10.1175C9.17306 9.53911 9.51402 9.09297 10.0345 8.74073C10.5422 8.39708 11.1341 8.2038 11.7851 8.16899C11.9261 8.16145 11.9735 8.16306 13.1931 8.21668C13.8872 8.2472 14.4848 8.27212 14.521 8.27205C14.6744 8.27177 14.8135 8.18554 14.8767 8.05157C14.8947 8.01348 15.0099 7.55257 15.4498 5.75793C15.9774 3.6058 16.0004 3.50939 16 3.45088C15.9996 3.37848 15.9871 3.32635 15.954 3.25854C15.913 3.17463 15.8463 3.11617 15.7449 3.07526C15.7195 3.06501 15.5237 3.06383 13.3322 3.06071L10.9471 3.05732L10.9082 3.03823C10.8408 3.00511 10.8012 2.94206 10.8012 2.8677C10.8012 2.83397 10.8619 2.56226 11.0639 1.69205C11.3199 0.589451 11.3267 0.558442 11.3269 0.489033C11.3271 0.431737 11.3239 0.408049 11.3108 0.368063C11.273 0.25269 11.1815 0.158752 11.064 0.114701L11.0218 0.0988708L8.53828 0.0978462C6.60114 0.0970455 6.0466 0.0986469 6.01749 0.105127Z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$16 = [];
__vue_render__$16._withStripped = true;
  const __vue_inject_styles__$16 = undefined;
  const __vue_scope_id__$16 = undefined;
  const __vue_module_identifier__$16 = undefined;
  const __vue_is_functional_template__$16 = false;
  const __vue_component__$16 = normalizeComponent(
    { render: __vue_render__$16, staticRenderFns: __vue_staticRenderFns__$16 },
    __vue_inject_styles__$16,
    __vue_script__$14,
    __vue_scope_id__$16,
    __vue_is_functional_template__$16,
    __vue_module_identifier__$16,
    false,
    undefined,
    undefined,
    undefined
  );

let Twitch = class Twitch extends IconMixin$1 {
};
Twitch = __decorate([
    Component({})
], Twitch);
var script$13 = Twitch;

const __vue_script__$13 = script$13;
var __vue_render__$15 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
      attrs: { height: _vm.size, width: _vm.size },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$15 = [];
__vue_render__$15._withStripped = true;
  const __vue_inject_styles__$15 = undefined;
  const __vue_scope_id__$15 = undefined;
  const __vue_module_identifier__$15 = undefined;
  const __vue_is_functional_template__$15 = false;
  const __vue_component__$15 = normalizeComponent(
    { render: __vue_render__$15, staticRenderFns: __vue_staticRenderFns__$15 },
    __vue_inject_styles__$15,
    __vue_script__$13,
    __vue_scope_id__$15,
    __vue_is_functional_template__$15,
    __vue_module_identifier__$15,
    false,
    undefined,
    undefined,
    undefined
  );

let Youtube = class Youtube extends IconMixin$1 {
};
Youtube = __decorate([
    Component({})
], Youtube);
var script$12 = Youtube;

const __vue_script__$12 = script$12;
var __vue_render__$14 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: _vm.size,
            width: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 576 512",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$14 = [];
__vue_render__$14._withStripped = true;
  const __vue_inject_styles__$14 = undefined;
  const __vue_scope_id__$14 = undefined;
  const __vue_module_identifier__$14 = undefined;
  const __vue_is_functional_template__$14 = false;
  const __vue_component__$14 = normalizeComponent(
    { render: __vue_render__$14, staticRenderFns: __vue_staticRenderFns__$14 },
    __vue_inject_styles__$14,
    __vue_script__$12,
    __vue_scope_id__$14,
    __vue_is_functional_template__$14,
    __vue_module_identifier__$14,
    false,
    undefined,
    undefined,
    undefined
  );

let Twitter = class Twitter extends IconMixin$1 {
};
Twitter = __decorate([
    Component({})
], Twitter);
var script$11 = Twitter;

const __vue_script__$11 = script$11;
var __vue_render__$13 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            width: _vm.size,
            height: _vm.size,
            viewBox: "0 0 1200 1227",
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$13 = [];
__vue_render__$13._withStripped = true;
  const __vue_inject_styles__$13 = undefined;
  const __vue_scope_id__$13 = undefined;
  const __vue_module_identifier__$13 = undefined;
  const __vue_is_functional_template__$13 = false;
  const __vue_component__$13 = normalizeComponent(
    { render: __vue_render__$13, staticRenderFns: __vue_staticRenderFns__$13 },
    __vue_inject_styles__$13,
    __vue_script__$11,
    __vue_scope_id__$13,
    __vue_is_functional_template__$13,
    __vue_module_identifier__$13,
    false,
    undefined,
    undefined,
    undefined
  );

let Linkedin = class Linkedin extends IconMixin$1 {
};
Linkedin = __decorate([
    Component({})
], Linkedin);
var script$10 = Linkedin;

const __vue_script__$10 = script$10;
var __vue_render__$12 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: _vm.size,
            width: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$12 = [];
__vue_render__$12._withStripped = true;
  const __vue_inject_styles__$12 = undefined;
  const __vue_scope_id__$12 = undefined;
  const __vue_module_identifier__$12 = undefined;
  const __vue_is_functional_template__$12 = false;
  const __vue_component__$12 = normalizeComponent(
    { render: __vue_render__$12, staticRenderFns: __vue_staticRenderFns__$12 },
    __vue_inject_styles__$12,
    __vue_script__$10,
    __vue_scope_id__$12,
    __vue_is_functional_template__$12,
    __vue_module_identifier__$12,
    false,
    undefined,
    undefined,
    undefined
  );

let Kevin = class Kevin extends IconMixin$1 {
};
Kevin = __decorate([
    Component({})
], Kevin);
var script$$ = Kevin;

const __vue_script__$$ = script$$;
var __vue_render__$11 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: _vm.size,
            width: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 16 16",
          },
        },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M3.48537 9.38283C3.48537 7.63061 3.48537 6.75451 3.82638 6.08525C4.12633 5.49656 4.60496 5.01793 5.19365 4.71798C5.86291 4.37698 6.73901 4.37698 8.49122 4.37698H10.9941C12.7464 4.37698 13.6225 4.37698 14.2917 4.71798C14.8804 5.01793 15.359 5.49656 15.659 6.08525C16 6.75451 16 7.63061 16 9.38283V10.0979C16 11.8502 16 12.7263 15.659 13.3955C15.359 13.9842 14.8804 14.4628 14.2917 14.7628C13.6225 15.1038 12.7464 15.1038 10.9941 15.1038H6.34586C5.3446 15.1038 4.84396 15.1038 4.46153 14.9089C4.12513 14.7375 3.85164 14.464 3.68023 14.1276C3.48537 13.7452 3.48537 13.2446 3.48537 12.2433V9.38283ZM7.95488 9.74039C7.95488 9.2467 8.3551 8.84649 8.84878 8.84649C9.34247 8.84649 9.74269 9.2467 9.74269 9.74039V11.5282C9.74269 12.0219 9.34247 12.4221 8.84878 12.4221C8.3551 12.4221 7.95488 12.0219 7.95488 11.5282V9.74039ZM12.4244 8.84649C11.9307 8.84649 11.5305 9.2467 11.5305 9.74039V11.5282C11.5305 12.0219 11.9307 12.4221 12.4244 12.4221C12.9181 12.4221 13.3183 12.0219 13.3183 11.5282V9.74039C13.3183 9.2467 12.9181 8.84649 12.4244 8.84649Z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M6.6072 1.67528C6.66812 2.1652 6.32036 2.61174 5.83044 2.67267C5.56038 2.70625 5.34342 2.75194 5.15137 2.81178C3.6088 3.29247 2.40087 4.5004 1.92018 6.04297C1.86034 6.23502 1.81465 6.45199 1.78106 6.72204C1.72014 7.21196 1.2736 7.55972 0.783681 7.4988C0.293767 7.43787 -0.0539984 6.99133 0.00692629 6.50142C0.050682 6.14956 0.115441 5.82523 0.213329 5.51109C0.868809 3.40758 2.51598 1.76041 4.61949 1.10493C4.93363 1.00704 5.25796 0.942284 5.60981 0.898528C6.09973 0.837603 6.54627 1.18537 6.6072 1.67528Z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$11 = [];
__vue_render__$11._withStripped = true;
  const __vue_inject_styles__$11 = undefined;
  const __vue_scope_id__$11 = undefined;
  const __vue_module_identifier__$11 = undefined;
  const __vue_is_functional_template__$11 = false;
  const __vue_component__$11 = normalizeComponent(
    { render: __vue_render__$11, staticRenderFns: __vue_staticRenderFns__$11 },
    __vue_inject_styles__$11,
    __vue_script__$$,
    __vue_scope_id__$11,
    __vue_is_functional_template__$11,
    __vue_module_identifier__$11,
    false,
    undefined,
    undefined,
    undefined
  );

let PlatformIconSwitch = class PlatformIconSwitch extends Vue {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "platform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    Prop(String)
], PlatformIconSwitch.prototype, "platform", void 0);
PlatformIconSwitch = __decorate([
    Component({
        components: {
            Apple: __vue_component__$1c,
            Facebook: __vue_component__$1b,
            Google: __vue_component__$1a,
            Paypal: __vue_component__$19,
            Picarto: __vue_component__$18,
            Tiktok: __vue_component__$17,
            Trovo: __vue_component__$16,
            Twitch: __vue_component__$15,
            Youtube: __vue_component__$14,
            Twitter: __vue_component__$13,
            Linkedin: __vue_component__$12,
            Kevin: __vue_component__$11,
        },
    })
], PlatformIconSwitch);
var script$_ = PlatformIconSwitch;

const __vue_script__$_ = script$_;
var __vue_render__$10 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.platform === "apple"
    ? _c("Apple", {
        staticClass: "block text-apple dark:text-white",
        attrs: { size: 18 },
      })
    : _vm.platform === "facebook"
    ? _c("Facebook", {
        staticClass: "block text-facebook",
        attrs: { size: 18 },
      })
    : _vm.platform === "google"
    ? _c("Google", { staticClass: "block", attrs: { size: 18 } })
    : _vm.platform === "paypal"
    ? _c("Paypal", { staticClass: "block text-paypal", attrs: { size: 18 } })
    : _vm.platform === "picarto"
    ? _c("Picarto", { staticClass: "block text-picarto", attrs: { size: 18 } })
    : _vm.platform === "tiktok"
    ? _c("Tiktok", { staticClass: "block text-tiktok", attrs: { size: 18 } })
    : _vm.platform === "trovo"
    ? _c("Trovo", { staticClass: "block text-trovo", attrs: { size: 18 } })
    : _vm.platform === "twitch"
    ? _c("Twitch", { staticClass: "block text-twitch", attrs: { size: 18 } })
    : _vm.platform === "youtube"
    ? _c("Youtube", { staticClass: "block text-youtube", attrs: { size: 18 } })
    : _vm.platform === "twitter"
    ? _c("Twitter", { staticClass: "block text-twitter", attrs: { size: 18 } })
    : _vm.platform === "linkedin"
    ? _c("Linkedin", {
        staticClass: "block text-linkedin",
        attrs: { size: 18 },
      })
    : _vm.platform === "streamlabs"
    ? _c("Kevin", {
        staticClass: "block text-dark-teal dark:text-teal",
        attrs: { size: 18 },
      })
    : _vm._e()
};
var __vue_staticRenderFns__$10 = [];
__vue_render__$10._withStripped = true;
  const __vue_inject_styles__$10 = undefined;
  const __vue_scope_id__$10 = undefined;
  const __vue_module_identifier__$10 = undefined;
  const __vue_is_functional_template__$10 = false;
  const __vue_component__$10 = normalizeComponent(
    { render: __vue_render__$10, staticRenderFns: __vue_staticRenderFns__$10 },
    __vue_inject_styles__$10,
    __vue_script__$_,
    __vue_scope_id__$10,
    __vue_is_functional_template__$10,
    __vue_module_identifier__$10,
    false,
    undefined,
    undefined,
    undefined
  );

let PlatformButtonMixin = class PlatformButtonMixin extends BaseMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "platform", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "btnStyle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "bg", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disabledColor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disabledBg", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    emitClick(platform) {
        return platform;
    }
    get buttonText() {
        return this.t(`loginButton.${this.type}With`, {
            name: this.t(`brands.${this.platform}`),
        });
    }
};
__decorate([
    Emit('click')
], PlatformButtonMixin.prototype, "emitClick", null);
__decorate([
    Prop(String)
], PlatformButtonMixin.prototype, "platform", void 0);
__decorate([
    Prop(String)
], PlatformButtonMixin.prototype, "type", void 0);
__decorate([
    Prop({ type: String, default: 'sl-btn-outline' })
], PlatformButtonMixin.prototype, "btnStyle", void 0);
__decorate([
    Prop(Boolean)
], PlatformButtonMixin.prototype, "loading", void 0);
__decorate([
    Prop(Boolean)
], PlatformButtonMixin.prototype, "disabled", void 0);
__decorate([
    Prop({ type: String, default: 'disabled:text-white' })
], PlatformButtonMixin.prototype, "bg", void 0);
__decorate([
    Prop({ type: String, default: 'disabled:bg-gray-600' })
], PlatformButtonMixin.prototype, "disabledColor", void 0);
__decorate([
    Prop(String)
], PlatformButtonMixin.prototype, "disabledBg", void 0);
PlatformButtonMixin = __decorate([
    Component({
        components: {
            CircleNotch: __vue_component__$1e,
            ArrowRight: __vue_component__$1d,
            PlatformIconSwitch: __vue_component__$10,
        },
    })
], PlatformButtonMixin);
var PlatformButtonMixin$1 = PlatformButtonMixin;

let PlatformButtonFull = class PlatformButtonFull extends PlatformButtonMixin$1 {
};
PlatformButtonFull = __decorate([
    Component({
        components: {
            CircleNotch: __vue_component__$1e,
            ArrowRight: __vue_component__$1d,
        },
    })
], PlatformButtonFull);
var script$Z = PlatformButtonFull;

const __vue_script__$Z = script$Z;
var __vue_render__$$ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "button",
    {
      staticClass:
        "platform-button-full w-full sl-btn rounded-lg flex items-center justify-between px-4 py-3.5 hover:cursor-pointer hover:drop-shadow-md select-none disabled:cursor-not-allowed",
      class: [_vm.bg, _vm.btnStyle, _vm.disabledColor, _vm.disabledBg],
      attrs: { type: "button", disabled: _vm.disabled || _vm.loading },
      on: {
        click: function ($event) {
          return _vm.$emit("click", _vm.platform)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "platform-button-full__prepend w-8 text-left" },
        [
          _vm._t("prepend", [
            _c("PlatformIconSwitch", { attrs: { platform: _vm.platform } }),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "platform-button-full__text" },
        [
          _vm._t("default", [
            _vm._v("\n      " + _vm._s(_vm.buttonText) + "\n    "),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "platform-button-full__append w-8 text-right" },
        [
          _vm.loading
            ? _c(
                "div",
                [
                  _c("CircleNotch", {
                    staticClass: "animate-spin",
                    attrs: { size: 14 },
                  }),
                ],
                1
              )
            : _vm._t("append", [_c("ArrowRight", { attrs: { size: 14 } })]),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$$ = [];
__vue_render__$$._withStripped = true;
  const __vue_inject_styles__$$ = undefined;
  const __vue_scope_id__$$ = undefined;
  const __vue_module_identifier__$$ = undefined;
  const __vue_is_functional_template__$$ = false;
  const __vue_component__$$ = normalizeComponent(
    { render: __vue_render__$$, staticRenderFns: __vue_staticRenderFns__$$ },
    __vue_inject_styles__$$,
    __vue_script__$Z,
    __vue_scope_id__$$,
    __vue_is_functional_template__$$,
    __vue_module_identifier__$$,
    false,
    undefined,
    undefined,
    undefined
  );

let PlatformButtonIcon = class PlatformButtonIcon extends PlatformButtonMixin$1 {
};
PlatformButtonIcon = __decorate([
    Component({
        components: {
            CircleNotch: __vue_component__$1e,
            ArrowRight: __vue_component__$1d,
        },
    })
], PlatformButtonIcon);
var script$Y = PlatformButtonIcon;

const __vue_script__$Y = script$Y;
var __vue_render__$_ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "button",
    {
      staticClass:
        "platform-button-icon sl-btn sl-btn--icon rounded-lg text-center w-12 px-3 py-3.5 hover:cursor-pointer hover:drop-shadow-md select-none disabled:cursor-not-allowed",
      class: [_vm.bg, _vm.btnStyle, _vm.disabledColor, _vm.disabledBg],
      attrs: {
        type: "button",
        disabled: _vm.disabled || _vm.loading,
        title: _vm.buttonText,
      },
      on: {
        click: function ($event) {
          return _vm.$emit("click", _vm.platform)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "platform-button-icon__icon text-center mx-auto" },
        [
          _vm._t("default", [
            _vm.loading
              ? _c("CircleNotch", {
                  staticClass: "animate-spin",
                  attrs: { size: 14 },
                })
              : _c("PlatformIconSwitch", { attrs: { platform: _vm.platform } }),
          ]),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$_ = [];
__vue_render__$_._withStripped = true;
  const __vue_inject_styles__$_ = function (inject) {
    if (!inject) return
    inject("data-v-d8520e7c_0", { source: ".platform-button-icon i[data-v-d8520e7c] {\n  margin: 0 auto;\n}\n", map: {"version":3,"sources":["PlatformButtonIcon.vue"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB","file":"PlatformButtonIcon.vue","sourcesContent":[".platform-button-icon i {\n  margin: 0 auto;\n}\n"]}, media: undefined });
  };
  const __vue_scope_id__$_ = "data-v-d8520e7c";
  const __vue_module_identifier__$_ = undefined;
  const __vue_is_functional_template__$_ = false;
  const __vue_component__$_ = normalizeComponent(
    { render: __vue_render__$_, staticRenderFns: __vue_staticRenderFns__$_ },
    __vue_inject_styles__$_,
    __vue_script__$Y,
    __vue_scope_id__$_,
    __vue_is_functional_template__$_,
    __vue_module_identifier__$_,
    false,
    createInjector,
    undefined,
    undefined
  );

let PlatformButtons = class PlatformButtons extends Vue {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "heading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "btnStyle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platformButtons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platformIcons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isLoggingIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "loginTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    emitSource(source, resolve) {
        return [source, resolve];
    }
    setLoggingIn(source) {
        this.isLoggingIn = source;
    }
    onClick(name) {
        const resolve = () => {
            this.isLoggingIn = false;
        };
        this.isLoggingIn = name;
        this.emitSource(name, resolve);
        clearTimeout(this.loginTimeout);
        this.loginTimeout = setTimeout(() => {
            resolve();
        }, 2000);
    }
    get hasPlatformOptions() {
        var _a, _b;
        return (!!this.$slots.before ||
            !!this.$slots.after ||
            !!((_a = this.$slots) === null || _a === void 0 ? void 0 : _a.buttons) ||
            !!((_b = this.$slots) === null || _b === void 0 ? void 0 : _b.icons) ||
            this.platformButtons.length > 0 ||
            this.platformIcons.length > 0);
    }
    get hasLead() {
        var _a;
        return !!((_a = this.$slots) === null || _a === void 0 ? void 0 : _a.lead) || !!this.lead;
    }
    get stateProps() {
        return {
            isLoggingIn: this.isLoggingIn,
            setIsLoggingIn: this.setLoggingIn,
            onClick: this.onClick,
        };
    }
};
__decorate([
    Emit('source')
], PlatformButtons.prototype, "emitSource", null);
__decorate([
    Prop(String)
], PlatformButtons.prototype, "heading", void 0);
__decorate([
    Prop({ type: String, default: 'login' })
], PlatformButtons.prototype, "type", void 0);
__decorate([
    Prop({ type: String, default: 'sl-btn-outline' })
], PlatformButtons.prototype, "btnStyle", void 0);
__decorate([
    Prop(String)
], PlatformButtons.prototype, "lead", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], PlatformButtons.prototype, "platformButtons", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], PlatformButtons.prototype, "platformIcons", void 0);
PlatformButtons = __decorate([
    Component({
        components: {
            PlatformButtonFull: __vue_component__$$,
            PlatformButtonIcon: __vue_component__$_,
        },
    })
], PlatformButtons);
var script$X = PlatformButtons;

const __vue_script__$X = script$X;
var __vue_render__$Z = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.hasPlatformOptions,
          expression: "hasPlatformOptions",
        },
      ],
      staticClass: "platform-buttons py-3",
    },
    [
      _c("div", { staticClass: "platform-buttons__top" }, [
        _c("div", { staticClass: "py-3" }, [
          _c(
            "div",
            { staticClass: "platform-buttons__heading" },
            [
              _vm._t(
                "heading",
                [
                  _c(
                    "h4",
                    {
                      staticClass:
                        "pt-4 text-center text-lg text-dark-2 dark:text-white",
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(_vm.heading) + "\n          "
                      ),
                    ]
                  ),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "platform-buttons__lead" },
            [
              _vm._t(
                "lead",
                [
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasLead,
                          expression: "hasLead",
                        },
                      ],
                      staticClass:
                        "text-center pt-2 text-sm text-dark-5 dark:text-light-4 max-w-[400px] mx-auto",
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(_vm.lead) + "\n          "
                      ),
                    ]
                  ),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "platform-buttons__before" }, [
        _c(
          "div",
          { staticClass: "mx-auto max-w-[350px]" },
          [_vm._t("before", null, null, _vm.stateProps)],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "platform-buttons__buttons" },
        [
          _vm._t(
            "buttons",
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.platformButtons.length > 0,
                      expression: "platformButtons.length > 0",
                    },
                  ],
                  staticClass: "grid gap-y-4 mx-auto max-w-[350px] py-3",
                },
                _vm._l(_vm.platformButtons, function (p, i) {
                  return _c("PlatformButtonFull", {
                    key: p + "-" + i,
                    attrs: {
                      type: _vm.type,
                      platform: p,
                      "btn-style": _vm.btnStyle,
                      loading: _vm.isLoggingIn === p,
                    },
                    on: { click: _vm.onClick },
                  })
                }),
                1
              ),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "platform-buttons__after" }, [
        _c(
          "div",
          { staticClass: "mx-auto max-w-[350px]" },
          [_vm._t("after", null, null, _vm.stateProps)],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "platform-buttons__icons" },
        [
          _vm._t(
            "icons",
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.platformIcons.length > 0,
                      expression: "platformIcons.length > 0",
                    },
                  ],
                  staticClass:
                    "grid justify-center gap-4 mx-auto max-w-[350px] py-3",
                },
                _vm._l(_vm.platformIcons, function (p, i) {
                  return _c("PlatformButtonIcon", {
                    key: p + "-" + i,
                    attrs: {
                      type: _vm.type,
                      platform: p,
                      loading: _vm.isLoggingIn === p,
                      "btn-style": _vm.btnStyle,
                    },
                    on: { click: _vm.onClick },
                  })
                }),
                1
              ),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$Z = [];
__vue_render__$Z._withStripped = true;
  const __vue_inject_styles__$Z = function (inject) {
    if (!inject) return
    inject("data-v-3e53e793_0", { source: ".platform-buttons__icons .grid[data-v-3e53e793] {\n  grid-template-columns: repeat(auto-fit, 48px);\n}\n", map: {"version":3,"sources":["PlatformButtons.vue"],"names":[],"mappings":"AAAA;EACE,6CAA6C;AAC/C","file":"PlatformButtons.vue","sourcesContent":[".platform-buttons__icons .grid {\n  grid-template-columns: repeat(auto-fit, 48px);\n}\n"]}, media: undefined });
  };
  const __vue_scope_id__$Z = "data-v-3e53e793";
  const __vue_module_identifier__$Z = undefined;
  const __vue_is_functional_template__$Z = false;
  const __vue_component__$Z = normalizeComponent(
    { render: __vue_render__$Z, staticRenderFns: __vue_staticRenderFns__$Z },
    __vue_inject_styles__$Z,
    __vue_script__$X,
    __vue_scope_id__$Z,
    __vue_is_functional_template__$Z,
    __vue_module_identifier__$Z,
    false,
    createInjector,
    undefined,
    undefined
  );

let ButtonMixin = class ButtonMixin extends Vue {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "loading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    handleClick() {
        if (!this.loading && !this.disabled) {
            this.$emit('click');
        }
    }
};
__decorate([
    Prop(Boolean)
], ButtonMixin.prototype, "loading", void 0);
__decorate([
    Prop(Boolean)
], ButtonMixin.prototype, "disabled", void 0);
ButtonMixin = __decorate([
    Component({})
], ButtonMixin);
var ButtonMixin$1 = ButtonMixin;

let SubmitGoButton = class SubmitGoButton extends ButtonMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "classes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    Prop({ type: String, default: 'sl-btn-one-dark' })
], SubmitGoButton.prototype, "classes", void 0);
SubmitGoButton = __decorate([
    Component({
        components: {
            ArrowRight: __vue_component__$1d,
            CircleNotch: __vue_component__$1e,
        },
    })
], SubmitGoButton);
var script$W = SubmitGoButton;

const __vue_script__$W = script$W;
var __vue_render__$Y = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "button",
    {
      staticClass: "sl-btn w-full whitespace-nowrap py-[14px]",
      class: [{ loading: _vm.loading }, _vm.classes],
      attrs: { type: "submit", disabled: _vm.loading || _vm.disabled },
      on: { click: _vm.handleClick },
    },
    [
      _vm._t("prepend"),
      _vm._v(" "),
      _c("span", [_vm._t("default")], 2),
      _vm._v(" "),
      _vm._t("append", [
        _c(
          "span",
          { staticClass: "pl-2" },
          [
            _vm.loading
              ? _c("CircleNotch", {
                  staticClass: "animate-spin",
                  attrs: { size: 14 },
                })
              : _c("ArrowRight", {
                  staticClass: "pt-[2.5px]",
                  attrs: { size: 14 },
                }),
          ],
          1
        ),
      ]),
    ],
    2
  )
};
var __vue_staticRenderFns__$Y = [];
__vue_render__$Y._withStripped = true;
  const __vue_inject_styles__$Y = undefined;
  const __vue_scope_id__$Y = undefined;
  const __vue_module_identifier__$Y = undefined;
  const __vue_is_functional_template__$Y = false;
  const __vue_component__$Y = normalizeComponent(
    { render: __vue_render__$Y, staticRenderFns: __vue_staticRenderFns__$Y },
    __vue_inject_styles__$Y,
    __vue_script__$W,
    __vue_scope_id__$Y,
    __vue_is_functional_template__$Y,
    __vue_module_identifier__$Y,
    false,
    undefined,
    undefined,
    undefined
  );

const { getCompanyById } = methods;
const getCompany = (companyId) => {
    return getCompanyById(companyId);
};

function Async(asyncOptions) {
    return createDecorator((options, property) => {
        options.data = () => ({ [property]: asyncOptions === null || asyncOptions === void 0 ? void 0 : asyncOptions.default });
        const asyncProperty = `${property}Async`;
        if (!options.computed) {
            options.computed = {};
        }
        options.computed[asyncProperty] = options.computed[property];
        options.watch = {
            [asyncProperty]: {
                immediate: true,
                handler: function (val) {
                    val.then((value) => {
                        this[property] = value;
                        return value;
                    });
                },
            },
        };
        delete options.computed[property];
    });
}
function asyncComputed(promise) {
    const res = typeof promise === 'function' ? promise() : promise;
    return res;
}

const fallbackCompanies = methods.getFallbackCompanies();
let CompanyMixin = class CompanyMixin extends Vue {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "companyId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    get company() {
        const useId = this.companyId || getCompanyId();
        return asyncComputed(() => __awaiter(this, void 0, void 0, function* () {
            const found = fallbackCompanies.find((c) => c.id === useId);
            if (found) {
                const vm = this;
                vm.company = Object.assign(Object.assign({}, found), { fallback: true });
            }
            return (yield getCompany(useId));
        }));
    }
};
__decorate([
    Prop(String)
], CompanyMixin.prototype, "companyId", void 0);
__decorate([
    Async({ default: () => ({}) })
], CompanyMixin.prototype, "company", null);
CompanyMixin = __decorate([
    Component({
        components: {
            i18n: I18n,
        },
    })
], CompanyMixin);
var CompanyMixin$1 = CompanyMixin;

let Alert = class Alert extends Vue {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "color", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "bg", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "padded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    get classes() {
        const c = [];
        if (this.padded) {
            c.push(...['px-4', 'py-2']);
        }
        return c;
    }
};
__decorate([
    Prop({ type: String, default: 'text-error' })
], Alert.prototype, "color", void 0);
__decorate([
    Prop({ type: String, default: 'bg-none' })
], Alert.prototype, "bg", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], Alert.prototype, "padded", void 0);
Alert = __decorate([
    Component({})
], Alert);
var script$V = Alert;

const __vue_script__$V = script$V;
var __vue_render__$X = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "alert mb-2",
      class: [_vm.color, _vm.bg].concat(_vm.classes),
    },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$X = [];
__vue_render__$X._withStripped = true;
  const __vue_inject_styles__$X = undefined;
  const __vue_scope_id__$X = undefined;
  const __vue_module_identifier__$X = undefined;
  const __vue_is_functional_template__$X = false;
  const __vue_component__$X = normalizeComponent(
    { render: __vue_render__$X, staticRenderFns: __vue_staticRenderFns__$X },
    __vue_inject_styles__$X,
    __vue_script__$V,
    __vue_scope_id__$X,
    __vue_is_functional_template__$X,
    __vue_module_identifier__$X,
    false,
    undefined,
    undefined,
    undefined
  );

let CheckCircle = class CheckCircle extends IconMixin$1 {
};
CheckCircle = __decorate([
    Component({})
], CheckCircle);
var script$U = CheckCircle;

const __vue_script__$U = script$U;
var __vue_render__$W = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: _vm.size,
            width: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM371.8 211.8C382.7 200.9 382.7 183.1 371.8 172.2C360.9 161.3 343.1 161.3 332.2 172.2L224 280.4L179.8 236.2C168.9 225.3 151.1 225.3 140.2 236.2C129.3 247.1 129.3 264.9 140.2 275.8L204.2 339.8C215.1 350.7 232.9 350.7 243.8 339.8L371.8 211.8z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$W = [];
__vue_render__$W._withStripped = true;
  const __vue_inject_styles__$W = undefined;
  const __vue_scope_id__$W = undefined;
  const __vue_module_identifier__$W = undefined;
  const __vue_is_functional_template__$W = false;
  const __vue_component__$W = normalizeComponent(
    { render: __vue_render__$W, staticRenderFns: __vue_staticRenderFns__$W },
    __vue_inject_styles__$W,
    __vue_script__$U,
    __vue_scope_id__$W,
    __vue_is_functional_template__$W,
    __vue_module_identifier__$W,
    false,
    undefined,
    undefined,
    undefined
  );

let CircleExclamation = class CircleExclamation extends IconMixin$1 {
};
CircleExclamation = __decorate([
    Component({})
], CircleExclamation);
var script$T = CircleExclamation;

const __vue_script__$T = script$T;
var __vue_render__$V = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: _vm.size,
            width: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$V = [];
__vue_render__$V._withStripped = true;
  const __vue_inject_styles__$V = undefined;
  const __vue_scope_id__$V = undefined;
  const __vue_module_identifier__$V = undefined;
  const __vue_is_functional_template__$V = false;
  const __vue_component__$V = normalizeComponent(
    { render: __vue_render__$V, staticRenderFns: __vue_staticRenderFns__$V },
    __vue_inject_styles__$V,
    __vue_script__$T,
    __vue_scope_id__$V,
    __vue_is_functional_template__$V,
    __vue_module_identifier__$V,
    false,
    undefined,
    undefined,
    undefined
  );

var __vue_render__$U = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [
    _c(
      "h2",
      { staticClass: "sl-card__title py-2 text-3xl font-normal text-center" },
      [_vm._t("default")],
      2
    ),
  ])
};
var __vue_staticRenderFns__$U = [];
__vue_render__$U._withStripped = true;
  const __vue_inject_styles__$U = undefined;
  const __vue_scope_id__$U = undefined;
  const __vue_module_identifier__$U = undefined;
  const __vue_is_functional_template__$U = false;
  const __vue_component__$U = normalizeComponent(
    { render: __vue_render__$U, staticRenderFns: __vue_staticRenderFns__$U },
    __vue_inject_styles__$U,
    {},
    __vue_scope_id__$U,
    __vue_is_functional_template__$U,
    __vue_module_identifier__$U,
    false,
    undefined,
    undefined,
    undefined
  );

var __vue_render__$T = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "p",
    { staticClass: "text-md pt-1 pb-3 text-center leading-relaxed" },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$T = [];
__vue_render__$T._withStripped = true;
  const __vue_inject_styles__$T = undefined;
  const __vue_scope_id__$T = undefined;
  const __vue_module_identifier__$T = undefined;
  const __vue_is_functional_template__$T = false;
  const __vue_component__$T = normalizeComponent(
    { render: __vue_render__$T, staticRenderFns: __vue_staticRenderFns__$T },
    __vue_inject_styles__$T,
    {},
    __vue_scope_id__$T,
    __vue_is_functional_template__$T,
    __vue_module_identifier__$T,
    false,
    undefined,
    undefined,
    undefined
  );

let Card = class Card extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    get stateProps() {
        return {
            company: this.company,
            title: this.title,
            lead: this.lead,
            errorMessage: this.errorMessage,
        };
    }
};
__decorate([
    Prop({ type: String, default: '' })
], Card.prototype, "title", void 0);
__decorate([
    Prop({ type: String, default: '' })
], Card.prototype, "lead", void 0);
__decorate([
    Prop({ type: String, default: '' })
], Card.prototype, "errorMessage", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], Card.prototype, "dark", void 0);
Card = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            CircleExclamation: __vue_component__$V,
            I18n,
            CardTitle: __vue_component__$U,
            CardLead: __vue_component__$T,
        },
    })
], Card);
var script$S = Card;

const __vue_script__$S = script$S;
var __vue_render__$S = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "sl-one-component" }, [
    _c("div", { staticClass: "sl-card max-w-card w-[600px]" }, [
      _c(
        "div",
        { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
        [
          _c(
            "div",
            {
              staticClass:
                "max-h-card text-dark-2 flex flex-col bg-white dark:bg-dark-2 dark:text-light-3 p-6 md:p-10 rounded-2xl flex flex-col justify-center items-center",
            },
            [
              !_vm.company
                ? _c("div", { staticClass: "sl-card__not-found" }, [
                    _c("h1", [_vm._v(_vm._s(_vm.t("card.404.title")))]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.t("card.404.desc")))]),
                  ])
                : [
                    _c(
                      "div",
                      { staticClass: "sl-card__logo" },
                      [
                        _vm._t(
                          "logo",
                          [
                            _c("img", {
                              staticClass:
                                "sl-card__logo-img max-w-full max-h-[60px] pb-2",
                              attrs: {
                                src: _vm.company.logoThumb,
                                alt: _vm.t("card.company.logoAlt", {
                                  company: _vm.company.name,
                                }),
                              },
                            }),
                          ],
                          null,
                          _vm.stateProps
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "sl-card__title" },
                      [
                        _vm._t(
                          "title",
                          [
                            _c(
                              "CardTitle",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.title,
                                    expression: "title",
                                  },
                                ],
                              },
                              [
                                _c("I18n", {
                                  attrs: {
                                    message: _vm.t(_vm.title, {
                                      company: _vm.company.name,
                                    }),
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "id",
                                      fn: function (text) {
                                        return [_c("b", [_vm._v(_vm._s(text))])]
                                      },
                                    },
                                    {
                                      key: "company",
                                      fn: function (text) {
                                        return [_c("b", [_vm._v(_vm._s(text))])]
                                      },
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                          ],
                          null,
                          _vm.stateProps
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "sl-card__subtitle" },
                      [_vm._t("subtitle")],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "sl-card__lead" },
                      [
                        _vm._t(
                          "lead",
                          [
                            _c(
                              "CardLead",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !!_vm.lead,
                                    expression: "!!lead",
                                  },
                                ],
                              },
                              [
                                _c("I18n", {
                                  attrs: {
                                    message: _vm.t(_vm.lead, {
                                      company: _vm.company.name,
                                    }),
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "b",
                                      fn: function (text) {
                                        return [_c("b", [_vm._v(_vm._s(text))])]
                                      },
                                    },
                                    {
                                      key: "id",
                                      fn: function (text) {
                                        return [_c("b", [_vm._v(_vm._s(text))])]
                                      },
                                    },
                                    {
                                      key: "company",
                                      fn: function (text) {
                                        return [_c("b", [_vm._v(_vm._s(text))])]
                                      },
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                          ],
                          null,
                          _vm.stateProps
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "sl-card__error" },
                      [
                        _vm._t(
                          "error",
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errorMessage,
                                    expression: "errorMessage",
                                  },
                                ],
                                staticClass: "pt-3 pb-1",
                              },
                              [
                                _c(
                                  "Alert",
                                  {
                                    staticClass:
                                      "flex text-sm items-center font-medium",
                                  },
                                  [
                                    _c("CircleExclamation", {
                                      staticClass: "mr-2",
                                      attrs: { size: 14 },
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.errorMessage) +
                                        "\n                "
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          null,
                          _vm.stateProps
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "sl-card__default-content w-full" },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !!_vm.$slots.default,
                                expression: "!!$slots.default",
                              },
                            ],
                            staticClass: "pt-3 pb-4",
                          },
                          [_vm._t("default")],
                          2
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "sl-card__footer" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !!_vm.$slots.footer,
                              expression: "!!$slots.footer",
                            },
                          ],
                          staticClass: "pt-6 pb-3",
                        },
                        [_vm._t("footer", null, null, _vm.stateProps)],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "sl-card__powered-by pt-3 font-caveat mt-auto",
                      },
                      [
                        _c("I18n", {
                          staticClass: "font-caveat",
                          attrs: { message: _vm.t("poweredBy") },
                          scopedSlots: _vm._u([
                            {
                              key: "company",
                              fn: function (text) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "pl-0.5 font-caveat font-medium text-lg",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(text) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
            ],
            2
          ),
        ]
      ),
    ]),
  ])
};
var __vue_staticRenderFns__$S = [];
__vue_render__$S._withStripped = true;
  const __vue_inject_styles__$S = undefined;
  const __vue_scope_id__$S = undefined;
  const __vue_module_identifier__$S = undefined;
  const __vue_is_functional_template__$S = false;
  const __vue_component__$S = normalizeComponent(
    { render: __vue_render__$S, staticRenderFns: __vue_staticRenderFns__$S },
    __vue_inject_styles__$S,
    __vue_script__$S,
    __vue_scope_id__$S,
    __vue_is_functional_template__$S,
    __vue_module_identifier__$S,
    false,
    undefined,
    undefined,
    undefined
  );

let FormMixin = class FormMixin extends BaseMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "defaultState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "validate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "submit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onResetForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onResetErrors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "formDisabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "resetFormOnSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isSubmitting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "hasSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isValid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "form", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "formErrors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "dirty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "blurred", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "trackBlurred", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
    validateForm() {
        throw new Error('Parent must extend method: validateForm()');
    }
    onSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('Parent must extend method: validateForm()');
        });
    }
    beforeMount() {
        this.form = Object.assign({}, this.defaultState);
        this.formErrors = this.makeErrorObj();
        this.dirty = this.makeFieldBooleans();
        this.blurred = this.makeFieldBooleans();
        setTimeout(() => {
            this.trackBlurred = true;
        }, 2000);
    }
    setHasSuccess(bool) {
        this.hasSuccess = bool;
    }
    makeFieldBooleans() {
        const booleans = {};
        Object.entries(this.defaultState).map(([key]) => {
            booleans[key] = false;
        });
        return booleans;
    }
    makeErrorObj() {
        const defaultErrors = {};
        Object.entries(this.defaultState).map(([key]) => {
            defaultErrors[key] = '';
        });
        return defaultErrors;
    }
    resetDirty() {
        Object.assign(this.dirty, this.makeFieldBooleans());
    }
    resetBlurred() {
        Object.assign(this.blurred, this.makeFieldBooleans());
    }
    resetForm() {
        return __awaiter(this, void 0, void 0, function* () {
            Object.assign(this.form, Object.assign({}, this.defaultState));
            this.resetBlurred();
            this.resetDirty();
            if (typeof this.onResetForm === 'function') {
                yield this.onResetForm();
            }
        });
    }
    resetErrors() {
        return __awaiter(this, void 0, void 0, function* () {
            Object.assign(this.formErrors, this.makeErrorObj());
            if (typeof this.onResetErrors === 'function') {
                yield this.onResetErrors();
            }
        });
    }
    setValid(isValid) {
        this.isValid = isValid;
    }
    setSubmitting(isSubmitting) {
        this.isSubmitting = isSubmitting;
    }
    handleFieldFocus(e) {
        const target = e.target;
        if (target.name) {
            const name = target.name;
            this.blurred[name] = false;
        }
        else {
            console.warn('Field not given name attribute');
        }
    }
    handleFieldBlur(e) {
        const target = e.target;
        if (target.name) {
            const name = target.name;
            if (this.trackBlurred) {
                this.blurred[name] = true;
            }
        }
        else {
            console.warn('Field not given name attribute');
        }
    }
    handleFieldChange(e) {
        const target = e.target;
        if (target.name) {
            const name = target.name;
            this.dirty[name] = true;
            if (!target.value.length) {
                this.handleFieldFocus(e);
            }
        }
        else {
            console.warn('Field not given name attribute');
        }
    }
    formatSubmitData(data) {
        return data;
    }
    handleSubmit(submit, onSuccess, onError) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isSubmitting || !this.isValid) {
                return false;
            }
            this.resetErrors();
            this.setHasSuccess(false);
            this.setSubmitting(true);
            this.resetBlurred();
            try {
                const data = this.formatSubmitData(Object.assign({}, this.form));
                const res = yield submit(data);
                if (this.resetFormOnSuccess) {
                    this.resetForm();
                }
                this.setHasSuccess(true);
                this.setSubmitting(false);
                setTimeout(() => {
                    this.setHasSuccess(false);
                }, 4000);
                onSuccess(res);
                return true;
            }
            catch (err) {
                this.setSubmitting(false);
                if (err instanceof ApiError) {
                    const errorData = err.data;
                    const message = errorData.message || err.message;
                    if (Object.keys(errorData.errors || {}).length > 0) {
                        Object.entries(errorData.errors).map(([key, val]) => {
                            if ((val === null || val === void 0 ? void 0 : val.length) && (val === null || val === void 0 ? void 0 : val[0]) !== message) {
                                this.formErrors[key] = val[0];
                                this.blurred[key] = true;
                            }
                        });
                    }
                    onError(message);
                }
                else if (err instanceof TypeError) {
                    onError(err.message || this.t('errors.unknown'));
                    console.warn('caught error', err, err.message);
                }
                else {
                    console.warn('unhandled error from submit', err);
                    onError(this.t('errors.tryAgain'));
                }
                return false;
            }
        });
    }
    getStateProps() {
        const { isValid, isSubmitting, form, formErrors, setValid, setSubmitting, resetForm, resetErrors, validateForm, onSubmit, hasSuccess, setHasSuccess, } = this;
        return {
            isValid,
            isSubmitting,
            form,
            errors: formErrors,
            setValid,
            setSubmitting,
            resetForm,
            resetErrors,
            validateForm,
            onSubmit,
            hasSuccess,
            setHasSuccess,
        };
    }
    get stateProps() {
        return this.getStateProps();
    }
    formWatcher() {
        this.isValid = this.validateForm();
    }
    defaultStateWatcher() {
        this.resetForm();
    }
};
__decorate([
    Prop(Function)
], FormMixin.prototype, "validate", void 0);
__decorate([
    Prop(Function)
], FormMixin.prototype, "submit", void 0);
__decorate([
    Prop(Function)
], FormMixin.prototype, "onResetForm", void 0);
__decorate([
    Prop(Function)
], FormMixin.prototype, "onResetErrors", void 0);
__decorate([
    Prop(Boolean)
], FormMixin.prototype, "formDisabled", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], FormMixin.prototype, "resetFormOnSuccess", void 0);
__decorate([
    Watch('form', { deep: true })
], FormMixin.prototype, "formWatcher", null);
__decorate([
    Watch('defaultState', { deep: true })
], FormMixin.prototype, "defaultStateWatcher", null);
FormMixin = __decorate([
    Component({})
], FormMixin);
var FormMixin$1 = FormMixin;

const t = (path) => {
    return vueI18nService.client.t(path);
};
const validateEmail = (value) => {
    const v = !!String(value).match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    return [v, v ? '' : t('validation.email.invalid')];
};
const validatePasswordExistence = (value) => {
    let msg = '';
    if (String(value).trim().length < 1) {
        msg = t('validation.password.required');
    }
    return [!msg.length, msg];
};
const validatePassword = (value) => {
    let msg = '';
    if (value.length < 8) {
        msg = t('validation.password.min');
    }
    else if (!value.match(/[0-9]/)) {
        msg = t('validation.password.number');
    }
    else if (!value.match(/[A-Z]/)) {
        msg = t('validation.password.upper');
    }
    else if (value.match(/^[a-zA-Z0-9]+$/)) {
        msg = t('validation.password.special');
    }
    return [!msg.length, msg];
};
const validateUsername = (value) => {
    const v = value.length >= 5;
    return [v, v ? '' : t('validation.username.invalid')];
};
const validateCode = (value) => {
    const v = value.length >= 6 || value.length > 10;
    return [v, v ? '' : t('validation.code.minmax')];
};
function getAge(dateString) {
    const today = new Date();
    const birthDate = new Date(dateString);
    let age = today.getUTCFullYear() - birthDate.getUTCFullYear();
    const m = today.getUTCMonth() - birthDate.getUTCMonth();
    if (m < 0 || (m === 0 && today.getUTCDate() < birthDate.getUTCDate())) {
        age--;
    }
    return age;
}
const validateAge = (dateString, minAge, validateMinAge = true) => {
    const t = vueI18nService.client.t.bind(vueI18nService);
    const d = new Date(dateString);
    const n = new Date();
    if (d.toString() === 'Invalid Date' || !dateString.trim().length) {
        return [false, t('ageInput.invalidDate')];
    }
    if (d > n) {
        return [false, t('ageInput.futureDate')];
    }
    if (d.getFullYear() < 1900) {
        return [false, t('ageInput.minDate', { year: 1900 })];
    }
    const age = getAge(dateString);
    if (age < minAge && validateMinAge) {
        return [false, t('ageInput.minAge', { count: minAge, years: minAge })];
    }
    return [true, ''];
};

let InputError = class InputError extends Vue {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "text", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dirty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    Prop({ type: String, default: '' })
], InputError.prototype, "text", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], InputError.prototype, "dirty", void 0);
InputError = __decorate([
    Component({
        components: {
            CircleExclamation: __vue_component__$V,
            Alert: __vue_component__$X,
        },
    })
], InputError);
var script$R = InputError;

const __vue_script__$R = script$R;
var __vue_render__$R = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Alert",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.dirty && _vm.text.length,
          expression: "dirty && text.length",
        },
      ],
      staticClass: "text-sm font-medium flex items-start mt-1 text-left",
    },
    [
      _c("CircleExclamation", {
        staticClass: "mr-2 pt-[2px]",
        attrs: { size: 14 },
      }),
      _vm._v(" "),
      _c("div", [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]),
    ],
    1
  )
};
var __vue_staticRenderFns__$R = [];
__vue_render__$R._withStripped = true;
  const __vue_inject_styles__$R = undefined;
  const __vue_scope_id__$R = "data-v-e49bbc42";
  const __vue_module_identifier__$R = undefined;
  const __vue_is_functional_template__$R = false;
  const __vue_component__$R = normalizeComponent(
    { render: __vue_render__$R, staticRenderFns: __vue_staticRenderFns__$R },
    __vue_inject_styles__$R,
    __vue_script__$R,
    __vue_scope_id__$R,
    __vue_is_functional_template__$R,
    __vue_module_identifier__$R,
    false,
    undefined,
    undefined,
    undefined
  );

let DobInput = class DobInput extends Vue {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "modelValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "label", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "placeholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    onInput(e) {
        this.$emit('input', e);
    }
    onBlur(e) {
        this.$emit('blur', e);
    }
    get computedClasses() {
        const obj = {};
        if (!this.modelValue.length) {
            obj['dob-input--empty'] = true;
        }
        return obj;
    }
};
__decorate([
    ModelSync('value', 'update:value', { type: String })
], DobInput.prototype, "modelValue", void 0);
__decorate([
    Prop(String)
], DobInput.prototype, "label", void 0);
__decorate([
    Prop(String)
], DobInput.prototype, "placeholder", void 0);
__decorate([
    Prop(String)
], DobInput.prototype, "error", void 0);
__decorate([
    Prop(Boolean)
], DobInput.prototype, "disabled", void 0);
DobInput = __decorate([
    Component({
        components: {
            InputError: __vue_component__$R,
        },
    })
], DobInput);
var script$Q = DobInput;

const __vue_script__$Q = script$Q;
var __vue_render__$Q = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "dob-input", class: _vm.computedClasses },
    [
      _c(
        "label",
        {
          staticClass:
            "dob-input__field-label block text-dark-5 dark:text-light-4 text-sm mb-1",
        },
        [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.modelValue,
            expression: "modelValue",
          },
        ],
        staticClass: "sl-form-control theme-dark w-full",
        attrs: {
          name: "dob",
          type: "date",
          min: "1900-01-01",
          max: "2100-01-01",
          autocomplete: "username",
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
        },
        domProps: { value: _vm.modelValue },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.modelValue = $event.target.value;
            },
            _vm.onInput,
          ],
          blur: _vm.onBlur,
        },
      }),
      _vm._v(" "),
      _c("InputError", {
        attrs: { dirty: !!_vm.error.length, text: _vm.error },
      }),
    ],
    1
  )
};
var __vue_staticRenderFns__$Q = [];
__vue_render__$Q._withStripped = true;
  const __vue_inject_styles__$Q = function (inject) {
    if (!inject) return
    inject("data-v-dc5647de_0", { source: ".dob-input--empty .sl-form-control[data-v-dc5647de]:not(:focus) {\n  color: #4f5e65;\n}\n", map: {"version":3,"sources":["DobInput.vue"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB","file":"DobInput.vue","sourcesContent":[".dob-input--empty .sl-form-control:not(:focus) {\n  color: #4f5e65;\n}\n"]}, media: undefined });
  };
  const __vue_scope_id__$Q = "data-v-dc5647de";
  const __vue_module_identifier__$Q = undefined;
  const __vue_is_functional_template__$Q = false;
  const __vue_component__$Q = normalizeComponent(
    { render: __vue_render__$Q, staticRenderFns: __vue_staticRenderFns__$Q },
    __vue_inject_styles__$Q,
    __vue_script__$Q,
    __vue_scope_id__$Q,
    __vue_is_functional_template__$Q,
    __vue_module_identifier__$Q,
    false,
    createInjector,
    undefined,
    undefined
  );

let AgeGateForm = class AgeGateForm extends FormMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "noAgeGate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showFooter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "validateMinAge", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ageLabel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "agePlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "buttonText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultFormState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ageGate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                dob: '',
            }
        });
    }
    validateForm() {
        var _a;
        if (this.validate) {
            return this.validate(this.form, this.formErrors);
        }
        let dobValid;
        [dobValid, this.formErrors.dob] = validateAge(this.form.dob, ((_a = this.ageGate) === null || _a === void 0 ? void 0 : _a.required) ? Number(this.ageGate.minAge) : 0, this.validateMinAge);
        return dobValid;
    }
    defaultSubmit(form) {
        return __awaiter(this, void 0, void 0, function* () {
        });
    }
    onSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            const submitMethod = this.submit ? this.submit : this.defaultSubmit;
            return this.handleSubmit(submitMethod, (result) => {
                this.$emit('success', result);
            }, (message) => this.$emit('error', message));
        });
    }
    onCustomBlur(e) {
        this.handleFieldBlur(e);
        if (this.formErrors.dob && this.dirty.dob) {
            this.$emit('blur:invalid', 'dob', this.formErrors.dob, this.form.dob.length === 10);
        }
    }
    get tr() {
        return {
            ageLabel: this.ageLabel || this.t('ageGateForm.ageLabel'),
            agePlaceholder: this.agePlaceholder || this.t('ageGateForm.agePlaceholder'),
            buttonText: this.buttonText || this.t('actions.continue'),
        };
    }
    get stateProps() {
        return Object.assign({}, this.getStateProps());
    }
    defaultFormStateWatcher() {
        this.defaultState = Object.assign({ dob: '' }, this.defaultFormState);
        this.form = Object.assign({ dob: '' }, this.defaultFormState);
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], AgeGateForm.prototype, "dark", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], AgeGateForm.prototype, "noAgeGate", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], AgeGateForm.prototype, "showFooter", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], AgeGateForm.prototype, "validateMinAge", void 0);
__decorate([
    Prop({ type: String, default: '' })
], AgeGateForm.prototype, "ageLabel", void 0);
__decorate([
    Prop({ type: String, default: '' })
], AgeGateForm.prototype, "agePlaceholder", void 0);
__decorate([
    Prop({ type: String, default: '' })
], AgeGateForm.prototype, "buttonText", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], AgeGateForm.prototype, "defaultFormState", void 0);
__decorate([
    Prop({ type: Object, default: undefined })
], AgeGateForm.prototype, "ageGate", void 0);
__decorate([
    Watch('defaultFormState')
], AgeGateForm.prototype, "defaultFormStateWatcher", null);
AgeGateForm = __decorate([
    Component({
        components: {
            SubmitGoButton: __vue_component__$Y,
            InputError: __vue_component__$R,
            DobInput: __vue_component__$Q,
        },
    })
], AgeGateForm);
var script$P = AgeGateForm;

const __vue_script__$P = script$P;
var __vue_render__$P = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "sl-one-component mx-auto max-w-full" }, [
    _c(
      "div",
      { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
      [
        _c("div", { staticClass: "age-gate-form text-center" }, [
          _c(
            "div",
            { staticClass: "age-gate-form__header" },
            [_vm._t("header", null, null, _vm.stateProps)],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "age-gate-form__form" },
            [
              _vm._t(
                "form",
                [
                  _c(
                    "form",
                    {
                      staticClass: "w-[300px] mx-auto text-left",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault();
                          return _vm.onSubmit($event)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "age-gate-form__age" },
                        [
                          _vm._t(
                            "ageInput",
                            [
                              _c(
                                "div",
                                { staticClass: "mb-4" },
                                [
                                  _c("DobInput", {
                                    attrs: {
                                      label: _vm.tr.ageLabel,
                                      placeholder: _vm.tr.agePlaceholder,
                                      error:
                                        _vm.dirty.dob &&
                                        _vm.blurred.dob &&
                                        !!_vm.formErrors.dob
                                          ? _vm.formErrors.dob
                                          : "",
                                    },
                                    on: {
                                      input: _vm.handleFieldChange,
                                      blur: _vm.onCustomBlur,
                                    },
                                    model: {
                                      value: _vm.form.dob,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "dob", $$v);
                                      },
                                      expression: "form.dob",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            null,
                            _vm.stateProps
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "age-gate-form__button" },
                        [
                          _vm._t(
                            "button",
                            [
                              _c(
                                "SubmitGoButton",
                                {
                                  attrs: {
                                    disabled: _vm.isSubmitting || !_vm.isValid,
                                    loading: _vm.isSubmitting,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.tr.buttonText) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ],
                            null,
                            _vm.stateProps
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "age-gate-form__footer" },
            [_vm._t("footer", null, null, _vm.stateProps)],
            2
          ),
        ]),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$P = [];
__vue_render__$P._withStripped = true;
  const __vue_inject_styles__$P = undefined;
  const __vue_scope_id__$P = undefined;
  const __vue_module_identifier__$P = undefined;
  const __vue_is_functional_template__$P = false;
  const __vue_component__$P = normalizeComponent(
    { render: __vue_render__$P, staticRenderFns: __vue_staticRenderFns__$P },
    __vue_inject_styles__$P,
    __vue_script__$P,
    __vue_scope_id__$P,
    __vue_is_functional_template__$P,
    __vue_module_identifier__$P,
    false,
    undefined,
    undefined,
    undefined
  );

let HaveIdFooter = class HaveIdFooter extends BaseMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "company", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    get text() {
        var _a;
        return ((_a = this.company) === null || _a === void 0 ? void 0 : _a.name)
            ? this.t('alreadyHaveAccount.company', { company: this.company.name })
            : this.t('alreadyHaveAccount.text');
    }
};
__decorate([
    Prop(Object)
], HaveIdFooter.prototype, "company", void 0);
HaveIdFooter = __decorate([
    Component({})
], HaveIdFooter);
var script$O = HaveIdFooter;

const __vue_script__$O = script$O;
var __vue_render__$O = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("p", { staticClass: "text-dark-5 text-sm dark:text-light-3" }, [
    _vm._v("\n  " + _vm._s(_vm.text) + "\n  "),
    _c(
      "a",
      {
        staticClass: "cursor-pointer underline sl-btn-link-dark-5",
        attrs: { href: "#" },
        on: {
          click: function ($event) {
            $event.preventDefault();
            return _vm.$emit("click")
          },
        },
      },
      [_vm._v("\n    " + _vm._s(_vm.t("alreadyHaveAccount.link")) + "\n  ")]
    ),
  ])
};
var __vue_staticRenderFns__$O = [];
__vue_render__$O._withStripped = true;
  const __vue_inject_styles__$O = undefined;
  const __vue_scope_id__$O = undefined;
  const __vue_module_identifier__$O = undefined;
  const __vue_is_functional_template__$O = false;
  const __vue_component__$O = normalizeComponent(
    { render: __vue_render__$O, staticRenderFns: __vue_staticRenderFns__$O },
    __vue_inject_styles__$O,
    __vue_script__$O,
    __vue_scope_id__$O,
    __vue_is_functional_template__$O,
    __vue_module_identifier__$O,
    false,
    undefined,
    undefined,
    undefined
  );

let AgeGateCard = class AgeGateCard extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showFooter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "noAgeGate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "validateMinAge", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ageLabel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "agePlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "submitButtonText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ageGate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "hasSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "ageGateInternal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                required: false,
                minAge: 0,
            }
        });
    }
    setErrorMessage(msg) {
        this.errorMessage = msg;
    }
    setHasSuccess(bool) {
        this.hasSuccess = bool;
    }
    onSuccess(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setErrorMessage('');
            if (typeof this.success === 'function') {
                yield this.success(data);
            }
            else {
                this.$emit('success', data);
                this.setHasSuccess(true);
                setTimeout(() => this.setHasSuccess(false), 4000);
            }
        });
    }
    onError(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.error === 'function') {
                yield this.error(msg);
            }
            else {
                this.setErrorMessage(msg);
                this.$emit('error', msg);
            }
        });
    }
    onClickLogin() {
        this.$emit('redirect', 'login');
    }
    onBlurInvalid(field, message, complete) {
        this.$emit('blur:invalid', field, message, complete);
    }
    loadAgeGate() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { ageGate } = yield feSdk__default.api.auth.getLocaleInfo();
                if (!this.ageGate) {
                    this.ageGateInternal = ageGate;
                }
            }
            catch (_a) {
            }
        });
    }
    get tr() {
        return {
            title: this.title || this.t('ageGateCard.title'),
            lead: this.lead || this.ageGateInternal.minAge
                ? this.t('ageGateCard.lead.years', {
                    years: this.ageGateInternal.minAge,
                })
                : this.t('ageGateCard.lead.noYears'),
            ageLabel: this.ageLabel,
            agePlaceholder: this.agePlaceholder,
            submitButtonText: this.submitButtonText,
        };
    }
    ageGateWatcher() {
        this.ageGateInternal = Object.assign({ required: false, minAge: 0 }, this.ageGate);
    }
    get stateProps() {
        return {
            company: this.company,
            errorMessage: this.errorMessage,
            hasSuccess: this.hasSuccess,
            setErrorMessage: this.setErrorMessage,
            setHasSuccess: this.setHasSuccess,
            onSuccess: this.onSuccess,
            onError: this.onError,
            ageGate: this.ageGateInternal,
        };
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    mounted() {
        if (!this.ageGate && !this.noAgeGate) {
            this.loadAgeGate();
        }
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], AgeGateCard.prototype, "dark", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], AgeGateCard.prototype, "showFooter", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], AgeGateCard.prototype, "noAgeGate", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], AgeGateCard.prototype, "validateMinAge", void 0);
__decorate([
    Prop(String)
], AgeGateCard.prototype, "title", void 0);
__decorate([
    Prop(String)
], AgeGateCard.prototype, "lead", void 0);
__decorate([
    Prop(String)
], AgeGateCard.prototype, "ageLabel", void 0);
__decorate([
    Prop(String)
], AgeGateCard.prototype, "agePlaceholder", void 0);
__decorate([
    Prop(String)
], AgeGateCard.prototype, "submitButtonText", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], AgeGateCard.prototype, "defaultState", void 0);
__decorate([
    Prop({ type: Object, default: undefined })
], AgeGateCard.prototype, "ageGate", void 0);
__decorate([
    Prop(Function)
], AgeGateCard.prototype, "success", void 0);
__decorate([
    Prop(Function)
], AgeGateCard.prototype, "error", void 0);
__decorate([
    Watch('ageGate', { deep: true, immediate: true })
], AgeGateCard.prototype, "ageGateWatcher", null);
AgeGateCard = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            CheckCircle: __vue_component__$W,
            Card: __vue_component__$S,
            AgeGateForm: __vue_component__$P,
            HaveIdFooter: __vue_component__$O,
        },
    })
], AgeGateCard);
var script$N = AgeGateCard;

const __vue_script__$N = script$N;
var __vue_render__$N = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    {
      staticClass: "age-gate-card",
      attrs: {
        "company-id": _vm.companyId,
        dark: _vm.dark,
        "error-message": _vm.errorMessage,
        title: _vm.tr.title,
        lead: _vm.tr.lead,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "logo",
            fn: function () {
              return [_vm._t("logo", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [_vm._t("title", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "lead",
            fn: function () {
              return [_vm._t("lead", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [_vm._t("error", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _vm._t(
                  "footer",
                  [
                    _vm.showFooter
                      ? _c(
                          "div",
                          [
                            _c("HaveIdFooter", {
                              on: { click: _vm.onClickLogin },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  null,
                  _vm.stateProps
                ),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "age-gate-card__form relative" },
        [
          _vm._t(
            "form",
            [
              _c("AgeGateForm", {
                attrs: {
                  dark: _vm.dark,
                  "default-form-state": _vm.defaultState,
                  "age-gate": _vm.ageGateInternal,
                  "validate-min-age": _vm.validateMinAge,
                },
                on: {
                  "blur:invalid": _vm.onBlurInvalid,
                  success: _vm.onSuccess,
                  error: _vm.onError,
                  reset: function ($event) {
                    return _vm.setErrorMessage("")
                  },
                },
              }),
            ],
            null,
            _vm.stateProps
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "age-gate-card__success" },
            [
              _vm._t(
                "success",
                [
                  _c(
                    "Alert",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasSuccess,
                          expression: "hasSuccess",
                        },
                      ],
                      staticClass:
                        "absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center p-5",
                      attrs: { bg: "bg-white", color: "text-emerald-900" },
                    },
                    [
                      _c("div", { staticClass: "flex items-center text-lg" }, [
                        _c(
                          "div",
                          { staticClass: "mr-2" },
                          [
                            _c("CheckCircle", {
                              staticClass: "block",
                              attrs: { size: 28 },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.t("ageGateCard.successText")) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$N = [];
__vue_render__$N._withStripped = true;
  const __vue_inject_styles__$N = undefined;
  const __vue_scope_id__$N = undefined;
  const __vue_module_identifier__$N = undefined;
  const __vue_is_functional_template__$N = false;
  const __vue_component__$N = normalizeComponent(
    { render: __vue_render__$N, staticRenderFns: __vue_staticRenderFns__$N },
    __vue_inject_styles__$N,
    __vue_script__$N,
    __vue_scope_id__$N,
    __vue_is_functional_template__$N,
    __vue_module_identifier__$N,
    false,
    undefined,
    undefined,
    undefined
  );

let Eye$1 = class Eye extends IconMixin$1 {
};
Eye$1 = __decorate([
    Component({})
], Eye$1);
var script$M = Eye$1;

const __vue_script__$M = script$M;
var __vue_render__$M = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: _vm.size,
            width: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 576 512",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M279.6 160.4C282.4 160.1 285.2 160 288 160C341 160 384 202.1 384 256C384 309 341 352 288 352C234.1 352 192 309 192 256C192 253.2 192.1 250.4 192.4 247.6C201.7 252.1 212.5 256 224 256C259.3 256 288 227.3 288 192C288 180.5 284.1 169.7 279.6 160.4zM480.6 112.6C527.4 156 558.7 207.1 573.5 243.7C576.8 251.6 576.8 260.4 573.5 268.3C558.7 304 527.4 355.1 480.6 399.4C433.5 443.2 368.8 480 288 480C207.2 480 142.5 443.2 95.42 399.4C48.62 355.1 17.34 304 2.461 268.3C-.8205 260.4-.8205 251.6 2.461 243.7C17.34 207.1 48.62 156 95.42 112.6C142.5 68.84 207.2 32 288 32C368.8 32 433.5 68.84 480.6 112.6V112.6zM288 112C208.5 112 144 176.5 144 256C144 335.5 208.5 400 288 400C367.5 400 432 335.5 432 256C432 176.5 367.5 112 288 112z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$M = [];
__vue_render__$M._withStripped = true;
  const __vue_inject_styles__$M = undefined;
  const __vue_scope_id__$M = undefined;
  const __vue_module_identifier__$M = undefined;
  const __vue_is_functional_template__$M = false;
  const __vue_component__$M = normalizeComponent(
    { render: __vue_render__$M, staticRenderFns: __vue_staticRenderFns__$M },
    __vue_inject_styles__$M,
    __vue_script__$M,
    __vue_scope_id__$M,
    __vue_is_functional_template__$M,
    __vue_module_identifier__$M,
    false,
    undefined,
    undefined,
    undefined
  );

let Eye = class Eye extends IconMixin$1 {
};
Eye = __decorate([
    Component({})
], Eye);
var script$L = Eye;

const __vue_script__$L = script$L;
var __vue_render__$L = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: _vm.size,
            width: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 640 512",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L524 384.1c41.9-44 70.2-93.9 84-128.1C578 181.3 478.4 32 320 32c-66.9 0-123.2 26.6-168.3 63L48.4 14.8zM222.5 150c25.6-23.6 59.9-38 97.5-38c79.5 0 144 64.5 144 144c0 24.7-6.2 47.9-17.1 68.2l-38.7-30.1c5.1-11.7 7.9-24.6 7.9-38.1c0-53-43-96-96-96c-6.4 0-12.7 .6-18.8 1.8l11.6 58.2L222.5 150zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L85.7 163.5C60.2 197.1 42.1 230.8 32 256c30 74.7 129.6 224 288 224c46.9 0 88.6-13.1 124.9-33.4L373 389.9zM320 352c1.6 0 3.2 0 4.8-.1l-99.1-78.1C234 318.3 273.1 352 320 352z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$L = [];
__vue_render__$L._withStripped = true;
  const __vue_inject_styles__$L = undefined;
  const __vue_scope_id__$L = undefined;
  const __vue_module_identifier__$L = undefined;
  const __vue_is_functional_template__$L = false;
  const __vue_component__$L = normalizeComponent(
    { render: __vue_render__$L, staticRenderFns: __vue_staticRenderFns__$L },
    __vue_inject_styles__$L,
    __vue_script__$L,
    __vue_scope_id__$L,
    __vue_is_functional_template__$L,
    __vue_module_identifier__$L,
    false,
    undefined,
    undefined,
    undefined
  );

let PasswordInput = class PasswordInput extends Vue {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "modelValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "placeholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "autocomplete", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showPassword", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
    onToggleShowPassword() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            this.showPassword = !this.showPassword;
            yield this.$nextTick();
            const end = ((_a = this.passwordInput) === null || _a === void 0 ? void 0 : _a.value.length) || 0;
            (_b = this.passwordInput) === null || _b === void 0 ? void 0 : _b.setSelectionRange(end, end);
            (_c = this.passwordInput) === null || _c === void 0 ? void 0 : _c.focus();
        });
    }
    get passwordInput() {
        return this.$refs.passwordInput;
    }
};
__decorate([
    VModel({ type: String })
], PasswordInput.prototype, "modelValue", void 0);
__decorate([
    Prop(String)
], PasswordInput.prototype, "placeholder", void 0);
__decorate([
    Prop({ type: String, default: 'password' })
], PasswordInput.prototype, "name", void 0);
__decorate([
    Prop({ type: String, default: 'password' })
], PasswordInput.prototype, "autocomplete", void 0);
__decorate([
    Prop(Boolean)
], PasswordInput.prototype, "disabled", void 0);
PasswordInput = __decorate([
    Component({
        components: {
            Eye: __vue_component__$M,
            EyeSlash: __vue_component__$L,
        },
    })
], PasswordInput);
var script$K = PasswordInput;

const __vue_script__$K = script$K;
var __vue_render__$K = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "relative" }, [
    (_vm.showPassword ? "text" : "password") === "checkbox"
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.modelValue,
              expression: "modelValue",
            },
          ],
          ref: "passwordInput",
          staticClass: "sl-form-control theme-dark w-full pr-10",
          attrs: {
            name: _vm.name,
            autocomplete: _vm.autocomplete,
            placeholder: _vm.placeholder,
            disabled: _vm.disabled,
            type: "checkbox",
          },
          domProps: {
            checked: Array.isArray(_vm.modelValue)
              ? _vm._i(_vm.modelValue, null) > -1
              : _vm.modelValue,
          },
          on: {
            blur: function ($event) {
              return _vm.$emit("blur", $event)
            },
            focus: function ($event) {
              return _vm.$emit("focus", $event)
            },
            input: function ($event) {
              return _vm.$emit("change", $event)
            },
            change: function ($event) {
              var $$a = _vm.modelValue,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.modelValue = $$a.concat([$$v]));
                } else {
                  $$i > -1 &&
                    (_vm.modelValue = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)));
                }
              } else {
                _vm.modelValue = $$c;
              }
            },
          },
        })
      : (_vm.showPassword ? "text" : "password") === "radio"
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.modelValue,
              expression: "modelValue",
            },
          ],
          ref: "passwordInput",
          staticClass: "sl-form-control theme-dark w-full pr-10",
          attrs: {
            name: _vm.name,
            autocomplete: _vm.autocomplete,
            placeholder: _vm.placeholder,
            disabled: _vm.disabled,
            type: "radio",
          },
          domProps: { checked: _vm._q(_vm.modelValue, null) },
          on: {
            blur: function ($event) {
              return _vm.$emit("blur", $event)
            },
            focus: function ($event) {
              return _vm.$emit("focus", $event)
            },
            input: function ($event) {
              return _vm.$emit("change", $event)
            },
            change: function ($event) {
              _vm.modelValue = null;
            },
          },
        })
      : _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.modelValue,
              expression: "modelValue",
            },
          ],
          ref: "passwordInput",
          staticClass: "sl-form-control theme-dark w-full pr-10",
          attrs: {
            name: _vm.name,
            autocomplete: _vm.autocomplete,
            placeholder: _vm.placeholder,
            disabled: _vm.disabled,
            type: _vm.showPassword ? "text" : "password",
          },
          domProps: { value: _vm.modelValue },
          on: {
            blur: function ($event) {
              return _vm.$emit("blur", $event)
            },
            focus: function ($event) {
              return _vm.$emit("focus", $event)
            },
            input: [
              function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.modelValue = $event.target.value;
              },
              function ($event) {
                return _vm.$emit("change", $event)
              },
            ],
          },
        }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "toggle-show-password absolute cursor-pointer text-light-5 hover:text-dark-5 p-2 leading-none",
        on: { click: _vm.onToggleShowPassword },
      },
      [!_vm.showPassword ? _c("Eye") : _c("EyeSlash")],
      1
    ),
  ])
};
var __vue_staticRenderFns__$K = [];
__vue_render__$K._withStripped = true;
  const __vue_inject_styles__$K = function (inject) {
    if (!inject) return
    inject("data-v-16c37a57_0", { source: ".toggle-show-password {\n  top: 50%;\n  transform: translateY(-50%);\n  right: 4px;\n  z-index: 1;\n}\n", map: {"version":3,"sources":["PasswordInput.vue"],"names":[],"mappings":"AAAA;EACE,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,UAAU;AACZ","file":"PasswordInput.vue","sourcesContent":[".toggle-show-password {\n  top: 50%;\n  transform: translateY(-50%);\n  right: 4px;\n  z-index: 1;\n}\n"]}, media: undefined });
  };
  const __vue_scope_id__$K = undefined;
  const __vue_module_identifier__$K = undefined;
  const __vue_is_functional_template__$K = false;
  const __vue_component__$K = normalizeComponent(
    { render: __vue_render__$K, staticRenderFns: __vue_staticRenderFns__$K },
    __vue_inject_styles__$K,
    __vue_script__$K,
    __vue_scope_id__$K,
    __vue_is_functional_template__$K,
    __vue_module_identifier__$K,
    false,
    createInjector,
    undefined,
    undefined
  );

let ChangePasswordCard$1 = class ChangePasswordCard extends mixins(FormMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentPasswordPlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "newPasswordPlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "newPasswordConfirmationPlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "buttonText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "successText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultFormState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: Object.assign({ current_password: '', new_password: '', new_password_confirmation: '' }, this.defaultFormState)
        });
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    validateForm() {
        if (this.validate) {
            return this.validate(this.form, this.formErrors);
        }
        let currentPasswordValid;
        let newPasswordValid;
        let newPasswordConfirmationValid;
        [currentPasswordValid, this.formErrors.current_password] =
            validatePasswordExistence(this.form.current_password);
        [newPasswordValid, this.formErrors.new_password] = validatePassword(this.form.new_password);
        if (newPasswordValid) {
            newPasswordConfirmationValid =
                this.form.new_password === this.form.new_password_confirmation;
            if (!newPasswordConfirmationValid) {
                this.formErrors.new_password_confirmation = this.t('changePasswordForm.newPasswordConfirmationError');
            }
            else {
                this.formErrors.new_password_confirmation = '';
            }
        }
        else {
            [
                newPasswordConfirmationValid,
                this.formErrors.new_password_confirmation,
            ] = validatePassword(this.form.new_password_confirmation);
        }
        return (currentPasswordValid && newPasswordValid && newPasswordConfirmationValid);
    }
    defaultSubmit(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { current_password, new_password, new_password_confirmation } = data;
            return yield feSdk__default.api.auth.changePassword(current_password, new_password, new_password_confirmation);
        });
    }
    onSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            const submitMethod = this.submit ? this.submit : this.defaultSubmit;
            return this.handleSubmit(submitMethod, (result) => {
                this.$emit('change:success', result);
            }, (message) => this.$emit('change:error', message));
        });
    }
    get tr() {
        return {
            currentPasswordPlaceholder: this.currentPasswordPlaceholder ||
                this.t('changePasswordForm.currentPasswordPlaceholder'),
            newPasswordPlaceholder: this.newPasswordPlaceholder ||
                this.t('changePasswordForm.newPasswordPlaceholder'),
            newPasswordConfirmationPlaceholder: this.newPasswordConfirmationPlaceholder ||
                this.t('changePasswordForm.newPasswordConfirmationPlaceholder'),
            buttonText: this.buttonText || this.t('changePasswordForm.buttonText'),
            successText: this.successText || this.t('changePasswordForm.successText'),
        };
    }
    get stateProps() {
        return Object.assign(Object.assign({}, this.getStateProps()), { hasSuccess: this.hasSuccess, setHasSuccess: this.setHasSuccess });
    }
    defaultFormStateWatcher() {
        this.defaultState = Object.assign({ current_password: '', new_password: '', new_password_confirmation: '' }, this.defaultFormState);
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], ChangePasswordCard$1.prototype, "dark", void 0);
__decorate([
    Prop(String)
], ChangePasswordCard$1.prototype, "currentPasswordPlaceholder", void 0);
__decorate([
    Prop(String)
], ChangePasswordCard$1.prototype, "newPasswordPlaceholder", void 0);
__decorate([
    Prop(String)
], ChangePasswordCard$1.prototype, "newPasswordConfirmationPlaceholder", void 0);
__decorate([
    Prop(String)
], ChangePasswordCard$1.prototype, "buttonText", void 0);
__decorate([
    Prop(String)
], ChangePasswordCard$1.prototype, "successText", void 0);
__decorate([
    Prop(Object)
], ChangePasswordCard$1.prototype, "user", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], ChangePasswordCard$1.prototype, "defaultFormState", void 0);
__decorate([
    Watch('defaultFormState')
], ChangePasswordCard$1.prototype, "defaultFormStateWatcher", null);
ChangePasswordCard$1 = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            SubmitGoButton: __vue_component__$Y,
            InputError: __vue_component__$R,
            PasswordInput: __vue_component__$K,
        },
    })
], ChangePasswordCard$1);
var script$J = ChangePasswordCard$1;

const __vue_script__$J = script$J;
var __vue_render__$J = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "sl-one-component" }, [
    _c(
      "div",
      { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
      [
        _c(
          "div",
          {
            staticClass: "change-password-form text-center mx-auto max-w-full",
          },
          [
            _c(
              "div",
              { staticClass: "change-password-form__header" },
              [_vm._t("header", null, null, _vm.stateProps)],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "change-password-form__form" },
              [
                _vm._t(
                  "form",
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.hasSuccess,
                            expression: "!hasSuccess",
                          },
                        ],
                        staticClass: "w-[300px] mx-auto",
                      },
                      [
                        _c(
                          "form",
                          {
                            attrs: { action: "", method: "POST" },
                            on: {
                              submit: function ($event) {
                                $event.preventDefault();
                                return _vm.onSubmit($event)
                              },
                            },
                          },
                          [
                            _vm.user && _vm.user.email
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "h-0 overflow-hidden change-password-form__form-email",
                                  },
                                  [
                                    _vm._t(
                                      "emailInput",
                                      [
                                        _c("input", {
                                          attrs: {
                                            type: "text",
                                            name: "email",
                                            autocomplete: "username",
                                            readonly: "",
                                          },
                                          domProps: { value: _vm.user.email },
                                        }),
                                      ],
                                      null,
                                      _vm.stateProps
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "change-password-form__form-current_password mb-4",
                              },
                              [
                                _vm._t(
                                  "currentPasswordInput",
                                  [
                                    _c("PasswordInput", {
                                      attrs: {
                                        name: "current_password",
                                        autocomplete: "current-password",
                                        placeholder:
                                          _vm.tr.currentPasswordPlaceholder,
                                        error: _vm.formErrors.current_password,
                                      },
                                      on: {
                                        change: _vm.handleFieldChange,
                                        blur: _vm.handleFieldBlur,
                                      },
                                      model: {
                                        value: _vm.form.current_password,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "current_password",
                                            $$v
                                          );
                                        },
                                        expression: "form.current_password",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("InputError", {
                                      attrs: {
                                        dirty:
                                          _vm.blurred.current_password &&
                                          _vm.dirty.current_password &&
                                          !!_vm.formErrors.current_password,
                                        text: _vm.formErrors.current_password,
                                      },
                                    }),
                                  ],
                                  null,
                                  _vm.stateProps
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "change-password-form__form-new_password mb-4",
                              },
                              [
                                _vm._t(
                                  "newPasswordInput",
                                  [
                                    _c("PasswordInput", {
                                      attrs: {
                                        name: "new_password",
                                        autocomplete: "new-password",
                                        placeholder:
                                          _vm.tr.newPasswordPlaceholder,
                                        error: _vm.formErrors.new_password,
                                      },
                                      on: {
                                        change: _vm.handleFieldChange,
                                        blur: _vm.handleFieldBlur,
                                      },
                                      model: {
                                        value: _vm.form.new_password,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "new_password",
                                            $$v
                                          );
                                        },
                                        expression: "form.new_password",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("InputError", {
                                      attrs: {
                                        dirty:
                                          _vm.blurred.new_password &&
                                          _vm.dirty.new_password &&
                                          !!_vm.formErrors.new_password,
                                        text: _vm.formErrors.new_password,
                                      },
                                    }),
                                  ],
                                  null,
                                  _vm.stateProps
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "change-password-form__form-new_password_confirmation mb-4",
                              },
                              [
                                _vm._t(
                                  "newPasswordConfirmationInput",
                                  [
                                    _c("PasswordInput", {
                                      attrs: {
                                        name: "new_password_confirmation",
                                        placeholder:
                                          _vm.tr
                                            .newPasswordConfirmationPlaceholder,
                                        error:
                                          _vm.formErrors
                                            .new_password_confirmation,
                                      },
                                      on: {
                                        change: _vm.handleFieldChange,
                                        blur: _vm.handleFieldBlur,
                                      },
                                      model: {
                                        value:
                                          _vm.form.new_password_confirmation,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "new_password_confirmation",
                                            $$v
                                          );
                                        },
                                        expression:
                                          "form.new_password_confirmation",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("InputError", {
                                      attrs: {
                                        dirty:
                                          _vm.blurred
                                            .new_password_confirmation &&
                                          _vm.dirty.new_password_confirmation &&
                                          !!_vm.formErrors
                                            .new_password_confirmation,
                                        text: _vm.formErrors
                                          .new_password_confirmation,
                                      },
                                    }),
                                  ],
                                  null,
                                  _vm.stateProps
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "change-password-form__button" },
                              [
                                _vm._t(
                                  "button",
                                  [
                                    _c(
                                      "SubmitGoButton",
                                      {
                                        attrs: {
                                          disabled:
                                            _vm.isSubmitting || !_vm.isValid,
                                          loading: _vm.isSubmitting,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.tr.buttonText) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  null,
                                  _vm.stateProps
                                ),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "change-password-form__success" },
              [
                _vm._t(
                  "success",
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.hasSuccess,
                            expression: "hasSuccess",
                          },
                        ],
                        staticClass: "py-3 w-full",
                      },
                      [
                        _c(
                          "Alert",
                          {
                            staticClass: "px-6 py-3 text-md",
                            attrs: { color: "text-emerald-700", bg: "" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.tr.successText) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "change-password-form__footer" },
              [_vm._t("footer", null, null, _vm.stateProps)],
              2
            ),
          ]
        ),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$J = [];
__vue_render__$J._withStripped = true;
  const __vue_inject_styles__$J = undefined;
  const __vue_scope_id__$J = undefined;
  const __vue_module_identifier__$J = undefined;
  const __vue_is_functional_template__$J = false;
  const __vue_component__$J = normalizeComponent(
    { render: __vue_render__$J, staticRenderFns: __vue_staticRenderFns__$J },
    __vue_inject_styles__$J,
    __vue_script__$J,
    __vue_scope_id__$J,
    __vue_is_functional_template__$J,
    __vue_module_identifier__$J,
    false,
    undefined,
    undefined,
    undefined
  );

let ChangePasswordCard = class ChangePasswordCard extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showBackBtn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "hasSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    setErrorMessage(msg) {
        this.errorMessage = msg;
    }
    setHasSuccess(bool) {
        this.hasSuccess = bool;
    }
    onSuccess(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setErrorMessage('');
            if (typeof this.success === 'function') {
                yield this.success(data);
            }
            else {
                this.$emit('change:success', data);
                this.setHasSuccess(true);
                setTimeout(() => this.setHasSuccess(false), 4000);
            }
        });
    }
    onError(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.error === 'function') {
                yield this.error(msg);
            }
            else {
                this.setErrorMessage(msg);
                this.$emit('change:error', msg);
            }
        });
    }
    onClickBack() {
        this.$emit('back');
    }
    get tr() {
        return {
            title: this.title || this.t('changePasswordCard.title'),
            lead: this.lead || this.t('changePasswordCard.lead'),
        };
    }
    get stateProps() {
        return {
            company: this.company,
            errorMessage: this.errorMessage,
            hasSuccess: this.hasSuccess,
            setErrorMessage: this.setErrorMessage,
            setHasSuccess: this.setHasSuccess,
            onSuccess: this.onSuccess,
            onError: this.onError,
        };
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], ChangePasswordCard.prototype, "dark", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], ChangePasswordCard.prototype, "showBackBtn", void 0);
__decorate([
    Prop({ type: String, default: '' })
], ChangePasswordCard.prototype, "title", void 0);
__decorate([
    Prop({ type: String, default: '' })
], ChangePasswordCard.prototype, "lead", void 0);
__decorate([
    Prop(Object)
], ChangePasswordCard.prototype, "user", void 0);
__decorate([
    Prop(Function)
], ChangePasswordCard.prototype, "success", void 0);
__decorate([
    Prop(Function)
], ChangePasswordCard.prototype, "error", void 0);
ChangePasswordCard = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            CheckCircle: __vue_component__$W,
            Card: __vue_component__$S,
            ChangePasswordForm: __vue_component__$J,
        },
    })
], ChangePasswordCard);
var script$I = ChangePasswordCard;

const __vue_script__$I = script$I;
var __vue_render__$I = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    {
      staticClass: "change-password-card",
      attrs: {
        "company-id": _vm.company.id,
        dark: _vm.dark,
        "error-message": _vm.errorMessage,
        title: _vm.tr.title,
        lead: _vm.tr.lead,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "logo",
            fn: function () {
              return [_vm._t("logo", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [_vm._t("title", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "lead",
            fn: function () {
              return [_vm._t("lead", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [_vm._t("error", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [_vm._t("footer", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "change-password-card__form relative" },
        [
          _vm._t(
            "form",
            [
              _c("ChangePasswordForm", {
                attrs: { dark: _vm.dark, user: _vm.user },
                on: {
                  "change:success": _vm.onSuccess,
                  "change:error": _vm.onError,
                  reset: function ($event) {
                    return _vm.setErrorMessage("")
                  },
                },
              }),
            ],
            null,
            _vm.stateProps
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "change-password-card__success" },
            [
              _vm._t(
                "success",
                [
                  _c(
                    "Alert",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasSuccess,
                          expression: "hasSuccess",
                        },
                      ],
                      staticClass:
                        "absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center p-5",
                      attrs: { bg: "bg-white", color: "text-emerald-900" },
                    },
                    [
                      _c("div", { staticClass: "flex items-center text-lg" }, [
                        _c(
                          "div",
                          { staticClass: "mr-2" },
                          [
                            _c("CheckCircle", {
                              staticClass: "block",
                              attrs: { size: 28 },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.t("changePasswordCard.successText")) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "change-password-card__back" },
        [
          _vm._t(
            "back",
            [
              _vm.showBackBtn
                ? _c("div", { staticClass: "pt-6 text-center" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-sm sl-btn-link-dark-5 underline",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault();
                            return _vm.onClickBack($event)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.t("changePasswordForm.back")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$I = [];
__vue_render__$I._withStripped = true;
  const __vue_inject_styles__$I = undefined;
  const __vue_scope_id__$I = undefined;
  const __vue_module_identifier__$I = undefined;
  const __vue_is_functional_template__$I = false;
  const __vue_component__$I = normalizeComponent(
    { render: __vue_render__$I, staticRenderFns: __vue_staticRenderFns__$I },
    __vue_inject_styles__$I,
    __vue_script__$I,
    __vue_scope_id__$I,
    __vue_is_functional_template__$I,
    __vue_module_identifier__$I,
    false,
    undefined,
    undefined,
    undefined
  );

const onCheckboxKeystroke = (type, e) => {
    if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        if (type === 'keyup') {
            const target = e.target;
            target.checked = !target.checked;
            const event = new Event('change');
            target.dispatchEvent(event);
        }
    }
};
const handleCheckboxKeystroke = (type) => (e) => onCheckboxKeystroke(type, e);
let boundKeyupMethod = () => {
};
let boundKeydownMethod = () => {
};
const vCheckbox = {
    bind(el) {
        boundKeyupMethod = handleCheckboxKeystroke('keyup');
        boundKeydownMethod = handleCheckboxKeystroke('keydown');
        el.addEventListener('keyup', boundKeyupMethod);
        el.addEventListener('keydown', boundKeydownMethod);
    },
    unbind(el) {
        el.removeEventListener('keyup', boundKeyupMethod);
        el.removeEventListener('keydown', boundKeydownMethod);
    },
};

let CheckTfaForm = class CheckTfaForm extends FormMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tfaCodePlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "buttonText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "successText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultFormState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: Object.assign({ tfa_code: '', remember: false }, this.defaultFormState)
        });
    }
    get tr() {
        return {
            tfaCodePlaceholder: this.tfaCodePlaceholder || this.t('checkTfaForm.tfaCodePlaceholder'),
            buttonText: this.buttonText || this.t('actions.continue'),
            successText: this.successText || this.t('checkTfaForm.successText'),
        };
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    defaultSubmit(form) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield feSdk__default.api.auth.checkTfa(form.tfa_code, form.remember);
        });
    }
    validateForm() {
        if (this.validate) {
            return this.validate(this.form, this.formErrors);
        }
        let codeValid;
        [codeValid, this.formErrors.tfa_code] = validateCode(this.form.tfa_code);
        return codeValid;
    }
    onSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            const submitMethod = this.submit ? this.submit : this.defaultSubmit;
            return this.handleSubmit(submitMethod, (result) => {
                this.$emit('check:success', result);
            }, (message) => this.$emit('check:error', message));
        });
    }
    get stateProps() {
        return Object.assign(Object.assign({}, this.getStateProps()), { hasSuccess: this.hasSuccess, setHasSuccess: this.setHasSuccess });
    }
    get hasEmail() {
        var _a;
        return !!((_a = this.defaultState) === null || _a === void 0 ? void 0 : _a.email);
    }
    get forceRemember() {
        var _a;
        return !!((_a = this.defaultState) === null || _a === void 0 ? void 0 : _a.remember);
    }
    defaultFormStateWatcher() {
        this.defaultState = Object.assign({ tfa_code: '', remember: false }, this.defaultFormState);
        this.form = Object.assign({}, this.defaultState);
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], CheckTfaForm.prototype, "dark", void 0);
__decorate([
    Prop(String)
], CheckTfaForm.prototype, "tfaCodePlaceholder", void 0);
__decorate([
    Prop(String)
], CheckTfaForm.prototype, "buttonText", void 0);
__decorate([
    Prop(String)
], CheckTfaForm.prototype, "successText", void 0);
__decorate([
    Prop({ type: Object, default: () => ({ tfa_code: '', remember: false }) })
], CheckTfaForm.prototype, "defaultFormState", void 0);
__decorate([
    Watch('defaultFormState')
], CheckTfaForm.prototype, "defaultFormStateWatcher", null);
CheckTfaForm = __decorate([
    Component({
        components: {
            SubmitGoButton: __vue_component__$Y,
            InputError: __vue_component__$R,
            Alert: __vue_component__$X,
        },
        directives: {
            checkbox: vCheckbox,
        },
    })
], CheckTfaForm);
var script$H = CheckTfaForm;

const __vue_script__$H = script$H;
var __vue_render__$H = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "sl-one-component mx-auto max-w-full" }, [
    _c(
      "div",
      { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
      [
        _c("div", { staticClass: "check-tfa-form text-center" }, [
          _c(
            "div",
            { staticClass: "check-tfa-form__header" },
            [_vm._t("header", null, null, _vm.stateProps)],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "check-tfa-form__form" },
            [
              _vm._t(
                "form",
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.hasSuccess,
                          expression: "!hasSuccess",
                        },
                      ],
                      staticClass: "w-[300px] mx-auto",
                    },
                    [
                      _vm.hasEmail
                        ? _c(
                            "div",
                            { staticClass: "check-tfa-form__tfa-email" },
                            [
                              _vm._t(
                                "emailInput",
                                [
                                  _c("div", { staticClass: "mb-4" }, [
                                    _c("input", {
                                      staticClass:
                                        "sl-form-control theme-dark w-full",
                                      attrs: {
                                        name: "email",
                                        type: "text",
                                        disabled: "",
                                      },
                                      domProps: {
                                        value: _vm.defaultState.email,
                                      },
                                    }),
                                  ]),
                                ],
                                null,
                                _vm.stateProps
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "check-tfa-form__tfa-code" },
                        [
                          _vm._t(
                            "tfaCodeInput",
                            [
                              _c("div", { staticClass: "mb-4" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.tfa_code,
                                      expression: "form.tfa_code",
                                    },
                                  ],
                                  staticClass:
                                    "sl-form-control theme-dark w-full",
                                  attrs: {
                                    name: "tfa_code",
                                    type: "text",
                                    placeholder: _vm.tr.tfaCodePlaceholder,
                                    maxlength: "10",
                                  },
                                  domProps: { value: _vm.form.tfa_code },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.onSubmit($event)
                                    },
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form,
                                          "tfa_code",
                                          $event.target.value
                                        );
                                      },
                                      _vm.handleFieldChange,
                                    ],
                                    blur: _vm.handleFieldBlur,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "mr-[-100px]" },
                                  [
                                    _c("InputError", {
                                      attrs: {
                                        dirty:
                                          _vm.blurred.tfa_code &&
                                          _vm.dirty.tfa_code &&
                                          !!_vm.formErrors.tfa_code,
                                        text: _vm.formErrors.tfa_code,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            null,
                            _vm.stateProps
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.forceRemember,
                              expression: "!forceRemember",
                            },
                          ],
                          staticClass: "check-tfa-form__remember",
                        },
                        [
                          _vm._t(
                            "rememberInput",
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mb-8 w-full text-left text-dark-5",
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "cursor-pointer pl-1 dark:text-light-1 flex items-center",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.form.remember,
                                            expression: "form.remember",
                                          },
                                          {
                                            name: "checkbox",
                                            rawName: "v-checkbox",
                                          },
                                        ],
                                        staticClass: "mr-2 sl-checkbox",
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          value: true,
                                          checked: Array.isArray(
                                            _vm.form.remember
                                          )
                                            ? _vm._i(_vm.form.remember, true) >
                                              -1
                                            : _vm.form.remember,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.form.remember,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false;
                                            if (Array.isArray($$a)) {
                                              var $$v = true,
                                                $$i = _vm._i($$a, $$v);
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    _vm.form,
                                                    "remember",
                                                    $$a.concat([$$v])
                                                  );
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    _vm.form,
                                                    "remember",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  );
                                              }
                                            } else {
                                              _vm.$set(
                                                _vm.form,
                                                "remember",
                                                $$c
                                              );
                                            }
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.t("checkTfaForm.remember")
                                            ) +
                                            "\n                    "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            null,
                            _vm.stateProps
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "check-tfa-form__button" },
                        [
                          _vm._t(
                            "button",
                            [
                              _c(
                                "SubmitGoButton",
                                {
                                  attrs: {
                                    disabled: _vm.isSubmitting || !_vm.isValid,
                                    loading: _vm.isSubmitting,
                                  },
                                  on: { click: _vm.onSubmit },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.tr.buttonText) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ],
                            null,
                            _vm.stateProps
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "check-tfa-form__success" },
            [
              _vm._t(
                "success",
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasSuccess,
                          expression: "hasSuccess",
                        },
                      ],
                      staticClass: "py-3 w-full",
                    },
                    [
                      _c(
                        "Alert",
                        {
                          staticClass: "px-6 py-3 text-md",
                          attrs: { color: "text-emerald-700" },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.tr.successText) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "check-tfa-form__footer" },
            [_vm._t("footer", null, null, _vm.stateProps)],
            2
          ),
        ]),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$H = [];
__vue_render__$H._withStripped = true;
  const __vue_inject_styles__$H = undefined;
  const __vue_scope_id__$H = undefined;
  const __vue_module_identifier__$H = undefined;
  const __vue_is_functional_template__$H = false;
  const __vue_component__$H = normalizeComponent(
    { render: __vue_render__$H, staticRenderFns: __vue_staticRenderFns__$H },
    __vue_inject_styles__$H,
    __vue_script__$H,
    __vue_scope_id__$H,
    __vue_is_functional_template__$H,
    __vue_module_identifier__$H,
    false,
    undefined,
    undefined,
    undefined
  );

let CheckTfaCard = class CheckTfaCard extends mixins(CompanyMixin$1, BaseMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showBackBtn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hasSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    setErrorMessage(msg) {
        this.errorMessage = msg;
    }
    setHasSuccess(bool) {
        this.hasSuccess = bool;
    }
    onSuccess(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setErrorMessage('');
            if (typeof this.success === 'function') {
                yield this.success(data);
            }
            else {
                this.$emit('check:success', data);
                this.setHasSuccess(true);
                setTimeout(() => this.setHasSuccess(false), 4000);
            }
        });
    }
    onError(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.error === 'function') {
                yield this.error(msg);
            }
            else {
                this.setErrorMessage(msg);
                this.$emit('check:error', msg);
            }
        });
    }
    onClickBack() {
        this.$emit('back');
    }
    get tr() {
        return {
            title: this.title || this.t('checkTfaCard.title'),
            lead: this.lead || this.t('checkTfaCard.lead'),
        };
    }
    get stateProps() {
        return {
            company: this.company,
            errorMessage: this.errorMessage,
            hasSuccess: this.hasSuccess,
            setErrorMessage: this.setErrorMessage,
            setHasSuccess: this.setHasSuccess,
            onSuccess: this.onSuccess,
            onError: this.onError,
        };
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], CheckTfaCard.prototype, "dark", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], CheckTfaCard.prototype, "showBackBtn", void 0);
__decorate([
    Prop(String)
], CheckTfaCard.prototype, "title", void 0);
__decorate([
    Prop(String)
], CheckTfaCard.prototype, "lead", void 0);
__decorate([
    Prop(Function)
], CheckTfaCard.prototype, "success", void 0);
__decorate([
    Prop(Function)
], CheckTfaCard.prototype, "error", void 0);
CheckTfaCard = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            CheckCircle: __vue_component__$W,
            Card: __vue_component__$S,
            CheckTfaForm: __vue_component__$H,
        },
    })
], CheckTfaCard);
var script$G = CheckTfaCard;

const __vue_script__$G = script$G;
var __vue_render__$G = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    {
      staticClass: "check-tfa-card",
      attrs: {
        "company-id": _vm.companyId,
        dark: _vm.dark,
        "error-message": _vm.errorMessage,
        title: _vm.tr.title,
        lead: _vm.tr.lead,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "logo",
            fn: function () {
              return [_vm._t("logo", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [_vm._t("title", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "lead",
            fn: function () {
              return [_vm._t("lead", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [_vm._t("error", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [_vm._t("footer", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "check-tfa-card__form relative" },
        [
          _vm._t(
            "form",
            [
              _c("CheckTfaForm", {
                attrs: { dark: _vm.dark },
                on: {
                  "check:success": _vm.onSuccess,
                  "check:error": _vm.onError,
                  reset: function ($event) {
                    return _vm.setErrorMessage("")
                  },
                },
              }),
            ],
            null,
            _vm.stateProps
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "check-tfa-card__success" },
            [
              _vm._t(
                "success",
                [
                  _c(
                    "Alert",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasSuccess,
                          expression: "hasSuccess",
                        },
                      ],
                      staticClass:
                        "absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center p-5",
                      attrs: { bg: "bg-white", color: "text-emerald-900" },
                    },
                    [
                      _c("div", { staticClass: "flex items-center text-lg" }, [
                        _c(
                          "div",
                          { staticClass: "mr-2" },
                          [
                            _c("CheckCircle", {
                              staticClass: "block",
                              attrs: { size: 28 },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.t("checkTfaCard.successText")) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "check-tfa-card__back text-center" },
        [
          _vm._t(
            "back",
            [
              _vm.showBackBtn
                ? _c("div", { staticClass: "pt-6" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-sm sl-btn-link-dark-5 underline",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault();
                            return _vm.onClickBack($event)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.t("checkTfaCard.back")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$G = [];
__vue_render__$G._withStripped = true;
  const __vue_inject_styles__$G = undefined;
  const __vue_scope_id__$G = undefined;
  const __vue_module_identifier__$G = undefined;
  const __vue_is_functional_template__$G = false;
  const __vue_component__$G = normalizeComponent(
    { render: __vue_render__$G, staticRenderFns: __vue_staticRenderFns__$G },
    __vue_inject_styles__$G,
    __vue_script__$G,
    __vue_scope_id__$G,
    __vue_is_functional_template__$G,
    __vue_module_identifier__$G,
    false,
    undefined,
    undefined,
    undefined
  );

let RightArrow$2 = class RightArrow extends IconMixin$1 {
};
RightArrow$2 = __decorate([
    Component({})
], RightArrow$2);
var script$F = RightArrow$2;

const __vue_script__$F = script$F;
var __vue_render__$F = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: _vm.size,
            width: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$F = [];
__vue_render__$F._withStripped = true;
  const __vue_inject_styles__$F = undefined;
  const __vue_scope_id__$F = undefined;
  const __vue_module_identifier__$F = undefined;
  const __vue_is_functional_template__$F = false;
  const __vue_component__$F = normalizeComponent(
    { render: __vue_render__$F, staticRenderFns: __vue_staticRenderFns__$F },
    __vue_inject_styles__$F,
    __vue_script__$F,
    __vue_scope_id__$F,
    __vue_is_functional_template__$F,
    __vue_module_identifier__$F,
    false,
    undefined,
    undefined,
    undefined
  );

let SimpleButton = class SimpleButton extends ButtonMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "color", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    Prop({ type: String, default: 'text-white' })
], SimpleButton.prototype, "color", void 0);
SimpleButton = __decorate([
    Component({
        components: {
            CircleNotch: __vue_component__$1e,
        },
    })
], SimpleButton);
var script$E = SimpleButton;

const __vue_script__$E = script$E;
var __vue_render__$E = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "button",
    {
      staticClass: "sl-btn whitespace-nowrap relative",
      class: [_vm.color],
      attrs: { type: "submit", disabled: _vm.disabled || _vm.loading },
      on: { click: _vm.handleClick },
    },
    [
      _c(
        "div",
        {
          class: {
            invisible: _vm.loading,
          },
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.loading
        ? [
            _vm._t("loading", [
              _c(
                "div",
                { staticClass: "absolute sl-center-y sl-center-x pt-1" },
                [
                  _c("CircleNotch", {
                    staticClass: "animate-spin",
                    attrs: { size: 16 },
                  }),
                ],
                1
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
};
var __vue_staticRenderFns__$E = [];
__vue_render__$E._withStripped = true;
  const __vue_inject_styles__$E = undefined;
  const __vue_scope_id__$E = undefined;
  const __vue_module_identifier__$E = undefined;
  const __vue_is_functional_template__$E = false;
  const __vue_component__$E = normalizeComponent(
    { render: __vue_render__$E, staticRenderFns: __vue_staticRenderFns__$E },
    __vue_inject_styles__$E,
    __vue_script__$E,
    __vue_scope_id__$E,
    __vue_is_functional_template__$E,
    __vue_module_identifier__$E,
    false,
    undefined,
    undefined,
    undefined
  );

let ConnectCard = class ConnectCard extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loggedUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cancel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "connect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loginRequired", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loginTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loginLead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loginBtn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "switchBtn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorLead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "authorizeBtn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cancelBtn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "origin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pk", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "termsUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "privacyUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "connectIntent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "extraData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "noAuthTarget", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "forceVerify", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "autoRedirect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hideSwitchBtn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "hasSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isConnecting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "showWaiting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "view", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'connect'
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.init();
        });
    }
    setHasSuccess(hasSuccess) {
        this.hasSuccess = hasSuccess;
    }
    handleUserLoaded(user) {
        this.$emit('connect:user', user);
        if (!this.computedForceVerify) {
            this.onConnect();
        }
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setErrorMessage('');
            this.setView('connect');
            if (this.loggedUser) {
                this.user = Object.assign({}, this.loggedUser);
                this.handleUserLoaded(Object.assign({}, this.loggedUser));
            }
            else {
                yield this.getLoggedInUser();
            }
            if (this.user) {
                yield this.authorizeEndpoint();
            }
        });
    }
    authorizeEndpoint() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield feSdk__default.api.identity.authorizeClient(this.computedOrigin, this.computedForceVerify, this.pk);
            }
            catch (err) {
                if (err instanceof ApiError) {
                    this.setView('error');
                    this.onError(err.message, err.status);
                }
            }
        });
    }
    getLoggedInUser() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setIsLoading(true);
            try {
                this.user = yield feSdk__default.api.user.getAuthUser();
                this.handleUserLoaded(this.user);
            }
            catch (err) {
                if (err instanceof ApiError && err.status === 401) {
                    this.onLoginRequired();
                }
                else if (err instanceof ApiError) {
                    this.setView('error');
                    this.onError(err.message, err.status);
                }
            }
            this.setIsLoading(false);
        });
    }
    setErrorMessage(errorMessage) {
        this.errorMessage = errorMessage;
    }
    setIsLoading(isLoading) {
        this.isLoading = isLoading;
    }
    setView(view) {
        this.view = view;
    }
    setIsConnecting(isConnecting) {
        this.isConnecting = isConnecting;
    }
    setShowWaiting(bool, timeout) {
        this.showWaiting = bool;
        if (timeout !== undefined) {
            setTimeout(() => {
                this.showWaiting = !bool;
            }, timeout);
        }
    }
    onLoginRequired() {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.loginRequired === 'function') {
                return this.loginRequired();
            }
            this.setView('login');
            this.handleLoginRedirect('connect');
        });
    }
    onSuccess(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setErrorMessage('');
            this.setHasSuccess(true);
            const successTimeout = setTimeout(() => {
                this.setHasSuccess(false);
            }, 4e3);
            const waitingTimeout = setTimeout(() => {
                this.setShowWaiting(true, 3e3);
            }, 1e3);
            const getSuccessResolve = () => {
                clearTimeout(successTimeout);
                return () => this.setHasSuccess(false);
            };
            const getWaitingResolve = (setWaiting = true) => {
                clearTimeout(waitingTimeout);
                this.setShowWaiting(setWaiting);
                return (bool = !setWaiting, timeout) => this.setShowWaiting(bool, timeout);
            };
            if (typeof this.success === 'function') {
                yield this.success(data, { getSuccessResolve, getWaitingResolve });
            }
            else {
                this.$emit('connect:success', data, {
                    getSuccessResolve,
                    getWaitingResolve,
                });
                if (this.autoRedirect) {
                    window.location.href = data.redirect_url;
                }
            }
        });
    }
    handleConnect() {
        if (typeof this.connect === 'function') {
            return this.connect();
        }
        return feSdk__default.api.identity.connectIdentity(Object.assign({ origin: this.computedOrigin, pk: this.pk, intent: this.connectIntent, state: this.state, noAuthTarget: this.noAuthTarget }, this.extraData));
    }
    onConnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setIsConnecting(true);
            try {
                const res = yield this.handleConnect();
                this.onSuccess(res);
            }
            catch (err) {
                if (err instanceof ApiError) {
                    this.handleXhrError(err, (e) => {
                        var _a;
                        this.onError(((_a = e.data) === null || _a === void 0 ? void 0 : _a.message) || e.message);
                    });
                }
            }
            this.setIsConnecting(false);
        });
    }
    onCancel() {
        if (typeof this.cancel === 'function') {
            return this.cancel();
        }
        this.$emit('connect:cancel');
    }
    handleXhrError(err, fallback) {
        if (err.data.code === 'email_verification_required') {
            this.$emit('validate', 'email');
            this.setErrorMessage(this.t('connectCard.connect.emailRequired'));
        }
        else if (err.data.code === 'token_required') {
            this.$emit('validate', 'tfa');
            this.setErrorMessage(this.t('connectCard.connect.tfaRequired'));
        }
        else if (err.data.code === 'age_gate_required') {
            this.$emit('validate', 'age-gate');
            this.setErrorMessage(this.t('connectCard.connect.ageRequired'));
        }
        else {
            fallback(err);
        }
    }
    handleLoginRedirect(intent) {
        this.$emit('redirect', 'login', intent);
    }
    onError(msg, status = 400) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.error === 'function') {
                yield this.error(msg, status);
            }
            else {
                this.setErrorMessage(msg);
                this.setView('error');
                this.$emit('connect:error', msg, status);
            }
        });
    }
    cleanUrl(str) {
        return str.replace(/^https?:\/\//, '').replace(/\/*$/, '');
    }
    get stateProps() {
        return {
            company: this.company,
            title: this.computedTitle,
            lead: this.computedLead,
            origin: this.computedOrigin,
            pk: this.pk || '',
            errorMessage: this.errorMessage,
            isLoading: this.isLoading,
            isConnecting: this.isConnecting,
            hasSuccess: this.hasSuccess,
            view: this.view,
            init: this.init,
            setHasSuccess: this.setHasSuccess,
            setErrorMessage: this.setErrorMessage,
            setIsLoading: this.setIsLoading,
            setIsConnecting: this.setIsConnecting,
            setView: this.setView,
            onCancel: this.onCancel,
            onSuccess: this.onSuccess,
            onError: this.onError,
            onConnect: this.onConnect,
            onLoginRequired: this.onLoginRequired,
            showWaiting: this.showWaiting,
            setShowWaiting: this.setShowWaiting,
        };
    }
    get computedOrigin() {
        return this.origin || this.company.url.replace(/\/*$/, '');
    }
    get computedForceVerify() {
        return typeof this.forceVerify === 'boolean'
            ? this.forceVerify
            : getForceVerify();
    }
    get tr() {
        return {
            title: this.title || this.t('connectCard.connect.title'),
            lead: this.lead || this.t('connectCard.connect.lead'),
            loginTitle: this.loginTitle || this.t('connectCard.login.title'),
            loginLead: this.loginLead || this.t('connectCard.login.lead'),
            errorTitle: this.errorTitle || this.t('connectCard.error.title'),
            errorLead: this.errorLead || this.t('connectCard.error.lead'),
            loginBtn: this.loginBtn || this.t('connectCard.login.loginBtn'),
            switchBtn: this.switchBtn || this.t('connectCard.switch.btn'),
            authorizeBtn: this.authorizeBtn || this.t('connectCard.connect.authorize'),
            cancelBtn: this.cancelBtn || this.t('connectCard.connect.cancel'),
        };
    }
    get computedTitle() {
        if (this.view === 'login') {
            return this.tr.loginTitle;
        }
        else if (this.view === 'error') {
            return this.tr.errorTitle;
        }
        return this.tr.title;
    }
    get computedLead() {
        if (this.view === 'login') {
            return this.tr.loginLead;
        }
        else if (this.view === 'error') {
            return this.tr.errorLead;
        }
        return this.tr.lead;
    }
    get computedCompanyId() {
        return this.companyId || getCompanyId();
    }
    get computedTermsUrl() {
        return methods.getCompanyLink(this.computedCompanyId, 'terms', this.termsUrl);
    }
    get computedPrivacyUrl() {
        return methods.getCompanyLink(this.computedCompanyId, 'privacy', this.privacyUrl);
    }
    get disclaimerMessage() {
        return (this.t(`connectCard.connect.disclaimer.${this.company.id}`, {
            company: this.company.name,
        }, '') ||
            this.t('connectCard.connect.disclaimer.default', {
                company: this.company.name,
            }));
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], ConnectCard.prototype, "dark", void 0);
__decorate([
    Prop({ type: Object, default: null })
], ConnectCard.prototype, "loggedUser", void 0);
__decorate([
    Prop(Function)
], ConnectCard.prototype, "error", void 0);
__decorate([
    Prop(Function)
], ConnectCard.prototype, "success", void 0);
__decorate([
    Prop(Function)
], ConnectCard.prototype, "cancel", void 0);
__decorate([
    Prop(Function)
], ConnectCard.prototype, "connect", void 0);
__decorate([
    Prop(Function)
], ConnectCard.prototype, "loginRequired", void 0);
__decorate([
    Prop(String)
], ConnectCard.prototype, "title", void 0);
__decorate([
    Prop(String)
], ConnectCard.prototype, "lead", void 0);
__decorate([
    Prop(String)
], ConnectCard.prototype, "loginTitle", void 0);
__decorate([
    Prop(String)
], ConnectCard.prototype, "loginLead", void 0);
__decorate([
    Prop(String)
], ConnectCard.prototype, "loginBtn", void 0);
__decorate([
    Prop(String)
], ConnectCard.prototype, "switchBtn", void 0);
__decorate([
    Prop(String)
], ConnectCard.prototype, "errorTitle", void 0);
__decorate([
    Prop(String)
], ConnectCard.prototype, "errorLead", void 0);
__decorate([
    Prop(String)
], ConnectCard.prototype, "authorizeBtn", void 0);
__decorate([
    Prop(String)
], ConnectCard.prototype, "cancelBtn", void 0);
__decorate([
    Prop(String)
], ConnectCard.prototype, "origin", void 0);
__decorate([
    Prop(String)
], ConnectCard.prototype, "pk", void 0);
__decorate([
    Prop(String)
], ConnectCard.prototype, "termsUrl", void 0);
__decorate([
    Prop(String)
], ConnectCard.prototype, "privacyUrl", void 0);
__decorate([
    Prop({ type: String, default: 'connect' })
], ConnectCard.prototype, "connectIntent", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], ConnectCard.prototype, "extraData", void 0);
__decorate([
    Prop({ type: String, default: 'login' })
], ConnectCard.prototype, "noAuthTarget", void 0);
__decorate([
    Prop(String)
], ConnectCard.prototype, "state", void 0);
__decorate([
    Prop({ type: Boolean, default: undefined })
], ConnectCard.prototype, "forceVerify", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], ConnectCard.prototype, "autoRedirect", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ConnectCard.prototype, "hideSwitchBtn", void 0);
ConnectCard = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            Card: __vue_component__$S,
            CheckCircle: __vue_component__$W,
            CircleExclamation: __vue_component__$V,
            CircleNotch: __vue_component__$1e,
            SubmitGoButton: __vue_component__$Y,
            SimpleButton: __vue_component__$E,
            UserIcon: __vue_component__$F,
            I18n,
        },
    })
], ConnectCard);
var script$D = ConnectCard;

const __vue_script__$D = script$D;
var __vue_render__$D = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    {
      attrs: {
        dark: _vm.dark,
        title: _vm.t(_vm.computedTitle, {
          company: _vm.company ? _vm.company.name : "",
          user: _vm.user ? _vm.user.username : "",
        }),
        "company-id": _vm.companyId,
        lead: _vm.t(_vm.computedLead, {
          company: _vm.company ? _vm.company.name : "",
          domain: _vm.cleanUrl(_vm.company ? _vm.company.url : ""),
        }),
      },
      scopedSlots: _vm._u(
        [
          {
            key: "logo",
            fn: function () {
              return [_vm._t("logo", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [_vm._t("title", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "lead",
            fn: function () {
              return [_vm._t("lead", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [_vm._t("footer", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "connect-card__views w-full" },
        [
          !_vm.isLoading && _vm.user && _vm.company && _vm.view === "connect"
            ? _c("div", { staticClass: "connect-card__loading-view w-full" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.view === "connect",
                        expression: "view === 'connect'",
                      },
                    ],
                    staticClass: "connect-card__connect-view w-full",
                  },
                  [
                    _vm._t(
                      "connect",
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "divide-y divide-light-4 mx-auto max-w-[400px] mb-8",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex cursor-pointer items-center space-x-2 py-3 px-3 rounded-t-lg text-dark-1 hover:bg-light-3",
                                on: { click: _vm.onConnect },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex h-10 w-10 items-center justify-center rounded-full bg-gray-300 font-semibold",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.user.username.slice(0, 1)) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _c("div", [
                                    _vm._v(_vm._s(_vm.user.username)),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "text-sm text-light-5" },
                                    [_vm._v(_vm._s(_vm.user.email))]
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.hideSwitchBtn
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex cursor-pointer items-center space-x-2 py-3 px-3 rounded-b-lg text-dark-1 hover:bg-light-3",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleLoginRedirect("switch")
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex h-10 w-10 items-center justify-center rounded-full bg-gray-300",
                                      },
                                      [
                                        _c("UserIcon", {
                                          staticClass: "mb-1",
                                          attrs: { size: 14 },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(_vm._s(_vm.tr.switchBtn)),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "mb-8 text-sm text-gray-500 text-center max-w-[400px] mx-auto",
                          },
                          [
                            _c("I18n", {
                              attrs: { message: _vm.disclaimerMessage },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "terms",
                                    fn: function (text) {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "text-sky-700 hover:text-sky-900 hover:underline",
                                            attrs: {
                                              target: "_blank",
                                              href: _vm.computedTermsUrl,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(text) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "privacy",
                                    fn: function (text) {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "text-sky-700 hover:text-sky-900 hover:underline",
                                            attrs: {
                                              target: "_blank",
                                              href: _vm.computedPrivacyUrl,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(text) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3675120425
                              ),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.showWaiting
                          ? _c(
                              "div",
                              { staticClass: "max-w-[400px] mx-auto mb-6" },
                              [
                                _c(
                                  "Alert",
                                  {
                                    staticClass:
                                      "flex rounded-1 text-sm items-center py-3 px-9",
                                    attrs: {
                                      bg: "bg-info-light",
                                      color: "text-info",
                                    },
                                  },
                                  [
                                    _c("CircleNotch", {
                                      staticClass: "mr-2 animate-spin",
                                      attrs: { size: 14 },
                                    }),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.t("connect.waitMessage")) +
                                          "\n              "
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "max-w-[400px] mx-auto flex flex-col items-center",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "mb-6 w-full" },
                              [
                                _c(
                                  "SubmitGoButton",
                                  {
                                    attrs: {
                                      disabled:
                                        _vm.isConnecting || _vm.hasSuccess,
                                      loading: _vm.isConnecting,
                                    },
                                    on: { click: _vm.onConnect },
                                    scopedSlots: _vm._u(
                                      [
                                        _vm.hasSuccess
                                          ? {
                                              key: "append",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    { staticClass: "pl-2" },
                                                    [
                                                      _c("CheckCircle", {
                                                        attrs: { size: 14 },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            }
                                          : null,
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _vm.hasSuccess
                                      ? [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.t(
                                                  "connectCard.connect.authorizeSuccess"
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      : [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.tr.authorizeBtn) +
                                              "\n                "
                                          ),
                                        ],
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.hasSuccess,
                                    expression: "!hasSuccess",
                                  },
                                ],
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "underline mx-auto text-dark-2 hover:text-dark-1 dark:text-light-3 dark:hover:text-light-1",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault();
                                        return _vm.onCancel($event)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.tr.cancelBtn) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      null,
                      _vm.stateProps
                    ),
                  ],
                  2
                ),
              ])
            : !_vm.isLoading && _vm.view !== "connect"
            ? [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.view === "login",
                        expression: "view === 'login'",
                      },
                    ],
                    staticClass: "connect-card__login-view py-4 w-full",
                  },
                  [
                    _vm._t(
                      "login",
                      [
                        _c(
                          "div",
                          { staticClass: "mx-auto flex justify-center" },
                          [
                            _c(
                              "div",
                              { staticClass: "min-w-[300px]" },
                              [
                                _c(
                                  "SubmitGoButton",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleLoginRedirect(
                                          "connect"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.tr.loginBtn) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      null,
                      _vm.stateProps
                    ),
                  ],
                  2
                ),
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "connect-card__loading mx-auto h-32 flex items-center justify-center",
                  },
                  [
                    _c("CheckCircle", {
                      staticClass: "animate-spin",
                      attrs: { size: 32 },
                    }),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "connect-card__error-view w-full" },
        [
          _vm._t(
            "error",
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errorMessage,
                      expression: "errorMessage",
                    },
                  ],
                  staticClass: "py-4",
                },
                [
                  _vm.view !== "connect"
                    ? _c(
                        "div",
                        { staticClass: "text-center mb-8" },
                        [
                          _c(
                            "SimpleButton",
                            {
                              staticClass: "bg-gray-500 hover:bg-gray-600",
                              on: { click: _vm.onCancel },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.tr.cancelBtn) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "Alert",
                    {
                      staticClass:
                        "flex text-sm justify-center items-center font-medium",
                    },
                    [
                      _c("CircleExclamation", {
                        staticClass: "mr-2",
                        attrs: { size: 14 },
                      }),
                      _vm._v(
                        "\n          " + _vm._s(_vm.errorMessage) + "\n        "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$D = [];
__vue_render__$D._withStripped = true;
  const __vue_inject_styles__$D = undefined;
  const __vue_scope_id__$D = undefined;
  const __vue_module_identifier__$D = undefined;
  const __vue_is_functional_template__$D = false;
  const __vue_component__$D = normalizeComponent(
    { render: __vue_render__$D, staticRenderFns: __vue_staticRenderFns__$D },
    __vue_inject_styles__$D,
    __vue_script__$D,
    __vue_scope_id__$D,
    __vue_is_functional_template__$D,
    __vue_module_identifier__$D,
    false,
    undefined,
    undefined,
    undefined
  );

let ConnectCardMixin = class ConnectCardMixin extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "connectIntent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cancel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "connect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loginRequired", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loggedUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loginBtn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorLead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "authorizeBtn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cancelBtn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "origin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pk", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "termsUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "privacyUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "forceVerify", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showConfirm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "extraData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "noAuthTarget", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "autoRedirect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "confirmed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "hasSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "showWaiting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "successData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    setIsLoading(value) {
        this.isLoading = value;
    }
    setShowWaiting(bool, timeout) {
        this.showWaiting = bool;
        if (timeout !== undefined) {
            setTimeout(() => {
                this.showWaiting = !bool;
            }, timeout);
        }
    }
    setErrorMessage(msg) {
        this.errorMessage = msg;
    }
    setConfirmed(bool) {
        this.confirmed = bool;
    }
    setUser(user) {
        this.user = user;
    }
    setHasSuccess(hasSuccess) {
        this.hasSuccess = hasSuccess;
    }
    onClickCancel() {
        this.$emit('connect:cancel');
    }
    onClickClose() {
        this.onSuccess(this.successData);
    }
    authorizeEndpoint() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield feSdk__default.api.identity.authorizeClient(this.computedOrigin, true, this.pk);
                this.$emit('connect:authorized', response);
            }
            catch (err) {
                if (err instanceof ApiError) {
                    this.handleXhrError(err, (e) => {
                        this.onError(e.message);
                    });
                }
            }
        });
    }
    onSuccess(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setErrorMessage('');
            this.setHasSuccess(true);
            const successTimeout = setTimeout(() => {
                this.setHasSuccess(false);
            }, 4e3);
            const waitingTimeout = setTimeout(() => {
                this.setShowWaiting(true, 3e3);
            }, 1e3);
            const getSuccessResolve = () => {
                clearTimeout(successTimeout);
                return () => this.setHasSuccess(false);
            };
            const getWaitingResolve = (setWaiting = true) => {
                clearTimeout(waitingTimeout);
                this.setShowWaiting(setWaiting);
                return (bool = !setWaiting, timeout) => this.setShowWaiting(bool, timeout);
            };
            if (typeof this.success === 'function') {
                yield this.success(data, { getSuccessResolve, getWaitingResolve });
            }
            else {
                this.$emit('connect:success', data, {
                    getSuccessResolve,
                    getWaitingResolve,
                });
                if (this.autoRedirect) {
                    window.location.href = data.redirect_url;
                }
            }
        });
    }
    onError(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.error === 'function') {
                yield this.error(msg);
            }
            else {
                this.setErrorMessage(msg);
                this.$emit('connect:error', msg);
            }
        });
    }
    onLoginRequired() {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.loginRequired === 'function') {
                return this.loginRequired();
            }
            this.$emit('redirect', 'login', 'connect');
        });
    }
    onClickSwitchAccount(e) {
        e.preventDefault();
        this.$emit('redirect', 'login', 'switch');
    }
    onConfirm() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setIsLoading(true);
            yield this.onConnect();
            this.setIsLoading(false);
        });
    }
    handleXhrError(err, fallback) {
        if (err.data.code === 'email_verification_required') {
            this.setErrorMessage(this.t('upgradeCard.error.user'));
            this.$emit('validate', 'email');
        }
        else if (err.data.code === 'token_required') {
            this.setErrorMessage(this.t('upgradeCard.error.user'));
            this.$emit('validate', 'tfa');
        }
        else if (err.data.code === 'age_gate_verification') {
            this.setErrorMessage(this.t('upgradeCard.error.user'));
            this.$emit('validate', 'age-gate');
        }
        else {
            fallback(err);
        }
    }
    getLoggedInUser() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setIsLoading(true);
            try {
                const userResponse = yield feSdk__default.api.user.getAuthUser();
                this.setUser(userResponse);
            }
            catch (err) {
                if (err instanceof ApiError && err.status === 401) {
                    this.onLoginRequired();
                    this.setErrorMessage(this.t('upgradeCard.error.user'));
                }
                else if (err instanceof ApiError) {
                    this.handleXhrError(err, (e) => {
                        this.onError(e.message);
                    });
                }
            }
            this.setIsLoading(false);
        });
    }
    handleConnect() {
        if (typeof this.connect === 'function') {
            return this.connect();
        }
        return feSdk__default.api.identity.connectIdentity(Object.assign({ origin: this.computedOrigin, pk: this.pk, state: this.state, intent: this.connectIntent, noAuthTarget: this.noAuthTarget }, this.extraData));
    }
    onConnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setIsLoading(true);
            try {
                const data = (yield this.handleConnect());
                this.successData = data;
                this.onSuccess(data);
            }
            catch (err) {
                if (err instanceof ApiError) {
                    this.handleXhrError(err, (e) => {
                        this.onError(e.message);
                    });
                }
            }
            this.setIsLoading(false);
        });
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setErrorMessage('');
            this.setConfirmed(false);
            if (this.loggedUser) {
                this.setUser(Object.assign({}, this.loggedUser));
            }
            else {
                yield this.getLoggedInUser();
            }
            if (this.user && !this.showConfirm) {
                yield this.authorizeEndpoint();
            }
        });
    }
    get computedOrigin() {
        return this.origin || this.company.url.replace(/\/*$/, '');
    }
    getStateProps() {
        return {
            company: this.company,
            errorMessage: this.errorMessage,
            setErrorMessage: this.setErrorMessage,
            onSuccess: this.onSuccess,
            onError: this.onError,
            confirmed: this.confirmed,
            setConfirmed: this.setConfirmed,
            onClickCancel: this.onClickCancel,
            user: this.user,
            setUser: this.setUser,
            isLoading: this.isLoading,
            setIsLoading: this.setIsLoading,
            onConfirm: this.onConfirm,
            init: this.init,
            onClickSwitchAccount: this.onClickSwitchAccount,
            hasSuccess: this.hasSuccess,
            setHasSuccess: this.setHasSuccess,
            showWaiting: this.showWaiting,
            setShowWaiting: this.setShowWaiting,
        };
    }
};
__decorate([
    Prop({ type: String, default: 'upgrade' })
], ConnectCardMixin.prototype, "connectIntent", void 0);
__decorate([
    Prop(Function)
], ConnectCardMixin.prototype, "error", void 0);
__decorate([
    Prop(Function)
], ConnectCardMixin.prototype, "success", void 0);
__decorate([
    Prop(Function)
], ConnectCardMixin.prototype, "cancel", void 0);
__decorate([
    Prop(Function)
], ConnectCardMixin.prototype, "connect", void 0);
__decorate([
    Prop(Function)
], ConnectCardMixin.prototype, "loginRequired", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ConnectCardMixin.prototype, "dark", void 0);
__decorate([
    Prop({ type: Object, default: null })
], ConnectCardMixin.prototype, "loggedUser", void 0);
__decorate([
    Prop(String)
], ConnectCardMixin.prototype, "loginBtn", void 0);
__decorate([
    Prop(String)
], ConnectCardMixin.prototype, "errorTitle", void 0);
__decorate([
    Prop(String)
], ConnectCardMixin.prototype, "errorLead", void 0);
__decorate([
    Prop(String)
], ConnectCardMixin.prototype, "authorizeBtn", void 0);
__decorate([
    Prop(String)
], ConnectCardMixin.prototype, "cancelBtn", void 0);
__decorate([
    Prop(String)
], ConnectCardMixin.prototype, "origin", void 0);
__decorate([
    Prop(String)
], ConnectCardMixin.prototype, "pk", void 0);
__decorate([
    Prop(String)
], ConnectCardMixin.prototype, "termsUrl", void 0);
__decorate([
    Prop(String)
], ConnectCardMixin.prototype, "privacyUrl", void 0);
__decorate([
    Prop(String)
], ConnectCardMixin.prototype, "state", void 0);
__decorate([
    Prop({ type: Boolean, default: undefined })
], ConnectCardMixin.prototype, "forceVerify", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ConnectCardMixin.prototype, "showConfirm", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], ConnectCardMixin.prototype, "extraData", void 0);
__decorate([
    Prop(String)
], ConnectCardMixin.prototype, "noAuthTarget", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], ConnectCardMixin.prototype, "autoRedirect", void 0);
ConnectCardMixin = __decorate([
    Component({})
], ConnectCardMixin);
var ConnectCardMixin$1 = ConnectCardMixin;

let ConnectUpgradeCard = class ConnectUpgradeCard extends mixins(BaseMixin$1, CompanyMixin$1, ConnectCardMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "confirmTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "confirmLead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "confirmedTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "confirmedLead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    get stateProps() {
        return Object.assign(Object.assign({}, this.getStateProps()), { title: this.title, lead: this.lead });
    }
    get tr() {
        return {
            confirmTitle: this.confirmTitle ||
                this.t('upgradeCard.confirm.title', { company: this.company.name }),
            confirmLead: this.confirmLead,
            confirmedTitle: this.confirmedTitle || this.t('upgradeCard.confirmed.title'),
            confirmedLead: this.confirmedLead ||
                this.t('upgradeCard.confirmed.subtitle', {
                    company: this.company.name,
                }),
        };
    }
    get title() {
        return this.confirmed ? this.tr.confirmedTitle : this.tr.confirmTitle;
    }
    get lead() {
        return (this.confirmed ? this.tr.confirmedLead : this.tr.confirmLead) || '';
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    mounted() {
        this.init();
        if (this.showConfirm) {
            this.setConfirmed(true);
        }
    }
};
__decorate([
    Prop(String)
], ConnectUpgradeCard.prototype, "confirmTitle", void 0);
__decorate([
    Prop(String)
], ConnectUpgradeCard.prototype, "confirmLead", void 0);
__decorate([
    Prop(String)
], ConnectUpgradeCard.prototype, "confirmedTitle", void 0);
__decorate([
    Prop(String)
], ConnectUpgradeCard.prototype, "confirmedLead", void 0);
__decorate([
    Prop({ type: String, default: 'upgrade' })
], ConnectUpgradeCard.prototype, "connectIntent", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], ConnectUpgradeCard.prototype, "extraData", void 0);
__decorate([
    Prop(String)
], ConnectUpgradeCard.prototype, "noAuthTarget", void 0);
ConnectUpgradeCard = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            CheckCircle: __vue_component__$W,
            CircleExclamation: __vue_component__$V,
            CircleNotch: __vue_component__$1e,
            UserIcon: __vue_component__$F,
            SubmitGoButton: __vue_component__$Y,
            SimpleButton: __vue_component__$E,
            Card: __vue_component__$S,
            I18n,
        },
    })
], ConnectUpgradeCard);
var script$C = ConnectUpgradeCard;

const __vue_script__$C = script$C;
var __vue_render__$C = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    {
      staticClass: "upgrade-card",
      class: { "upgrade-card--confirmed": _vm.confirmed },
      attrs: {
        "company-id": _vm.companyId,
        dark: _vm.dark,
        "error-message": _vm.errorMessage,
        title: _vm.title,
        lead: _vm.lead,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "logo",
            fn: function () {
              return [_vm._t("logo", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [_vm._t("title", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "lead",
            fn: function () {
              return [_vm._t("lead", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [_vm._t("error", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "upgrade-card__content py-3" },
        [
          _vm._t("loader", [
            _vm.isLoading
              ? [
                  _c(
                    "div",
                    {
                      staticClass:
                        "connect-sl-card__loading mx-auto h-32 flex items-center justify-center",
                    },
                    [
                      _c("CircleNotch", {
                        staticClass: "animate-spin",
                        attrs: { size: 32 },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm._t(
            "content",
            [
              _vm.user && !_vm.isLoading
                ? [
                    !_vm.confirmed
                      ? [
                          _c(
                            "p",
                            {
                              staticClass:
                                "mb-5 text-lg flex flex-wrap gap-x-3 items-center",
                            },
                            [
                              _c("I18n", {
                                attrs: {
                                  message: _vm.t(
                                    "upgradeCard.confirm.userLine",
                                    { email: _vm.user.email }
                                  ),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "b",
                                      fn: function (text) {
                                        return [
                                          _c("b", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(text) +
                                                "\n                "
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1554281131
                                ),
                              }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "text-sm sl-btn-link-dark-5 font-semibold underline",
                                  attrs: { href: "#" },
                                  on: { click: _vm.onClickSwitchAccount },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.t(
                                          "upgradeCard.confirm.switchAccount"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-disc pl-6" },
                            _vm._l(3, function (i) {
                              return _c(
                                "li",
                                {
                                  key: i,
                                  staticClass: "text-lg leading-7 mb-4",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.t(
                                          "upgradeCard.confirm.items." + (i - 1)
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      : [
                          _c("div", {
                            staticClass:
                              "break border-t border-light-3 mt-4 mb-7",
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "py-3 text-one-black text-md text-center leading-normal",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.t("upgradeCard.confirmed.text")) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "pt-3 pb-7" }, [
                            _c("img", {
                              staticClass: "img-fluid mx-auto block",
                              attrs: {
                                src: "https://cdn.streamlabs.com/static/imgs/identity/upgrade-brands.png",
                              },
                            }),
                          ]),
                        ],
                  ]
                : _vm._e(),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm._v(" "),
      _c("div", { staticClass: "upgrade-card__spacer" }),
      _vm._v(" "),
      _vm.showWaiting
        ? _c(
            "div",
            { staticClass: "max-w-[400px] mx-auto" },
            [
              _c(
                "Alert",
                {
                  staticClass: "flex rounded-1 text-sm items-center py-3 px-9",
                  attrs: { bg: "bg-info-light", color: "text-info" },
                },
                [
                  _c("CircleNotch", {
                    staticClass: "mr-2 animate-spin",
                    attrs: { size: 14 },
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.t("connect.waitMessage")) +
                        "\n      "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "upgrade-card__button" },
        [
          _vm._t(
            "button",
            [
              _c("div", { staticClass: "max-w-[288px] mx-auto py-3" }, [
                !_vm.confirmed
                  ? _c("div", { staticClass: "upgrade-card__button-confirm" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "sl-btn w-full sl-btn-one-dark whitespace-nowrap py-[14px]",
                          attrs: { type: "button", disabled: _vm.hasSuccess },
                          on: { click: _vm.onConfirm },
                        },
                        [
                          _vm.hasSuccess
                            ? [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.t("upgradeCard.confirm.success")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.t("upgradeCard.confirm.button")
                                    ) +
                                    "\n            "
                                ),
                              ],
                        ],
                        2
                      ),
                    ])
                  : _c(
                      "button",
                      {
                        staticClass:
                          "sl-btn w-full sl-btn-one-dark whitespace-nowrap py-[14px]",
                        attrs: { type: "button" },
                        on: { click: _vm.onClickClose },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.t("upgradeCard.confirmed.button")) +
                            "\n        "
                        ),
                      ]
                    ),
              ]),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
      _vm._v(" "),
      !_vm.confirmed
        ? _c(
            "div",
            { staticClass: "upgrade-card__cancel" },
            [
              _vm._t(
                "cancel",
                [
                  _c("div", { staticClass: "py-3 text-center pb-4" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-sm sl-btn-link-dark-5 underline",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault();
                            return _vm.onClickCancel($event)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.t("upgradeCard.confirm.cancel")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          )
        : _vm._e(),
    ]
  )
};
var __vue_staticRenderFns__$C = [];
__vue_render__$C._withStripped = true;
  const __vue_inject_styles__$C = function (inject) {
    if (!inject) return
    inject("data-v-609e1034_0", { source: "@media (min-height: 850px) {\n.upgrade-card__spacer[data-v-609e1034] {\n    margin-top: 60px;\n}\n}\n.upgrade-card--confirmed[data-v-609e1034]  .sl-card__lead p {\n  font-size: 24px;\n}\n", map: {"version":3,"sources":["ConnectUpgradeCard.vue"],"names":[],"mappings":"AAAA;AACE;IACE,gBAAgB;AAClB;AACF;AACA;EACE,eAAe;AACjB","file":"ConnectUpgradeCard.vue","sourcesContent":["@media (min-height: 850px) {\n  .upgrade-card__spacer {\n    margin-top: 60px;\n  }\n}\n.upgrade-card--confirmed ::v-deep .sl-card__lead p {\n  font-size: 24px;\n}\n"]}, media: undefined });
  };
  const __vue_scope_id__$C = "data-v-609e1034";
  const __vue_module_identifier__$C = undefined;
  const __vue_is_functional_template__$C = false;
  const __vue_component__$C = normalizeComponent(
    { render: __vue_render__$C, staticRenderFns: __vue_staticRenderFns__$C },
    __vue_inject_styles__$C,
    __vue_script__$C,
    __vue_scope_id__$C,
    __vue_is_functional_template__$C,
    __vue_module_identifier__$C,
    false,
    createInjector,
    undefined,
    undefined
  );

let ConnectConfirmCard = class ConnectConfirmCard extends mixins(BaseMixin$1, CompanyMixin$1, ConnectCardMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "confirmTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "confirmSubtitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "confirmLead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "confirmedTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "confirmedLead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    get stateProps() {
        return Object.assign(Object.assign({}, this.getStateProps()), { title: this.title, lead: this.lead });
    }
    get tr() {
        return {
            confirmTitle: this.confirmTitle ||
                this.t('confirmCard.confirm.title', { company: this.company.name }),
            confirmSubtitle: this.confirmSubtitle ||
                this.t('confirmCard.confirm.subtitle', { company: this.company.name }),
            confirmLead: this.confirmLead,
            confirmedTitle: this.confirmedTitle || this.t('confirmCard.confirmed.title'),
            confirmedLead: this.confirmedLead || this.t('confirmCard.confirmed.subtitle'),
        };
    }
    get title() {
        return this.confirmed ? this.tr.confirmedTitle : this.tr.confirmTitle;
    }
    get lead() {
        return (this.confirmed ? this.tr.confirmedLead : this.tr.confirmLead) || '';
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    mounted() {
        this.init();
        if (this.showConfirm) {
            this.setConfirmed(true);
        }
    }
};
__decorate([
    Prop(String)
], ConnectConfirmCard.prototype, "confirmTitle", void 0);
__decorate([
    Prop(String)
], ConnectConfirmCard.prototype, "confirmSubtitle", void 0);
__decorate([
    Prop(String)
], ConnectConfirmCard.prototype, "confirmLead", void 0);
__decorate([
    Prop(String)
], ConnectConfirmCard.prototype, "confirmedTitle", void 0);
__decorate([
    Prop(String)
], ConnectConfirmCard.prototype, "confirmedLead", void 0);
__decorate([
    Prop({ type: String, default: 'confirm' })
], ConnectConfirmCard.prototype, "connectIntent", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], ConnectConfirmCard.prototype, "extraData", void 0);
__decorate([
    Prop(String)
], ConnectConfirmCard.prototype, "noAuthTarget", void 0);
ConnectConfirmCard = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            CheckCircle: __vue_component__$W,
            CircleExclamation: __vue_component__$V,
            CircleNotch: __vue_component__$1e,
            UserIcon: __vue_component__$F,
            SubmitGoButton: __vue_component__$Y,
            SimpleButton: __vue_component__$E,
            Card: __vue_component__$S,
            I18n,
        },
    })
], ConnectConfirmCard);
var script$B = ConnectConfirmCard;

const __vue_script__$B = script$B;
var __vue_render__$B = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    {
      staticClass: "confirm-card",
      class: { "confirm-card--confirmed": _vm.confirmed },
      attrs: {
        "company-id": _vm.companyId,
        dark: _vm.dark,
        "error-message": _vm.errorMessage,
        title: _vm.title,
        lead: _vm.lead,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "logo",
            fn: function () {
              return [_vm._t("logo", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [_vm._t("title", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "subtitle",
            fn: function () {
              return [
                !_vm.confirmed
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "text-2xl py-2 text-center text-one-black dark:text-light-3",
                      },
                      [
                        _vm._v(
                          "\n      " + _vm._s(_vm.tr.confirmSubtitle) + "\n    "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "pt-2" }, [
                  _c("div", { staticClass: "w-full border-t border-light-3" }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "lead",
            fn: function () {
              return [_vm._t("lead", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [_vm._t("error", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c("div", { staticClass: "confirm-card__content-main py-1" }, [
        _c(
          "div",
          { staticClass: "confirm-card__loader" },
          [
            _vm._t("loader", [
              _vm.isLoading
                ? [
                    _c(
                      "div",
                      {
                        staticClass:
                          "connect-sl-card__loading mx-auto h-32 flex items-center justify-center",
                      },
                      [
                        _c("CircleNotch", {
                          staticClass: "animate-spin",
                          attrs: { size: 32 },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ]),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "confirm-card__content" },
          [
            _vm._t(
              "content",
              [
                _vm.user && !_vm.isLoading
                  ? [
                      !_vm.confirmed
                        ? [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "mb-5 text-lg flex flex-wrap gap-x-3 items-center justify-center",
                              },
                              [
                                _c("I18n", {
                                  attrs: {
                                    message: _vm.t(
                                      "confirmCard.confirm.userLine",
                                      { email: _vm.user.email }
                                    ),
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "b",
                                        fn: function (text) {
                                          return [
                                            _c("b", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(text) +
                                                  "\n                  "
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2373787051
                                  ),
                                }),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "text-sm sl-btn-link-dark-5 font-semibold underline",
                                    attrs: { href: "#" },
                                    on: { click: _vm.onClickSwitchAccount },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.t(
                                            "confirmCard.confirm.switchAccount"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "ul",
                              { staticClass: "list-disc pl-6" },
                              _vm._l(3, function (i) {
                                return _c(
                                  "li",
                                  {
                                    key: i,
                                    staticClass: "text-lg leading-7 mb-4",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.t(
                                            "confirmCard.confirm.items." +
                                              (i - 1),
                                            {
                                              company: _vm.company.name,
                                            }
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        : [
                            _c("div", {
                              staticClass:
                                "break border-t border-light-3 mt-4 mb-7",
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "py-3 text-one-black text-md text-center leading-normal",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.t("confirmCard.confirmed.text")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "pt-3 pb-7" }, [
                              _c("img", {
                                staticClass: "img-fluid mx-auto block",
                                attrs: {
                                  src: "https://cdn.streamlabs.com/static/imgs/identity/upgrade-brands.png",
                                },
                              }),
                            ]),
                          ],
                    ]
                  : _vm._e(),
              ],
              null,
              _vm.stateProps
            ),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm._v(" "),
      _c("div", { staticClass: "confirm-card__spacer" }),
      _vm._v(" "),
      _vm.showWaiting
        ? _c(
            "div",
            { staticClass: "max-w-[400px] mx-auto" },
            [
              _c(
                "Alert",
                {
                  staticClass: "flex rounded-1 text-sm items-center py-3 px-9",
                  attrs: { bg: "bg-info-light", color: "text-info" },
                },
                [
                  _c("CircleNotch", {
                    staticClass: "mr-2 animate-spin",
                    attrs: { size: 14 },
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.t("connect.waitMessage")) +
                        "\n      "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "confirm-card__button" },
        [
          _vm._t(
            "button",
            [
              _c("div", { staticClass: "max-w-[288px] mx-auto py-3 mt-4" }, [
                !_vm.confirmed
                  ? _c("div", { staticClass: "confirm-card__button-confirm" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "sl-btn w-full sl-btn-one-dark whitespace-nowrap py-[14px]",
                          attrs: { type: "button", disabled: _vm.hasSuccess },
                          on: { click: _vm.onConfirm },
                        },
                        [
                          _vm.hasSuccess
                            ? [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.t("confirmCard.confirm.success")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.t("confirmCard.confirm.button")
                                    ) +
                                    "\n            "
                                ),
                              ],
                        ],
                        2
                      ),
                    ])
                  : _c(
                      "button",
                      {
                        staticClass:
                          "sl-btn w-full sl-btn-one-dark whitespace-nowrap py-[14px]",
                        attrs: { type: "button" },
                        on: { click: _vm.onClickClose },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.t("confirmCard.confirmed.button")) +
                            "\n        "
                        ),
                      ]
                    ),
              ]),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
      _vm._v(" "),
      !_vm.confirmed
        ? _c(
            "div",
            { staticClass: "confirm-card__cancel" },
            [
              _vm._t(
                "cancel",
                [
                  _c("div", { staticClass: "py-3 text-center pb-4" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-sm sl-btn-link-dark-5 underline",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault();
                            return _vm.onClickCancel($event)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.t("confirmCard.confirm.cancel")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          )
        : _vm._e(),
    ]
  )
};
var __vue_staticRenderFns__$B = [];
__vue_render__$B._withStripped = true;
  const __vue_inject_styles__$B = function (inject) {
    if (!inject) return
    inject("data-v-39dd3add_0", { source: ".confirm-card--confirmed[data-v-39dd3add]  .sl-card__lead p {\n  font-size: 24px;\n}\n", map: {"version":3,"sources":["ConnectConfirmCard.vue"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB","file":"ConnectConfirmCard.vue","sourcesContent":[".confirm-card--confirmed ::v-deep .sl-card__lead p {\n  font-size: 24px;\n}\n"]}, media: undefined });
  };
  const __vue_scope_id__$B = "data-v-39dd3add";
  const __vue_module_identifier__$B = undefined;
  const __vue_is_functional_template__$B = false;
  const __vue_component__$B = normalizeComponent(
    { render: __vue_render__$B, staticRenderFns: __vue_staticRenderFns__$B },
    __vue_inject_styles__$B,
    __vue_script__$B,
    __vue_scope_id__$B,
    __vue_is_functional_template__$B,
    __vue_module_identifier__$B,
    false,
    createInjector,
    undefined,
    undefined
  );

let ConnectUpgradeConfirmCard = class ConnectUpgradeConfirmCard extends mixins(BaseMixin$1, CompanyMixin$1, ConnectCardMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "confirmTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "confirmLead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "confirmedTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "confirmedLead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hasAgreed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
    onClickConfirm() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.hasAgreed) {
                return false;
            }
            return this.onConfirm();
        });
    }
    get stateProps() {
        return Object.assign(Object.assign({}, this.getStateProps()), { title: this.title, lead: this.lead });
    }
    get tr() {
        return {
            confirmTitle: this.confirmTitle ||
                this.t('upgradeConfirmCard.confirm.title', {
                    company: this.company.name,
                }),
            confirmLead: this.confirmLead,
            confirmedTitle: this.confirmedTitle || this.t('upgradeConfirmCard.confirmed.title'),
            confirmedLead: this.confirmedLead ||
                this.t('upgradeConfirmCard.confirmed.subtitle', {
                    company: this.company.name,
                }),
        };
    }
    get title() {
        return this.confirmed ? this.tr.confirmedTitle : this.tr.confirmTitle;
    }
    get lead() {
        return (this.confirmed ? this.tr.confirmedLead : this.tr.confirmLead) || '';
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    mounted() {
        this.init();
        if (this.showConfirm) {
            this.setConfirmed(true);
        }
    }
};
__decorate([
    Prop(String)
], ConnectUpgradeConfirmCard.prototype, "confirmTitle", void 0);
__decorate([
    Prop(String)
], ConnectUpgradeConfirmCard.prototype, "confirmLead", void 0);
__decorate([
    Prop(String)
], ConnectUpgradeConfirmCard.prototype, "confirmedTitle", void 0);
__decorate([
    Prop(String)
], ConnectUpgradeConfirmCard.prototype, "confirmedLead", void 0);
__decorate([
    Prop({ type: String, default: 'upgrade_confirm' })
], ConnectUpgradeConfirmCard.prototype, "connectIntent", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], ConnectUpgradeConfirmCard.prototype, "extraData", void 0);
__decorate([
    Prop(String)
], ConnectUpgradeConfirmCard.prototype, "noAuthTarget", void 0);
ConnectUpgradeConfirmCard = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            CheckCircle: __vue_component__$W,
            CircleExclamation: __vue_component__$V,
            CircleNotch: __vue_component__$1e,
            UserIcon: __vue_component__$F,
            SubmitGoButton: __vue_component__$Y,
            SimpleButton: __vue_component__$E,
            Card: __vue_component__$S,
            I18n,
        },
        directives: {
            checkbox: vCheckbox,
        },
    })
], ConnectUpgradeConfirmCard);
var script$A = ConnectUpgradeConfirmCard;

const __vue_script__$A = script$A;
var __vue_render__$A = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    {
      staticClass: "upgrade-card",
      class: { "upgrade-card--confirmed": _vm.confirmed },
      attrs: {
        "company-id": _vm.companyId,
        dark: _vm.dark,
        "error-message": _vm.errorMessage,
        title: _vm.title,
        lead: _vm.lead,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "logo",
            fn: function () {
              return [_vm._t("logo", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [_vm._t("title", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "lead",
            fn: function () {
              return [_vm._t("lead", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [_vm._t("error", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c("div", { staticClass: "upgrade-confirm-card__content-main py-3" }, [
        _c(
          "div",
          { staticClass: "upgrade-confirm-card__loader" },
          [
            _vm._t("loader", [
              _vm.isLoading
                ? [
                    _c(
                      "div",
                      {
                        staticClass:
                          "connect-sl-card__loading mx-auto h-32 flex items-center justify-center",
                      },
                      [
                        _c("CircleNotch", {
                          staticClass: "animate-spin",
                          attrs: { size: 32 },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ]),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "upgrade-confirm-card__content" },
          [
            _vm._t(
              "content",
              [
                _vm.user && !_vm.isLoading
                  ? [
                      !_vm.confirmed
                        ? [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "mb-5 text-lg flex flex-wrap gap-x-3 items-center justify-center",
                              },
                              [
                                _c("I18n", {
                                  attrs: {
                                    message: _vm.t(
                                      "upgradeConfirmCard.confirm.userLine",
                                      {
                                        email: _vm.user.email,
                                      }
                                    ),
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "b",
                                        fn: function (text) {
                                          return [
                                            _c("b", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(text) +
                                                  "\n                  "
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2373787051
                                  ),
                                }),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "text-sm sl-btn-link-dark-5 font-semibold underline",
                                    attrs: { href: "#" },
                                    on: { click: _vm.onClickSwitchAccount },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.t(
                                            "upgradeConfirmCard.confirm.switchAccount"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "ul",
                              { staticClass: "list-disc pl-6" },
                              _vm._l(3, function (i) {
                                return _c(
                                  "li",
                                  {
                                    key: i,
                                    staticClass:
                                      "text-lg leading-7 text-dark-5 mb-4",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.t(
                                            "upgradeConfirmCard.confirm.items." +
                                              (i - 1),
                                            {
                                              company: _vm.company.name,
                                            }
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "upgrade-confirm-card__agree py-2 px-2",
                              },
                              [
                                _vm._t(
                                  "agreeInput",
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "cursor-pointer flex font-normal text-md leading-relaxed flex items-start text-error",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.hasAgreed,
                                              expression: "hasAgreed",
                                            },
                                            {
                                              name: "checkbox",
                                              rawName: "v-checkbox",
                                            },
                                          ],
                                          staticClass: "mr-2 sl-checkbox mt-1",
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            value: true,
                                            checked: Array.isArray(
                                              _vm.hasAgreed
                                            )
                                              ? _vm._i(_vm.hasAgreed, true) > -1
                                              : _vm.hasAgreed,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = _vm.hasAgreed,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false;
                                              if (Array.isArray($$a)) {
                                                var $$v = true,
                                                  $$i = _vm._i($$a, $$v);
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.hasAgreed = $$a.concat(
                                                      [$$v]
                                                    ));
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.hasAgreed = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ));
                                                }
                                              } else {
                                                _vm.hasAgreed = $$c;
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("I18n", {
                                          attrs: {
                                            message: _vm.t(
                                              "upgradeConfirmCard.confirm.agreeLabel",
                                              {
                                                company: _vm.company.name,
                                              }
                                            ),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  null,
                                  _vm.stateProps
                                ),
                              ],
                              2
                            ),
                          ]
                        : [
                            _c("div", {
                              staticClass:
                                "break border-t border-light-3 mt-4 mb-7",
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "py-3 text-one-black text-md text-center leading-normal",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.t("upgradeConfirmCard.confirmed.text")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "pt-3 pb-7" }, [
                              _c("img", {
                                staticClass: "img-fluid mx-auto block",
                                attrs: {
                                  src: "https://cdn.streamlabs.com/static/imgs/identity/upgrade-brands.png",
                                },
                              }),
                            ]),
                          ],
                    ]
                  : _vm._e(),
              ],
              null,
              _vm.stateProps
            ),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm._v(" "),
      _vm.showWaiting
        ? _c(
            "div",
            { staticClass: "max-w-[400px] mx-auto" },
            [
              _c(
                "Alert",
                {
                  staticClass: "flex rounded-1 text-sm items-center py-3 px-9",
                  attrs: { bg: "bg-info-light", color: "text-info" },
                },
                [
                  _c("CircleNotch", {
                    staticClass: "mr-2 animate-spin",
                    attrs: { size: 14 },
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.t("connect.waitMessage")) +
                        "\n      "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "upgrade-confirm-card__button" },
        [
          _vm._t(
            "button",
            [
              _c("div", { staticClass: "max-w-[288px] mx-auto py-3" }, [
                !_vm.confirmed
                  ? _c(
                      "div",
                      { staticClass: "upgrade-confirm-card__button-confirm" },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "sl-btn w-full sl-btn-one-dark whitespace-nowrap py-[14px]",
                            attrs: {
                              type: "button",
                              disabled: _vm.hasSuccess || !_vm.hasAgreed,
                            },
                            on: { click: _vm.onClickConfirm },
                          },
                          [
                            _vm.hasSuccess
                              ? [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.t(
                                          "upgradeConfirmCard.confirm.success"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              : [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.t(
                                          "upgradeConfirmCard.confirm.button"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass:
                          "sl-btn w-full sl-btn-one-dark whitespace-nowrap py-[14px]",
                        attrs: { type: "button" },
                        on: { click: _vm.onClickClose },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.t("upgradeConfirmCard.confirmed.button")
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
              ]),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
      _vm._v(" "),
      !_vm.confirmed
        ? _c(
            "div",
            { staticClass: "upgrade-confirm-card__cancel" },
            [
              _vm._t(
                "cancel",
                [
                  _c("div", { staticClass: "py-3 text-center pb-4" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-sm sl-btn-link-dark-5 underline",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault();
                            return _vm.onClickCancel($event)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.t("upgradeConfirmCard.confirm.cancel")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          )
        : _vm._e(),
    ]
  )
};
var __vue_staticRenderFns__$A = [];
__vue_render__$A._withStripped = true;
  const __vue_inject_styles__$A = function (inject) {
    if (!inject) return
    inject("data-v-4de71afe_0", { source: "@media (min-height: 850px) {\n.upgrade-card__button-confirm[data-v-4de71afe] {\n    margin-top: 60px;\n}\n}\n.upgrade-card--confirmed[data-v-4de71afe]  .sl-card__lead p {\n  font-size: 24px;\n}\n", map: {"version":3,"sources":["ConnectUpgradeConfirmCard.vue"],"names":[],"mappings":"AAAA;AACE;IACE,gBAAgB;AAClB;AACF;AACA;EACE,eAAe;AACjB","file":"ConnectUpgradeConfirmCard.vue","sourcesContent":["@media (min-height: 850px) {\n  .upgrade-card__button-confirm {\n    margin-top: 60px;\n  }\n}\n.upgrade-card--confirmed ::v-deep .sl-card__lead p {\n  font-size: 24px;\n}\n"]}, media: undefined });
  };
  const __vue_scope_id__$A = "data-v-4de71afe";
  const __vue_module_identifier__$A = undefined;
  const __vue_is_functional_template__$A = false;
  const __vue_component__$A = normalizeComponent(
    { render: __vue_render__$A, staticRenderFns: __vue_staticRenderFns__$A },
    __vue_inject_styles__$A,
    __vue_script__$A,
    __vue_scope_id__$A,
    __vue_is_functional_template__$A,
    __vue_module_identifier__$A,
    false,
    createInjector,
    undefined,
    undefined
  );

let Times = class Times extends IconMixin$1 {
};
Times = __decorate([
    Component({})
], Times);
var script$z = Times;

const __vue_script__$z = script$z;
var __vue_render__$z = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            height: _vm.size,
            width: _vm.size,
            viewBox: "0 0 384 512",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$z = [];
__vue_render__$z._withStripped = true;
  const __vue_inject_styles__$z = undefined;
  const __vue_scope_id__$z = undefined;
  const __vue_module_identifier__$z = undefined;
  const __vue_is_functional_template__$z = false;
  const __vue_component__$z = normalizeComponent(
    { render: __vue_render__$z, staticRenderFns: __vue_staticRenderFns__$z },
    __vue_inject_styles__$z,
    __vue_script__$z,
    __vue_scope_id__$z,
    __vue_is_functional_template__$z,
    __vue_module_identifier__$z,
    false,
    undefined,
    undefined,
    undefined
  );

let Spinner = class Spinner extends IconMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "width", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    Prop({ type: Number, default: 4 })
], Spinner.prototype, "width", void 0);
Spinner = __decorate([
    Component({})
], Spinner);
var script$y = Spinner;

const __vue_script__$y = script$y;
var __vue_render__$y = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "svg",
    {
      attrs: {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 " + _vm.size + " " + _vm.size,
        "xml:space": "preserve",
      },
    },
    [
      _c(
        "rect",
        {
          attrs: {
            x: _vm.width / 2,
            y: "25%",
            width: _vm.width,
            height: "50%",
            fill: "currentColor",
            opacity: "0.2",
          },
        },
        [
          _c("animate", {
            attrs: {
              attributeName: "opacity",
              values: "0.2; 1; 0.2; 0.2",
              dur: "1s",
              repeatCount: "indefinite",
              begin: "0s",
            },
          }),
          _vm._v(" "),
          _c("animate", {
            attrs: {
              attributeName: "height",
              values: "50%; 100%; 50%; 50%",
              dur: "1s",
              repeatCount: "indefinite",
              begin: "0s",
            },
          }),
          _vm._v(" "),
          _c("animate", {
            attrs: {
              attributeName: "y",
              values: "25%; 0%; 25%; 25%",
              dur: "1s",
              repeatCount: "indefinite",
              begin: "0s",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "rect",
        {
          attrs: {
            x: (_vm.size - _vm.width) / 2,
            y: "25%",
            width: _vm.width,
            height: "50%",
            fill: "currentColor",
            opacity: "0.2",
          },
        },
        [
          _c("animate", {
            attrs: {
              attributeName: "opacity",
              values: "0.2; 1; 0.2; 0.2",
              dur: "1s",
              repeatCount: "indefinite",
              begin: "0.25s",
            },
          }),
          _vm._v(" "),
          _c("animate", {
            attrs: {
              attributeName: "height",
              values: "50%; 100%; 50%; 50%",
              dur: "1s",
              repeatCount: "indefinite",
              begin: "0.25s",
            },
          }),
          _vm._v(" "),
          _c("animate", {
            attrs: {
              attributeName: "y",
              values: "25%; 0%; 25%; 25%",
              dur: "1s",
              repeatCount: "indefinite",
              begin: "0.25s",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "rect",
        {
          attrs: {
            x: _vm.size - 1.5 * _vm.width,
            y: "25%",
            width: _vm.width,
            height: "50%",
            fill: "currentColor",
            opacity: "0.2",
          },
        },
        [
          _c("animate", {
            attrs: {
              attributeName: "opacity",
              values: "0.2; 1; 0.2; 0.2",
              dur: "1s",
              repeatCount: "indefinite",
              begin: "0.5s",
            },
          }),
          _vm._v(" "),
          _c("animate", {
            attrs: {
              attributeName: "height",
              values: "50%; 100%; 50%; 50%",
              dur: "1s",
              repeatCount: "indefinite",
              begin: "0.5s",
            },
          }),
          _vm._v(" "),
          _c("animate", {
            attrs: {
              attributeName: "y",
              values: "25%; 0%; 25%; 25%",
              dur: "1s",
              repeatCount: "indefinite",
              begin: "0.5s",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$y = [];
__vue_render__$y._withStripped = true;
  const __vue_inject_styles__$y = undefined;
  const __vue_scope_id__$y = undefined;
  const __vue_module_identifier__$y = undefined;
  const __vue_is_functional_template__$y = false;
  const __vue_component__$y = normalizeComponent(
    { render: __vue_render__$y, staticRenderFns: __vue_staticRenderFns__$y },
    __vue_inject_styles__$y,
    __vue_script__$y,
    __vue_scope_id__$y,
    __vue_is_functional_template__$y,
    __vue_module_identifier__$y,
    false,
    undefined,
    undefined,
    undefined
  );

let ConnectOneClick = class ConnectOneClick extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loggedUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disclaimer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "buttonText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "origin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "returnOrigin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pk", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "privacyUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "connectIntent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "extraData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "autoRedirect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "useNewTab", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "connect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "startOauth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "close", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isConnecting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    setIsConnecting(bool) {
        this.isConnecting = bool;
    }
    setUser(u) {
        this.user = u;
    }
    onSuccess(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.success === 'function') {
                yield this.success(data);
            }
            else {
                this.$emit('connect:success', data);
            }
        });
    }
    onRedirect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.$emit('connect:redirect');
        });
    }
    onTimeout() {
        return __awaiter(this, void 0, void 0, function* () {
            this.$emit('connect:timeout');
        });
    }
    onClosed() {
        return __awaiter(this, void 0, void 0, function* () {
            this.$emit('connect:closed');
        });
    }
    onError(msg, status = 400) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.error === 'function') {
                yield this.error(msg, status);
            }
            else {
                this.$emit('connect:error', msg, status);
            }
        });
    }
    handleConnect() {
        if (typeof this.connect === 'function') {
            return this.connect();
        }
        return feSdk__default.api.identity.connectIdentity(Object.assign({ origin: this.computedOrigin, returnOrigin: this.returnOrigin, pk: this.pk, state: this.state, intent: this.connectIntent }, this.extraData));
    }
    handleXhrError(err, fallback) {
        if (err.data.code === 'email_verification_required') {
            this.$emit('validate', 'email');
        }
        else if (err.data.code === 'token_required') {
            this.$emit('validate', 'tfa');
        }
        else if (err.data.code === 'age_gate_required') {
            this.$emit('validate', 'age-gate');
        }
        else {
            fallback(err);
        }
    }
    get validEventOrigins() {
        return [
            window.location.origin,
            this.computedOrigin,
            this.returnOrigin,
        ].reduce((acc, o) => {
            if (o) {
                const u = new URL(o);
                acc.push(u.origin);
            }
            return acc;
        }, []);
    }
    applyConnectListener(popout, { onSuccess, onClose, }) {
        const source = 'connect';
        let succeeded = false;
        const messageListener = (event) => {
            if (!this.validEventOrigins.includes(event.origin)) {
                return;
            }
            if (event.data.source === source) {
                succeeded = true;
                onSuccess(event.data.data);
            }
        };
        const openedAt = Math.round(Date.now() / 1000);
        const interval = window.setInterval(() => {
            if (succeeded) {
                window.clearInterval(interval);
                window.removeEventListener('message', messageListener, false);
                return;
            }
            if (!popout || popout.closed) {
                window.clearInterval(interval);
                window.removeEventListener('message', messageListener, false);
                onClose('closed');
            }
            else if (Math.round(Date.now() / 1000) - openedAt > 15) {
                window.clearInterval(interval);
                window.removeEventListener('message', messageListener, false);
                onClose('timeout');
            }
        }, 250);
        window.addEventListener('message', messageListener, false);
    }
    onStartOauth(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.startOauth === 'function') {
                return this.startOauth(data);
            }
            this.$emit('connect:click');
            if (this.autoRedirect) {
                if (data === null || data === void 0 ? void 0 : data.redirect_url) {
                    if (this.useNewTab) {
                        try {
                            const opened = window.open(data.redirect_url, '_blank');
                            yield new Promise((resolve) => {
                                this.applyConnectListener(opened, {
                                    onSuccess: (data) => {
                                        this.onSuccess(data);
                                        resolve(true);
                                    },
                                    onClose: (message) => {
                                        if (message === 'timeout') {
                                            this.onTimeout();
                                        }
                                        else {
                                            this.onClosed();
                                        }
                                        resolve(false);
                                    },
                                });
                            });
                            this.setIsConnecting(false);
                        }
                        catch (err) {
                            this.onRedirect();
                            window.location.href = data.redirect_url;
                        }
                    }
                    else {
                        this.onRedirect();
                        window.location.href = data.redirect_url;
                    }
                }
                else {
                    console.error('could not auto-redirect from ConnectOneClick. Data was: ', data);
                    this.onError(this.t('connectOneClick.errors.auto-redirect'));
                }
            }
            else {
                this.$emit('connect:response', data);
            }
        });
    }
    onConnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setIsConnecting(true);
            try {
                const data = yield this.handleConnect();
                this.onStartOauth(data);
            }
            catch (err) {
                if (err instanceof ApiError) {
                    this.handleXhrError(err, (e) => {
                        this.setIsConnecting(false);
                        this.onError(e.message, e.status);
                    });
                }
            }
        });
    }
    onClose() {
        if (typeof this.close === 'function') {
            return this.close();
        }
        this.$emit('close');
        this.$emit('show', false);
    }
    getLoggedInUser() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const userResponse = yield feSdk__default.api.user.getAuthUser();
                this.setUser(userResponse);
            }
            catch (err) {
            }
        });
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.loggedUser) {
                this.setUser(Object.assign({}, this.loggedUser));
            }
            else {
                yield this.getLoggedInUser();
            }
        });
    }
    get computedOrigin() {
        return this.origin !== undefined
            ? this.origin
            : feSdk__default.env.get().domains.identity;
    }
    get computedPrivacyUrl() {
        return methods.getCompanyLink(this.company.id, 'privacy', this.privacyUrl);
    }
    get iconInitial() {
        var _a;
        if ((_a = this.user) === null || _a === void 0 ? void 0 : _a.username) {
            return this.user.username[0].toUpperCase();
        }
        return '';
    }
    userWatcher() {
        var _a;
        this.$emit('show', !!((_a = this.user) === null || _a === void 0 ? void 0 : _a.username));
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    mounted() {
        this.init();
    }
    get tr() {
        var _a, _b;
        return {
            title: this.title || this.company.name
                ? this.t('connectOneClick.title.company', {
                    company: this.company.name,
                })
                : this.t('connectOneClick.title.noCompany'),
            disclaimer: this.disclaimer ||
                this.t('connectOneClick.disclaimer', { company: this.company.name }),
            buttonText: this.buttonText || ((_a = this.user) === null || _a === void 0 ? void 0 : _a.username)
                ? this.t('connectOneClick.buttonText.username', {
                    name: (_b = this.user) === null || _b === void 0 ? void 0 : _b.username,
                })
                : this.t('connectOneClick.buttonText.noUsername'),
        };
    }
    get stateProps() {
        return {
            company: this.company,
            title: this.tr.title,
            disclaimer: this.tr.disclaimer,
            buttonText: this.tr.buttonText,
            origin: this.computedOrigin,
            pk: this.pk || '',
            isConnecting: this.isConnecting,
            user: this.user,
            init: this.init,
            setIsConnecting: this.setIsConnecting,
            onClose: this.onClose,
            onError: this.onError,
            onConnect: this.onConnect,
            onSuccess: this.onSuccess,
            onTimeout: this.onTimeout,
            onClosed: this.onClosed,
            onRedirect: this.onRedirect,
            onStartOauth: this.onStartOauth,
        };
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], ConnectOneClick.prototype, "dark", void 0);
__decorate([
    Prop({ type: Object, default: null })
], ConnectOneClick.prototype, "loggedUser", void 0);
__decorate([
    Prop(String)
], ConnectOneClick.prototype, "title", void 0);
__decorate([
    Prop(String)
], ConnectOneClick.prototype, "disclaimer", void 0);
__decorate([
    Prop(String)
], ConnectOneClick.prototype, "buttonText", void 0);
__decorate([
    Prop(String)
], ConnectOneClick.prototype, "origin", void 0);
__decorate([
    Prop(String)
], ConnectOneClick.prototype, "returnOrigin", void 0);
__decorate([
    Prop(String)
], ConnectOneClick.prototype, "pk", void 0);
__decorate([
    Prop(String)
], ConnectOneClick.prototype, "state", void 0);
__decorate([
    Prop(String)
], ConnectOneClick.prototype, "privacyUrl", void 0);
__decorate([
    Prop({ type: String, default: 'connect' })
], ConnectOneClick.prototype, "connectIntent", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], ConnectOneClick.prototype, "extraData", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], ConnectOneClick.prototype, "autoRedirect", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], ConnectOneClick.prototype, "useNewTab", void 0);
__decorate([
    Prop(Function)
], ConnectOneClick.prototype, "connect", void 0);
__decorate([
    Prop(Function)
], ConnectOneClick.prototype, "success", void 0);
__decorate([
    Prop(Function)
], ConnectOneClick.prototype, "startOauth", void 0);
__decorate([
    Prop(Function)
], ConnectOneClick.prototype, "error", void 0);
__decorate([
    Prop(Function)
], ConnectOneClick.prototype, "close", void 0);
__decorate([
    Watch('user')
], ConnectOneClick.prototype, "userWatcher", null);
ConnectOneClick = __decorate([
    Component({
        components: {
            IconTimes: __vue_component__$z,
            Kevin: __vue_component__$11,
            Spinner: __vue_component__$y,
            I18n,
        },
    })
], ConnectOneClick);
var script$x = ConnectOneClick;

const __vue_script__$x = script$x;
var __vue_render__$x = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "sl-one-component" }, [
    _c(
      "div",
      { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
      [
        _c(
          "div",
          {
            staticClass:
              "one-click min-h-[256px] w-[375px] max-w-full rounded-lg py-2 text-sm text-dark-2 bg-white dark:bg-dark-2 dark:text-light-3",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "one-click__top border-b-1 mb-2 border-b border-gray-300 dark:border-gray-700 px-3 pb-3",
              },
              [
                _vm._t(
                  "top",
                  [
                    _c("div", { staticClass: "flex items-center gap-x-4" }, [
                      _c("div", [_c("Kevin", { attrs: { size: 24 } })], 1),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pt-[2px]" },
                        [
                          _c("I18n", {
                            attrs: { message: _vm.tr.title },
                            scopedSlots: _vm._u([
                              {
                                key: "b",
                                fn: function (text) {
                                  return [_c("b", [_vm._v(_vm._s(text))])]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "ml-auto pt-[2px]" }, [
                        _c(
                          "a",
                          {
                            staticClass: "text-lg",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault();
                                return _vm.onClose($event)
                              },
                            },
                          },
                          [_c("IconTimes")],
                          1
                        ),
                      ]),
                    ]),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "one-click__profile px-3" },
              [
                _vm._t(
                  "profile",
                  [
                    _vm.user
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center cursor-pointer gap-x-2 px-3 py-2 hover:bg-light-3 dark:hover:bg-dark-4",
                            on: { click: _vm.onConnect },
                          },
                          [
                            _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "one-click__icon flex h-8 w-8 items-center justify-center rounded-full bg-dark-teal text-white",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.iconInitial) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", { staticClass: "font-medium" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.user.username) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "text-sm" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.user.email) +
                                    "\n              "
                                ),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "one-click__button px-3 py-2" },
              [
                _vm._t(
                  "button",
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "w-100 block flex h-10 w-full items-center justify-center rounded bg-dark-1 py-2 px-3 text-white",
                        attrs: { disabled: _vm.isConnecting },
                        on: { click: _vm.onConnect },
                      },
                      [
                        _vm.isConnecting
                          ? [_c("Spinner", { staticClass: "h-5 text-white" })]
                          : [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "block text-center w-full text-ellipsis whitespace-nowrap overflow-hidden",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.tr.buttonText) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                      ],
                      2
                    ),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "one-click__terms px-3 py-2" },
              [
                _vm._t(
                  "terms",
                  [
                    _c("I18n", {
                      attrs: { message: _vm.tr.disclaimer },
                      scopedSlots: _vm._u([
                        {
                          key: "privacy",
                          fn: function (text) {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "text-sky-700 hover:text-sky-900 hover:underline",
                                  attrs: {
                                    target: "_blank",
                                    href: _vm.computedPrivacyUrl,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(text) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
          ]
        ),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$x = [];
__vue_render__$x._withStripped = true;
  const __vue_inject_styles__$x = undefined;
  const __vue_scope_id__$x = undefined;
  const __vue_module_identifier__$x = undefined;
  const __vue_is_functional_template__$x = false;
  const __vue_component__$x = normalizeComponent(
    { render: __vue_render__$x, staticRenderFns: __vue_staticRenderFns__$x },
    __vue_inject_styles__$x,
    __vue_script__$x,
    __vue_scope_id__$x,
    __vue_is_functional_template__$x,
    __vue_module_identifier__$x,
    false,
    undefined,
    undefined,
    undefined
  );

let RightArrow$1 = class RightArrow extends IconMixin$1 {
};
RightArrow$1 = __decorate([
    Component({})
], RightArrow$1);
var script$w = RightArrow$1;

const __vue_script__$w = script$w;
var __vue_render__$w = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: _vm.size,
            width: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M384 96L384 0h-112c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48H464c26.51 0 48-21.49 48-48V128h-95.1C398.4 128 384 113.6 384 96zM416 0v96h96L416 0zM192 352V128h-144c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h192c26.51 0 48-21.49 48-48L288 416h-32C220.7 416 192 387.3 192 352z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$w = [];
__vue_render__$w._withStripped = true;
  const __vue_inject_styles__$w = undefined;
  const __vue_scope_id__$w = undefined;
  const __vue_module_identifier__$w = undefined;
  const __vue_is_functional_template__$w = false;
  const __vue_component__$w = normalizeComponent(
    { render: __vue_render__$w, staticRenderFns: __vue_staticRenderFns__$w },
    __vue_inject_styles__$w,
    __vue_script__$w,
    __vue_scope_id__$w,
    __vue_is_functional_template__$w,
    __vue_module_identifier__$w,
    false,
    undefined,
    undefined,
    undefined
  );

const { getAuthenticatorApps } = methods;
let CreateTfaScan = class CreateTfaScan extends BaseMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "authApps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: getAuthenticatorApps()
        });
        Object.defineProperty(this, "qrUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "qrSecret", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "qrHtml", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "clicked", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
    }
    mounted() {
        this.getQrCode();
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setErrorMessage(msg) {
        this.errorMessage = msg;
    }
    getQrCode() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            this.qrUrl = '';
            this.qrSecret = '';
            this.qrHtml = '';
            try {
                const { secret, secret_url } = yield feSdk__default.api.auth.generateTfa();
                this.qrSecret = secret;
                this.qrUrl = secret_url;
                this.qrHtml = yield QRCode.toString(this.qrUrl);
                this.$emit('qr:ready');
            }
            catch (err) {
                if (err instanceof ApiError) {
                    this.setErrorMessage(((_a = err.data) === null || _a === void 0 ? void 0 : _a.message) || err.message || this.t('errors.unknown'));
                    this.$emit('step:error', err.message || this.t('errors.unknown'));
                }
                else if (err instanceof TypeError) {
                    this.setErrorMessage(this.t('errors.unknown'));
                    this.$emit('step:error', err.message || this.t('errors.unknown'));
                }
                else {
                    this.setErrorMessage(this.t('errors.contactSupport'));
                    this.$emit('step:error', this.t('errors.contactSupport'));
                }
            }
            this.loading = false;
        });
    }
    onCopySecret() {
        copyToClipboard(this.qrSecret);
        this.clicked = true;
        setTimeout(() => {
            this.clicked = false;
        }, 2000);
    }
    onFocusSecret(e) {
        const target = e.target;
        target.select();
    }
    onComplete() {
        this.$emit('step:complete');
    }
    getAppSlot(i) {
        return `app${i}`;
    }
    get hasQrCode() {
        return !!this.qrHtml;
    }
    get stateProps() {
        return {
            hasQrCode: this.hasQrCode,
            loading: this.loading,
            errorMessage: this.errorMessage,
            setLoading: this.setLoading,
            setErrorMessage: this.setErrorMessage,
        };
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], CreateTfaScan.prototype, "dark", void 0);
CreateTfaScan = __decorate([
    Component({
        components: {
            CircleNotch: __vue_component__$1e,
            Alert: __vue_component__$X,
            CircleExclamation: __vue_component__$V,
            SimpleButton: __vue_component__$E,
            CardTitle: __vue_component__$U,
            CardLead: __vue_component__$T,
            SubmitGoButton: __vue_component__$Y,
            I18n,
            Copy: __vue_component__$w,
            CheckCircle: __vue_component__$W,
        },
    })
], CreateTfaScan);
var script$v = CreateTfaScan;

const __vue_script__$v = script$v;
var __vue_render__$v = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "sl-one-component" }, [
    _c(
      "div",
      { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
      [
        _c(
          "div",
          {
            staticClass:
              "create-tfa-scan text-gray-900 dark:text-gray-300 max-w-full w-full",
          },
          [
            _c("div", { staticClass: "pb-3" }, [
              _c(
                "div",
                { staticClass: "create-tfa-scan__title" },
                [
                  _vm._t(
                    "title",
                    [
                      _c("CardTitle", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.t("createTfa.scan.title")) +
                            "\n            "
                        ),
                      ]),
                    ],
                    null,
                    _vm.stateProps
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "create-tfa-scan__lead" },
                [
                  _vm._t(
                    "lead",
                    [
                      _c(
                        "CardLead",
                        [
                          _c("I18n", {
                            attrs: { message: _vm.t("createTfa.scan.lead") },
                            scopedSlots: _vm._u(
                              [
                                _vm._l(_vm.authApps, function (ref, i) {
                                  var name = ref.name;
                                  var url = ref.url;
                                  return {
                                    key: _vm.getAppSlot(i),
                                    fn: function () {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            key: name + "-link",
                                            staticClass:
                                              "font-semibold cursor-pointer underline text-dark-2 hover:text-black dark:text-light-3 dark:hover:text-light-1",
                                            attrs: {
                                              href: url,
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(name) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  }
                                }),
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    null,
                    _vm.stateProps
                  ),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "create-tfa-scan__qr" },
              [
                _vm._t(
                  "qr",
                  [
                    !_vm.loading && !_vm.errorMessage && _vm.hasQrCode
                      ? _c("div", { staticClass: "py-3 cursor-pointer" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-wrap xs:gap-x-4 md:gap-x-6 items-stretch justify-center py-6",
                            },
                            [
                              _c("div", { staticClass: "w-[240px]" }, [
                                _vm.qrHtml
                                  ? _c("div", {
                                      staticClass:
                                        "w-full rounded-t overflow-hidden",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.qrHtml),
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "xs:w-[240px] py-2" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-center p-4 bg-light-2 text-dark-5 rounded",
                                  },
                                  [
                                    _c("p", { staticClass: "text-sm mb-4" }, [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.t("createTfa.scan.instructions")
                                          ) +
                                          "\n                  "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "flex xs:block gap-x-4" },
                                      [
                                        _c("textarea", {
                                          staticClass:
                                            "secret-text grow mb-4 border border-light-3 rounded p-2 bg-light-2 focus:bg-light-1 focus:outline-none focus:border-dark-5",
                                          attrs: { readonly: "" },
                                          domProps: { value: _vm.qrSecret },
                                          on: { focus: _vm.onFocusSecret },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "shrink" },
                                          [
                                            _c(
                                              "SimpleButton",
                                              {
                                                staticClass:
                                                  "bg-light-3 md:w-full focus:text-dark-3 hover:text-dark-3 focus:bg-light-3 hover:bg-light-3",
                                                attrs: { color: "text-dark-5" },
                                                on: { click: _vm.onCopySecret },
                                              },
                                              [
                                                !_vm.clicked
                                                  ? [
                                                      _c("Copy", {
                                                        staticClass:
                                                          "md:mr-2 pt-0.5",
                                                        attrs: { size: 15 },
                                                      }),
                                                    ]
                                                  : [
                                                      _c("CheckCircle", {
                                                        staticClass: "md:mr-2",
                                                        attrs: { size: 15 },
                                                      }),
                                                    ],
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "hidden md:inline-block",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          _vm.clicked
                                                            ? _vm.t(
                                                                "createTfa.scan.copied"
                                                              )
                                                            : _vm.t(
                                                                "createTfa.scan.copy"
                                                              )
                                                        ) +
                                                        "\n                        "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "create-tfa-scan__error" },
              [
                _vm._t(
                  "error",
                  [
                    !_vm.loading && _vm.errorMessage
                      ? _c(
                          "div",
                          { staticClass: "py-3" },
                          [
                            _c(
                              "Alert",
                              {
                                staticClass:
                                  "flex text-sm items-center font-medium",
                              },
                              [
                                _c("CircleExclamation", {
                                  staticClass: "mr-2",
                                  attrs: { size: 16 },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errorMessage) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "create-tfa-scan__button md:w-[360px] mx-auto" },
              [
                _vm._t(
                  "button",
                  [
                    _c(
                      "div",
                      { staticClass: "py-3 mx-6 text-center" },
                      [
                        _c(
                          "SubmitGoButton",
                          {
                            staticClass: "hover:drop-shadow",
                            on: { click: _vm.onComplete },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.t("createTfa.scan.proceed")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "create-tfa-scan__loading" },
              [
                _vm._t(
                  "loading",
                  [
                    _vm.loading
                      ? _c(
                          "div",
                          { staticClass: "py-10 w-full flex justify-center" },
                          [
                            _c("CircleNotch", {
                              staticClass: "animate-spin text-gray-500",
                              attrs: { size: 28 },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
          ]
        ),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$v = [];
__vue_render__$v._withStripped = true;
  const __vue_inject_styles__$v = function (inject) {
    if (!inject) return
    inject("data-v-84f0acfc_0", { source: ".secret-text[data-v-84f0acfc] {\n  resize: none;\n}\n.secret-text[data-v-84f0acfc]:focus {\n  box-shadow: none;\n}\n", map: {"version":3,"sources":["CreateTfaScan.vue"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB","file":"CreateTfaScan.vue","sourcesContent":[".secret-text {\n  resize: none;\n}\n.secret-text:focus {\n  box-shadow: none;\n}\n"]}, media: undefined });
  };
  const __vue_scope_id__$v = "data-v-84f0acfc";
  const __vue_module_identifier__$v = undefined;
  const __vue_is_functional_template__$v = false;
  const __vue_component__$v = normalizeComponent(
    { render: __vue_render__$v, staticRenderFns: __vue_staticRenderFns__$v },
    __vue_inject_styles__$v,
    __vue_script__$v,
    __vue_scope_id__$v,
    __vue_is_functional_template__$v,
    __vue_module_identifier__$v,
    false,
    createInjector,
    undefined,
    undefined
  );

let Digits = class Digits extends Vue {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "count", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "digits", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "lastInputChanged", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    created() {
        this.digits = Array(this.count).fill('');
    }
    mounted() {
        this.setDigits(this.value);
    }
    focus() {
        this.inputs[0].focus();
    }
    cleanString(str) {
        const cleaned = str.replace(/[^0-9]/g, '');
        return [cleaned, cleaned.length !== str.length];
    }
    onPaste(index, $event) {
        var _a;
        const [paste, hadInvalidChars] = this.cleanString((_a = $event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData('text'));
        this.setDigits(paste, index);
        if (hadInvalidChars) {
            this.$emit('error:invalid');
        }
        const next = this.inputs[index + paste.length];
        if (next) {
            next.focus();
        }
        else if (!hadInvalidChars) {
            $event.target.blur();
        }
        this.checkComplete();
    }
    checkComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.$nextTick();
            if (this.count === this.code.length) {
                setTimeout(() => {
                    this.$emit('filled', this.code);
                }, 100);
            }
        });
    }
    onKeyup(index, $event) {
        if (!/^[A-Za-z0-9]+$/.test($event.key)) {
            return true;
        }
        const [parsed, hadInvalidChar] = this.cleanString($event.key);
        if (!hadInvalidChar && this.digits[index].length) {
            this.digits.splice(index, 1, parsed);
            const next = this.inputs[index + 1];
            if (next) {
                next.focus();
            }
        }
    }
    onInput(index, $event) {
        const target = $event.target;
        const [parsed, hadInvalidChars] = this.cleanString(this.digits[index]);
        this.digits[index] = parsed;
        if (hadInvalidChars) {
            this.$emit('error:invalid');
        }
        else {
            this.lastInputChanged = index;
            const next = this.inputs[index + 1];
            if (next) {
                next.focus();
            }
            else {
                target.blur();
            }
            this.checkComplete();
        }
    }
    onBackspace(index) {
        this.digits.splice(index, 1, '');
        const prev = this.inputs[index - 1];
        if (prev) {
            prev.focus();
        }
    }
    setDigits(v, from = 0) {
        var _a;
        const items = v.split('');
        for (let i = from; i < this.count; i++) {
            this.digits.splice(i, 1, (_a = items[i - from]) !== null && _a !== void 0 ? _a : '');
        }
    }
    get inputs() {
        return this.$refs.inputs;
    }
    get code() {
        return this.digits.join('');
    }
    codeWatcher(code) {
        if (code !== this.value) {
            this.$emit('update:value', code);
        }
    }
    valueWatcher(value) {
        if (value !== this.code) {
            this.setDigits(value);
        }
    }
};
__decorate([
    Model('update:value', { type: String })
], Digits.prototype, "value", void 0);
__decorate([
    Prop({ type: Number, default: 6 })
], Digits.prototype, "count", void 0);
__decorate([
    Prop(Boolean)
], Digits.prototype, "disabled", void 0);
__decorate([
    Watch('code')
], Digits.prototype, "codeWatcher", null);
__decorate([
    Watch('value')
], Digits.prototype, "valueWatcher", null);
Digits = __decorate([
    Component({})
], Digits);
var script$u = Digits;

const __vue_script__$u = script$u;
var __vue_render__$u = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "flex justify-between" },
    _vm._l(_vm.count, function (i) {
      return _c("div", { key: i - 1, staticClass: "input" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.digits[i - 1],
              expression: "digits[i - 1]",
            },
          ],
          ref: "inputs",
          refInFor: true,
          staticClass:
            "w-10 sm:w-12 text-center sl-form-input theme-dark sm:text-lg aspect-square",
          attrs: {
            maxlength: "1",
            selectall: "",
            autofocus: i === 1,
            disabled: _vm.disabled,
          },
          domProps: { value: _vm.digits[i - 1] },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.digits, i - 1, $event.target.value);
              },
              function ($event) {
                return _vm.onInput(i - 1, $event)
              },
            ],
            paste: function ($event) {
              $event.preventDefault();
              return _vm.onPaste(0, $event)
            },
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k(
                  $event.keyCode,
                  "backspace",
                  undefined,
                  $event.key,
                  undefined
                )
              ) {
                return null
              }
              $event.preventDefault();
              return _vm.onBackspace(i - 1)
            },
            keyup: function ($event) {
              return _vm.onKeyup(i - 1, $event)
            },
          },
        }),
      ])
    }),
    0
  )
};
var __vue_staticRenderFns__$u = [];
__vue_render__$u._withStripped = true;
  const __vue_inject_styles__$u = undefined;
  const __vue_scope_id__$u = undefined;
  const __vue_module_identifier__$u = undefined;
  const __vue_is_functional_template__$u = false;
  const __vue_component__$u = normalizeComponent(
    { render: __vue_render__$u, staticRenderFns: __vue_staticRenderFns__$u },
    __vue_inject_styles__$u,
    __vue_script__$u,
    __vue_scope_id__$u,
    __vue_is_functional_template__$u,
    __vue_module_identifier__$u,
    false,
    undefined,
    undefined,
    undefined
  );

let CreateTfaConfirm = class CreateTfaConfirm extends BaseMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "errorTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "checking", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "checkPassed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "recoveryCodes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
    }
    setErrorMessage(msg) {
        this.errorMessage = msg;
    }
    setChecking(checking) {
        this.checking = checking;
    }
    setCheckPassed(checkPassed) {
        this.checkPassed = checkPassed;
    }
    onComplete() {
        this.$emit('step:complete', this.recoveryCodes);
    }
    onDigitsFilled() {
        return __awaiter(this, void 0, void 0, function* () {
            this.onCheckCode();
        });
    }
    onCheckCode() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.setChecking(true);
            try {
                const { recovery_codes: recoveryCodes } = yield feSdk__default.api.auth.confirmTfa(this.code);
                this.recoveryCodes = recoveryCodes;
                this.setCheckPassed(true);
                this.onComplete();
            }
            catch (err) {
                if (err instanceof ApiError) {
                    this.setErrorMessage(((_a = err.data) === null || _a === void 0 ? void 0 : _a.message) || err.message || this.t('errors.unknown'));
                    this.$emit('step:error', err.message || this.t('errors.unknown'));
                }
                else if (err instanceof TypeError) {
                    this.setErrorMessage(this.t('errors.unknown'));
                    this.$emit('step:error', err.message || this.t('errors.unknown'));
                }
                else {
                    this.setErrorMessage(this.t('errors.contactSupport'));
                    this.$emit('step:error', this.t('errors.contactSupport'));
                }
            }
            this.setChecking(false);
        });
    }
    onDigitsError() {
        this.setErrorMessage('Auth code should only be digits 0-9');
        clearTimeout(this.errorTimeout);
        this.errorTimeout = setTimeout(() => {
            this.setErrorMessage('');
        }, 2500);
    }
    get stateProps() {
        return {
            errorMessage: this.errorMessage,
            setErrorMessage: this.setErrorMessage,
        };
    }
    get codeIsValid() {
        return this.code.length === 6;
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], CreateTfaConfirm.prototype, "dark", void 0);
CreateTfaConfirm = __decorate([
    Component({
        components: {
            CircleNotch: __vue_component__$1e,
            Alert: __vue_component__$X,
            CircleExclamation: __vue_component__$V,
            SimpleButton: __vue_component__$E,
            Digits: __vue_component__$u,
            CardTitle: __vue_component__$U,
            CardLead: __vue_component__$T,
            SubmitGoButton: __vue_component__$Y,
        },
    })
], CreateTfaConfirm);
var script$t = CreateTfaConfirm;

const __vue_script__$t = script$t;
var __vue_render__$t = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "sl-one-component" }, [
    _c(
      "div",
      { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
      [
        _c(
          "div",
          {
            staticClass:
              "create-tfa-scan max-w-full w-full text-gray-700 dark:text-gray-300",
          },
          [
            _c("div", { staticClass: "pb-3" }, [
              _c(
                "div",
                { staticClass: "create-tfa-scan__title" },
                [
                  _vm._t(
                    "title",
                    [
                      _c("CardTitle", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.t("createTfa.confirm.title")) +
                            "\n            "
                        ),
                      ]),
                    ],
                    null,
                    _vm.stateProps
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "create-tfa-scan__lead" },
                [
                  _vm._t(
                    "lead",
                    [
                      _c("CardLead", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.t("createTfa.confirm.lead")) +
                            "\n            "
                        ),
                      ]),
                    ],
                    null,
                    _vm.stateProps
                  ),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "create-tfa-scan__digits xs:w-[360px] mx-auto" },
              [
                _vm._t(
                  "digits",
                  [
                    _c(
                      "div",
                      { staticClass: "py-3" },
                      [
                        _c(
                          "h4",
                          {
                            staticClass:
                              "text-sm font-semibold text-black dark:text-white pb-1",
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.t("createTfa.confirm.label")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("Digits", {
                          attrs: { disabled: _vm.checking || _vm.checkPassed },
                          on: {
                            filled: _vm.onDigitsFilled,
                            "error:invalid": _vm.onDigitsError,
                          },
                          model: {
                            value: _vm.code,
                            callback: function ($$v) {
                              _vm.code = $$v;
                            },
                            expression: "code",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "create-tfa-scan__error" },
              [
                _vm._t(
                  "error",
                  [
                    _vm.errorMessage
                      ? _c(
                          "div",
                          { staticClass: "py-3" },
                          [
                            _c(
                              "Alert",
                              {
                                staticClass:
                                  "flex text-sm items-center justify-center font-medium",
                              },
                              [
                                _c("CircleExclamation", {
                                  staticClass: "mr-2",
                                  attrs: { size: 16 },
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errorMessage) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "create-tfa-scan__button xs:w-[360px] mx-auto" },
              [
                _vm._t(
                  "button",
                  [
                    !_vm.checkPassed
                      ? _c(
                          "div",
                          { staticClass: "py-3 text-center" },
                          [
                            _c(
                              "SubmitGoButton",
                              {
                                staticClass: "hover:drop-shadow",
                                attrs: {
                                  disabled: !_vm.codeIsValid || _vm.checking,
                                  loading: _vm.checking,
                                },
                                on: { click: _vm.onCheckCode },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.t("createTfa.confirm.verify")) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "py-3 text-center" },
                          [
                            _c(
                              "SubmitGoButton",
                              {
                                staticClass: "hover:drop-shadow",
                                on: { click: _vm.onComplete },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.t("createTfa.confirm.next")) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
          ]
        ),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$t = [];
__vue_render__$t._withStripped = true;
  const __vue_inject_styles__$t = undefined;
  const __vue_scope_id__$t = undefined;
  const __vue_module_identifier__$t = undefined;
  const __vue_is_functional_template__$t = false;
  const __vue_component__$t = normalizeComponent(
    { render: __vue_render__$t, staticRenderFns: __vue_staticRenderFns__$t },
    __vue_inject_styles__$t,
    __vue_script__$t,
    __vue_scope_id__$t,
    __vue_is_functional_template__$t,
    __vue_module_identifier__$t,
    false,
    undefined,
    undefined,
    undefined
  );

let CreateTfaSave = class CreateTfaSave extends BaseMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "recoveryCodes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "copied", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "copiedTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "downloaded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "downloadedMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
    }
    onTextareaFocus(e) {
        const target = e.target;
        copyToClipboard(this.recoveryCodes.join('\n'));
        target.select();
        this.copied = true;
        clearTimeout(this.copiedTimeout);
        this.copiedTimeout = setTimeout(() => {
            this.copied = false;
        }, 2500);
    }
    onDownload() {
        this.downloaded = true;
        this.downloadedMessage = '';
        this.$emit('step:download');
        const a = document.createElement('a');
        const file = new Blob([this.recoveryCodes.join('\n')], {
            type: 'text/plain',
        });
        a.href = URL.createObjectURL(file);
        a.download = 'streamlabs-identity-recovery-codes.txt';
        a.click();
        URL.revokeObjectURL(a.href);
    }
    onComplete() {
        if (!this.downloaded) {
            this.downloadedMessage = this.t('createTfa.save.downloadFirstMessage');
            return;
        }
        this.$emit('step:complete');
    }
    get stateProps() {
        return {
            recoveryCodes: this.recoveryCodes,
            onDownload: this.onDownload,
            onComplete: this.onComplete,
            downloaded: this.downloaded,
        };
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], CreateTfaSave.prototype, "dark", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], CreateTfaSave.prototype, "recoveryCodes", void 0);
CreateTfaSave = __decorate([
    Component({
        components: {
            CircleNotch: __vue_component__$1e,
            Alert: __vue_component__$X,
            CircleExclamation: __vue_component__$V,
            SimpleButton: __vue_component__$E,
            Digits: __vue_component__$u,
            CardTitle: __vue_component__$U,
            CardLead: __vue_component__$T,
            SubmitGoButton: __vue_component__$Y,
        },
    })
], CreateTfaSave);
var script$s = CreateTfaSave;

const __vue_script__$s = script$s;
var __vue_render__$s = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "sl-one-component" }, [
    _c(
      "div",
      { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
      [
        _c(
          "div",
          {
            staticClass:
              "create-tfa-scan max-w-full w-full text-gray-700 dark:text-gray-300",
          },
          [
            _c(
              "div",
              { staticClass: "pb-3" },
              [
                _c(
                  "div",
                  { staticClass: "create-tfa-scan__title" },
                  [
                    _vm._t(
                      "title",
                      [
                        _c("CardTitle", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.t("createTfa.save.title")) +
                              "\n            "
                          ),
                        ]),
                      ],
                      null,
                      _vm.stateProps
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "Alert",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.downloadedMessage,
                        expression: "downloadedMessage",
                      },
                    ],
                    staticClass: "p-4 mb-3 text-center w-full rounded-lg",
                    attrs: { bg: "bg-sky-100", color: "sky-600" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.downloadedMessage) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "create-tfa-scan__lead" },
                  [
                    _vm._t(
                      "lead",
                      [
                        _c("CardLead", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.t("createTfa.save.lead")) +
                              "\n            "
                          ),
                        ]),
                      ],
                      null,
                      _vm.stateProps
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "create-tfa-scan__codes md:w-[360px] mx-auto" },
              [
                _vm._t(
                  "codes",
                  [
                    _c(
                      "div",
                      { staticClass: "py-3" },
                      [
                        _c(
                          "h4",
                          {
                            staticClass:
                              "text-sm font-semibold text-black dark:text-white pb-1",
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.t("createTfa.save.label")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("textarea", {
                          staticClass: "sl-form-control theme-dark w-full",
                          attrs: { rows: "8", readonly: "" },
                          domProps: { value: _vm.recoveryCodes.join("\n") },
                          on: { focus: _vm.onTextareaFocus },
                        }),
                        _vm._v(" "),
                        _c(
                          "SimpleButton",
                          {
                            staticClass:
                              "bg-dark-teal sl-btn-active w-full hover:drop-shadow",
                            on: { click: _vm.onDownload },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.copied
                                    ? _vm.t("createTfa.save.copied")
                                    : _vm.t("createTfa.save.download")
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "create-tfa-scan__button md:w-[360px] mx-auto" },
              [
                _vm._t(
                  "button",
                  [
                    _c(
                      "div",
                      { staticClass: "py-3 text-center" },
                      [
                        _c(
                          "SubmitGoButton",
                          {
                            staticClass: "hover:drop-shadow",
                            on: { click: _vm.onComplete },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.t("createTfa.save.finished")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
          ]
        ),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$s = [];
__vue_render__$s._withStripped = true;
  const __vue_inject_styles__$s = undefined;
  const __vue_scope_id__$s = undefined;
  const __vue_module_identifier__$s = undefined;
  const __vue_is_functional_template__$s = false;
  const __vue_component__$s = normalizeComponent(
    { render: __vue_render__$s, staticRenderFns: __vue_staticRenderFns__$s },
    __vue_inject_styles__$s,
    __vue_script__$s,
    __vue_scope_id__$s,
    __vue_is_functional_template__$s,
    __vue_module_identifier__$s,
    false,
    undefined,
    undefined,
    undefined
  );

let CreateTfaCard = class CreateTfaCard extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "step", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'scan'
        });
        Object.defineProperty(this, "recoveryCodes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    setStep(s) {
        this.step = s;
        this.$emit('step', s);
    }
    setRecoveryCodes(codes) {
        this.recoveryCodes = codes;
    }
    onScanComplete() {
        this.$emit('event', 'scan', 'success', {});
        this.setStep('confirm');
    }
    onScanError(message) {
        this.$emit('event', 'scan', 'error', { message });
    }
    onScanReady() {
        this.$emit('event', 'scan', 'ready', {});
    }
    onConfirmComplete(recoveryCodes) {
        this.$emit('event', 'confirm', 'complete', { recoveryCodes });
        this.setRecoveryCodes(recoveryCodes);
        this.setStep('save');
    }
    onConfirmError(message) {
        this.$emit('event', 'confirm', 'error', { message });
    }
    onSaveDownload() {
        this.$emit('event', 'save', 'download', {});
    }
    onSaveComplete() {
        this.$emit('event', 'save', 'complete', {});
    }
    get stateProps() {
        return {
            step: this.step,
            recoveryCodes: this.recoveryCodes,
            setStep: this.setStep,
            setRecoveryCodes: this.setRecoveryCodes,
            onScanComplete: this.onScanComplete,
            onScanError: this.onScanError,
            onScanReady: this.onScanReady,
            onConfirmComplete: this.onConfirmComplete,
            onConfirmError: this.onConfirmError,
            onSaveDownload: this.onSaveDownload,
            onSaveComplete: this.onSaveComplete,
        };
    }
};
__decorate([
    Prop(Boolean)
], CreateTfaCard.prototype, "dark", void 0);
CreateTfaCard = __decorate([
    Component({
        components: {
            CreateTfaScan: __vue_component__$v,
            CreateTfaConfirm: __vue_component__$t,
            CreateTfaSave: __vue_component__$s,
            Card: __vue_component__$S,
        },
    })
], CreateTfaCard);
var script$r = CreateTfaCard;

const __vue_script__$r = script$r;
var __vue_render__$r = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    { attrs: { dark: _vm.dark, "company-id": _vm.companyId } },
    [
      _c("div", { staticClass: "create-tfa rounded-2xl" }, [
        _c("div", { staticClass: "create-tfa__scan" }, [
          _vm.step === "scan"
            ? _c(
                "div",
                [
                  _vm._t(
                    "scan",
                    [
                      _c("CreateTfaScan", {
                        on: {
                          "step:complete": _vm.onScanComplete,
                          "step:error": _vm.onScanError,
                          "qr:ready": _vm.onScanReady,
                        },
                      }),
                    ],
                    null,
                    _vm.stateProps
                  ),
                ],
                2
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "create-tfa__confirm" }, [
          _vm.step === "confirm"
            ? _c(
                "div",
                _vm._b({}, "div", _vm.stateProps, false),
                [
                  _vm._t("confirm", [
                    _c("CreateTfaConfirm", {
                      on: {
                        "step:complete": _vm.onConfirmComplete,
                        "step:error": _vm.onConfirmError,
                      },
                    }),
                  ]),
                ],
                2
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "create-tfa__save" }, [
          _vm.step === "save"
            ? _c(
                "div",
                [
                  _vm._t(
                    "save",
                    [
                      _c("CreateTfaSave", {
                        attrs: { "recovery-codes": _vm.recoveryCodes },
                        on: {
                          "step:download": _vm.onSaveDownload,
                          "step:complete": _vm.onSaveComplete,
                        },
                      }),
                    ],
                    null,
                    _vm.stateProps
                  ),
                ],
                2
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
};
var __vue_staticRenderFns__$r = [];
__vue_render__$r._withStripped = true;
  const __vue_inject_styles__$r = undefined;
  const __vue_scope_id__$r = undefined;
  const __vue_module_identifier__$r = undefined;
  const __vue_is_functional_template__$r = false;
  const __vue_component__$r = normalizeComponent(
    { render: __vue_render__$r, staticRenderFns: __vue_staticRenderFns__$r },
    __vue_inject_styles__$r,
    __vue_script__$r,
    __vue_scope_id__$r,
    __vue_is_functional_template__$r,
    __vue_module_identifier__$r,
    false,
    undefined,
    undefined,
    undefined
  );

let ForgotPasswordForm = class ForgotPasswordForm extends FormMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "create", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showBackBtn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "emailPlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "buttonText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "successText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultFormState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: Object.assign({ email: '' }, this.defaultFormState)
        });
        Object.defineProperty(this, "submittedEmail", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "maybeHasCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
    get tr() {
        let buttonText = this.t('forgotPasswordForm.buttonText');
        let successText = this.t('forgotPasswordForm.successText');
        if (this.create) {
            buttonText = this.t('forgotPasswordForm.create.buttonText');
            successText = this.t('forgotPasswordForm.create.successText');
        }
        return {
            emailPlaceholder: this.emailPlaceholder || this.t('forgotPasswordForm.emailPlaceholder'),
            buttonText: this.buttonText || buttonText,
            successText: this.successText || successText,
        };
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    setMaybeHasCode(bool) {
        this.maybeHasCode = bool;
    }
    defaultSubmit(form) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield feSdk__default.api.auth.forgotPassword(form.email);
        });
    }
    validateForm() {
        if (this.validate) {
            return this.validate(this.form, this.formErrors);
        }
        let emailValid;
        [emailValid, this.formErrors.email] = validateEmail(this.form.email);
        return emailValid;
    }
    onSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            const submitMethod = this.submit ? this.submit : this.defaultSubmit;
            this.submittedEmail = this.form.email;
            return this.handleSubmit(submitMethod, (result) => {
                this.$emit('forgot:success', Object.assign(Object.assign({}, result), { email: this.submittedEmail }));
            }, (message) => {
                this.$emit('forgot:error', message);
                if (message.includes('too quickly') || message.includes('recently')) {
                    this.setMaybeHasCode(true);
                }
            });
        });
    }
    onClickBack() {
        this.resetErrors();
        this.resetForm();
        this.$emit('back');
    }
    onClickNext() {
        this.$emit('next');
    }
    get stateProps() {
        return Object.assign(Object.assign({}, this.getStateProps()), { onClickBack: this.onClickBack, onClickNext: this.onClickNext, submittedEmail: this.submittedEmail, hasSuccess: this.hasSuccess, setHasSuccess: this.setHasSuccess, maybeHasCode: this.maybeHasCode, setMaybeHasCode: this.setMaybeHasCode });
    }
    defaultFormStateWatcher() {
        this.defaultState = Object.assign({ email: '' }, this.defaultFormState);
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], ForgotPasswordForm.prototype, "dark", void 0);
__decorate([
    Prop(Boolean)
], ForgotPasswordForm.prototype, "create", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], ForgotPasswordForm.prototype, "showBackBtn", void 0);
__decorate([
    Prop(String)
], ForgotPasswordForm.prototype, "emailPlaceholder", void 0);
__decorate([
    Prop(String)
], ForgotPasswordForm.prototype, "title", void 0);
__decorate([
    Prop(String)
], ForgotPasswordForm.prototype, "buttonText", void 0);
__decorate([
    Prop(String)
], ForgotPasswordForm.prototype, "lead", void 0);
__decorate([
    Prop(String)
], ForgotPasswordForm.prototype, "successText", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], ForgotPasswordForm.prototype, "defaultFormState", void 0);
__decorate([
    Watch('defaultFormState')
], ForgotPasswordForm.prototype, "defaultFormStateWatcher", null);
ForgotPasswordForm = __decorate([
    Component({
        components: {
            SubmitGoButton: __vue_component__$Y,
            InputError: __vue_component__$R,
            Alert: __vue_component__$X,
        },
    })
], ForgotPasswordForm);
var script$q = ForgotPasswordForm;

const __vue_script__$q = script$q;
var __vue_render__$q = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "sl-one-component" }, [
    _c(
      "div",
      { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
      [
        _c(
          "div",
          {
            staticClass: "forgot-password-form text-center mx-auto max-w-full",
          },
          [
            _c(
              "div",
              { staticClass: "forgot-password-form__header" },
              [_vm._t("header", null, null, _vm.stateProps)],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "forgot-password-form__form" },
              [
                _vm._t(
                  "form",
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.hasSuccess,
                            expression: "!hasSuccess",
                          },
                        ],
                        staticClass: "w-[300px] mx-auto",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "forgot-password-form__form-email mb-4",
                          },
                          [
                            _vm._t(
                              "emailInput",
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.email,
                                      expression: "form.email",
                                    },
                                  ],
                                  staticClass:
                                    "sl-form-control theme-dark w-full",
                                  attrs: {
                                    name: "email",
                                    type: "text",
                                    placeholder: _vm.tr.emailPlaceholder,
                                  },
                                  domProps: { value: _vm.form.email },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.onSubmit($event)
                                    },
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form,
                                          "email",
                                          $event.target.value
                                        );
                                      },
                                      _vm.handleFieldChange,
                                    ],
                                    blur: _vm.handleFieldBlur,
                                  },
                                }),
                                _vm._v(" "),
                                _c("InputError", {
                                  attrs: {
                                    dirty:
                                      _vm.dirty.email &&
                                      _vm.blurred.email &&
                                      !!_vm.formErrors.email,
                                    text: _vm.formErrors.email,
                                  },
                                }),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "forgot-password-form__button" },
                          [
                            _vm._t(
                              "button",
                              [
                                _c(
                                  "SubmitGoButton",
                                  {
                                    staticClass: "block",
                                    attrs: {
                                      disabled:
                                        _vm.isSubmitting || !_vm.isValid,
                                      loading: _vm.isSubmitting,
                                    },
                                    on: { click: _vm.onSubmit },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.tr.buttonText) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "forgot-password-form__success" },
              [
                _vm._t(
                  "success",
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.hasSuccess,
                            expression: "hasSuccess",
                          },
                        ],
                        staticClass: "py-3 w-full",
                      },
                      [
                        _c(
                          "Alert",
                          {
                            staticClass: "px-6 py-3 text-md",
                            attrs: { color: "text-emerald-700" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.tr.successText) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "forgot-password-form__next" },
              [
                _vm._t(
                  "next",
                  [
                    _vm.maybeHasCode
                      ? _c("div", { staticClass: "pt-6" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "text-sm sl-btn-link-dark-5 underline",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault();
                                  return _vm.onClickNext($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.t("resetPasswordForm.next")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "forgot-password-form__back" },
              [
                _vm._t(
                  "back",
                  [
                    _vm.showBackBtn
                      ? _c("div", { staticClass: "pt-6" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "text-sm sl-btn-link-dark-5 underline",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault();
                                  return _vm.onClickBack($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.t("forgotPasswordForm.back")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "forgot-password-form__footer" },
              [_vm._t("footer", null, null, _vm.stateProps)],
              2
            ),
          ]
        ),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$q = [];
__vue_render__$q._withStripped = true;
  const __vue_inject_styles__$q = undefined;
  const __vue_scope_id__$q = undefined;
  const __vue_module_identifier__$q = undefined;
  const __vue_is_functional_template__$q = false;
  const __vue_component__$q = normalizeComponent(
    { render: __vue_render__$q, staticRenderFns: __vue_staticRenderFns__$q },
    __vue_inject_styles__$q,
    __vue_script__$q,
    __vue_scope_id__$q,
    __vue_is_functional_template__$q,
    __vue_module_identifier__$q,
    false,
    undefined,
    undefined,
    undefined
  );

let ResetPasswordForm = class ResetPasswordForm extends FormMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showBackBtn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "create", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultContext", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "emailPlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "codePlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tfaCodePlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "newPasswordPlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "buttonText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "successText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "context", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                withEmail: false,
                tfa: false,
            }
        });
        Object.defineProperty(this, "defaultState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { code: '', new_password: '', email: '', tfa_code: '' }
        });
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    validateForm() {
        if (this.validate) {
            return this.validate(this.form, this.formErrors);
        }
        let newPasswordValid;
        let codeValid;
        let emailValid;
        let tfaCodeValid = true;
        this.formErrors.tfa_code = '';
        [emailValid, this.formErrors.email] = validateEmail(this.form.email);
        [newPasswordValid, this.formErrors.new_password] = validatePassword(this.form.new_password);
        [codeValid, this.formErrors.code] = validateCode(this.form.code);
        if (this.tfaRequired) {
            if (this.form.tfa_code.length < 6 || this.form.tfa_code.length > 10) {
                tfaCodeValid = false;
                this.formErrors.tfa_code = this.t('resetPasswordForm.tfaError');
            }
        }
        return emailValid && newPasswordValid && tfaCodeValid && codeValid;
    }
    defaultSubmit(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { email, new_password, code, tfa_code } = data;
            return yield feSdk__default.api.auth.resetPassword(email, code, new_password, tfa_code);
        });
    }
    setContext(c) {
        if (c.email) {
            this.context.withEmail = true;
            this.form.email = c.email;
        }
        else {
            this.context.withEmail = false;
            this.form.email = '';
        }
        if (typeof c.tfa === 'boolean') {
            this.context.tfa = c.tfa;
        }
    }
    onSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            const submitMethod = this.submit ? this.submit : this.defaultSubmit;
            return this.handleSubmit(submitMethod, (result) => {
                this.$emit('reset:success', result);
            }, (message) => {
                this.$emit('reset:error', message);
                if (message.includes('tfa') && message.includes('required')) {
                    this.context = Object.assign(Object.assign({}, this.context), { tfa: true });
                }
            });
        });
    }
    onClickBack() {
        this.resetErrors();
        this.resetForm();
        this.$emit('back');
    }
    get computedDefaultContext() {
        return Object.assign({ email: '', tfa: false }, this.defaultContext);
    }
    get tr() {
        let backButton = this.t('resetPasswordForm.back');
        let buttonText = this.t('resetPasswordForm.buttonText');
        let successText = this.t('resetPasswordForm.successText');
        if (this.create) {
            backButton = this.t('resetPasswordForm.create.back');
            buttonText = this.t('resetPasswordForm.create.buttonText');
            successText = this.t('resetPasswordForm.create.successText');
        }
        return {
            emailPlaceholder: this.emailPlaceholder || this.t('resetPasswordForm.emailPlaceholder'),
            codePlaceholder: this.codePlaceholder || this.t('resetPasswordForm.codePlaceholder'),
            tfaCodePlaceholder: this.tfaCodePlaceholder ||
                this.t('resetPasswordForm.tfaCodePlaceholder'),
            newPasswordPlaceholder: this.newPasswordPlaceholder ||
                this.t('resetPasswordForm.newPasswordPlaceholder'),
            buttonText: this.buttonText || buttonText,
            successText: this.successText || successText,
            backButton,
        };
    }
    get tfaRequired() {
        return this.context.tfa;
    }
    get stateProps() {
        return Object.assign(Object.assign({}, this.getStateProps()), { context: this.context, setContext: this.setContext, hasSuccess: this.hasSuccess, setHasSuccess: this.setHasSuccess });
    }
    defaultContextWatcher() {
        this.setContext(this.computedDefaultContext);
    }
};
__decorate([
    Prop(Boolean)
], ResetPasswordForm.prototype, "dark", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], ResetPasswordForm.prototype, "showBackBtn", void 0);
__decorate([
    Prop(Boolean)
], ResetPasswordForm.prototype, "create", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], ResetPasswordForm.prototype, "defaultContext", void 0);
__decorate([
    Prop(String)
], ResetPasswordForm.prototype, "emailPlaceholder", void 0);
__decorate([
    Prop(String)
], ResetPasswordForm.prototype, "codePlaceholder", void 0);
__decorate([
    Prop(String)
], ResetPasswordForm.prototype, "tfaCodePlaceholder", void 0);
__decorate([
    Prop(String)
], ResetPasswordForm.prototype, "newPasswordPlaceholder", void 0);
__decorate([
    Prop(String)
], ResetPasswordForm.prototype, "buttonText", void 0);
__decorate([
    Prop(String)
], ResetPasswordForm.prototype, "successText", void 0);
__decorate([
    Watch('computedDefaultContext', { immediate: true })
], ResetPasswordForm.prototype, "defaultContextWatcher", null);
ResetPasswordForm = __decorate([
    Component({
        components: {
            PasswordInput: __vue_component__$K,
            SubmitGoButton: __vue_component__$Y,
            InputError: __vue_component__$R,
            Alert: __vue_component__$X,
        },
    })
], ResetPasswordForm);
var script$p = ResetPasswordForm;

const __vue_script__$p = script$p;
var __vue_render__$p = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "sl-one-component" }, [
    _c(
      "div",
      { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
      [
        _c(
          "div",
          { staticClass: "reset-password-form text-center mx-auto max-w-full" },
          [
            _c(
              "div",
              { staticClass: "reset-password-form__header" },
              [_vm._t("header", null, null, _vm.stateProps)],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "reset-password-form__form" },
              [
                _vm._t(
                  "form",
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.hasSuccess,
                            expression: "!hasSuccess",
                          },
                        ],
                        staticClass: "w-[300px] mx-auto",
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  !_vm.context.withEmail ||
                                  !(
                                    _vm.context.withEmail &&
                                    !_vm.formErrors.email
                                  ),
                                expression:
                                  "\n                !context.withEmail ||\n                !(context.withEmail && !formErrors.email)\n              ",
                              },
                            ],
                            staticClass: "reset-password-form__form-email mb-4",
                          },
                          [
                            _vm._t(
                              "emailInput",
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.email,
                                      expression: "form.email",
                                    },
                                  ],
                                  staticClass:
                                    "sl-form-control theme-dark w-full",
                                  attrs: {
                                    type: "text",
                                    placeholder: _vm.tr.emailPlaceholder,
                                    name: "email",
                                    autocomplete: "username",
                                  },
                                  domProps: { value: _vm.form.email },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.onSubmit($event)
                                    },
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form,
                                          "email",
                                          $event.target.value
                                        );
                                      },
                                      _vm.handleFieldChange,
                                    ],
                                    blur: _vm.handleFieldBlur,
                                  },
                                }),
                                _vm._v(" "),
                                _c("InputError", {
                                  attrs: {
                                    dirty:
                                      _vm.dirty.email &&
                                      _vm.blurred.email &&
                                      !!_vm.formErrors.email,
                                    text: _vm.formErrors.email,
                                  },
                                }),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "reset-password-form__form-code mb-4",
                          },
                          [
                            _vm._t(
                              "codeInput",
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.code,
                                      expression: "form.code",
                                    },
                                  ],
                                  staticClass:
                                    "sl-form-control theme-dark w-full",
                                  attrs: {
                                    type: "text",
                                    name: "code",
                                    autocomplete: "off",
                                    placeholder: _vm.tr.codePlaceholder,
                                  },
                                  domProps: { value: _vm.form.code },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.onSubmit($event)
                                    },
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form,
                                          "code",
                                          $event.target.value
                                        );
                                      },
                                      _vm.handleFieldChange,
                                    ],
                                    blur: _vm.handleFieldBlur,
                                  },
                                }),
                                _vm._v(" "),
                                _c("InputError", {
                                  attrs: {
                                    dirty:
                                      _vm.dirty.code &&
                                      _vm.blurred.code &&
                                      !!_vm.formErrors.code,
                                    text: _vm.formErrors.code,
                                  },
                                }),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.tfaRequired,
                                expression: "tfaRequired",
                              },
                            ],
                            staticClass:
                              "reset-password-form__form-tfa_code mb-4",
                          },
                          [
                            _vm._t(
                              "tfaCodeInput",
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.tfa_code,
                                      expression: "form.tfa_code",
                                    },
                                  ],
                                  staticClass:
                                    "sl-form-control theme-dark w-full",
                                  attrs: {
                                    type: "text",
                                    name: "tfa_code",
                                    autocomplete: "off",
                                    placeholder: _vm.tr.tfaCodePlaceholder,
                                  },
                                  domProps: { value: _vm.form.tfa_code },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.onSubmit($event)
                                    },
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form,
                                          "tfa_code",
                                          $event.target.value
                                        );
                                      },
                                      _vm.handleFieldChange,
                                    ],
                                    blur: _vm.handleFieldBlur,
                                  },
                                }),
                                _vm._v(" "),
                                _c("InputError", {
                                  attrs: {
                                    dirty:
                                      _vm.dirty.tfa_code &&
                                      _vm.blurred.tfa_code &&
                                      !!_vm.formErrors.tfa_code,
                                    text: _vm.formErrors.tfa_code,
                                  },
                                }),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "reset-password-form__form-new_password mb-4",
                          },
                          [
                            _vm._t(
                              "newPasswordInput",
                              [
                                _c("PasswordInput", {
                                  attrs: {
                                    name: "new_password",
                                    autocomplete: "new-password",
                                    placeholder: _vm.tr.newPasswordPlaceholder,
                                  },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.onSubmit($event)
                                    },
                                    change: _vm.handleFieldChange,
                                    blur: _vm.handleFieldBlur,
                                  },
                                  model: {
                                    value: _vm.form.new_password,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "new_password", $$v);
                                    },
                                    expression: "form.new_password",
                                  },
                                }),
                                _vm._v(" "),
                                _c("InputError", {
                                  attrs: {
                                    dirty:
                                      _vm.dirty.new_password &&
                                      _vm.blurred.new_password &&
                                      !!_vm.formErrors.new_password,
                                    text: _vm.formErrors.new_password,
                                  },
                                }),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "reset-password-form__button" },
                          [
                            _vm._t(
                              "button",
                              [
                                _c(
                                  "SubmitGoButton",
                                  {
                                    attrs: {
                                      disabled:
                                        _vm.isSubmitting || !_vm.isValid,
                                      loading: _vm.isSubmitting,
                                    },
                                    on: { click: _vm.onSubmit },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.tr.buttonText) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "reset-password-form__success" },
              [
                _vm._t(
                  "success",
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.hasSuccess,
                            expression: "hasSuccess",
                          },
                        ],
                        staticClass: "py-3 w-full",
                      },
                      [
                        _c(
                          "Alert",
                          {
                            staticClass: "px-6 py-3 text-md",
                            attrs: { color: "text-emerald-700" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.tr.successText) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "reset-password-form__back" },
              [
                _vm._t(
                  "back",
                  [
                    _vm.showBackBtn
                      ? _c("div", { staticClass: "pt-6" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "text-sm sl-btn-link-dark-5 underline",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault();
                                  return _vm.onClickBack($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.tr.backButton) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "reset-password-form__footer" },
              [_vm._t("footer", null, null, _vm.stateProps)],
              2
            ),
          ]
        ),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$p = [];
__vue_render__$p._withStripped = true;
  const __vue_inject_styles__$p = undefined;
  const __vue_scope_id__$p = undefined;
  const __vue_module_identifier__$p = undefined;
  const __vue_is_functional_template__$p = false;
  const __vue_component__$p = normalizeComponent(
    { render: __vue_render__$p, staticRenderFns: __vue_staticRenderFns__$p },
    __vue_inject_styles__$p,
    __vue_script__$p,
    __vue_scope_id__$p,
    __vue_is_functional_template__$p,
    __vue_module_identifier__$p,
    false,
    undefined,
    undefined,
    undefined
  );

let ForgotPasswordCard = class ForgotPasswordCard extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "create", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "resetTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "resetLead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultFormState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "hasSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "successData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "formView", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'forgot'
        });
        Object.defineProperty(this, "forgotProxy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new ForgotPasswordFormStateProxy()
        });
        Object.defineProperty(this, "resetProxy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new ResetPasswordFormProxy()
        });
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    setErrorMessage(message) {
        this.errorMessage = message;
    }
    setHasSuccess(hasSuccess) {
        this.hasSuccess = hasSuccess;
    }
    setFormView(view) {
        this.formView = view;
    }
    onSuccess(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setErrorMessage('');
            if (typeof this.success === 'function') {
                yield this.success(data);
            }
            else {
                this.$emit('forgot:success', data);
                this.setHasSuccess(true);
                setTimeout(() => this.setHasSuccess(false), 4000);
            }
        });
    }
    onError(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.error === 'function') {
                yield this.error(msg);
            }
            else {
                this.setErrorMessage(msg);
                this.$emit('forgot:error', msg);
            }
        });
    }
    handleLoginClick() {
        this.$emit('redirect', 'login');
    }
    onRegisterResetProxy(resetGetter) {
        this.resetProxy.setState(resetGetter);
    }
    onRegisterForgotProxy(forgotGetter) {
        this.forgotProxy.setState(forgotGetter);
    }
    onForgotSuccess(data) {
        this.setFormView('reset');
        this.resetProxy.state.setContext(data);
        this.setErrorMessage('');
        this.successData = data;
    }
    onForgotNext(data) {
        this.resetProxy.state.setContext({
            email: data.email,
        });
        this.setFormView('reset');
        this.setErrorMessage('');
        this.successData = Object.assign(Object.assign({}, data), { tfa: false });
    }
    onResetSuccess() {
        this.resetProxy.state.resetErrors();
        this.resetProxy.state.resetForm();
        this.onSuccess(this.successData);
    }
    onResetBack() {
        this.setErrorMessage('');
        this.setFormView('forgot');
    }
    get tr() {
        if (this.create) {
            return {
                title: this.title || this.t('forgotPasswordCard.create.title'),
                lead: this.lead || this.t('forgotPasswordCard.create.lead'),
                resetTitle: this.resetTitle || this.t('forgotPasswordCard.create.resetTitle'),
                resetLead: this.resetLead || this.t('forgotPasswordCard.create.resetLead'),
            };
        }
        return {
            title: this.title || this.t('forgotPasswordCard.title'),
            lead: this.lead || this.t('forgotPasswordCard.lead'),
            resetTitle: this.resetTitle || this.t('forgotPasswordCard.resetTitle'),
            resetLead: this.resetLead || this.t('forgotPasswordCard.resetLead'),
        };
    }
    get computedTitle() {
        return this.formView === 'forgot' ? this.tr.title : this.tr.resetTitle;
    }
    get computedLead() {
        return this.formView === 'forgot' ? this.tr.lead : this.tr.resetLead;
    }
    get stateProps() {
        return {
            company: this.company,
            errorMessage: this.errorMessage,
            hasSuccess: this.hasSuccess,
            formView: this.formView,
            setFormView: this.setFormView,
            setErrorMessage: this.setErrorMessage,
            setHasSuccess: this.setHasSuccess,
            onSuccess: this.onSuccess,
            onError: this.onError,
            onResetBack: this.onResetBack,
            onResetSuccess: this.onResetSuccess,
            onForgotSuccess: this.onForgotSuccess,
            onForgotNext: this.onForgotNext,
            forgotProxy: this.forgotProxy,
            resetProxy: this.resetProxy,
        };
    }
};
__decorate([
    Prop(Boolean)
], ForgotPasswordCard.prototype, "dark", void 0);
__decorate([
    Prop(Boolean)
], ForgotPasswordCard.prototype, "create", void 0);
__decorate([
    Prop(String)
], ForgotPasswordCard.prototype, "title", void 0);
__decorate([
    Prop(String)
], ForgotPasswordCard.prototype, "lead", void 0);
__decorate([
    Prop(String)
], ForgotPasswordCard.prototype, "resetTitle", void 0);
__decorate([
    Prop(String)
], ForgotPasswordCard.prototype, "resetLead", void 0);
__decorate([
    Prop(Function)
], ForgotPasswordCard.prototype, "success", void 0);
__decorate([
    Prop(Function)
], ForgotPasswordCard.prototype, "error", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], ForgotPasswordCard.prototype, "defaultFormState", void 0);
ForgotPasswordCard = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            CheckCircle: __vue_component__$W,
            Card: __vue_component__$S,
            ForgotPasswordForm: __vue_component__$q,
            ResetPasswordForm: __vue_component__$p,
            HaveIdFooter: __vue_component__$O,
        },
    })
], ForgotPasswordCard);
var script$o = ForgotPasswordCard;

const __vue_script__$o = script$o;
var __vue_render__$o = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    {
      staticClass: "forgot-password-card",
      attrs: {
        "company-id": _vm.companyId,
        dark: _vm.dark,
        "error-message": _vm.errorMessage,
        title: _vm.computedTitle,
        lead: _vm.computedLead,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "logo",
            fn: function () {
              return [_vm._t("logo", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [_vm._t("title", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "lead",
            fn: function () {
              return [_vm._t("lead", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [_vm._t("error", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _vm._t(
                  "footer",
                  [
                    _c("HaveIdFooter", {
                      attrs: { company: _vm.company },
                      on: { click: _vm.handleLoginClick },
                    }),
                  ],
                  null,
                  _vm.stateProps
                ),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c("div", { staticClass: "forgot-password-card__form relative" }, [
        _c("div", { staticClass: "forgot-password-card__forgot" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.formView === "forgot",
                  expression: "formView === 'forgot'",
                },
              ],
            },
            [
              _vm._t(
                "forgot",
                [
                  _c("ForgotPasswordForm", {
                    attrs: {
                      dark: _vm.dark,
                      "show-back-btn": false,
                      "default-form-state": _vm.defaultFormState,
                      create: _vm.create,
                    },
                    on: {
                      "register:state": _vm.onRegisterForgotProxy,
                      reset: function ($event) {
                        return _vm.setErrorMessage("")
                      },
                      next: _vm.onForgotNext,
                      "forgot:error": _vm.onError,
                      "forgot:success": _vm.onForgotSuccess,
                    },
                  }),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "forgot-password-card__reset" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.formView === "reset",
                  expression: "formView === 'reset'",
                },
              ],
            },
            [
              _vm._t(
                "reset",
                [
                  _c("ResetPasswordForm", {
                    attrs: { dark: _vm.dark, create: _vm.create },
                    on: {
                      "register:state": _vm.onRegisterResetProxy,
                      back: _vm.onResetBack,
                      "reset:error": _vm.onError,
                      "reset:success": _vm.onResetSuccess,
                    },
                  }),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "forgot-password-card__success" },
          [
            _vm._t(
              "success",
              [
                _c(
                  "Alert",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasSuccess,
                        expression: "hasSuccess",
                      },
                    ],
                    staticClass:
                      "absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center px-5",
                    attrs: { bg: "bg-white", color: "text-emerald-900" },
                  },
                  [
                    _c("div", { staticClass: "flex items-center text-lg" }, [
                      _c(
                        "div",
                        { staticClass: "mr-2" },
                        [
                          _c("CheckCircle", {
                            staticClass: "block",
                            attrs: { text: "r", size: 28 },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.t("loginCard.successText")) +
                            "\n            "
                        ),
                      ]),
                    ]),
                  ]
                ),
              ],
              null,
              _vm.stateProps
            ),
          ],
          2
        ),
      ]),
    ]
  )
};
var __vue_staticRenderFns__$o = [];
__vue_render__$o._withStripped = true;
  const __vue_inject_styles__$o = undefined;
  const __vue_scope_id__$o = undefined;
  const __vue_module_identifier__$o = undefined;
  const __vue_is_functional_template__$o = false;
  const __vue_component__$o = normalizeComponent(
    { render: __vue_render__$o, staticRenderFns: __vue_staticRenderFns__$o },
    __vue_inject_styles__$o,
    __vue_script__$o,
    __vue_scope_id__$o,
    __vue_is_functional_template__$o,
    __vue_module_identifier__$o,
    false,
    undefined,
    undefined,
    undefined
  );

let EmailLoginForm = class EmailLoginForm extends FormMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "buttonText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "emailPlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "passwordPlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "emailDisabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "captchaInputName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultFormState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "formEl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: Object.assign({ email: '', password: '' }, this.defaultFormState)
        });
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    getFormData(overrideData = {}) {
        const data = Object.assign(Object.assign({}, this.form), overrideData);
        if (this.captchaInputName && this.formEl.value) {
            const captchaInput = this.formEl.value.querySelector(`input[name="${this.captchaInputName}"]`);
            if (captchaInput) {
                data[this.captchaInputName] = captchaInput.value;
            }
        }
        return data;
    }
    defaultSubmit(form) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield feSdk__default.api.auth.emailLogin(this.getFormData(form));
            return res;
        });
    }
    validateForm() {
        if (this.validate) {
            return this.validate(this.form, this.formErrors);
        }
        let emailValid, passwordValid;
        [emailValid, this.formErrors.email] = validateEmail(this.form.email);
        [passwordValid, this.formErrors.password] = validatePasswordExistence(this.form.password);
        return emailValid && passwordValid;
    }
    onSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            const submitMethod = this.submit ? this.submit : this.defaultSubmit;
            if (this.isValid && !this.isSubmitting) {
                this.$emit('login:attempt', this.getFormData());
            }
            return this.handleSubmit(submitMethod, (result) => {
                this.$emit('login:success', result);
            }, (message) => this.$emit('login:error', message));
        });
    }
    get tr() {
        return {
            buttonText: this.buttonText || this.t('emailLoginForm.buttonText'),
            emailPlaceholder: this.emailPlaceholder || this.t('emailLoginForm.emailPlaceholder'),
            passwordPlaceholder: this.passwordPlaceholder ||
                this.t('emailLoginForm.passwordPlaceholder'),
        };
    }
    get stateProps() {
        return Object.assign(Object.assign({}, this.getStateProps()), { tr: this.tr });
    }
    defaultFormStateWatcher() {
        this.defaultState = Object.assign({ email: '', password: '' }, this.defaultFormState);
    }
};
__decorate([
    Prop(String)
], EmailLoginForm.prototype, "buttonText", void 0);
__decorate([
    Prop(String)
], EmailLoginForm.prototype, "emailPlaceholder", void 0);
__decorate([
    Prop(String)
], EmailLoginForm.prototype, "passwordPlaceholder", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], EmailLoginForm.prototype, "dark", void 0);
__decorate([
    Prop(Boolean)
], EmailLoginForm.prototype, "emailDisabled", void 0);
__decorate([
    Prop({ type: String, default: undefined })
], EmailLoginForm.prototype, "captchaInputName", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], EmailLoginForm.prototype, "defaultFormState", void 0);
__decorate([
    Ref('formEl')
], EmailLoginForm.prototype, "formEl", void 0);
__decorate([
    Watch('defaultFormState')
], EmailLoginForm.prototype, "defaultFormStateWatcher", null);
EmailLoginForm = __decorate([
    Component({
        components: {
            SubmitGoButton: __vue_component__$Y,
            InputError: __vue_component__$R,
            PasswordInput: __vue_component__$K,
        },
    })
], EmailLoginForm);
var script$n = EmailLoginForm;

const __vue_script__$n = script$n;
var __vue_render__$n = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "sl-one-component" }, [
    _c(
      "div",
      { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
      [
        _c(
          "div",
          { staticClass: "email-login-form w-[300px] mx-auto max-w-full" },
          [
            _c(
              "div",
              { staticClass: "email-login-form__header" },
              [_vm._t("header", null, null, _vm.stateProps)],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "email-login-form__form" },
              [
                _vm._t(
                  "form",
                  [
                    _c(
                      "form",
                      {
                        ref: "formEl",
                        attrs: { action: "", method: "POST" },
                        on: {
                          submit: function ($event) {
                            $event.preventDefault();
                            return _vm.onSubmit($event)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "email-login-form__field email-login-form__field--email mb-4",
                          },
                          [
                            _vm._t(
                              "emailInput",
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.email,
                                      expression: "form.email",
                                    },
                                  ],
                                  staticClass:
                                    "sl-form-control theme-dark w-full",
                                  attrs: {
                                    name: "email",
                                    autocomplete: "username",
                                    type: "text",
                                    placeholder: _vm.tr.emailPlaceholder,
                                    disabled:
                                      _vm.emailDisabled || _vm.formDisabled,
                                  },
                                  domProps: { value: _vm.form.email },
                                  on: {
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form,
                                          "email",
                                          $event.target.value
                                        );
                                      },
                                      _vm.handleFieldChange,
                                    ],
                                    blur: _vm.handleFieldBlur,
                                  },
                                }),
                                _vm._v(" "),
                                _c("InputError", {
                                  attrs: {
                                    dirty:
                                      _vm.dirty.email &&
                                      !!_vm.formErrors.email &&
                                      _vm.blurred.email,
                                    text: _vm.formErrors.email,
                                  },
                                }),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "email-login-form__field email-login-form__field--password mb-4 md:w-full",
                          },
                          [
                            _vm._t(
                              "passwordInput",
                              [
                                _c("PasswordInput", {
                                  attrs: {
                                    name: "password",
                                    autocomplete: "password",
                                    placeholder: _vm.tr.passwordPlaceholder,
                                    disabled: _vm.formDisabled,
                                  },
                                  on: {
                                    change: _vm.handleFieldChange,
                                    blur: _vm.handleFieldBlur,
                                  },
                                  model: {
                                    value: _vm.form.password,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "password", $$v);
                                    },
                                    expression: "form.password",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "password__error mr-[-100px]",
                                  },
                                  [
                                    _c("InputError", {
                                      attrs: {
                                        dirty:
                                          _vm.blurred.password &&
                                          _vm.dirty.password &&
                                          !!_vm.formErrors.password,
                                        text: _vm.formErrors.password,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "email-login-form__captcha" },
                          [_vm._t("captcha", null, null, _vm.stateProps)],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "email-login-form__button" },
                          [
                            _vm._t(
                              "button",
                              [
                                _c(
                                  "SubmitGoButton",
                                  {
                                    attrs: {
                                      disabled:
                                        _vm.isSubmitting ||
                                        !_vm.isValid ||
                                        _vm.formDisabled,
                                      loading: _vm.isSubmitting,
                                      type: "submit",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.tr.buttonText) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "email-login-form__footer" },
              [_vm._t("footer", null, null, _vm.stateProps)],
              2
            ),
          ]
        ),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$n = [];
__vue_render__$n._withStripped = true;
  const __vue_inject_styles__$n = undefined;
  const __vue_scope_id__$n = undefined;
  const __vue_module_identifier__$n = undefined;
  const __vue_is_functional_template__$n = false;
  const __vue_component__$n = normalizeComponent(
    { render: __vue_render__$n, staticRenderFns: __vue_staticRenderFns__$n },
    __vue_inject_styles__$n,
    __vue_script__$n,
    __vue_scope_id__$n,
    __vue_is_functional_template__$n,
    __vue_module_identifier__$n,
    false,
    undefined,
    undefined,
    undefined
  );

let NoIdFooter = class NoIdFooter extends BaseMixin$1 {
};
NoIdFooter = __decorate([
    Component({})
], NoIdFooter);
var script$m = NoIdFooter;

const __vue_script__$m = script$m;
var __vue_render__$m = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("p", { staticClass: "text-dark-5 text-sm dark:text-light-3" }, [
    _vm._v("\n  " + _vm._s(_vm.t("noAccount.text")) + "\n  "),
    _c(
      "a",
      {
        staticClass: "cursor-pointer underline sl-btn-link-dark-5",
        attrs: { href: "#" },
        on: {
          click: function ($event) {
            $event.preventDefault();
            return _vm.$emit("click")
          },
        },
      },
      [_vm._v("\n    " + _vm._s(_vm.t("noAccount.link")) + "\n  ")]
    ),
  ])
};
var __vue_staticRenderFns__$m = [];
__vue_render__$m._withStripped = true;
  const __vue_inject_styles__$m = undefined;
  const __vue_scope_id__$m = undefined;
  const __vue_module_identifier__$m = undefined;
  const __vue_is_functional_template__$m = false;
  const __vue_component__$m = normalizeComponent(
    { render: __vue_render__$m, staticRenderFns: __vue_staticRenderFns__$m },
    __vue_inject_styles__$m,
    __vue_script__$m,
    __vue_scope_id__$m,
    __vue_is_functional_template__$m,
    __vue_module_identifier__$m,
    false,
    undefined,
    undefined,
    undefined
  );

let LoginCard = class LoginCard extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showAccountExists", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showForgotPassword", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showFooter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultFormState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "login", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "forgotPassword", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platformButtons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platformIcons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "btnStyle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "formDisabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "resetFormOnSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showSuccessMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "hasSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "loginData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    setErrorMessage(msg) {
        this.errorMessage = msg;
    }
    setHasSuccess(hasSuccess) {
        this.hasSuccess = hasSuccess;
    }
    onLoginError(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.error === 'function') {
                yield this.error(msg);
            }
            else {
                this.setErrorMessage(msg);
                this.$emit('login:error', msg);
            }
        });
    }
    handleXhrError(err, fallback) {
        if (err.data.code === 'email_verification_required') {
            this.$emit('validate', 'email');
            this.setErrorMessage(this.t('connectCard.connect.emailRequired'));
        }
        else if (err.data.code === 'token_required') {
            this.$emit('validate', 'tfa');
            this.setErrorMessage(this.t('connectCard.connect.tfaRequired'));
        }
        else if (err.data.code === 'age_gate_required') {
            this.$emit('validate', 'age-gate');
            this.setErrorMessage(this.t('connectCard.connect.ageRequired'));
        }
        else {
            fallback(err);
        }
    }
    onLoginSuccess(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.login === 'function') {
                return this.login(data);
            }
            this.loginData = data;
            this.setErrorMessage('');
            if (this.loginData.tfa_enabled) {
                try {
                    yield feSdk__default.api.user.getAuthUser();
                    this.loginComplete();
                }
                catch (err) {
                    if (err instanceof ApiError) {
                        this.handleXhrError(err, (e) => {
                            var _a;
                            this.onLoginError(((_a = e.data) === null || _a === void 0 ? void 0 : _a.message) || e.message);
                        });
                    }
                }
            }
            else {
                this.loginComplete();
            }
        });
    }
    loginComplete() {
        if (typeof this.success === 'function') {
            return this.success(this.loginData);
        }
        this.$emit('login:success', this.loginData);
        if (this.showSuccessMessage) {
            this.setHasSuccess(true);
            setTimeout(() => this.setHasSuccess(false), 4000);
        }
    }
    onClickForgotPassword() {
        if (typeof this.forgotPassword === 'function') {
            return this.forgotPassword();
        }
    }
    handleSignupClick() {
        this.$emit('redirect', 'signup');
    }
    onAttemptLogin(data) {
        this.$emit('login:attempt', data);
    }
    onPlatformBtnClick(name, resolve) {
        this.$emit('login:source', name, resolve);
    }
    get tr() {
        return {
            title: this.title || this.t('loginCard.title'),
            lead: this.lead || this.t('loginCard.lead'),
        };
    }
    get stateProps() {
        return {
            showAccountExists: !!this.showAccountExists,
            showForgotPassword: !!this.showForgotPassword,
            company: this.company,
            errorMessage: this.errorMessage,
            hasSuccess: this.hasSuccess,
            setErrorMessage: this.setErrorMessage,
            setHasSuccess: this.setHasSuccess,
            onLoginSuccess: this.onLoginSuccess,
            onLoginError: this.onLoginError,
            onClickForgotPassword: this.onClickForgotPassword,
            onPlatformBtnClick: this.onPlatformBtnClick,
            btnStyle: this.btnStyle,
            platformButtons: this.platformButtons,
            platformIcons: this.platformIcons,
        };
    }
};
__decorate([
    Prop(String)
], LoginCard.prototype, "title", void 0);
__decorate([
    Prop(String)
], LoginCard.prototype, "lead", void 0);
__decorate([
    Prop(Boolean)
], LoginCard.prototype, "dark", void 0);
__decorate([
    Prop(Boolean)
], LoginCard.prototype, "showAccountExists", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], LoginCard.prototype, "showForgotPassword", void 0);
__decorate([
    Prop(Boolean)
], LoginCard.prototype, "showFooter", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], LoginCard.prototype, "defaultFormState", void 0);
__decorate([
    Prop(Function)
], LoginCard.prototype, "success", void 0);
__decorate([
    Prop(Function)
], LoginCard.prototype, "login", void 0);
__decorate([
    Prop(Function)
], LoginCard.prototype, "error", void 0);
__decorate([
    Prop(Function)
], LoginCard.prototype, "forgotPassword", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], LoginCard.prototype, "platformButtons", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], LoginCard.prototype, "platformIcons", void 0);
__decorate([
    Prop({ type: String, default: 'sl-btn-solid' })
], LoginCard.prototype, "btnStyle", void 0);
__decorate([
    Prop(Boolean)
], LoginCard.prototype, "formDisabled", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], LoginCard.prototype, "resetFormOnSuccess", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], LoginCard.prototype, "showSuccessMessage", void 0);
LoginCard = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            CheckCircle: __vue_component__$W,
            CircleExclamation: __vue_component__$V,
            EmailLoginForm: __vue_component__$n,
            I18n,
            Card: __vue_component__$S,
            NoIdFooter: __vue_component__$m,
            PlatformButtons: __vue_component__$Z,
        },
    })
], LoginCard);
var script$l = LoginCard;

const __vue_script__$l = script$l;
var __vue_render__$l = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    {
      staticClass: "login-card",
      attrs: {
        dark: _vm.dark,
        "company-id": _vm.companyId,
        title: _vm.tr.title,
        lead: _vm.tr.lead,
        "error-message": _vm.errorMessage,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "logo",
            fn: function () {
              return [_vm._t("logo", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [_vm._t("title", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "subtitle",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "login-card__account-exists" },
                  [
                    _vm._t(
                      "accountExists",
                      [
                        _vm.showAccountExists
                          ? _c(
                              "div",
                              { staticClass: "py-3" },
                              [
                                _c(
                                  "Alert",
                                  {
                                    staticClass:
                                      "flex rounded-1 text-sm items-center py-3 px-9",
                                    attrs: {
                                      bg: "bg-info-light",
                                      color: "text-info",
                                    },
                                  },
                                  [
                                    _c("CircleExclamation", {
                                      staticClass: "mr-2",
                                      attrs: { size: 14 },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c("I18n", {
                                          attrs: {
                                            message: _vm.t(
                                              "loginCard.accountExists"
                                            ),
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "b",
                                                fn: function (text) {
                                                  return [
                                                    _c("b", [
                                                      _vm._v(_vm._s(text)),
                                                    ]),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            820957003
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _c("div", { staticClass: "w-full" }),
                      ],
                      null,
                      _vm.stateProps
                    ),
                  ],
                  2
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "lead",
            fn: function () {
              return [_vm._t("lead", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [_vm._t("error", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _vm._t(
                  "footer",
                  [
                    _c("NoIdFooter", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showFooter,
                          expression: "showFooter",
                        },
                      ],
                      on: { click: _vm.handleSignupClick },
                    }),
                  ],
                  null,
                  _vm.stateProps
                ),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c("div", { staticClass: "login-card__form relative" }, [
        _c(
          "div",
          { staticClass: "text-center" },
          [
            _vm._t(
              "form",
              [
                _c("EmailLoginForm", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.hasSuccess,
                      expression: "!hasSuccess",
                    },
                  ],
                  attrs: {
                    "default-form-state": _vm.defaultFormState,
                    "form-disabled": _vm.formDisabled,
                    "reset-form-on-success": _vm.resetFormOnSuccess,
                  },
                  on: {
                    "attempt:data": _vm.onAttemptLogin,
                    "login:success": _vm.onLoginSuccess,
                    "login:error": _vm.onLoginError,
                    reset: function ($event) {
                      return _vm.setErrorMessage("")
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "captcha",
                        fn: function (formState) {
                          return [
                            _c(
                              "div",
                              { staticClass: "login-card__captcha" },
                              [_vm._t("formCaptcha", null, null, formState)],
                              2
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _vm._v(" "),
                _vm.showForgotPassword
                  ? _c("div", { staticClass: "pt-6" }, [
                      _c(
                        "a",
                        {
                          staticClass: "text-sm sl-btn-link-dark-5 underline",
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault();
                              return _vm.onClickForgotPassword($event)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.t("loginCard.forgotPassword")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ],
              null,
              _vm.stateProps
            ),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "login-card__success" },
          [
            _vm._t(
              "success",
              [
                _c(
                  "Alert",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasSuccess,
                        expression: "hasSuccess",
                      },
                    ],
                    staticClass:
                      "absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center px-5",
                    attrs: { bg: "bg-white", color: "text-emerald-900" },
                  },
                  [
                    _c("div", { staticClass: "flex items-center text-lg" }, [
                      _c(
                        "div",
                        { staticClass: "mr-2" },
                        [
                          _c("CheckCircle", {
                            staticClass: "block",
                            attrs: { text: "r", size: 28 },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.t("loginCard.successText")) +
                            "\n            "
                        ),
                      ]),
                    ]),
                  ]
                ),
              ],
              null,
              _vm.stateProps
            ),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "login-card__platforms" },
        [
          _vm._t(
            "platforms",
            [
              _c("PlatformButtons", {
                attrs: {
                  heading: _vm.t("platformButtons.loginWithPlatform"),
                  "platform-buttons": _vm.platformButtons,
                  "platform-icons": _vm.platformIcons,
                  "btn-style": _vm.btnStyle,
                },
                on: { source: _vm.onPlatformBtnClick },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "before",
                      fn: function () {
                        return [
                          _vm._t("platformsBefore", null, null, _vm.stateProps),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "after",
                      fn: function () {
                        return [
                          _vm._t("platformsAfter", null, null, _vm.stateProps),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$l = [];
__vue_render__$l._withStripped = true;
  const __vue_inject_styles__$l = undefined;
  const __vue_scope_id__$l = undefined;
  const __vue_module_identifier__$l = undefined;
  const __vue_is_functional_template__$l = false;
  const __vue_component__$l = normalizeComponent(
    { render: __vue_render__$l, staticRenderFns: __vue_staticRenderFns__$l },
    __vue_inject_styles__$l,
    __vue_script__$l,
    __vue_scope_id__$l,
    __vue_is_functional_template__$l,
    __vue_module_identifier__$l,
    false,
    undefined,
    undefined,
    undefined
  );

const { connect: connect$1 } = methods;
let LoginSourcesCard = class LoginSourcesCard extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "connectConfig", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "buttons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showNoAccount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showAccountExists", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "connect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platformButtons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platformIcons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "btnStyle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "isConnecting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isLoggingIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "loginTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    onBeforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    onWindowFocus() {
        if (this.isConnecting) {
            const popout = methods.getConnectWindow();
            if (popout && !popout.closed) {
                popout.focus();
                setTimeout(() => {
                    popout.focus();
                }, 100);
            }
        }
    }
    mounted() {
        window.addEventListener('focus', this.onWindowFocus);
    }
    beforeDestroy() {
        window.removeEventListener('focus', this.onWindowFocus);
    }
    setIsConnecting(isConnecting) {
        this.isConnecting = isConnecting;
    }
    setIsLoggingIn(isLoggingIn) {
        this.isLoggingIn = isLoggingIn;
    }
    setErrorMessage(msg) {
        this.errorMessage = msg;
    }
    handleConnect(data) {
        return connect$1(data);
    }
    onConnect() {
        return __awaiter(this, void 0, void 0, function* () {
            const connectMethod = typeof this.connect === 'function' ? this.connect : this.handleConnect;
            if (this.isConnecting) {
                return false;
            }
            this.setIsLoggingIn(false);
            this.setIsConnecting(true);
            try {
                const response = yield connectMethod(Object.assign({}, this.computedConnectConfig));
                this.onSuccess(response);
                this.setIsConnecting(false);
                return true;
            }
            catch (err) {
                if (err instanceof ApiError) {
                    this.onError(err.message);
                }
            }
            this.setIsConnecting(false);
            return false;
        });
    }
    onSuccess(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setErrorMessage('');
            if (typeof this.success === 'function') {
                yield this.success(data);
            }
            else {
                this.$emit('connect:success', data);
            }
        });
    }
    onError(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.error === 'function') {
                yield this.error(msg);
            }
            else {
                this.setErrorMessage(msg);
                this.$emit('connect:error', msg);
            }
        });
    }
    handleSignupClick() {
        this.$emit('redirect', 'signup');
    }
    onPlatformBtnClick(name, resolve) {
        this.$emit('login:source', name, resolve);
    }
    get tr() {
        return {
            title: this.title || this.t('loginSourcesCard.title'),
            lead: this.lead || this.t('loginSourcesCard.lead'),
        };
    }
    get computedConnectConfig() {
        var _a;
        const suggestedUser = getSuggestedUser();
        return Object.assign(Object.assign({ suggestedEmail: suggestedUser.suggestedEmail, suggestedName: suggestedUser.suggestedName, forceVerify: getForceVerify() }, this.connectConfig), { companyId: this.company.id, lang: (((_a = this.connectConfig) === null || _a === void 0 ? void 0 : _a.lang) || vueI18nService.currentLang) });
    }
    get stateProps() {
        return {
            company: this.company,
            errorMessage: this.errorMessage,
            isConnecting: this.isConnecting,
            setIsConnecting: this.setIsConnecting,
            setErrorMessage: this.setErrorMessage,
            onConnect: this.onConnect,
            onSuccess: this.onSuccess,
            onError: this.onError,
            onPlatformBtnClick: this.onPlatformBtnClick,
            btnStyle: this.btnStyle,
            platformButtons: this.platformButtons,
            platformIcons: this.platformIcons,
        };
    }
};
__decorate([
    Prop(Boolean)
], LoginSourcesCard.prototype, "dark", void 0);
__decorate([
    Prop(String)
], LoginSourcesCard.prototype, "title", void 0);
__decorate([
    Prop(String)
], LoginSourcesCard.prototype, "lead", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], LoginSourcesCard.prototype, "connectConfig", void 0);
__decorate([
    Prop({
        type: Array,
        default: () => ['twitch', 'google', 'facebook', 'apple'],
    })
], LoginSourcesCard.prototype, "buttons", void 0);
__decorate([
    Prop(Boolean)
], LoginSourcesCard.prototype, "showNoAccount", void 0);
__decorate([
    Prop(Boolean)
], LoginSourcesCard.prototype, "showAccountExists", void 0);
__decorate([
    Prop(Function)
], LoginSourcesCard.prototype, "success", void 0);
__decorate([
    Prop(Function)
], LoginSourcesCard.prototype, "error", void 0);
__decorate([
    Prop(Function)
], LoginSourcesCard.prototype, "connect", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], LoginSourcesCard.prototype, "platformButtons", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], LoginSourcesCard.prototype, "platformIcons", void 0);
__decorate([
    Prop({ type: String, default: 'sl-btn-outline' })
], LoginSourcesCard.prototype, "btnStyle", void 0);
LoginSourcesCard = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            Card: __vue_component__$S,
            CircleExclamation: __vue_component__$V,
            I18n,
            SubmitGoButton: __vue_component__$Y,
            NoIdFooter: __vue_component__$m,
            KevinIcon: __vue_component__$11,
            PlatformButtons: __vue_component__$Z,
        },
    })
], LoginSourcesCard);
var script$k = LoginSourcesCard;

const __vue_script__$k = script$k;
var __vue_render__$k = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    {
      staticClass: "login-sources-card",
      attrs: {
        "company-id": _vm.companyId,
        dark: _vm.dark,
        "error-message": _vm.errorMessage,
        title: _vm.tr.title,
        lead: _vm.tr.lead,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "logo",
            fn: function () {
              return [_vm._t("logo", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [_vm._t("title", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "subtitle",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "login-sources-card__no-account" },
                  [
                    _vm._t(
                      "noAccount",
                      [
                        _vm.showNoAccount
                          ? _c(
                              "div",
                              { staticClass: "py-3" },
                              [
                                _c(
                                  "Alert",
                                  {
                                    staticClass:
                                      "flex rounded-1 text-sm items-center py-3 px-9",
                                    attrs: {
                                      bg: "bg-info-light",
                                      color: "text-info",
                                    },
                                  },
                                  [
                                    _c("CircleExclamation", {
                                      staticClass: "mr-2",
                                      attrs: { size: 14 },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c("I18n", {
                                          attrs: {
                                            message: _vm.t(
                                              "loginSourcesCard.noAccountMessage"
                                            ),
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "b",
                                                fn: function (text) {
                                                  return [
                                                    _c("b", [
                                                      _vm._v(_vm._s(text)),
                                                    ]),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "signup",
                                                fn: function (text) {
                                                  return [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "cursor-pointer underline text-info hover:text-info-dark",
                                                        attrs: { href: "#" },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault();
                                                            return _vm.handleSignupClick(
                                                              $event
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(text) +
                                                            "\n                  "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            2834831231
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      null,
                      _vm.stateProps
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "login-sources-card__account-exists" },
                  [
                    _vm._t(
                      "accountExists",
                      [
                        _vm.showAccountExists
                          ? _c(
                              "div",
                              { staticClass: "py-3" },
                              [
                                _c(
                                  "Alert",
                                  {
                                    staticClass:
                                      "flex rounded-1 text-sm items-center py-3 px-9",
                                    attrs: {
                                      bg: "bg-info-light",
                                      color: "text-info",
                                    },
                                  },
                                  [
                                    _c("CircleExclamation", {
                                      staticClass: "mr-2",
                                      attrs: { size: 14 },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c("I18n", {
                                          attrs: {
                                            message: _vm.t(
                                              "loginSourcesCard.accountExistsMessage"
                                            ),
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "b",
                                                fn: function (text) {
                                                  return [
                                                    _c("b", [
                                                      _vm._v(_vm._s(text)),
                                                    ]),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            820957003
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      null,
                      _vm.stateProps
                    ),
                  ],
                  2
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "lead",
            fn: function () {
              return [_vm._t("lead", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [_vm._t("error", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _vm._t(
                  "footer",
                  [_c("NoIdFooter", { on: { click: _vm.handleSignupClick } })],
                  null,
                  _vm.stateProps
                ),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "login-sources-card__connect" },
        [
          _vm._t(
            "connect",
            [
              _c(
                "div",
                { staticClass: "mx-auto max-w-[350px]" },
                [
                  _c(
                    "SubmitGoButton",
                    {
                      attrs: {
                        classes: "sl-btn-one-dark justify-between flex gap-x-2",
                        loading: _vm.isConnecting,
                      },
                      on: { click: _vm.onConnect },
                      scopedSlots: _vm._u([
                        {
                          key: "prepend",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {},
                                [_c("KevinIcon", { attrs: { size: 18 } })],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.t("loginSourcesCard.withSlId")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "login-sources-card__platforms" },
        [
          _vm._t(
            "platforms",
            [
              _c("PlatformButtons", {
                attrs: {
                  heading: _vm.t("platformButtons.loginWithPlatform"),
                  "platform-buttons": _vm.platformButtons,
                  "platform-icons": _vm.platformIcons,
                  "btn-style": _vm.btnStyle,
                },
                on: { source: _vm.onPlatformBtnClick },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "before",
                      fn: function () {
                        return [
                          _vm._t("platformsBefore", null, null, _vm.stateProps),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "after",
                      fn: function () {
                        return [
                          _vm._t("platformsAfter", null, null, _vm.stateProps),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$k = [];
__vue_render__$k._withStripped = true;
  const __vue_inject_styles__$k = undefined;
  const __vue_scope_id__$k = undefined;
  const __vue_module_identifier__$k = undefined;
  const __vue_is_functional_template__$k = false;
  const __vue_component__$k = normalizeComponent(
    { render: __vue_render__$k, staticRenderFns: __vue_staticRenderFns__$k },
    __vue_inject_styles__$k,
    __vue_script__$k,
    __vue_scope_id__$k,
    __vue_is_functional_template__$k,
    __vue_module_identifier__$k,
    false,
    undefined,
    undefined,
    undefined
  );

let RemoveTfaForm = class RemoveTfaForm extends FormMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tfaCodePlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "buttonText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "successText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { tfa_code: '' }
        });
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    validateForm() {
        if (this.validate) {
            return this.validate(this.form, this.formErrors);
        }
        let codeValid;
        [codeValid, this.formErrors.tfa_code] = validateCode(this.form.tfa_code);
        return codeValid;
    }
    defaultSubmit(form) {
        return __awaiter(this, void 0, void 0, function* () {
            return feSdk__default.api.auth.removeTfa(form.tfa_code);
        });
    }
    onSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            const submitMethod = this.submit ? this.submit : this.defaultSubmit;
            return this.handleSubmit(submitMethod, (result) => {
                this.$emit('remove:success', result);
            }, (message) => this.$emit('remove:error', message));
        });
    }
    get tr() {
        return {
            tfaCodePlaceholder: this.tfaCodePlaceholder || this.t('removeTfaForm.tfaCodePlaceholder'),
            buttonText: this.buttonText || this.t('removeTfaForm.removeBtn'),
            successText: this.successText || this.t('removeTfaForm.successText'),
        };
    }
    get stateProps() {
        return Object.assign(Object.assign({}, this.getStateProps()), { hasSuccess: this.hasSuccess, setHasSuccess: this.setHasSuccess });
    }
};
__decorate([
    Prop(Boolean)
], RemoveTfaForm.prototype, "dark", void 0);
__decorate([
    Prop(String)
], RemoveTfaForm.prototype, "tfaCodePlaceholder", void 0);
__decorate([
    Prop(String)
], RemoveTfaForm.prototype, "buttonText", void 0);
__decorate([
    Prop(String)
], RemoveTfaForm.prototype, "successText", void 0);
RemoveTfaForm = __decorate([
    Component({
        components: {
            SubmitGoButton: __vue_component__$Y,
            InputError: __vue_component__$R,
            Alert: __vue_component__$X,
        },
    })
], RemoveTfaForm);
var script$j = RemoveTfaForm;

const __vue_script__$j = script$j;
var __vue_render__$j = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "sl-one-component mx-auto max-w-full" }, [
    _c(
      "div",
      { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
      [
        _c("div", { staticClass: "remove-tfa-form text-center" }, [
          _c(
            "div",
            { staticClass: "remove-tfa-form__header" },
            [_vm._t("header", null, null, _vm.stateProps)],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "remove-tfa-form__form" },
            [
              _vm._t(
                "form",
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.hasSuccess,
                          expression: "!hasSuccess",
                        },
                      ],
                      staticClass: "w-[300px] mx-auto",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "remove-tfa-form__tfa-code" },
                        [
                          _vm._t(
                            "tfaCodeInput",
                            [
                              _c("div", { staticClass: "mb-4" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.tfa_code,
                                      expression: "form.tfa_code",
                                    },
                                  ],
                                  staticClass:
                                    "sl-form-control theme-dark w-full",
                                  attrs: {
                                    name: "tfa_code",
                                    type: "text",
                                    placeholder: _vm.tr.tfaCodePlaceholder,
                                    maxlength: "10",
                                  },
                                  domProps: { value: _vm.form.tfa_code },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.onSubmit($event)
                                    },
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form,
                                          "tfa_code",
                                          $event.target.value
                                        );
                                      },
                                      _vm.handleFieldChange,
                                    ],
                                    blur: _vm.handleFieldBlur,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "mr-[-100px]" },
                                  [
                                    _c("InputError", {
                                      attrs: {
                                        dirty:
                                          _vm.dirty.tfa_code &&
                                          _vm.blurred.tfa_code &&
                                          !!_vm.formErrors.tfa_code,
                                        text: _vm.formErrors.tfa_code,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            null,
                            _vm.stateProps
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "remove-tfa-form__button" },
                        [
                          _vm._t(
                            "button",
                            [
                              _c(
                                "SubmitGoButton",
                                {
                                  attrs: {
                                    disabled: _vm.isSubmitting || !_vm.isValid,
                                    loading: _vm.isSubmitting,
                                  },
                                  on: { click: _vm.onSubmit },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.tr.buttonText) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ],
                            null,
                            _vm.stateProps
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "remove-tfa-form__success" },
            [
              _vm._t(
                "success",
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasSuccess,
                          expression: "hasSuccess",
                        },
                      ],
                      staticClass: "py-3 w-full",
                    },
                    [
                      _c(
                        "Alert",
                        {
                          staticClass: "px-6 py-3 text-md",
                          attrs: { color: "text-emerald-700" },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.tr.successText) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "remove-tfa-form__footer" },
            [_vm._t("footer", null, null, _vm.stateProps)],
            2
          ),
        ]),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$j = [];
__vue_render__$j._withStripped = true;
  const __vue_inject_styles__$j = undefined;
  const __vue_scope_id__$j = undefined;
  const __vue_module_identifier__$j = undefined;
  const __vue_is_functional_template__$j = false;
  const __vue_component__$j = normalizeComponent(
    { render: __vue_render__$j, staticRenderFns: __vue_staticRenderFns__$j },
    __vue_inject_styles__$j,
    __vue_script__$j,
    __vue_scope_id__$j,
    __vue_is_functional_template__$j,
    __vue_module_identifier__$j,
    false,
    undefined,
    undefined,
    undefined
  );

let RemoveTfaCard = class RemoveTfaCard extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showBackBtn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "hasSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    setErrorMessage(msg) {
        this.errorMessage = msg;
    }
    setHasSuccess(hasSuccess) {
        this.hasSuccess = hasSuccess;
    }
    onSuccess(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setErrorMessage('');
            if (typeof this.success === 'function') {
                yield this.success(data);
            }
            else {
                this.$emit('remove:success', data);
                this.setHasSuccess(true);
                setTimeout(() => this.setHasSuccess(false), 4000);
            }
        });
    }
    onError(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.error === 'function') {
                yield this.error(msg);
            }
            else {
                this.setErrorMessage(msg);
                this.$emit('remove:error', msg);
            }
        });
    }
    onClickBack() {
        this.$emit('back');
    }
    get tr() {
        return {
            title: this.title || this.t('removeTfaCard.title'),
            lead: this.lead || this.t('removeTfaCard.lead'),
        };
    }
    get stateProps() {
        return {
            company: this.company,
            errorMessage: this.errorMessage,
            hasSuccess: this.hasSuccess,
            setErrorMessage: this.setErrorMessage,
            setHasSuccess: this.setHasSuccess,
            onSuccess: this.onSuccess,
            onError: this.onError,
        };
    }
};
__decorate([
    Prop(Boolean)
], RemoveTfaCard.prototype, "dark", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], RemoveTfaCard.prototype, "showBackBtn", void 0);
__decorate([
    Prop(String)
], RemoveTfaCard.prototype, "title", void 0);
__decorate([
    Prop(String)
], RemoveTfaCard.prototype, "lead", void 0);
__decorate([
    Prop(Function)
], RemoveTfaCard.prototype, "success", void 0);
__decorate([
    Prop(Function)
], RemoveTfaCard.prototype, "error", void 0);
RemoveTfaCard = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            Card: __vue_component__$S,
            CheckCircle: __vue_component__$W,
            RemoveTfaForm: __vue_component__$j,
        },
    })
], RemoveTfaCard);
var script$i = RemoveTfaCard;

const __vue_script__$i = script$i;
var __vue_render__$i = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    {
      staticClass: "remove-tfa-card",
      attrs: {
        "company-id": _vm.companyId,
        dark: _vm.dark,
        title: _vm.tr.title,
        lead: _vm.tr.lead,
        "error-message": _vm.errorMessage,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "logo",
            fn: function () {
              return [_vm._t("logo", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [_vm._t("title", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "lead",
            fn: function () {
              return [_vm._t("lead", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [_vm._t("error", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [_vm._t("footer", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "remove-tfa-card__form relative" },
        [
          _vm._t(
            "form",
            [
              _c("RemoveTfaForm", {
                attrs: { dark: _vm.dark },
                on: {
                  "remove:success": _vm.onSuccess,
                  "remove:error": _vm.onError,
                  reset: function ($event) {
                    return _vm.setErrorMessage("")
                  },
                },
              }),
            ],
            null,
            _vm.stateProps
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "remove-tfa-card__success" },
            [
              _vm._t(
                "success",
                [
                  _c(
                    "Alert",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasSuccess,
                          expression: "hasSuccess",
                        },
                      ],
                      staticClass:
                        "absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center p-5",
                      attrs: { bg: "bg-white", color: "text-emerald-900" },
                    },
                    [
                      _c("div", { staticClass: "flex items-center text-lg" }, [
                        _c(
                          "div",
                          { staticClass: "mr-2" },
                          [
                            _c("CheckCircle", {
                              staticClass: "block",
                              attrs: { size: 28 },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.t("removeTfaCard.successText")) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "remove-tfa-card__back" },
        [
          _vm._t(
            "back",
            [
              _vm.showBackBtn
                ? _c("div", { staticClass: "pt-6 text-center" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-sm sl-btn-link-dark-5 underline",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault();
                            return _vm.onClickBack($event)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.t("removeTfaCard.back")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$i = [];
__vue_render__$i._withStripped = true;
  const __vue_inject_styles__$i = undefined;
  const __vue_scope_id__$i = undefined;
  const __vue_module_identifier__$i = undefined;
  const __vue_is_functional_template__$i = false;
  const __vue_component__$i = normalizeComponent(
    { render: __vue_render__$i, staticRenderFns: __vue_staticRenderFns__$i },
    __vue_inject_styles__$i,
    __vue_script__$i,
    __vue_scope_id__$i,
    __vue_is_functional_template__$i,
    __vue_module_identifier__$i,
    false,
    undefined,
    undefined,
    undefined
  );

let EmailSignupForm = class EmailSignupForm extends FormMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "buttonText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "emailPlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "passwordPlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "usernamePlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "companyId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showAgreePromotional", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "termsUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "privacyUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultFormState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ageGate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ageLabel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "agePlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "captchaInputName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "formEl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: Object.assign({ email: '', username: '', password: '', agree: false, agreePromotional: false, dob: '' }, this.defaultFormState)
        });
    }
    get tr() {
        return {
            buttonText: this.buttonText || this.t('emailSignupForm.buttonText'),
            emailPlaceholder: this.emailPlaceholder || this.t('emailSignupForm.emailPlaceholder'),
            passwordPlaceholder: this.passwordPlaceholder ||
                this.t('emailSignupForm.passwordPlaceholder'),
            usernamePlaceholder: this.usernamePlaceholder ||
                this.t('emailSignupForm.usernamePlaceholder'),
            ageLabel: this.ageLabel || this.t('emailSignupForm.ageLabel'),
            agePlaceholder: this.agePlaceholder || this.t('emailSignupForm.agePlaceholder'),
        };
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    getFormData(overrideData = {}) {
        if (this.captchaInputName && this.formEl) {
            const captchaInput = this.formEl.querySelector(`input[name="${this.captchaInputName}"]`);
            if (captchaInput) {
                overrideData[this.captchaInputName] = captchaInput.value;
            }
        }
        const formatted = this.formatSubmitData(Object.assign({ email: this.form.email, username: this.form.username, password: this.form.password, agree: this.form.agree, agreePromotional: this.form.agreePromotional, dob: this.form.dob }, overrideData));
        if (!this.showAgreePromotional) {
            formatted.agreePromotional = null;
        }
        return formatted;
    }
    defaultSubmit(form) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield feSdk__default.api.auth.emailSignup(this.getFormData(form));
            return res;
        });
    }
    validateForm() {
        var _a;
        if (this.validate) {
            return this.validate(this.form, this.formErrors);
        }
        let usernameValid, emailValid, passwordValid, agreeValid;
        let dobValid = true;
        if (this.showName) {
            [usernameValid, this.formErrors.username] = validateUsername(this.form.username);
        }
        else {
            usernameValid = true;
        }
        [emailValid, this.formErrors.email] = validateEmail(this.form.email);
        [passwordValid, this.formErrors.password] = validatePassword(this.form.password);
        agreeValid = this.form.agree;
        if (!agreeValid) {
            this.formErrors.agree = this.t('emailSignupForm.agreeError');
        }
        if ((_a = this.ageGate) === null || _a === void 0 ? void 0 : _a.required) {
            [dobValid, this.formErrors.dob] = validateAge(this.form.dob, Number(this.ageGate.minAge));
        }
        return (usernameValid && emailValid && passwordValid && agreeValid && dobValid);
    }
    formatSubmitData(data) {
        if (!this.showName) {
            data.username = '';
        }
        if (this.showAgeGate) {
            try {
                data.dob = data.dob
                    ? new Date(data.dob).toISOString().split('T')[0]
                    : '';
            }
            catch (_a) {
                data.dob = '';
            }
        }
        else {
            data.dob = '';
        }
        return data;
    }
    onSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isValid || this.isSubmitting) {
                return false;
            }
            const submitMethod = this.submit ? this.submit : this.defaultSubmit;
            this.$emit('signup:attempt', this.getFormData());
            return this.handleSubmit(submitMethod, (result) => {
                this.$emit('signup:success', result);
            }, (message) => this.$emit('signup:error', message));
        });
    }
    get showAgeGate() {
        var _a;
        return !!((_a = this.ageGate) === null || _a === void 0 ? void 0 : _a.required);
    }
    get computedTermsUrl() {
        return methods.getCompanyLink(this.computedCompanyId, 'terms', this.termsUrl);
    }
    get computedPrivacyUrl() {
        return methods.getCompanyLink(this.computedCompanyId, 'privacy', this.privacyUrl);
    }
    get computedCompanyId() {
        return this.companyId || getCompanyId();
    }
    get stateProps() {
        return Object.assign(Object.assign({}, this.getStateProps()), { tr: this.tr, ageGate: this.ageGate });
    }
    defaultFormStateWatcher() {
        this.defaultFormState = Object.assign({ email: '', username: '', password: '' }, this.defaultFormState);
    }
};
__decorate([
    Prop(String)
], EmailSignupForm.prototype, "buttonText", void 0);
__decorate([
    Prop(String)
], EmailSignupForm.prototype, "emailPlaceholder", void 0);
__decorate([
    Prop(String)
], EmailSignupForm.prototype, "passwordPlaceholder", void 0);
__decorate([
    Prop(String)
], EmailSignupForm.prototype, "usernamePlaceholder", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], EmailSignupForm.prototype, "dark", void 0);
__decorate([
    Prop(String)
], EmailSignupForm.prototype, "companyId", void 0);
__decorate([
    Prop(Boolean)
], EmailSignupForm.prototype, "showName", void 0);
__decorate([
    Prop(Boolean)
], EmailSignupForm.prototype, "showAgreePromotional", void 0);
__decorate([
    Prop({ type: String, default: undefined })
], EmailSignupForm.prototype, "termsUrl", void 0);
__decorate([
    Prop({ type: String, default: undefined })
], EmailSignupForm.prototype, "privacyUrl", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], EmailSignupForm.prototype, "defaultFormState", void 0);
__decorate([
    Prop({ type: Object, default: undefined })
], EmailSignupForm.prototype, "ageGate", void 0);
__decorate([
    Prop(String)
], EmailSignupForm.prototype, "ageLabel", void 0);
__decorate([
    Prop(String)
], EmailSignupForm.prototype, "agePlaceholder", void 0);
__decorate([
    Prop(String)
], EmailSignupForm.prototype, "captchaInputName", void 0);
__decorate([
    Ref('formEl')
], EmailSignupForm.prototype, "formEl", void 0);
__decorate([
    Watch('defaultFormState')
], EmailSignupForm.prototype, "defaultFormStateWatcher", null);
EmailSignupForm = __decorate([
    Component({
        components: {
            SubmitGoButton: __vue_component__$Y,
            InputError: __vue_component__$R,
            I18n,
            PasswordInput: __vue_component__$K,
            DobInput: __vue_component__$Q,
        },
        directives: {
            checkbox: vCheckbox,
        },
    })
], EmailSignupForm);
var script$h = EmailSignupForm;

const __vue_script__$h = script$h;
var __vue_render__$h = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "sl-one-component" }, [
    _c(
      "div",
      { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
      [
        _c(
          "div",
          { staticClass: "email-signup-form w-[300px] mx-auto max-w-full" },
          [
            _c(
              "div",
              { staticClass: "email-signup-form__header" },
              [_vm._t("header")],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "email-signup-form__form" },
              [
                _vm._t(
                  "form",
                  [
                    _c(
                      "form",
                      {
                        ref: "formEl",
                        attrs: { action: "", method: "POST" },
                        on: {
                          submit: function ($event) {
                            $event.preventDefault();
                            return _vm.onSubmit($event)
                          },
                        },
                      },
                      [
                        _vm.showName
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "email-signup-form__field email-signup-form__field--username mb-4",
                              },
                              [
                                _vm._t(
                                  "usernameInput",
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.username,
                                          expression: "form.username",
                                        },
                                      ],
                                      staticClass:
                                        "sl-form-control theme-dark w-full",
                                      attrs: {
                                        name: "username",
                                        autocomplete: "name",
                                        type: "text",
                                        placeholder: _vm.tr.usernamePlaceholder,
                                        disabled: _vm.formDisabled,
                                      },
                                      domProps: { value: _vm.form.username },
                                      on: {
                                        input: [
                                          function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.form,
                                              "username",
                                              $event.target.value
                                            );
                                          },
                                          _vm.handleFieldChange,
                                        ],
                                        blur: _vm.handleFieldBlur,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("InputError", {
                                      attrs: {
                                        dirty:
                                          _vm.dirty.username &&
                                          _vm.blurred.username &&
                                          !!_vm.formErrors.username,
                                        text: _vm.formErrors.username,
                                      },
                                    }),
                                  ],
                                  null,
                                  _vm.stateProps
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "email-signup-form__field email-signup-form__field--email mb-4",
                          },
                          [
                            _vm._t(
                              "emailInput",
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.email,
                                      expression: "form.email",
                                    },
                                  ],
                                  staticClass:
                                    "sl-form-control theme-dark w-full",
                                  attrs: {
                                    type: "text",
                                    name: "email",
                                    autocomplete: "username",
                                    placeholder: _vm.tr.emailPlaceholder,
                                    disabled: _vm.formDisabled,
                                  },
                                  domProps: { value: _vm.form.email },
                                  on: {
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form,
                                          "email",
                                          $event.target.value
                                        );
                                      },
                                      _vm.handleFieldChange,
                                    ],
                                    blur: _vm.handleFieldBlur,
                                  },
                                }),
                                _vm._v(" "),
                                _c("InputError", {
                                  attrs: {
                                    dirty:
                                      _vm.dirty.email &&
                                      _vm.blurred.email &&
                                      !!_vm.formErrors.email,
                                    text: _vm.formErrors.email,
                                  },
                                }),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "email-signup-form__field email-signup-form__field--password mb-4",
                          },
                          [
                            _vm._t(
                              "passwordInput",
                              [
                                _c("PasswordInput", {
                                  attrs: {
                                    name: "password",
                                    autocomplete: "password",
                                    placeholder: _vm.tr.passwordPlaceholder,
                                    disabled: _vm.formDisabled,
                                  },
                                  on: {
                                    change: _vm.handleFieldChange,
                                    blur: _vm.handleFieldBlur,
                                  },
                                  model: {
                                    value: _vm.form.password,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "password", $$v);
                                    },
                                    expression: "form.password",
                                  },
                                }),
                                _vm._v(" "),
                                _c("InputError", {
                                  attrs: {
                                    dirty:
                                      _vm.dirty.password &&
                                      _vm.blurred.password &&
                                      !!_vm.formErrors.password,
                                    text: _vm.formErrors.password,
                                  },
                                }),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.showAgeGate
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "email-signup-form__field email-signup-form__field--age mb-6",
                              },
                              [
                                _vm._t(
                                  "ageInput",
                                  [
                                    _c("DobInput", {
                                      attrs: {
                                        label: _vm.tr.ageLabel,
                                        placeholder: _vm.tr.agePlaceholder,
                                        disabled: _vm.formDisabled,
                                        error:
                                          _vm.dirty.dob &&
                                          _vm.blurred.dob &&
                                          !!_vm.formErrors.dob
                                            ? _vm.formErrors.dob
                                            : "",
                                      },
                                      on: {
                                        input: _vm.handleFieldChange,
                                        blur: _vm.handleFieldBlur,
                                      },
                                      model: {
                                        value: _vm.form.dob,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "dob", $$v);
                                        },
                                        expression: "form.dob",
                                      },
                                    }),
                                  ],
                                  null,
                                  _vm.stateProps
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "email-signup-form__field email-signup-form__field--agree mb-6",
                          },
                          [
                            _vm._t(
                              "agreeInput",
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "cursor-pointer flex font-normal text-sm items-start text-dark-5 dark:text-light-1",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.agree,
                                          expression: "form.agree",
                                        },
                                        {
                                          name: "checkbox",
                                          rawName: "v-checkbox",
                                        },
                                      ],
                                      staticClass: "mr-2 mt-1 sl-checkbox",
                                      attrs: {
                                        type: "checkbox",
                                        disabled: _vm.formDisabled,
                                      },
                                      domProps: {
                                        value: true,
                                        checked: Array.isArray(_vm.form.agree)
                                          ? _vm._i(_vm.form.agree, true) > -1
                                          : _vm.form.agree,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.form.agree,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false;
                                          if (Array.isArray($$a)) {
                                            var $$v = true,
                                              $$i = _vm._i($$a, $$v);
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.form,
                                                  "agree",
                                                  $$a.concat([$$v])
                                                );
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.form,
                                                  "agree",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                );
                                            }
                                          } else {
                                            _vm.$set(_vm.form, "agree", $$c);
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("I18n", {
                                      attrs: {
                                        message: _vm.t(
                                          "emailSignupForm.agreeText"
                                        ),
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "terms",
                                          fn: function (text) {
                                            return [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "font-medium underline",
                                                  attrs: {
                                                    target: "_blank",
                                                    href: _vm.computedTermsUrl,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(text) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "privacy",
                                          fn: function (text) {
                                            return [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "font-medium underline",
                                                  attrs: {
                                                    target: "_blank",
                                                    href: _vm.computedPrivacyUrl,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(text) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showAgreePromotional,
                                expression: "showAgreePromotional",
                              },
                            ],
                            staticClass:
                              "email-signup-form__field email-signup-form__field--agree-promotional mb-6",
                          },
                          [
                            _vm._t(
                              "agreePromotionalInput",
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "cursor-pointer font-normal text-sm flex items-start text-dark-5 dark:text-light-1",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.agreePromotional,
                                          expression: "form.agreePromotional",
                                        },
                                        {
                                          name: "checkbox",
                                          rawName: "v-checkbox",
                                        },
                                      ],
                                      staticClass: "mr-2 sl-checkbox mt-1",
                                      attrs: {
                                        type: "checkbox",
                                        disabled: _vm.formDisabled,
                                      },
                                      domProps: {
                                        value: true,
                                        checked: Array.isArray(
                                          _vm.form.agreePromotional
                                        )
                                          ? _vm._i(
                                              _vm.form.agreePromotional,
                                              true
                                            ) > -1
                                          : _vm.form.agreePromotional,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.form.agreePromotional,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false;
                                          if (Array.isArray($$a)) {
                                            var $$v = true,
                                              $$i = _vm._i($$a, $$v);
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.form,
                                                  "agreePromotional",
                                                  $$a.concat([$$v])
                                                );
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.form,
                                                  "agreePromotional",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                );
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.form,
                                              "agreePromotional",
                                              $$c
                                            );
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("I18n", {
                                      attrs: {
                                        message: _vm.t(
                                          "emailSignupForm.agreePromotional"
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "email-signup-form__captcha" },
                          [_vm._t("captcha", null, null, _vm.stateProps)],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "email-signup-form__button" },
                          [
                            _vm._t(
                              "button",
                              [
                                _c(
                                  "SubmitGoButton",
                                  {
                                    attrs: {
                                      disabled:
                                        _vm.isSubmitting ||
                                        !_vm.isValid ||
                                        _vm.formDisabled,
                                      loading: _vm.isSubmitting,
                                      type: "submit",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.tr.buttonText) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "email-signup-form__footer" },
              [_vm._t("footer", null, null, _vm.stateProps)],
              2
            ),
          ]
        ),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$h = [];
__vue_render__$h._withStripped = true;
  const __vue_inject_styles__$h = function (inject) {
    if (!inject) return
    inject("data-v-3556666b_0", { source: ".toggle-show-password {\n  top: 50%;\n  transform: translateY(-50%);\n  right: 4px;\n  z-index: 1;\n}\n", map: {"version":3,"sources":["EmailSignupForm.vue"],"names":[],"mappings":"AAAA;EACE,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,UAAU;AACZ","file":"EmailSignupForm.vue","sourcesContent":[".toggle-show-password {\n  top: 50%;\n  transform: translateY(-50%);\n  right: 4px;\n  z-index: 1;\n}\n"]}, media: undefined });
  };
  const __vue_scope_id__$h = undefined;
  const __vue_module_identifier__$h = undefined;
  const __vue_is_functional_template__$h = false;
  const __vue_component__$h = normalizeComponent(
    { render: __vue_render__$h, staticRenderFns: __vue_staticRenderFns__$h },
    __vue_inject_styles__$h,
    __vue_script__$h,
    __vue_scope_id__$h,
    __vue_is_functional_template__$h,
    __vue_module_identifier__$h,
    false,
    createInjector,
    undefined,
    undefined
  );

let SignupCard = class SignupCard extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultFormState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platformButtons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platformIcons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "btnStyle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ageGate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "noAgeGate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "formDisabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "resetFormOnSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showSuccessMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showAgreePromotional", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "hasSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "ageGateInternal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                required: false,
                minAge: 0,
            }
        });
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    mounted() {
        if (!this.ageGate && !this.noAgeGate) {
            this.loadAgeGate();
        }
    }
    setErrorMessage(msg) {
        this.errorMessage = msg;
    }
    setHasSuccess(hasSuccess) {
        this.hasSuccess = hasSuccess;
    }
    loadAgeGate() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { ageGate } = yield feSdk__default.api.auth.getLocaleInfo();
                this.ageGateInternal = ageGate;
            }
            catch (_a) {
            }
        });
    }
    onSuccess(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setErrorMessage('');
            if (typeof this.success === 'function') {
                yield this.success(data);
            }
            else {
                this.$emit('signup:success', data);
                if (this.showSuccessMessage) {
                    this.setHasSuccess(true);
                    setTimeout(() => this.setHasSuccess(false), 4000);
                }
            }
        });
    }
    handleLoginClick() {
        this.$emit('redirect', 'login');
    }
    onPlatformBtnClick(name, resolve) {
        this.$emit('signup:source', name, resolve);
    }
    onError(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.error === 'function') {
                yield this.error(msg);
            }
            else {
                this.setErrorMessage(msg);
                this.$emit('signup:error', msg);
            }
        });
    }
    onSignupAttempt(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.$emit('signup:attempt', data);
        });
    }
    get tr() {
        return {
            title: this.title || this.t('signupCard.title'),
            lead: this.lead || this.t('signupCard.lead'),
        };
    }
    get stateProps() {
        return {
            company: this.company,
            errorMessage: this.errorMessage,
            hasSuccess: this.hasSuccess,
            setErrorMessage: this.setErrorMessage,
            setHasSuccess: this.setHasSuccess,
            onSuccess: this.onSuccess,
            onError: this.onError,
            onPlatformBtnClick: this.onPlatformBtnClick,
            btnStyle: this.btnStyle,
            platformButtons: this.platformButtons,
            platformIcons: this.platformIcons,
            ageGate: this.ageGateInternal,
        };
    }
    ageGateWatcher() {
        this.ageGateInternal = Object.assign({ required: false, minAge: 0 }, this.ageGate);
    }
};
__decorate([
    Prop(Boolean)
], SignupCard.prototype, "dark", void 0);
__decorate([
    Prop(String)
], SignupCard.prototype, "title", void 0);
__decorate([
    Prop(String)
], SignupCard.prototype, "lead", void 0);
__decorate([
    Prop(Boolean)
], SignupCard.prototype, "showName", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], SignupCard.prototype, "defaultFormState", void 0);
__decorate([
    Prop(Function)
], SignupCard.prototype, "success", void 0);
__decorate([
    Prop(Function)
], SignupCard.prototype, "error", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], SignupCard.prototype, "platformButtons", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], SignupCard.prototype, "platformIcons", void 0);
__decorate([
    Prop({ type: String, default: 'sl-btn-solid' })
], SignupCard.prototype, "btnStyle", void 0);
__decorate([
    Prop({ type: Object, default: undefined })
], SignupCard.prototype, "ageGate", void 0);
__decorate([
    Prop(Boolean)
], SignupCard.prototype, "noAgeGate", void 0);
__decorate([
    Prop(Boolean)
], SignupCard.prototype, "formDisabled", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], SignupCard.prototype, "resetFormOnSuccess", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], SignupCard.prototype, "showSuccessMessage", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], SignupCard.prototype, "showAgreePromotional", void 0);
__decorate([
    Watch('ageGate')
], SignupCard.prototype, "ageGateWatcher", null);
SignupCard = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            CheckCircle: __vue_component__$W,
            Card: __vue_component__$S,
            EmailSignupForm: __vue_component__$h,
            HaveIdFooter: __vue_component__$O,
            PlatformButtons: __vue_component__$Z,
        },
    })
], SignupCard);
var script$g = SignupCard;

const __vue_script__$g = script$g;
var __vue_render__$g = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    {
      staticClass: "signup-card",
      attrs: {
        "company-id": _vm.companyId,
        dark: _vm.dark,
        "error-message": _vm.errorMessage,
        title: _vm.tr.title,
        lead: _vm.tr.lead,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "logo",
            fn: function () {
              return [_vm._t("logo", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [_vm._t("title", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "lead",
            fn: function () {
              return [_vm._t("lead", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [_vm._t("error", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _vm._t(
                  "footer",
                  [_c("HaveIdFooter", { on: { click: _vm.handleLoginClick } })],
                  null,
                  _vm.stateProps
                ),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "signup-card__form relative" },
        [
          _vm._t(
            "form",
            [
              _c("EmailSignupForm", {
                attrs: {
                  "company-id": _vm.companyId,
                  "show-name": _vm.showName,
                  "default-form-state": _vm.defaultFormState,
                  "age-gate": _vm.ageGateInternal,
                  "form-disabled": _vm.formDisabled,
                  "reset-form-on-success": _vm.resetFormOnSuccess,
                  "show-agree-promotional": _vm.showAgreePromotional,
                },
                on: {
                  "signup:success": _vm.onSuccess,
                  "signup:error": _vm.onError,
                  "signup:attempt": _vm.onSignupAttempt,
                  reset: function ($event) {
                    return _vm.setErrorMessage("")
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "captcha",
                      fn: function (formState) {
                        return [
                          _c(
                            "div",
                            { staticClass: "signup-card__captcha" },
                            [_vm._t("formCaptcha", null, null, formState)],
                            2
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            null,
            _vm.stateProps
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "signup-card__success" },
            [
              _vm._t(
                "success",
                [
                  _c(
                    "Alert",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasSuccess,
                          expression: "hasSuccess",
                        },
                      ],
                      staticClass:
                        "absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center p-5",
                      attrs: { bg: "bg-white", color: "text-emerald-900" },
                    },
                    [
                      _c("div", { staticClass: "flex items-center text-lg" }, [
                        _c(
                          "div",
                          { staticClass: "mr-2" },
                          [
                            _c("check-circle", {
                              staticClass: "block",
                              attrs: { size: 28 },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.t("signupCard.successText")) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "signup-card__platforms" },
        [
          _vm._t(
            "platforms",
            [
              _c("PlatformButtons", {
                attrs: {
                  type: "signup",
                  heading: _vm.t("platformButtons.signUpWithPlatform"),
                  lead: _vm.t("platformButtons.signUpLead"),
                  "platform-buttons": _vm.platformButtons,
                  "platform-icons": _vm.platformIcons,
                  "btn-style": _vm.btnStyle,
                },
                on: { source: _vm.onPlatformBtnClick },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "before",
                      fn: function () {
                        return [
                          _vm._t("platformsBefore", null, null, _vm.stateProps),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "after",
                      fn: function () {
                        return [
                          _vm._t("platformsAfter", null, null, _vm.stateProps),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$g = [];
__vue_render__$g._withStripped = true;
  const __vue_inject_styles__$g = undefined;
  const __vue_scope_id__$g = undefined;
  const __vue_module_identifier__$g = undefined;
  const __vue_is_functional_template__$g = false;
  const __vue_component__$g = normalizeComponent(
    { render: __vue_render__$g, staticRenderFns: __vue_staticRenderFns__$g },
    __vue_inject_styles__$g,
    __vue_script__$g,
    __vue_scope_id__$g,
    __vue_is_functional_template__$g,
    __vue_module_identifier__$g,
    false,
    undefined,
    undefined,
    undefined
  );

const { connect } = methods;
let SignupSourcesCard = class SignupSourcesCard extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "connectConfig", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "connect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platformButtons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "platformIcons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "btnStyle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isConnecting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    onWindowFocus() {
        if (this.isConnecting) {
            const popout = methods.getConnectWindow();
            if (popout && !popout.closed) {
                popout.focus();
            }
        }
    }
    mounted() {
        window.addEventListener('focus', this.onWindowFocus);
    }
    beforeDestroy() {
        window.removeEventListener('focus', this.onWindowFocus);
    }
    setErrorMessage(msg) {
        this.errorMessage = msg;
    }
    setIsConnecting(isConnecting) {
        this.isConnecting = isConnecting;
    }
    handleConnect(data) {
        return connect(data);
    }
    onConnect() {
        return __awaiter(this, void 0, void 0, function* () {
            const connectMethod = typeof this.connect === 'function' ? this.connect : this.handleConnect;
            if (this.isConnecting) {
                return false;
            }
            this.setIsConnecting(true);
            try {
                const response = yield connectMethod(Object.assign({}, this.computedConnectConfig));
                this.onSuccess(response);
                this.setIsConnecting(false);
                return true;
            }
            catch (err) {
                if (err instanceof ApiError) {
                    this.onError(err.message);
                }
            }
            this.setIsConnecting(false);
            return false;
        });
    }
    onSuccess(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setErrorMessage('');
            if (typeof this.success === 'function') {
                yield this.success(data);
            }
            else {
                this.$emit('connect:success', data);
            }
        });
    }
    onError(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.error === 'function') {
                yield this.error(msg);
            }
            else {
                this.setErrorMessage(msg);
                this.$emit('connect:error', msg);
            }
        });
    }
    handleLoginClick() {
        this.$emit('redirect', 'login');
    }
    onPlatformBtnClick(name, resolve) {
        this.$emit('signup:source', name, resolve);
    }
    get computedConnectConfig() {
        var _a;
        const suggestedUser = getSuggestedUser();
        return Object.assign(Object.assign({ forceVerify: getForceVerify(), noAuthTarget: 'signup', suggestedEmail: suggestedUser.suggestedEmail, suggestedName: suggestedUser.suggestedName }, this.connectConfig), { companyId: this.company.id, lang: (((_a = this.connectConfig) === null || _a === void 0 ? void 0 : _a.lang) || vueI18nService.currentLang) });
    }
    get tr() {
        return {
            title: this.title || this.t('signupSourcesCard.title'),
            lead: this.lead || this.t('signupSourcesCard.lead'),
        };
    }
    get stateProps() {
        return {
            company: this.company,
            errorMessage: this.errorMessage,
            isConnecting: this.isConnecting,
            setIsConnecting: this.setIsConnecting,
            setErrorMessage: this.setErrorMessage,
            onConnect: this.onConnect,
            onSuccess: this.onSuccess,
            onError: this.onError,
            onPlatformBtnClick: this.onPlatformBtnClick,
            btnStyle: this.btnStyle,
            platformButtons: this.platformButtons,
            platformIcons: this.platformIcons,
        };
    }
};
__decorate([
    Prop(Boolean)
], SignupSourcesCard.prototype, "dark", void 0);
__decorate([
    Prop(String)
], SignupSourcesCard.prototype, "title", void 0);
__decorate([
    Prop(String)
], SignupSourcesCard.prototype, "lead", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], SignupSourcesCard.prototype, "connectConfig", void 0);
__decorate([
    Prop()
], SignupSourcesCard.prototype, "success", void 0);
__decorate([
    Prop()
], SignupSourcesCard.prototype, "error", void 0);
__decorate([
    Prop()
], SignupSourcesCard.prototype, "connect", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], SignupSourcesCard.prototype, "platformButtons", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], SignupSourcesCard.prototype, "platformIcons", void 0);
__decorate([
    Prop({ type: String, default: 'sl-btn-solid' })
], SignupSourcesCard.prototype, "btnStyle", void 0);
SignupSourcesCard = __decorate([
    Component({
        components: {
            Card: __vue_component__$S,
            SubmitGoButton: __vue_component__$Y,
            HaveIdFooter: __vue_component__$O,
            PlatformButtons: __vue_component__$Z,
        },
    })
], SignupSourcesCard);
var script$f = SignupSourcesCard;

const __vue_script__$f = script$f;
var __vue_render__$f = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    {
      staticClass: "signup-sources-card",
      attrs: {
        "company-id": _vm.companyId,
        dark: _vm.dark,
        "error-message": _vm.errorMessage,
        title: _vm.tr.title,
        lead: _vm.tr.lead,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "logo",
            fn: function () {
              return [_vm._t("logo", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [_vm._t("title", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "lead",
            fn: function () {
              return [_vm._t("lead", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [_vm._t("error", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _vm._t(
                  "footer",
                  [
                    _c("HaveIdFooter", {
                      attrs: { company: _vm.company },
                      on: { click: _vm.handleLoginClick },
                    }),
                  ],
                  null,
                  _vm.stateProps
                ),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "signup-sources-card__connect" },
        [
          _vm._t(
            "connect",
            [
              _c(
                "div",
                { staticClass: "mx-auto max-w-[350px]" },
                [
                  _c(
                    "SubmitGoButton",
                    {
                      attrs: {
                        classes: "sl-btn-one-dark justify-center flex gap-x-2",
                        loading: _vm.isConnecting,
                      },
                      on: { click: _vm.onConnect },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.t("signupSourcesCard.withSlId")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "signup-sources-card__platforms" },
        [
          _vm._t(
            "platforms",
            [
              _c("PlatformButtons", {
                attrs: {
                  type: "signup",
                  heading: _vm.t("platformButtons.signUpWithPlatform"),
                  lead: _vm.t("platformButtons.signUpLead"),
                  "platform-buttons": _vm.platformButtons,
                  "platform-icons": _vm.platformIcons,
                  "btn-style": _vm.btnStyle,
                },
                on: { source: _vm.onPlatformBtnClick },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "before",
                      fn: function () {
                        return [
                          _vm._t("platformsBefore", null, null, _vm.stateProps),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "after",
                      fn: function () {
                        return [
                          _vm._t("platformsAfter", null, null, _vm.stateProps),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$f = [];
__vue_render__$f._withStripped = true;
  const __vue_inject_styles__$f = undefined;
  const __vue_scope_id__$f = undefined;
  const __vue_module_identifier__$f = undefined;
  const __vue_is_functional_template__$f = false;
  const __vue_component__$f = normalizeComponent(
    { render: __vue_render__$f, staticRenderFns: __vue_staticRenderFns__$f },
    __vue_inject_styles__$f,
    __vue_script__$f,
    __vue_scope_id__$f,
    __vue_is_functional_template__$f,
    __vue_module_identifier__$f,
    false,
    undefined,
    undefined,
    undefined
  );

let VerifyEmailForm = class VerifyEmailForm extends FormMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showBackBtn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "requestOnInit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "emailDisabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultContext", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "codePlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tfaCodePlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "emailPlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "buttonText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "successText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { code: '', email: '', tfa_code: '' }
        });
        Object.defineProperty(this, "hasSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "context", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                tfa: false,
                email: '',
            }
        });
        Object.defineProperty(this, "isRequesting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "requestSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "requestAgain", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "requestTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    get tr() {
        return {
            codePlaceholder: this.codePlaceholder || this.t('verifyEmailForm.codePlaceholder'),
            tfaCodePlaceholder: this.tfaCodePlaceholder || this.t('verifyEmailForm.tfaCodePlaceholder'),
            emailPlaceholder: this.emailPlaceholder || this.t('verifyEmailForm.emailPlaceholder'),
            buttonText: this.buttonText || this.t('verifyEmailForm.buttonText'),
            successText: this.successText || this.t('verifyEmailForm.successText'),
        };
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    mounted() {
        if (this.requestOnInit) {
            this.onRequestCode();
        }
    }
    defaultSubmit(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { email, code, tfa_code } = data;
            return feSdk__default.api.user.verifyEmailConfirm(code, email, tfa_code);
        });
    }
    setHasSuccess(hasSuccess) {
        this.hasSuccess = hasSuccess;
    }
    setContext(context) {
        if (typeof context.tfa === 'boolean') {
            this.context.tfa = context.tfa;
        }
        if (context.email) {
            this.form.email = context.email;
            this.context.email = context.email;
            setTimeout(() => {
                this.form.email = context.email || '';
            }, 200);
        }
    }
    validateForm() {
        if (this.validate) {
            return this.validate(this.form, this.formErrors);
        }
        let emailValid;
        let codeValid;
        let tfaCodeValid = true;
        this.formErrors.tfa_code = '';
        [emailValid, this.formErrors.email] = validateEmail(this.form.email);
        [codeValid, this.formErrors.code] = validateCode(this.form.code);
        if (this.tfaRequired) {
            if (this.form.tfa_code.length < 6 || this.form.tfa_code.length > 10) {
                tfaCodeValid = false;
                this.formErrors.tfa_code = this.t('verifyEmailForm.tfaError');
            }
        }
        return emailValid && tfaCodeValid && codeValid;
    }
    onSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            const submitMethod = this.submit ? this.submit : this.defaultSubmit;
            return this.handleSubmit(submitMethod, (result) => {
                this.$emit('verify:success', result);
            }, (message) => this.$emit('verify:error', message));
        });
    }
    onClickBack() {
        this.resetErrors();
        this.resetForm();
        this.$emit('back');
    }
    cancelRequestInterval() {
        clearTimeout(this.requestTimeout);
        this.requestTimeout = null;
        this.requestAgain = 0;
    }
    startRequestInterval() {
        this.requestTimeout = setInterval(() => {
            this.requestAgain -= 1;
            if (this.requestAgain < 0) {
                this.cancelRequestInterval();
            }
        }, 1000);
    }
    onRequestCode() {
        return __awaiter(this, void 0, void 0, function* () {
            this.form.code = '';
            this.formErrors.code = '';
            this.isRequesting = true;
            const method = this.request
                ? this.request
                : () => feSdk__default.api.user.verifyEmailRequest();
            try {
                yield method();
                this.requestSuccess = true;
                this.requestAgain = 60;
                this.startRequestInterval();
                setTimeout(() => {
                    this.requestSuccess = false;
                }, 4000);
            }
            catch (err) {
                if (err instanceof ApiError) {
                    this.formErrors.code = err.message;
                }
            }
            this.isRequesting = false;
        });
    }
    get tfaRequired() {
        return this.context.tfa;
    }
    get stateProps() {
        return Object.assign(Object.assign({}, this.getStateProps()), { context: this.context, hasSuccess: this.hasSuccess, setHasSuccess: this.setHasSuccess, setContext: this.setContext });
    }
    defaultContextWatcher(defaultContext) {
        this.setContext(defaultContext);
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], VerifyEmailForm.prototype, "dark", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], VerifyEmailForm.prototype, "showBackBtn", void 0);
__decorate([
    Prop(Boolean)
], VerifyEmailForm.prototype, "requestOnInit", void 0);
__decorate([
    Prop(Boolean)
], VerifyEmailForm.prototype, "emailDisabled", void 0);
__decorate([
    Prop({ type: Object, default: () => ({ email: '', tfa: false }) })
], VerifyEmailForm.prototype, "defaultContext", void 0);
__decorate([
    Prop(String)
], VerifyEmailForm.prototype, "codePlaceholder", void 0);
__decorate([
    Prop(String)
], VerifyEmailForm.prototype, "tfaCodePlaceholder", void 0);
__decorate([
    Prop(String)
], VerifyEmailForm.prototype, "emailPlaceholder", void 0);
__decorate([
    Prop(String)
], VerifyEmailForm.prototype, "buttonText", void 0);
__decorate([
    Prop(String)
], VerifyEmailForm.prototype, "successText", void 0);
__decorate([
    Prop(Function)
], VerifyEmailForm.prototype, "request", void 0);
__decorate([
    Watch('defaultContext', {
        immediate: true,
    })
], VerifyEmailForm.prototype, "defaultContextWatcher", null);
VerifyEmailForm = __decorate([
    Component({
        components: {
            SubmitGoButton: __vue_component__$Y,
            InputError: __vue_component__$R,
            Alert: __vue_component__$X,
            CircleNotch: __vue_component__$1e,
            HaveIdFooter: __vue_component__$O,
        },
    })
], VerifyEmailForm);
var script$e = VerifyEmailForm;

const __vue_script__$e = script$e;
var __vue_render__$e = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "sl-one-component" }, [
    _c(
      "div",
      { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
      [
        _c(
          "div",
          {
            staticClass:
              "verify-email-form w-[300px] text-center mx-auto max-w-full",
          },
          [
            _c(
              "div",
              { staticClass: "verify-email-form__header" },
              [_vm._t("header", null, null, _vm.stateProps)],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "verify-email-form__form" },
              [
                _vm._t(
                  "form",
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.hasSuccess,
                            expression: "!hasSuccess",
                          },
                        ],
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "verify-email-form__form-email mb-4 disabled:pointer-events-none disabled:bg-gray-100",
                          },
                          [
                            _vm._t(
                              "emailInput",
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.email,
                                      expression: "form.email",
                                    },
                                  ],
                                  staticClass:
                                    "sl-form-control theme-dark w-full",
                                  attrs: {
                                    type: "text",
                                    name: "email",
                                    placeholder: _vm.tr.emailPlaceholder,
                                    readonly: !!_vm.context.email,
                                    disabled:
                                      !!_vm.context.email || _vm.emailDisabled,
                                  },
                                  domProps: { value: _vm.form.email },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.onSubmit($event)
                                    },
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form,
                                          "email",
                                          $event.target.value
                                        );
                                      },
                                      _vm.handleFieldChange,
                                    ],
                                    blur: _vm.handleFieldBlur,
                                  },
                                }),
                                _vm._v(" "),
                                _c("InputError", {
                                  attrs: {
                                    dirty:
                                      _vm.dirty.email &&
                                      _vm.blurred.email &&
                                      !!_vm.formErrors.email,
                                    text: _vm.formErrors.email,
                                  },
                                }),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "verify-email-form__form-code mb-4" },
                          [
                            _vm._t(
                              "codeInput",
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.code,
                                      expression: "form.code",
                                    },
                                  ],
                                  staticClass:
                                    "sl-form-control theme-dark w-full",
                                  attrs: {
                                    name: "code",
                                    type: "text",
                                    placeholder: _vm.tr.codePlaceholder,
                                  },
                                  domProps: { value: _vm.form.code },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.onSubmit($event)
                                    },
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form,
                                          "code",
                                          $event.target.value
                                        );
                                      },
                                      _vm.handleFieldChange,
                                    ],
                                    blur: _vm.handleFieldBlur,
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "text-right" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "sl-btn-link text-sm text-dark-5 hover:text-dark-4 dark:text-light-5 dark:hover:text-light-4 disabled:text-gray-500",
                                      attrs: {
                                        type: "button",
                                        disabled:
                                          _vm.isRequesting ||
                                          _vm.requestAgain > 0,
                                      },
                                      on: { click: _vm.onRequestCode },
                                    },
                                    [
                                      _vm.isRequesting
                                        ? [
                                            _c("CircleNotch", {
                                              staticClass: "animate-spin",
                                              attrs: { size: 12 },
                                            }),
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.t(
                                                    "verifyEmailForm.requestingBtn"
                                                  )
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        : _vm.requestSuccess
                                        ? [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.t(
                                                    "verifyEmailForm.requestSuccess"
                                                  )
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        : _vm.requestAgain
                                        ? [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.t(
                                                    "verifyEmailForm.requestAgain",
                                                    {
                                                      seconds: _vm.requestAgain,
                                                    }
                                                  )
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        : [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.t(
                                                    "verifyEmailForm.requestBtn"
                                                  )
                                                ) +
                                                "\n                    "
                                            ),
                                          ],
                                    ],
                                    2
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("InputError", {
                                  attrs: {
                                    dirty:
                                      _vm.dirty.code &&
                                      _vm.blurred.code &&
                                      !!_vm.formErrors.code,
                                    text: _vm.formErrors.code,
                                  },
                                }),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.context.tfa,
                                expression: "context.tfa",
                              },
                            ],
                            staticClass:
                              "verify-email-form__form-tfa_code mb-4",
                          },
                          [
                            _vm._t(
                              "tfaCodeInput",
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.tfa_code,
                                      expression: "form.tfa_code",
                                    },
                                  ],
                                  staticClass:
                                    "sl-form-control theme-dark w-full",
                                  attrs: {
                                    name: "tfa_code",
                                    type: "text",
                                    placeholder: _vm.tr.tfaCodePlaceholder,
                                  },
                                  domProps: { value: _vm.form.tfa_code },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.onSubmit($event)
                                    },
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form,
                                          "tfa_code",
                                          $event.target.value
                                        );
                                      },
                                      _vm.handleFieldChange,
                                    ],
                                    blur: _vm.handleFieldBlur,
                                  },
                                }),
                                _vm._v(" "),
                                _c("InputError", {
                                  attrs: {
                                    dirty:
                                      _vm.dirty.tfa_code &&
                                      _vm.blurred.tfa_code &&
                                      !!_vm.formErrors.tfa_code,
                                    text: _vm.formErrors.tfa_code,
                                  },
                                }),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "verify-email-form__button" },
                          [
                            _vm._t(
                              "button",
                              [
                                _c(
                                  "SubmitGoButton",
                                  {
                                    attrs: {
                                      disabled:
                                        _vm.isSubmitting || !_vm.isValid,
                                      loading: _vm.isSubmitting,
                                    },
                                    on: { click: _vm.onSubmit },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.tr.buttonText) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "verify-email-form__success" },
              [
                _vm._t(
                  "success",
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.hasSuccess,
                            expression: "hasSuccess",
                          },
                        ],
                        staticClass: "py-3 w-full",
                      },
                      [
                        _c(
                          "Alert",
                          {
                            staticClass: "px-6 py-3 text-md",
                            attrs: { color: "text-emerald-700" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.tr.successText) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "verify-email-form__back" },
              [
                _vm._t(
                  "back",
                  [
                    _vm.showBackBtn
                      ? _c("div", { staticClass: "pt-6" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "text-sm sl-btn-link-dark-5 underline",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault();
                                  return _vm.onClickBack($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.t("verifyEmailForm.back")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "verify-email-form__footer" },
              [_vm._t("footer", null, null, _vm.stateProps)],
              2
            ),
          ]
        ),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$e = [];
__vue_render__$e._withStripped = true;
  const __vue_inject_styles__$e = undefined;
  const __vue_scope_id__$e = undefined;
  const __vue_module_identifier__$e = undefined;
  const __vue_is_functional_template__$e = false;
  const __vue_component__$e = normalizeComponent(
    { render: __vue_render__$e, staticRenderFns: __vue_staticRenderFns__$e },
    __vue_inject_styles__$e,
    __vue_script__$e,
    __vue_scope_id__$e,
    __vue_is_functional_template__$e,
    __vue_module_identifier__$e,
    false,
    undefined,
    undefined,
    undefined
  );

let VerifyEmailCard = class VerifyEmailCard extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "requestOnInit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultContext", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showBackBtn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showFooter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "hasSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    setErrorMessage(msg) {
        this.errorMessage = msg;
    }
    setHasSuccess(hasSuccess) {
        this.hasSuccess = hasSuccess;
    }
    onClickBack() {
        this.$emit('back');
    }
    handleLoginClick() {
        this.$emit('redirect', 'login');
    }
    onSuccess(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setErrorMessage('');
            if (typeof this.success === 'function') {
                yield this.success(data);
            }
            else {
                this.$emit('verify:success', data);
                this.setHasSuccess(true);
                setTimeout(() => this.setHasSuccess(false), 4000);
            }
        });
    }
    onError(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.error === 'function') {
                yield this.error(msg);
            }
            else {
                this.setErrorMessage(msg);
                this.$emit('verify:error', msg);
            }
        });
    }
    get computedDefaultContext() {
        return Object.assign({ email: '', tfa: false }, this.defaultContext);
    }
    get tr() {
        return {
            title: this.title || this.t('verifyEmailCard.title'),
            lead: this.lead || this.t('verifyEmailCard.lead'),
        };
    }
    get stateProps() {
        return {
            company: this.company,
            errorMessage: this.errorMessage,
            hasSuccess: this.hasSuccess,
            setErrorMessage: this.setErrorMessage,
            setHasSuccess: this.setHasSuccess,
            onSuccess: this.onSuccess,
            onError: this.onError,
        };
    }
};
__decorate([
    Prop(Boolean)
], VerifyEmailCard.prototype, "dark", void 0);
__decorate([
    Prop(String)
], VerifyEmailCard.prototype, "title", void 0);
__decorate([
    Prop(String)
], VerifyEmailCard.prototype, "lead", void 0);
__decorate([
    Prop(Boolean)
], VerifyEmailCard.prototype, "requestOnInit", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], VerifyEmailCard.prototype, "defaultContext", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], VerifyEmailCard.prototype, "showBackBtn", void 0);
__decorate([
    Prop(Boolean)
], VerifyEmailCard.prototype, "showFooter", void 0);
__decorate([
    Prop(Function)
], VerifyEmailCard.prototype, "success", void 0);
__decorate([
    Prop(Function)
], VerifyEmailCard.prototype, "error", void 0);
VerifyEmailCard = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            CheckCircle: __vue_component__$W,
            Card: __vue_component__$S,
            VerifyEmailForm: __vue_component__$e,
            HaveIdFooter: __vue_component__$O,
        },
    })
], VerifyEmailCard);
var script$d = VerifyEmailCard;

const __vue_script__$d = script$d;
var __vue_render__$d = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    {
      staticClass: "verify-email-card",
      attrs: {
        "company-id": _vm.companyId,
        dark: _vm.dark,
        "error-message": _vm.errorMessage,
        title: _vm.tr.title,
        lead: _vm.tr.lead,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "logo",
            fn: function () {
              return [_vm._t("logo", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [_vm._t("title", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "lead",
            fn: function () {
              return [_vm._t("lead", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [_vm._t("error", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _vm._t(
                  "footer",
                  [
                    _c("HaveIdFooter", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showFooter,
                          expression: "showFooter",
                        },
                      ],
                      on: { click: _vm.handleLoginClick },
                    }),
                  ],
                  null,
                  _vm.stateProps
                ),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "verify-email-card__form relative" },
        [
          _vm._t(
            "form",
            [
              _c("VerifyEmailForm", {
                attrs: {
                  dark: _vm.dark,
                  "request-on-init": _vm.requestOnInit,
                  "show-back-btn": false,
                  "default-context": _vm.computedDefaultContext,
                },
                on: {
                  "verify:success": _vm.onSuccess,
                  "verify:error": _vm.onError,
                  reset: function ($event) {
                    return _vm.setErrorMessage("")
                  },
                },
              }),
            ],
            null,
            _vm.stateProps
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "verify-email-card__success" },
            [
              _vm._t(
                "success",
                [
                  _c(
                    "Alert",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasSuccess,
                          expression: "hasSuccess",
                        },
                      ],
                      staticClass:
                        "absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center p-5",
                      attrs: { bg: "bg-white", color: "text-emerald-900" },
                    },
                    [
                      _c("div", { staticClass: "flex items-center text-lg" }, [
                        _c(
                          "div",
                          { staticClass: "mr-2" },
                          [
                            _c("check-circle", {
                              staticClass: "block",
                              attrs: { size: 28 },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.t("verifyEmailCard.successText")) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "forgot-password-form__back" },
        [
          _vm._t(
            "back",
            [
              _vm.showBackBtn
                ? _c("div", { staticClass: "pt-6 text-center" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-sm sl-btn-link-dark-5 underline",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault();
                            return _vm.onClickBack($event)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.t("verifyEmailCard.back")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$d = [];
__vue_render__$d._withStripped = true;
  const __vue_inject_styles__$d = undefined;
  const __vue_scope_id__$d = undefined;
  const __vue_module_identifier__$d = undefined;
  const __vue_is_functional_template__$d = false;
  const __vue_component__$d = normalizeComponent(
    { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
    __vue_inject_styles__$d,
    __vue_script__$d,
    __vue_scope_id__$d,
    __vue_is_functional_template__$d,
    __vue_module_identifier__$d,
    false,
    undefined,
    undefined,
    undefined
  );

let RightArrow = class RightArrow extends IconMixin$1 {
};
RightArrow = __decorate([
    Component({})
], RightArrow);
var script$c = RightArrow;

const __vue_script__$c = script$c;
var __vue_render__$c = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            height: _vm.size,
            width: _vm.size,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M0 72C0 49.91 17.91 32 40 32H88C110.1 32 128 49.91 128 72V120C128 142.1 110.1 160 88 160H40C17.91 160 0 142.1 0 120V72zM0 232C0 209.9 17.91 192 40 192H88C110.1 192 128 209.9 128 232V280C128 302.1 110.1 320 88 320H40C17.91 320 0 302.1 0 280V232zM128 440C128 462.1 110.1 480 88 480H40C17.91 480 0 462.1 0 440V392C0 369.9 17.91 352 40 352H88C110.1 352 128 369.9 128 392V440zM160 72C160 49.91 177.9 32 200 32H248C270.1 32 288 49.91 288 72V120C288 142.1 270.1 160 248 160H200C177.9 160 160 142.1 160 120V72zM288 280C288 302.1 270.1 320 248 320H200C177.9 320 160 302.1 160 280V232C160 209.9 177.9 192 200 192H248C270.1 192 288 209.9 288 232V280zM160 392C160 369.9 177.9 352 200 352H248C270.1 352 288 369.9 288 392V440C288 462.1 270.1 480 248 480H200C177.9 480 160 462.1 160 440V392zM448 120C448 142.1 430.1 160 408 160H360C337.9 160 320 142.1 320 120V72C320 49.91 337.9 32 360 32H408C430.1 32 448 49.91 448 72V120zM320 232C320 209.9 337.9 192 360 192H408C430.1 192 448 209.9 448 232V280C448 302.1 430.1 320 408 320H360C337.9 320 320 302.1 320 280V232zM448 440C448 462.1 430.1 480 408 480H360C337.9 480 320 462.1 320 440V392C320 369.9 337.9 352 360 352H408C430.1 352 448 369.9 448 392V440z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$c = [];
__vue_render__$c._withStripped = true;
  const __vue_inject_styles__$c = undefined;
  const __vue_scope_id__$c = undefined;
  const __vue_module_identifier__$c = undefined;
  const __vue_is_functional_template__$c = false;
  const __vue_component__$c = normalizeComponent(
    { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
    __vue_inject_styles__$c,
    __vue_script__$c,
    __vue_scope_id__$c,
    __vue_is_functional_template__$c,
    __vue_module_identifier__$c,
    false,
    undefined,
    undefined,
    undefined
  );

let MenuInner = class MenuInner extends BaseMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "label", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "apps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stateProps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "limit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showViewAll", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showAll", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "viewMore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "viewLess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fullScreen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    get filteredApps() {
        if (this.showViewAll && this.showAll) {
            return this.apps;
        }
        return this.apps.slice(0, this.limit);
    }
    get hasExtraApps() {
        return this.apps.length > this.limit;
    }
};
__decorate([
    Prop(String)
], MenuInner.prototype, "label", void 0);
__decorate([
    Prop(Array)
], MenuInner.prototype, "apps", void 0);
__decorate([
    Prop(Object)
], MenuInner.prototype, "stateProps", void 0);
__decorate([
    Prop(Number)
], MenuInner.prototype, "limit", void 0);
__decorate([
    Prop(Boolean)
], MenuInner.prototype, "showViewAll", void 0);
__decorate([
    Prop(Boolean)
], MenuInner.prototype, "showAll", void 0);
__decorate([
    Prop(String)
], MenuInner.prototype, "viewMore", void 0);
__decorate([
    Prop(String)
], MenuInner.prototype, "viewLess", void 0);
__decorate([
    Prop(Boolean)
], MenuInner.prototype, "fullScreen", void 0);
MenuInner = __decorate([
    Component({})
], MenuInner);
var script$b = MenuInner;

const __vue_script__$b = script$b;
var __vue_render__$b = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass:
        "apps-dropdown__menu-inner bg-white dark:bg-dark-3 p-4 rounded-lg",
      class: {
        "shadow-md": !_vm.fullScreen,
      },
    },
    [
      _c(
        "div",
        { staticClass: "apps-dropdown__label mb-4" },
        [
          _vm._t(
            "label",
            [
              _c(
                "h4",
                { staticClass: "text-dark-1 text-sm dark:text-light-1" },
                [_vm._v("\n        " + _vm._s(_vm.label) + "\n      ")]
              ),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "apps-dropdown__scroller" }, [
        _c(
          "div",
          {
            staticClass: "apps-dropdown__grid grid gap-2 justify-between mb-2",
          },
          [
            _vm._l(_vm.filteredApps, function (app, i) {
              return [
                _vm._t(
                  "app",
                  [
                    _c(
                      "a",
                      {
                        key: app.id + "-" + i,
                        staticClass:
                          "app block text-center cursor-pointer p-2 hover:brightness-90 hover:bg-light-3/25 dark:hover:bg-black/25 rounded-lg",
                        attrs: { href: app.url, target: "_blank" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "app__icon flex items-center justify-center mx-auto mb-2",
                          },
                          [
                            _c("img", {
                              staticClass: "block h-10 w-10",
                              attrs: { src: app.logoThumb },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "app__name text-sm text-dark-2 dark:text-light-2 mb-1",
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(app.nameShort) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "app__description text-dark-5 dark:text-light-4 text-[11px]",
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(app.description) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  null,
                  Object.assign({}, _vm.stateProps, { app: app })
                ),
              ]
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showViewAll && _vm.hasExtraApps,
              expression: "showViewAll && hasExtraApps",
            },
          ],
          staticClass: "apps-dropdown__toggle-slot pt-4",
        },
        [
          _vm._t(
            "expandToggle",
            [
              _c(
                "div",
                {
                  staticClass:
                    "apps-dropdown__toggle -mb-4 -mx-4 py-2 text-center text-dark-3 bg-light-3 hover:bg-light-4 rounded-b-lg cursor-pointer",
                  on: { click: _vm.stateProps.toggleShowAll },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.showAll ? _vm.viewLess : _vm.viewMore) +
                      "\n      "
                  ),
                ]
              ),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$b = [];
__vue_render__$b._withStripped = true;
  const __vue_inject_styles__$b = function (inject) {
    if (!inject) return
    inject("data-v-405706e2_0", { source: ".apps-dropdown__grid[data-v-405706e2] {\n  grid-template-columns: repeat(auto-fit, minmax(152px, 1fr));\n}\n", map: {"version":3,"sources":["MenuInner.vue"],"names":[],"mappings":"AAAA;EACE,2DAA2D;AAC7D","file":"MenuInner.vue","sourcesContent":[".apps-dropdown__grid {\n  grid-template-columns: repeat(auto-fit, minmax(152px, 1fr));\n}\n"]}, media: undefined });
  };
  const __vue_scope_id__$b = "data-v-405706e2";
  const __vue_module_identifier__$b = undefined;
  const __vue_is_functional_template__$b = false;
  const __vue_component__$b = normalizeComponent(
    { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
    __vue_inject_styles__$b,
    __vue_script__$b,
    __vue_scope_id__$b,
    __vue_is_functional_template__$b,
    __vue_module_identifier__$b,
    false,
    createInjector,
    undefined,
    undefined
  );

let BasicModal = class BasicModal extends Vue {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "show", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "closeButton", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    emitOpen() {
        return null;
    }
    onClose() {
        this.$emit('close');
    }
    get stateProps() {
        return {
            onClose: this.onClose,
            show: this.show,
        };
    }
    showWatcher() {
        const body = document.querySelector('body');
        if (this.show) {
            body.style.overflow = 'hidden';
        }
        else {
            body.style.overflow = 'auto';
        }
    }
};
__decorate([
    Emit('close')
], BasicModal.prototype, "emitOpen", null);
__decorate([
    Prop({ type: Boolean, default: false })
], BasicModal.prototype, "show", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BasicModal.prototype, "dark", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], BasicModal.prototype, "closeButton", void 0);
__decorate([
    Watch('show')
], BasicModal.prototype, "showWatcher", null);
BasicModal = __decorate([
    Component({})
], BasicModal);
var script$a = BasicModal;

const __vue_script__$a = script$a;
var __vue_render__$a = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", { attrs: { name: "modal" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show",
          },
        ],
        staticClass: "sl-one-component",
      },
      [
        _c(
          "div",
          { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
          [
            _c("div", { staticClass: "modal-mask bg-white dark:bg-dark-3" }, [
              _c(
                "div",
                { staticClass: "modal-wrapper", on: { click: _vm.onClose } },
                [
                  _c("div", { staticClass: "modal-scroller" }, [
                    _c(
                      "div",
                      {
                        staticClass: "modal-container",
                        on: {
                          click: function ($event) {
                            $event.preventDefault();
                            $event.stopPropagation();
                            return (function () {})()
                          },
                        },
                      },
                      [
                        _vm.closeButton
                          ? _c(
                              "div",
                              {
                                staticClass: "modal-close",
                                on: { click: _vm.onClose },
                              },
                              [_vm._v("\n                ×\n              ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "modal-header" },
                          [_vm._t("header", null, null, _vm.stateProps)],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "modal-body" },
                          [_vm._t("body", null, null, _vm.stateProps)],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "modal-footer" },
                          [_vm._t("footer", null, null, _vm.stateProps)],
                          2
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]),
          ]
        ),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$a = [];
__vue_render__$a._withStripped = true;
  const __vue_inject_styles__$a = function (inject) {
    if (!inject) return
    inject("data-v-0ed88afb_0", { source: ".modal-mask[data-v-0ed88afb] {\n  position: fixed;\n  z-index: 9998;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: table;\n}\n.modal-wrapper[data-v-0ed88afb] {\n  display: flex;\n  height: 100%;\n}\n.modal-scroller[data-v-0ed88afb] {\n  height: 100vh;\n  overflow-y: auto;\n  width: 100%;\n  display: flex;\n}\n.modal-container[data-v-0ed88afb] {\n  transition: all 0.3s ease;\n  position: relative;\n  margin: 0 auto;\n}\n.modal-close[data-v-0ed88afb] {\n  color: #000;\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  cursor: pointer;\n  opacity: 0.75;\n  padding: 4px 8px;\n}\n.dark .modal-close[data-v-0ed88afb] {\n  color: #fff;\n}\n.modal-close[data-v-0ed88afb]:hover {\n  opacity: 1;\n}\n.modal-enter-from[data-v-0ed88afb],\n.modal-leave-to[data-v-0ed88afb] {\n  opacity: 0;\n}\n.modal-enter-active .modal-container[data-v-0ed88afb],\n.modal-leave-active .modal-container[data-v-0ed88afb] {\n  -webkit-transform: scale(0.9);\n  transform: scale(0.9);\n}\n", map: {"version":3,"sources":["BasicModal.vue"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,6BAA6B;EAC7B,qBAAqB;AACvB","file":"BasicModal.vue","sourcesContent":[".modal-mask {\n  position: fixed;\n  z-index: 9998;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: table;\n}\n.modal-wrapper {\n  display: flex;\n  height: 100%;\n}\n.modal-scroller {\n  height: 100vh;\n  overflow-y: auto;\n  width: 100%;\n  display: flex;\n}\n.modal-container {\n  transition: all 0.3s ease;\n  position: relative;\n  margin: 0 auto;\n}\n.modal-close {\n  color: #000;\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  cursor: pointer;\n  opacity: 0.75;\n  padding: 4px 8px;\n}\n.dark .modal-close {\n  color: #fff;\n}\n.modal-close:hover {\n  opacity: 1;\n}\n.modal-enter-from,\n.modal-leave-to {\n  opacity: 0;\n}\n.modal-enter-active .modal-container,\n.modal-leave-active .modal-container {\n  -webkit-transform: scale(0.9);\n  transform: scale(0.9);\n}\n"]}, media: undefined });
  };
  const __vue_scope_id__$a = "data-v-0ed88afb";
  const __vue_module_identifier__$a = undefined;
  const __vue_is_functional_template__$a = false;
  const __vue_component__$a = normalizeComponent(
    { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
    __vue_inject_styles__$a,
    __vue_script__$a,
    __vue_scope_id__$a,
    __vue_is_functional_template__$a,
    __vue_module_identifier__$a,
    false,
    createInjector,
    undefined,
    undefined
  );

let AppsDropdown = class AppsDropdown extends BaseMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "open", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "iconSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "limit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showViewAll", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "columns", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dropdownZIndex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "positionAbsolute", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "horizontalAlign", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dropdownWidth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "labelText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "viewMoreText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "viewLessText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "companyId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lang", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "buttonColor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "buttonBackground", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fullScreen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dropdownRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "internalOpen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "showAll", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "openChanged", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "openChangedTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    emitOpen() {
        return this.stateProps;
    }
    emitClose() {
        return this.stateProps;
    }
    emitShowMore() {
        return this.stateProps;
    }
    emitShowLess() {
        return this.stateProps;
    }
    emitRegisterState(getter) {
        return getter;
    }
    beforeMount() {
        return __awaiter(this, void 0, void 0, function* () {
            const c = new ComponentStateGetter(this, 'stateProps');
            this.emitRegisterState(c);
        });
    }
    onClickOutside() {
        if (this.computedOpen && !this.openChanged && !this.fullScreen) {
            this.toggleOpen();
        }
    }
    onOpen() {
        this.internalOpen = true;
        this.emitOpen();
    }
    onClose() {
        this.internalOpen = false;
        this.emitClose();
    }
    toggleOpen() {
        if (typeof this.open === 'boolean') {
            if (this.open) {
                this.emitClose();
            }
            else {
                this.emitOpen();
            }
        }
        else {
            if (this.computedOpen) {
                this.onClose();
            }
            else {
                this.onOpen();
            }
        }
    }
    showMore() {
        this.showAll = true;
        this.emitShowMore();
    }
    showLess() {
        this.showAll = false;
        this.emitShowLess();
    }
    toggleShowAll() {
        if (this.showAll) {
            this.showLess();
        }
        else {
            this.showMore();
        }
    }
    get apps() {
        return asyncComputed(() => {
            return methods.getApps(this.computedCompanyId, this.computedLang);
        });
    }
    calculatePaneWidth() {
        return 10 + 32 + 155 * this.columns + (this.columns - 1) * 8;
    }
    get computedOpen() {
        return typeof this.open === 'boolean' ? this.open : this.internalOpen;
    }
    get computedDropdownWidth() {
        return this.dropdownWidth ? this.dropdownWidth : this.calculatePaneWidth();
    }
    get mainApps() {
        var _a;
        return ((_a = this.apps) === null || _a === void 0 ? void 0 : _a.length) ? [...this.apps] : [];
    }
    get tr() {
        return {
            label: this.labelText || this.t('appsDropdown.label'),
            viewMore: this.viewMoreText || this.t('appsDropdown.viewMore'),
            viewLess: this.viewLessText || this.t('appsDropdown.viewLess'),
        };
    }
    get appsDropdownStyles() {
        return {
            '--icon-size': `${this.iconSize}px`,
            '--z': this.dropdownZIndex,
            '--button-color': this.buttonColor,
            '--button-background': this.buttonBackground,
        };
    }
    get paneContentStyles() {
        return {
            width: `${this.computedDropdownWidth}px`,
        };
    }
    get stateProps() {
        return {
            isOpen: this.computedOpen,
            showAll: this.showAll,
            apps: this.apps,
            open: this.onOpen,
            close: this.onClose,
            toggleOpen: this.toggleOpen,
            toggleShowAll: this.toggleShowAll,
            showMore: this.showMore,
            showLess: this.showLess,
        };
    }
    get computedLang() {
        return this.lang || getLang();
    }
    get computedCompanyId() {
        return this.companyId || getCompanyId();
    }
    openWatcher() {
        return __awaiter(this, void 0, void 0, function* () {
            this.openChanged = true;
            clearTimeout(this.openChangedTimeout);
            this.openChangedTimeout = setTimeout(() => {
                this.openChanged = false;
            }, 100);
        });
    }
};
__decorate([
    Emit('open')
], AppsDropdown.prototype, "emitOpen", null);
__decorate([
    Emit('close')
], AppsDropdown.prototype, "emitClose", null);
__decorate([
    Emit('show:more')
], AppsDropdown.prototype, "emitShowMore", null);
__decorate([
    Emit('show:less')
], AppsDropdown.prototype, "emitShowLess", null);
__decorate([
    Emit('register:state')
], AppsDropdown.prototype, "emitRegisterState", null);
__decorate([
    Prop({ type: Boolean, default: undefined })
], AppsDropdown.prototype, "open", void 0);
__decorate([
    Prop(Boolean)
], AppsDropdown.prototype, "dark", void 0);
__decorate([
    Prop({ type: Number, default: 25 })
], AppsDropdown.prototype, "iconSize", void 0);
__decorate([
    Prop(Object)
], AppsDropdown.prototype, "user", void 0);
__decorate([
    Prop({ type: Number, default: 6 })
], AppsDropdown.prototype, "limit", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], AppsDropdown.prototype, "showViewAll", void 0);
__decorate([
    Prop({ type: Number, default: 2 })
], AppsDropdown.prototype, "columns", void 0);
__decorate([
    Prop({ type: Number, default: 100 })
], AppsDropdown.prototype, "dropdownZIndex", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], AppsDropdown.prototype, "positionAbsolute", void 0);
__decorate([
    Prop({ type: String, default: 'right' })
], AppsDropdown.prototype, "horizontalAlign", void 0);
__decorate([
    Prop({ type: Number, default: undefined })
], AppsDropdown.prototype, "dropdownWidth", void 0);
__decorate([
    Prop({ type: String, default: undefined })
], AppsDropdown.prototype, "labelText", void 0);
__decorate([
    Prop({ type: String, default: undefined })
], AppsDropdown.prototype, "viewMoreText", void 0);
__decorate([
    Prop({ type: String, default: undefined })
], AppsDropdown.prototype, "viewLessText", void 0);
__decorate([
    Prop({ type: String, default: undefined })
], AppsDropdown.prototype, "companyId", void 0);
__decorate([
    Prop({ type: String, default: undefined })
], AppsDropdown.prototype, "lang", void 0);
__decorate([
    Prop({ type: String, default: '#91979A' })
], AppsDropdown.prototype, "buttonColor", void 0);
__decorate([
    Prop({ type: String, default: 'transparent' })
], AppsDropdown.prototype, "buttonBackground", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], AppsDropdown.prototype, "fullScreen", void 0);
__decorate([
    Ref()
], AppsDropdown.prototype, "dropdownRef", void 0);
__decorate([
    Async({ default: () => [] })
], AppsDropdown.prototype, "apps", null);
__decorate([
    Watch('open')
], AppsDropdown.prototype, "openWatcher", null);
AppsDropdown = __decorate([
    Component({
        components: {
            Grid: __vue_component__$c,
            Teleport: __vue_component__$1f,
            MenuInner: __vue_component__$b,
            BasicModal: __vue_component__$a,
        },
        directives: {
            ClickOutside,
        },
    })
], AppsDropdown);
var script$9 = AppsDropdown;

const __vue_script__$9 = script$9;
var __vue_render__$9 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "sl-one-component" }, [
    _c(
      "div",
      { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.onClickOutside,
                expression: "onClickOutside",
              },
            ],
            ref: "dropdownRef",
            staticClass: "apps-dropdown relative",
            style: _vm.appsDropdownStyles,
          },
          [
            _c(
              "div",
              { staticClass: "apps-dropdown__button" },
              [
                _vm._t(
                  "button",
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "leading-none flex flex-col rounded p-2 border-none",
                        class: {
                          "ml-auto":
                            !_vm.positionAbsolute &&
                            _vm.horizontalAlign === "right",
                        },
                        attrs: { type: "button" },
                        on: { click: _vm.toggleOpen },
                      },
                      [_c("Grid", { attrs: { size: _vm.iconSize } })],
                      1
                    ),
                  ],
                  null,
                  _vm.stateProps
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.computedOpen,
                    expression: "computedOpen",
                  },
                ],
                staticClass: "apps-dropdown__pane",
                class: [
                  "position--" +
                    (_vm.positionAbsolute ? "absolute" : "relative"),
                  "align--" + _vm.horizontalAlign,
                ],
              },
              [
                !_vm.fullScreen
                  ? _c(
                      "div",
                      {
                        staticClass: "apps-dropdown__pane-content",
                        style: _vm.paneContentStyles,
                      },
                      [
                        _c("MenuInner", {
                          attrs: {
                            label: _vm.tr.label,
                            apps: _vm.mainApps,
                            "state-props": _vm.stateProps,
                            limit: _vm.limit,
                            "show-view-all": _vm.showViewAll,
                            "show-all": _vm.showAll,
                            "view-more": _vm.tr.viewMore,
                            "view-less": _vm.tr.viewLess,
                            "full-screen": _vm.fullScreen,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function () {
                                  return undefined
                                },
                                proxy: true,
                              },
                              {
                                key: "app",
                                fn: function () {
                                  return undefined
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3697348782
                          ),
                        }),
                      ],
                      1
                    )
                  : [
                      _c("Teleport", { attrs: { to: "body" } }, [
                        _c(
                          "div",
                          { staticClass: "apps-dropdown__teleport-container" },
                          [
                            _c("BasicModal", {
                              attrs: { dark: _vm.dark, show: _vm.computedOpen },
                              on: { close: _vm.onClose },
                              scopedSlots: _vm._u([
                                {
                                  key: "body",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "apps-dropdown__modal-wrapper",
                                          style: _vm.paneContentStyles,
                                        },
                                        [
                                          _c("MenuInner", {
                                            attrs: {
                                              label: _vm.tr.label,
                                              apps: _vm.mainApps,
                                              "state-props": _vm.stateProps,
                                              limit: _vm.mainApps.length,
                                              "show-view-all": true,
                                              "show-all": true,
                                              "view-more": _vm.tr.viewMore,
                                              "view-less": _vm.tr.viewLess,
                                              "full-screen": _vm.fullScreen,
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return undefined
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "app",
                                                fn: function () {
                                                  return undefined
                                                },
                                                proxy: true,
                                              },
                                            ]),
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
              ],
              2
            ),
          ]
        ),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$9 = [];
__vue_render__$9._withStripped = true;
  const __vue_inject_styles__$9 = function (inject) {
    if (!inject) return
    inject("data-v-208f589b_0", { source: ".position--absolute .apps-dropdown[data-v-208f589b] ::v-deep__scroller {\n  max-height: calc(100vh - 100px);\n  overflow: auto;\n}\n@media (min-height: 600px) {\n.position--absolute .apps-dropdown[data-v-208f589b] ::v-deep__scroller {\n    max-height: calc(100vh - 300px);\n}\n}\n.apps-dropdown__button button[data-v-208f589b] {\n  background: var(--button-background);\n  color: var(--button-color);\n}\n.apps-dropdown__button button[data-v-208f589b]:hover {\n  filter: brightness(75%);\n}\n.apps-dropdown__pane[data-v-208f589b] {\n  overflow: visible;\n}\n.apps-dropdown__pane-content[data-v-208f589b] {\n  position: relative;\n  max-width: 100vw;\n}\n.apps-dropdown__pane.position--absolute[data-v-208f589b] {\n  width: calc(var(--icon-size) + 18px);\n  position: absolute;\n  top: 125%;\n  top: calc(100% + 16px);\n}\n.apps-dropdown__pane.position--absolute.align--left[data-v-208f589b] {\n  left: 0;\n}\n.apps-dropdown__pane.position--absolute.align--left .apps-dropdown__pane-content[data-v-208f589b] {\n  position: absolute;\n  left: 0;\n}\n.apps-dropdown__pane.position--absolute.align--right[data-v-208f589b] {\n  right: 0;\n}\n.apps-dropdown__pane.position--absolute.align--right .apps-dropdown__pane-content[data-v-208f589b] {\n  position: absolute;\n  right: 0;\n}\n.apps-dropdown__pane.position--relative[data-v-208f589b] {\n  margin-top: 16px;\n}\n.apps-dropdown__pane-content[data-v-208f589b] {\n  z-index: var(--z);\n}\n.dark .apps-dropdown__button button[data-v-208f589b]:hover {\n  filter: brightness(125%);\n}\n", map: {"version":3,"sources":["AppsDropdown.vue"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,cAAc;AAChB;AACA;AACE;IACE,+BAA+B;AACjC;AACF;AACA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B","file":"AppsDropdown.vue","sourcesContent":[".position--absolute .apps-dropdown ::v-deep__scroller {\n  max-height: calc(100vh - 100px);\n  overflow: auto;\n}\n@media (min-height: 600px) {\n  .position--absolute .apps-dropdown ::v-deep__scroller {\n    max-height: calc(100vh - 300px);\n  }\n}\n.apps-dropdown__button button {\n  background: var(--button-background);\n  color: var(--button-color);\n}\n.apps-dropdown__button button:hover {\n  filter: brightness(75%);\n}\n.apps-dropdown__pane {\n  overflow: visible;\n}\n.apps-dropdown__pane-content {\n  position: relative;\n  max-width: 100vw;\n}\n.apps-dropdown__pane.position--absolute {\n  width: calc(var(--icon-size) + 18px);\n  position: absolute;\n  top: 125%;\n  top: calc(100% + 16px);\n}\n.apps-dropdown__pane.position--absolute.align--left {\n  left: 0;\n}\n.apps-dropdown__pane.position--absolute.align--left .apps-dropdown__pane-content {\n  position: absolute;\n  left: 0;\n}\n.apps-dropdown__pane.position--absolute.align--right {\n  right: 0;\n}\n.apps-dropdown__pane.position--absolute.align--right .apps-dropdown__pane-content {\n  position: absolute;\n  right: 0;\n}\n.apps-dropdown__pane.position--relative {\n  margin-top: 16px;\n}\n.apps-dropdown__pane-content {\n  z-index: var(--z);\n}\n.dark .apps-dropdown__button button:hover {\n  filter: brightness(125%);\n}\n"]}, media: undefined });
  };
  const __vue_scope_id__$9 = "data-v-208f589b";
  const __vue_module_identifier__$9 = undefined;
  const __vue_is_functional_template__$9 = false;
  const __vue_component__$9 = normalizeComponent(
    { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
    __vue_inject_styles__$9,
    __vue_script__$9,
    __vue_scope_id__$9,
    __vue_is_functional_template__$9,
    __vue_module_identifier__$9,
    false,
    createInjector,
    undefined,
    undefined
  );

let UltraIcon = class UltraIcon extends IconMixin$1 {
};
UltraIcon = __decorate([
    Component({})
], UltraIcon);
var script$8 = UltraIcon;

const __vue_script__$8 = script$8;
var __vue_render__$8 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "i",
    {
      staticClass: "sl-icon",
      style: { height: _vm.size + "px", width: _vm.size + "px" },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            width: _vm.size,
            height: _vm.size,
            viewBox: "0 0 32 32",
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M29.3318 7.15333C28.4883 5.88475 26.7761 5.54015 25.5075 6.38365C24.2389 7.22715 23.8943 8.93933 24.7378 10.2079C25.8406 11.8664 26.4832 13.8549 26.4832 16.0019C26.4832 21.7906 21.7905 26.4832 16.0019 26.4832C13.8549 26.4832 11.8664 25.8407 10.2079 24.7379C8.93927 23.8944 7.22708 24.239 6.38359 25.5076C5.54009 26.7762 5.88469 28.4884 7.15327 29.3319C9.68877 31.0177 12.7348 32 16.0019 32C24.8374 32 32 24.8374 32 16.0019C32 12.7349 31.0177 9.68883 29.3318 7.15333ZM15.9986 20.4121C18.4361 20.4121 20.412 18.4361 20.412 15.9987C20.412 13.5612 18.4361 11.5853 15.9986 11.5853C13.5612 11.5853 11.5852 13.5612 11.5852 15.9987C11.5852 18.4361 13.5612 20.4121 15.9986 20.4121Z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M15.9981 5.51678C10.2094 5.51678 5.51678 10.2094 5.51678 15.9981C5.51678 17.5215 4.28181 18.7565 2.75839 18.7565C1.23497 18.7565 0 17.5215 0 15.9981C0 7.16259 7.16259 0 15.9981 0C17.5215 0 18.7565 1.23497 18.7565 2.75839C18.7565 4.28181 17.5215 5.51678 15.9981 5.51678Z",
            },
          }),
        ]
      ),
    ]
  )
};
var __vue_staticRenderFns__$8 = [];
__vue_render__$8._withStripped = true;
  const __vue_inject_styles__$8 = undefined;
  const __vue_scope_id__$8 = undefined;
  const __vue_module_identifier__$8 = undefined;
  const __vue_is_functional_template__$8 = false;
  const __vue_component__$8 = normalizeComponent(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    false,
    undefined,
    undefined,
    undefined
  );

let UltraCheckoutMixin = class UltraCheckoutMixin extends BaseMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "companyId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "planName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "affiliateData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "badgeColor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "plan", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "seeIncludedHref", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "useApiData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultPrices", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "badge", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "descriptionMonth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "descriptionYear", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "included", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "button", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "priceMonth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "priceYear", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "buyNow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "seeIncluded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cardRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fallbackPlan", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'month'
        });
        Object.defineProperty(this, "oldPriceByIntervalCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 53
        });
        Object.defineProperty(this, "cardWidth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 600
        });
        Object.defineProperty(this, "internalLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "plans", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: methods
                .getFallbackPlans()
                .map((p) => (Object.assign(Object.assign({}, p), { cache: true })))
        });
        Object.defineProperty(this, "breakpoints", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "observer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sizes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "debounceComputeCardWidth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: debounce(this.computeCardWidth, 250)
        });
    }
    get isLoading() {
        if (typeof this.loading === 'boolean') {
            return this.loading;
        }
        return this.internalLoading;
    }
    get planObj() {
        var _a;
        const found = (this.plans.find((p) => p.period === this.plan) ||
            this.plans.find((p) => p.period === this.fallbackPlan));
        if (found && !this.useApiData) {
            found.price = (_a = this.defaultPrices) === null || _a === void 0 ? void 0 : _a[found.period];
        }
        return found;
    }
    get oldPrice() {
        var _a;
        return (((_a = this.planObj) === null || _a === void 0 ? void 0 : _a.frequency) || 12) * this.oldPriceByIntervalCount;
    }
    onBuyNow() {
        return __awaiter(this, void 0, void 0, function* () {
            const setLoading = (bool) => {
                this.internalLoading = bool;
            };
            if (typeof this.buyNow === 'function') {
                yield this.buyNow(setLoading);
                return;
            }
            this.internalLoading = true;
            try {
                const promise = methods
                    .getUltraSubscribeUrl()
                    .then(({ redirect_url }) => {
                    const url = new URL(redirect_url);
                    if (this.affiliateData &&
                        Object.keys(this.affiliateData).length > 0) {
                        url.searchParams.set('affiliate_data', encode(JSON.stringify(this.affiliateData)));
                    }
                    return url.toString();
                });
                this.$emit('buy-now', promise);
            }
            catch (err) {
                if (err instanceof Error) {
                    this.$emit('error', err.message);
                }
            }
            setTimeout(() => {
                this.internalLoading = false;
            }, 4000);
        });
    }
    onSeeIncluded(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.seeIncluded === 'function') {
                e.preventDefault();
                return this.seeIncluded();
            }
            this.$emit('see-included');
        });
    }
    computeCardWidth() {
        const sizes = ['lg'];
        Object.entries(this.breakpoints).forEach(([name, size]) => {
            if (this.cardWidth < size) {
                sizes.push(name);
            }
        });
        this.sizes = sizes.map((s) => `ultra-card--${s}`);
    }
    get computedCurrency() {
        return this.currency || getCurrency();
    }
    get includedHrefComputed() {
        return this.seeIncludedHref || feSdk__default.env.get().links.ultra;
    }
    cardWidthWatcher() {
        return __awaiter(this, void 0, void 0, function* () {
            this.debounceComputeCardWidth();
        });
    }
    computedCurrencyWatcher() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.useApiData) {
                this.plans = yield methods.getPlans(this.computedCurrency);
            }
        });
    }
    mounted() {
        this.observer = new ResizeObserver((entries) => {
            const [entry] = entries;
            const { width } = entry.contentRect;
            this.cardWidth = width;
        });
        this.observer.observe(this.cardRef);
    }
    beforeDestroy() {
        this.observer.disconnect();
    }
};
__decorate([
    Prop(String)
], UltraCheckoutMixin.prototype, "companyId", void 0);
__decorate([
    Prop(Boolean)
], UltraCheckoutMixin.prototype, "dark", void 0);
__decorate([
    Prop(String)
], UltraCheckoutMixin.prototype, "planName", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], UltraCheckoutMixin.prototype, "affiliateData", void 0);
__decorate([
    Prop({ type: String, default: '#F44584' })
], UltraCheckoutMixin.prototype, "badgeColor", void 0);
__decorate([
    Prop({ type: String, default: undefined })
], UltraCheckoutMixin.prototype, "currency", void 0);
__decorate([
    Prop({ type: String, default: 'month' })
], UltraCheckoutMixin.prototype, "plan", void 0);
__decorate([
    Prop({ type: String, default: undefined })
], UltraCheckoutMixin.prototype, "seeIncludedHref", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], UltraCheckoutMixin.prototype, "useApiData", void 0);
__decorate([
    Prop({ type: Object, default: () => ({ month: 19, year: 149 }) })
], UltraCheckoutMixin.prototype, "defaultPrices", void 0);
__decorate([
    Prop(String)
], UltraCheckoutMixin.prototype, "title", void 0);
__decorate([
    Prop(String)
], UltraCheckoutMixin.prototype, "badge", void 0);
__decorate([
    Prop(String)
], UltraCheckoutMixin.prototype, "descriptionMonth", void 0);
__decorate([
    Prop(String)
], UltraCheckoutMixin.prototype, "descriptionYear", void 0);
__decorate([
    Prop(String)
], UltraCheckoutMixin.prototype, "totalValue", void 0);
__decorate([
    Prop(String)
], UltraCheckoutMixin.prototype, "included", void 0);
__decorate([
    Prop(String)
], UltraCheckoutMixin.prototype, "button", void 0);
__decorate([
    Prop(String)
], UltraCheckoutMixin.prototype, "priceMonth", void 0);
__decorate([
    Prop(String)
], UltraCheckoutMixin.prototype, "priceYear", void 0);
__decorate([
    Prop({ type: Function, default: undefined })
], UltraCheckoutMixin.prototype, "buyNow", void 0);
__decorate([
    Prop({ type: Function, default: undefined })
], UltraCheckoutMixin.prototype, "seeIncluded", void 0);
__decorate([
    Prop({ type: Boolean, default: undefined })
], UltraCheckoutMixin.prototype, "loading", void 0);
__decorate([
    Ref()
], UltraCheckoutMixin.prototype, "cardRef", void 0);
__decorate([
    Watch('cardWidth', { immediate: true })
], UltraCheckoutMixin.prototype, "cardWidthWatcher", null);
__decorate([
    Watch('computedCurrency', { immediate: true })
], UltraCheckoutMixin.prototype, "computedCurrencyWatcher", null);
UltraCheckoutMixin = __decorate([
    Component({
        components: {
            UltraIcon: __vue_component__$8,
        },
    })
], UltraCheckoutMixin);
var UltraCheckoutMixin$1 = UltraCheckoutMixin;

let UltraCheckoutCard = class UltraCheckoutCard extends mixins(UltraCheckoutMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "breakpoints", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                md: 544,
                sm: 375,
                xs: 335,
            }
        });
    }
    get stateProps() {
        return {
            company: this.company,
            planName: this.planName,
            plan: this.planObj,
            oldPrice: this.oldPrice,
            onBuyNow: this.onBuyNow,
            onSeeIncluded: this.onSeeIncluded,
            isLoading: this.isLoading,
            seeIncludedHref: this.includedHrefComputed,
            description: this.description,
            currency: this.computedCurrency,
            price: this.price,
        };
    }
    get tr() {
        return {
            title: this.title || this.t('ultraCheckoutCard.title'),
            badge: this.badge || this.t('ultraCheckoutCard.badge'),
            descriptionMonth: this.descriptionMonth || this.t('ultraCheckoutCard.description.month'),
            descriptionYear: this.descriptionYear || this.t('ultraCheckoutCard.description.year'),
            totalValue: this.totalValue || this.t('ultraCheckoutCard.totalValue'),
            included: this.included || this.t('ultraCheckoutCard.seeIncluded'),
            button: this.button || this.t('ultraCheckoutCard.buyNow'),
            priceMonth: this.priceMonth || this.t('ultraCheckoutCard.price.month'),
            priceYear: this.priceYear || this.t('ultraCheckoutCard.price.year'),
        };
    }
    get description() {
        return this.planObj.period === 'month'
            ? this.tr.descriptionMonth
            : this.tr.descriptionYear;
    }
    get price() {
        return this.planObj.period === 'month'
            ? this.tr.priceMonth
            : this.tr.priceYear;
    }
    get lang() {
        return getLang();
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
};
UltraCheckoutCard = __decorate([
    Component({
        components: {
            ArrowRight: __vue_component__$1d,
            I18n: I18n,
            CircleNotchIcon: __vue_component__$1e,
        },
    })
], UltraCheckoutCard);
var script$7 = UltraCheckoutCard;

const __vue_script__$7 = script$7;
var __vue_render__$7 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "sl-one-component max-w-[600px]" }, [
    _c(
      "div",
      { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
      [
        _c(
          "div",
          {
            ref: "cardRef",
            staticClass: "ultra-card relative",
            class: [].concat(_vm.sizes),
            style: {
              "--badge-color": _vm.badgeColor,
            },
          },
          [
            _c("div", { staticClass: "ultra-card__inner" }, [
              _c("div", { staticClass: "ultra-card__inner-bg p-6" }, [
                _c("div", { staticClass: "ultra-card__top mb-6" }, [
                  _c("div", { staticClass: "ultra-card__icon" }, [
                    _c(
                      "div",
                      { staticClass: "ultra-card__icon-content" },
                      [
                        _vm._t(
                          "icon",
                          [_c("UltraIcon", { attrs: { size: 32 } })],
                          null,
                          _vm.stateProps
                        ),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ultra-card__brands" },
                    [_vm._t("brands", null, null, _vm.stateProps)],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ultra-card__title mb-4" },
                  [
                    _vm._t(
                      "title",
                      [
                        _c("h2", { staticClass: "ultra-card__title-h2" }, [
                          _c(
                            "div",
                            { staticClass: "ultra-card__title-inner" },
                            [
                              _c("I18n", {
                                attrs: { message: _vm.t(_vm.tr.title) },
                                scopedSlots: _vm._u([
                                  {
                                    key: "b",
                                    fn: function (text) {
                                      return [
                                        _c(
                                          "b",
                                          { staticClass: "font-medium" },
                                          [_vm._v(_vm._s(text))]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "ultra-card__badge-outer" },
                            [
                              _vm._t(
                                "badge",
                                [
                                  _c(
                                    "span",
                                    { staticClass: "ultra-card__badge" },
                                    [
                                      _c("I18n", {
                                        attrs: {
                                          message: _vm.t(_vm.tr.badge, {
                                            planName: _vm.planName,
                                          }),
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "b",
                                            fn: function (text) {
                                              return [
                                                _c(
                                                  "b",
                                                  { staticClass: "font-lg" },
                                                  [_vm._v(_vm._s(text))]
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                null,
                                _vm.stateProps
                              ),
                            ],
                            2
                          ),
                        ]),
                      ],
                      null,
                      _vm.stateProps
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "ultra-card__price mb-6" }, [
                  _c(
                    "div",
                    { staticClass: "price__current" },
                    [
                      _vm._t(
                        "priceCurrent",
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.t(_vm.price, {
                                  price: _vm.planObj.price,
                                  formatParams: {
                                    price: {
                                      style: "currency",
                                      currency: _vm.planObj.currency,
                                      lng: _vm.lang,
                                      minimumFractionDigits: 0,
                                    },
                                  },
                                })
                              ) +
                              "\n              "
                          ),
                        ],
                        null,
                        _vm.stateProps
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "price__old" },
                    [
                      _vm._t(
                        "priceOld",
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.t(_vm.tr.totalValue, {
                                  price: _vm.oldPrice,
                                  formatParams: {
                                    price: {
                                      style: "currency",
                                      currency: _vm.planObj.currency,
                                      lng: _vm.lang,
                                      minimumFractionDigits: 0,
                                    },
                                  },
                                })
                              ) +
                              "\n              "
                          ),
                        ],
                        null,
                        _vm.stateProps
                      ),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ultra-card__description" },
                  [
                    _vm._t(
                      "description",
                      [
                        _c(
                          "p",
                          { staticClass: "ultra-card__description-p" },
                          [
                            _c("I18n", {
                              attrs: {
                                message: _vm.t(_vm.description, {
                                  price: _vm.planObj.price,
                                  formatParams: {
                                    price: {
                                      style: "currency",
                                      currency: _vm.planObj.currency,
                                      lng: _vm.lang,
                                      minimumFractionDigits: 0,
                                    },
                                  },
                                }),
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "b",
                                  fn: function (text) {
                                    return [
                                      _c("b", { staticClass: "font-medium" }, [
                                        _vm._v(_vm._s(text)),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                      ],
                      null,
                      _vm.stateProps
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ultra-card__after-description" },
                  [
                    _vm._t(
                      "afterDescription",
                      [_vm._m(0)],
                      null,
                      _vm.stateProps
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "ultra-card__divider my-6 border-t border-t-dark-2 dark:border-t-white -mx-6 opacity-[0.08]",
                }),
                _vm._v(" "),
                _c("div", { staticClass: "ultra-card__footer" }, [
                  _c(
                    "div",
                    { staticClass: "ultra-card__included" },
                    [
                      _vm._t(
                        "seeIncluded",
                        [
                          _c(
                            "a",
                            {
                              staticClass: "ultra-card__included-link",
                              attrs: {
                                href: _vm.includedHrefComputed,
                                target: "_blank",
                              },
                              on: { click: _vm.onSeeIncluded },
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.t(_vm.tr.included)) +
                                  "\n                  "
                              ),
                              _c("ArrowRight"),
                            ],
                            1
                          ),
                        ],
                        null,
                        _vm.stateProps
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ultra-card__buy" },
                    [
                      _vm._t(
                        "buyNow",
                        [
                          _c(
                            "button",
                            {
                              staticClass: "ultra-card__buy-btn",
                              class: {
                                "ultra-card__buy-btn--loading": _vm.isLoading,
                              },
                              attrs: {
                                type: "button",
                                disabled: _vm.isLoading,
                              },
                              on: { click: _vm.onBuyNow },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "loading" },
                                [
                                  _c("CircleNotchIcon", {
                                    staticClass: "animate-spin",
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "text" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.t(_vm.tr.button)) +
                                    "\n                  "
                                ),
                              ]),
                            ]
                          ),
                        ],
                        null,
                        _vm.stateProps
                      ),
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$7 = [
  function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "max-w-[250px] pt-4" }, [
      _c("img", {
        attrs: {
          src: "https://cdn.streamlabs.com/static/imgs/library/slone/ultra-brand-icons-v2.png",
          alt: "Ultra Plan Brands",
        },
      }),
    ])
  },
];
__vue_render__$7._withStripped = true;
  const __vue_inject_styles__$7 = function (inject) {
    if (!inject) return
    inject("data-v-f4b5c3e8_0", { source: ".ultra-card__top[data-v-f4b5c3e8] {\n  margin-top: -60px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n}\n.ultra-card__title-h2[data-v-f4b5c3e8] {\n  display: flex;\n  justify-content: space-between;\n}\n.ultra-card__title-h2 > span[data-v-f4b5c3e8]:first-child {\n  margin-right: 8px;\n}\n.ultra-card__footer[data-v-f4b5c3e8] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.ultra-card--md .ultra-card__title-h2[data-v-f4b5c3e8] {\n  display: block;\n}\n.ultra-card--sm .ultra-card__top[data-v-f4b5c3e8] {\n  display: block;\n}\n.ultra-card--sm .ultra-card__icon[data-v-f4b5c3e8] {\n  margin-bottom: 16px;\n}\n.ultra-card--xs .ultra-card__footer[data-v-f4b5c3e8] {\n  display: block;\n  text-align: center;\n}\n.ultra-card--xs .ultra-card__included[data-v-f4b5c3e8] {\n  margin-bottom: 16px;\n}\n.ultra-card--xs .ultra-card__included-link[data-v-f4b5c3e8] {\n  margin-right: auto;\n  margin-left: auto;\n  justify-content: center;\n}\n", map: {"version":3,"sources":["UltraCheckoutCard.vue"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB","file":"UltraCheckoutCard.vue","sourcesContent":[".ultra-card__top {\n  margin-top: -60px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n}\n.ultra-card__title-h2 {\n  display: flex;\n  justify-content: space-between;\n}\n.ultra-card__title-h2 > span:first-child {\n  margin-right: 8px;\n}\n.ultra-card__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.ultra-card--md .ultra-card__title-h2 {\n  display: block;\n}\n.ultra-card--sm .ultra-card__top {\n  display: block;\n}\n.ultra-card--sm .ultra-card__icon {\n  margin-bottom: 16px;\n}\n.ultra-card--xs .ultra-card__footer {\n  display: block;\n  text-align: center;\n}\n.ultra-card--xs .ultra-card__included {\n  margin-bottom: 16px;\n}\n.ultra-card--xs .ultra-card__included-link {\n  margin-right: auto;\n  margin-left: auto;\n  justify-content: center;\n}\n"]}, media: undefined });
  };
  const __vue_scope_id__$7 = "data-v-f4b5c3e8";
  const __vue_module_identifier__$7 = undefined;
  const __vue_is_functional_template__$7 = false;
  const __vue_component__$7 = normalizeComponent(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    false,
    createInjector,
    undefined,
    undefined
  );

let UltraCheckoutBanner = class UltraCheckoutBanner extends mixins(UltraCheckoutMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "breakpoints", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                md: 872,
                sm: 480,
                xs: 360,
            }
        });
    }
    get stateProps() {
        return {
            company: this.company,
            planName: this.planName,
            plan: this.planObj,
            oldPrice: this.oldPrice,
            onBuyNow: this.onBuyNow,
            onSeeIncluded: this.onSeeIncluded,
            isLoading: this.isLoading,
            seeIncludedHref: this.includedHrefComputed,
            description: this.description,
            currency: this.computedCurrency,
            price: this.price,
        };
    }
    get tr() {
        return {
            title: this.title || this.t('ultraCheckoutBanner.title'),
            badge: this.badge || this.t('ultraCheckoutBanner.badge'),
            descriptionMonth: this.descriptionMonth ||
                this.t('ultraCheckoutBanner.description.month'),
            descriptionYear: this.descriptionYear || this.t('ultraCheckoutBanner.description.year'),
            totalValue: this.totalValue || this.t('ultraCheckoutBanner.totalValue'),
            included: this.included || this.t('ultraCheckoutBanner.seeIncluded'),
            button: this.button || this.t('ultraCheckoutBanner.buyNow'),
            priceMonth: this.priceMonth || this.t('ultraCheckoutBanner.price.month'),
            priceYear: this.priceYear || this.t('ultraCheckoutBanner.price.year'),
        };
    }
    get description() {
        return this.planObj.period === 'month'
            ? this.tr.descriptionMonth
            : this.tr.descriptionYear;
    }
    get price() {
        return this.planObj.period === 'month'
            ? this.tr.priceMonth
            : this.tr.priceYear;
    }
    get lang() {
        return getLang();
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
};
UltraCheckoutBanner = __decorate([
    Component({
        components: {
            ArrowRight: __vue_component__$1d,
            CircleNotchIcon: __vue_component__$1e,
            I18n: I18n,
        },
    })
], UltraCheckoutBanner);
var script$6 = UltraCheckoutBanner;

const __vue_script__$6 = script$6;
var __vue_render__$6 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "sl-one-component" }, [
    _c(
      "div",
      { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
      [
        _c(
          "div",
          {
            ref: "cardRef",
            staticClass: "ultra-card ultra-card--banner relative",
            class: [].concat(_vm.sizes),
            style: {
              "--badge-color": _vm.badgeColor,
            },
          },
          [
            _c("div", { staticClass: "ultra-card__inner" }, [
              _c("div", { staticClass: "ultra-card__inner-bg p-6" }, [
                _c("div", { staticClass: "ultra-card__top mb-6" }, [
                  _c("div", { staticClass: "ultra-card__icon" }, [
                    _c(
                      "div",
                      { staticClass: "ultra-card__icon-content" },
                      [
                        _vm._t(
                          "icon",
                          [_c("UltraIcon", { attrs: { size: 32 } })],
                          null,
                          _vm.stateProps
                        ),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ultra-card__brands" },
                    [
                      _vm._t(
                        "brands",
                        [
                          _c("img", {
                            attrs: {
                              src: "https://cdn.streamlabs.com/static/imgs/library/slone/ultra-brand-icons.png",
                              alt: "Ultra Plan Brands",
                            },
                          }),
                        ],
                        null,
                        _vm.stateProps
                      ),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ultra-card__container" }, [
                  _c("div", { staticClass: "ultra-card__body" }, [
                    _c(
                      "div",
                      { staticClass: "ultra-card__title mb-2" },
                      [
                        _vm._t(
                          "title",
                          [
                            _c("h2", { staticClass: "ultra-card__title-h2" }, [
                              _c(
                                "span",
                                { staticClass: "ultra-card__title-inner" },
                                [
                                  _c("I18n", {
                                    attrs: { message: _vm.t(_vm.tr.title) },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "b",
                                        fn: function (text) {
                                          return [
                                            _c(
                                              "b",
                                              { staticClass: "font-medium" },
                                              [_vm._v(_vm._s(text))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "ultra-card__badge-outer" },
                                [
                                  _vm._t(
                                    "badge",
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "ultra-card__badge" },
                                        [
                                          _c("I18n", {
                                            attrs: {
                                              message: _vm.t(_vm.tr.badge, {
                                                planName: _vm.planName,
                                              }),
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "b",
                                                fn: function (text) {
                                                  return [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass: "font-lg",
                                                      },
                                                      [_vm._v(_vm._s(text))]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ]),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    null,
                                    _vm.stateProps
                                  ),
                                ],
                                2
                              ),
                            ]),
                          ],
                          null,
                          _vm.stateProps
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "ultra-card__description-line flex flex-wrap gap-x-2 gap-y-4",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "ultra-card__description" },
                          [
                            _vm._t(
                              "description",
                              [
                                _c(
                                  "p",
                                  { staticClass: "ultra-card__description-p" },
                                  [
                                    _c("I18n", {
                                      attrs: {
                                        message: _vm.t(_vm.description, {
                                          price: _vm.planObj.price,
                                          formatParams: {
                                            price: {
                                              style: "currency",
                                              currency: _vm.planObj.currency,
                                              lng: _vm.lang,
                                              minimumFractionDigits: 0,
                                            },
                                          },
                                        }),
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "b",
                                          fn: function (text) {
                                            return [
                                              _c(
                                                "b",
                                                { staticClass: "font-medium" },
                                                [_vm._v(_vm._s(text))]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "link",
                                          fn: function () {
                                            return [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "ultra-card__included-link leading-normal",
                                                  attrs: {
                                                    href: _vm.includedHrefComputed,
                                                    target: "_blank",
                                                  },
                                                  on: {
                                                    click: _vm.onSeeIncluded,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm.t(_vm.tr.included)
                                                      ) +
                                                      "\n                            "
                                                  ),
                                                  _c("ArrowRight"),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "ultra-card__included" },
                          [
                            _vm._t(
                              "seeIncluded",
                              [_c("span")],
                              null,
                              _vm.stateProps
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ultra-card__after-description" },
                      [_vm._t("afterDescription", null, null, _vm.stateProps)],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "ultra-card__divider my-6 border-t border-t-dark-2 dark:border-t-white -mx-6 opacity-[0.08]",
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ultra-card__footer" }, [
                    _c("div", { staticClass: "ultra-card__price" }, [
                      _c(
                        "div",
                        { staticClass: "price__current" },
                        [
                          _vm._t(
                            "priceCurrent",
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.t(_vm.price, {
                                      price: _vm.planObj.price,
                                      formatParams: {
                                        price: {
                                          style: "currency",
                                          currency: _vm.planObj.currency,
                                          lng: _vm.lang,
                                          minimumFractionDigits: 0,
                                        },
                                      },
                                    })
                                  ) +
                                  "\n                  "
                              ),
                            ],
                            null,
                            _vm.stateProps
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "price__old" },
                        [
                          _vm._t(
                            "priceOld",
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.t(_vm.tr.totalValue, {
                                      price: _vm.oldPrice,
                                      formatParams: {
                                        price: {
                                          style: "currency",
                                          currency: _vm.planObj.currency,
                                          lng: _vm.lang,
                                          minimumFractionDigits: 0,
                                        },
                                      },
                                    })
                                  ) +
                                  "\n                  "
                              ),
                            ],
                            null,
                            _vm.stateProps
                          ),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ultra-card__buy" },
                      [
                        _vm._t(
                          "buyNow",
                          [
                            _c(
                              "button",
                              {
                                staticClass: "ultra-card__buy-btn",
                                class: {
                                  "ultra-card__buy-btn--loading": _vm.isLoading,
                                },
                                attrs: {
                                  type: "button",
                                  disabled: _vm.isLoading,
                                },
                                on: { click: _vm.onBuyNow },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "loading" },
                                  [
                                    _c("CircleNotchIcon", {
                                      staticClass: "animate-spin",
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "text" }, [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.t(_vm.tr.button)) +
                                      "\n                    "
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          null,
                          _vm.stateProps
                        ),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$6 = [];
__vue_render__$6._withStripped = true;
  const __vue_inject_styles__$6 = function (inject) {
    if (!inject) return
    inject("data-v-3b882ca6_0", { source: ".ultra-card__top[data-v-3b882ca6] {\n  margin-top: -60px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n}\n.ultra-card__title-h2[data-v-3b882ca6] {\n  display: flex;\n  column-gap: 16px;\n}\n.ultra-card__divider[data-v-3b882ca6] {\n  display: none;\n}\n.ultra-card__description-p[data-v-3b882ca6] {\n  max-width: 800px;\n}\n.ultra-card__price[data-v-3b882ca6] {\n  flex-direction: column;\n}\n.ultra-card .price__old[data-v-3b882ca6] {\n  padding-top: 0;\n}\n.ultra-card__footer[data-v-3b882ca6] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  column-gap: 32px;\n}\n.ultra-card__container[data-v-3b882ca6] {\n  display: flex;\n  column-gap: 16px;\n  justify-content: space-between;\n  align-items: center;\n}\n.ultra-card__included-link[data-v-3b882ca6] {\n  display: inline-flex;\n  margin-left: 8px;\n}\n.ultra-card--md .ultra-card__container[data-v-3b882ca6] {\n  display: block;\n}\n.ultra-card--md .ultra-card__price[data-v-3b882ca6] {\n  flex-direction: row;\n}\n.ultra-card--md .ultra-card .price__old[data-v-3b882ca6] {\n  padding-top: 4px;\n}\n.ultra-card--md .ultra-card__body[data-v-3b882ca6] {\n  margin-bottom: 16px;\n}\n.ultra-card--md .ultra-card__title-h2[data-v-3b882ca6] {\n  display: block;\n}\n.ultra-card--md .ultra-card__badge-outer[data-v-3b882ca6] {\n  padding-left: 16px;\n}\n.ultra-card--md .ultra-card__divider[data-v-3b882ca6] {\n  display: block;\n}\n.ultra-card--sm .ultra-card__top[data-v-3b882ca6] {\n  display: block;\n}\n.ultra-card--sm .ultra-card__icon[data-v-3b882ca6] {\n  margin-bottom: 16px;\n}\n.ultra-card--sm .ultra-card__brands img[data-v-3b882ca6] {\n  margin-right: auto;\n  margin-left: auto;\n}\n.ultra-card--sm .ultra-card__body[data-v-3b882ca6] {\n  margin-bottom: 0;\n}\n.ultra-card--xs .ultra-card__footer[data-v-3b882ca6] {\n  display: block;\n  text-align: center;\n}\n.ultra-card--xs .ultra-card__price[data-v-3b882ca6] {\n  justify-content: center;\n  margin-bottom: 16px;\n}\n.ultra-card--xs .ultra-card__included-link[data-v-3b882ca6] {\n  margin-left: auto;\n  margin-right: auto;\n  justify-content: center;\n}\n", map: {"version":3,"sources":["UltraCheckoutBanner.vue"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB","file":"UltraCheckoutBanner.vue","sourcesContent":[".ultra-card__top {\n  margin-top: -60px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n}\n.ultra-card__title-h2 {\n  display: flex;\n  column-gap: 16px;\n}\n.ultra-card__divider {\n  display: none;\n}\n.ultra-card__description-p {\n  max-width: 800px;\n}\n.ultra-card__price {\n  flex-direction: column;\n}\n.ultra-card .price__old {\n  padding-top: 0;\n}\n.ultra-card__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  column-gap: 32px;\n}\n.ultra-card__container {\n  display: flex;\n  column-gap: 16px;\n  justify-content: space-between;\n  align-items: center;\n}\n.ultra-card__included-link {\n  display: inline-flex;\n  margin-left: 8px;\n}\n.ultra-card--md .ultra-card__container {\n  display: block;\n}\n.ultra-card--md .ultra-card__price {\n  flex-direction: row;\n}\n.ultra-card--md .ultra-card .price__old {\n  padding-top: 4px;\n}\n.ultra-card--md .ultra-card__body {\n  margin-bottom: 16px;\n}\n.ultra-card--md .ultra-card__title-h2 {\n  display: block;\n}\n.ultra-card--md .ultra-card__badge-outer {\n  padding-left: 16px;\n}\n.ultra-card--md .ultra-card__divider {\n  display: block;\n}\n.ultra-card--sm .ultra-card__top {\n  display: block;\n}\n.ultra-card--sm .ultra-card__icon {\n  margin-bottom: 16px;\n}\n.ultra-card--sm .ultra-card__brands img {\n  margin-right: auto;\n  margin-left: auto;\n}\n.ultra-card--sm .ultra-card__body {\n  margin-bottom: 0;\n}\n.ultra-card--xs .ultra-card__footer {\n  display: block;\n  text-align: center;\n}\n.ultra-card--xs .ultra-card__price {\n  justify-content: center;\n  margin-bottom: 16px;\n}\n.ultra-card--xs .ultra-card__included-link {\n  margin-left: auto;\n  margin-right: auto;\n  justify-content: center;\n}\n"]}, media: undefined });
  };
  const __vue_scope_id__$6 = "data-v-3b882ca6";
  const __vue_module_identifier__$6 = undefined;
  const __vue_is_functional_template__$6 = false;
  const __vue_component__$6 = normalizeComponent(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    false,
    createInjector,
    undefined,
    undefined
  );

let VerifyPasswordCard = class VerifyPasswordCard extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "focusInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "verify", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "hasSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
    setErrorMessage(msg) {
        this.errorMessage = msg;
    }
    setHasSuccess(bool) {
        this.hasSuccess = bool;
    }
    handleXhrError(err, fallback) {
        if (err.data.code === 'email_verification_required') {
            this.$emit('validate', 'email');
            this.setErrorMessage(this.t('connectCard.connect.emailRequired'));
        }
        else if (err.data.code === 'token_required') {
            this.$emit('validate', 'tfa');
            this.setErrorMessage(this.t('connectCard.connect.tfaRequired'));
        }
        else if (err.data.code === 'age_gate_required') {
            this.$emit('validate', 'age');
            this.setErrorMessage(this.t('connectCard.connect.ageRequired'));
        }
        else {
            fallback(err);
        }
    }
    onSuccess(data, response) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = {
                data,
                response,
            };
            if (typeof this.success === 'function') {
                yield this.success(payload);
                return;
            }
            this.$emit('step:success', payload);
            this.setHasSuccess(true);
            setTimeout(() => this.setHasSuccess(false), 4000);
        });
    }
    onError(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.error === 'function') {
                yield this.error(msg);
            }
            else {
                this.setErrorMessage(msg);
                this.$emit('step:error', msg);
            }
        });
    }
    handleVerify(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return feSdk__default.api.auth.emailLogin(data);
        });
    }
    onSubmit(form) {
        return __awaiter(this, void 0, void 0, function* () {
            const method = typeof this.verify === 'function' ? this.verify : this.handleVerify;
            this.setErrorMessage('');
            try {
                const user = yield method(form);
                this.$emit('user', user, form);
                if (user.tfa_enabled) {
                    yield feSdk__default.api.user.getAuthUser();
                }
                this.onSuccess(form, user);
            }
            catch (err) {
                if (err instanceof ApiError) {
                    this.handleXhrError(err, (e) => {
                        throw e;
                    });
                }
            }
            return this.user;
        });
    }
    get defaultState() {
        var _a;
        return {
            email: ((_a = this.user) === null || _a === void 0 ? void 0 : _a.email) || '',
            password: '',
        };
    }
    get isLoggedIn() {
        return !!this.defaultState.email;
    }
    get stateProps() {
        return {
            company: this.company,
            errorMessage: this.errorMessage,
            hasSuccess: this.hasSuccess,
            setErrorMessage: this.setErrorMessage,
            setHasSuccess: this.setHasSuccess,
            onSubmit: this.onSubmit,
            onSuccess: this.onSuccess,
            onError: this.onError,
            defaultState: this.defaultState,
            isLoggedIn: this.isLoggedIn,
        };
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    get tr() {
        return {
            title: this.title || this.t('verifyPasswordCard.title'),
            lead: this.lead || this.t('verifyPasswordCard.lead'),
            buttonText: this.isLoggedIn
                ? this.t('verifyPasswordCard.buttonText')
                : this.t('emailLoginForm.buttonText'),
        };
    }
};
__decorate([
    Prop(Boolean)
], VerifyPasswordCard.prototype, "dark", void 0);
__decorate([
    Prop(String)
], VerifyPasswordCard.prototype, "title", void 0);
__decorate([
    Prop(String)
], VerifyPasswordCard.prototype, "lead", void 0);
__decorate([
    Prop(Boolean)
], VerifyPasswordCard.prototype, "focusInput", void 0);
__decorate([
    Prop(Object)
], VerifyPasswordCard.prototype, "user", void 0);
__decorate([
    Prop(Function)
], VerifyPasswordCard.prototype, "success", void 0);
__decorate([
    Prop(Function)
], VerifyPasswordCard.prototype, "verify", void 0);
__decorate([
    Prop(Function)
], VerifyPasswordCard.prototype, "error", void 0);
VerifyPasswordCard = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            CheckCircle: __vue_component__$W,
            EmailLoginForm: __vue_component__$n,
            Card: __vue_component__$S,
        },
    })
], VerifyPasswordCard);
var script$5 = VerifyPasswordCard;

const __vue_script__$5 = script$5;
var __vue_render__$5 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    {
      staticClass: "login-card",
      attrs: {
        dark: _vm.dark,
        "company-id": _vm.companyId,
        title: _vm.tr.title,
        lead: _vm.tr.lead,
        "error-message": _vm.errorMessage,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "logo",
            fn: function () {
              return [_vm._t("logo", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [_vm._t("title", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "subtitle",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
          {
            key: "lead",
            fn: function () {
              return [_vm._t("lead", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [_vm._t("error", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [_vm._t("footer", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c("div", { staticClass: "verify-password-card__form relative" }, [
        _c(
          "div",
          { staticClass: "text-center" },
          [
            _vm._t(
              "form",
              [
                _c("EmailLoginForm", {
                  attrs: {
                    "default-form-state": _vm.defaultState,
                    "focus-input": _vm.focusInput,
                    "email-disabled": _vm.isLoggedIn,
                    "button-text": _vm.tr.buttonText,
                    submit: _vm.onSubmit,
                  },
                  on: {
                    "login:error": _vm.onError,
                    reset: function ($event) {
                      return _vm.setErrorMessage("")
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "captcha",
                        fn: function (formState) {
                          return [
                            _c(
                              "div",
                              { staticClass: "verify-password-card__captcha" },
                              [_vm._t("formCaptcha", null, null, formState)],
                              2
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ],
              null,
              _vm.stateProps
            ),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "verify-password-card__success" },
          [
            _vm._t(
              "success",
              [
                _c(
                  "Alert",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasSuccess,
                        expression: "hasSuccess",
                      },
                    ],
                    staticClass:
                      "absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center px-5",
                    attrs: { bg: "bg-white", color: "text-emerald-900" },
                  },
                  [
                    _c("div", { staticClass: "flex items-center text-lg" }, [
                      _c(
                        "div",
                        { staticClass: "mr-2" },
                        [
                          _c("CheckCircle", {
                            staticClass: "block",
                            attrs: { text: "r", size: 28 },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.t("verifyPasswordCard.success")) +
                            "\n            "
                        ),
                      ]),
                    ]),
                  ]
                ),
              ],
              null,
              _vm.stateProps
            ),
          ],
          2
        ),
      ]),
    ]
  )
};
var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;
  const __vue_inject_styles__$5 = undefined;
  const __vue_scope_id__$5 = undefined;
  const __vue_module_identifier__$5 = undefined;
  const __vue_is_functional_template__$5 = false;
  const __vue_component__$5 = normalizeComponent(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    undefined,
    undefined,
    undefined
  );

let EmailChangeForm = class EmailChangeForm extends FormMixin$1 {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "stepState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultFormState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "companyId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "focusInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "buttonText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "emailPlaceholder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "termsUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "privacyUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "captchaInputName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "formEl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isValid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isSubmitting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "defaultState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: Object.assign({ password: '', email: '', agree: false }, this.defaultFormState)
        });
    }
    validateForm() {
        if (this.validate) {
            return this.validate(this.form, this.formErrors);
        }
        let emailValid, agreeValid;
        [emailValid, this.formErrors.email] = validateEmail(this.form.email);
        agreeValid = this.form.agree;
        if (!agreeValid) {
            this.formErrors.agree = this.t('emailChangeForm.agreeError');
        }
        return emailValid && agreeValid;
    }
    formatSubmitData(data) {
        return Object.assign(Object.assign({}, data), { password: this.stepState.password });
    }
    getFormData() {
        const data = Object.assign(Object.assign({}, this.form), { password: this.stepState.password });
        if (this.captchaInputName && this.formEl.value) {
            const captchaInput = this.formEl.value.querySelector(`input[name="${this.captchaInputName}"]`);
            if (captchaInput) {
                data[this.captchaInputName] = captchaInput.value;
            }
        }
        return data;
    }
    defaultSubmit(_a) {
        var { email: to_email, password } = _a, other = __rest(_a, ["email", "password"]);
        return __awaiter(this, void 0, void 0, function* () {
            return feSdk__default.api.user.requestChangeEmail(Object.assign(Object.assign({}, other), { password, to_email }));
        });
    }
    onSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isValid || this.isSubmitting) {
                if (this.formErrors.agree) {
                    this.handleFieldBlur({
                        target: { name: 'agree' },
                    });
                }
                return false;
            }
            const submitMethod = this.submit ? this.submit : this.defaultSubmit;
            this.$emit('verify:attempt', this.getFormData());
            return this.handleSubmit(() => submitMethod(this.getFormData()), (result) => {
                this.$emit('verify:success', result);
            }, (message) => this.$emit('verify:error', message));
        });
    }
    get tr() {
        return {
            buttonText: this.buttonText || this.t('emailChangeForm.buttonText'),
            emailPlaceholder: this.emailPlaceholder || this.t('emailChangeForm.emailPlaceholder'),
        };
    }
    get computedCompanyId() {
        return this.companyId || getCompanyId();
    }
    get computedTermsUrl() {
        return methods.getCompanyLink(this.computedCompanyId, 'terms', this.termsUrl);
    }
    get computedPrivacyUrl() {
        return methods.getCompanyLink(this.computedCompanyId, 'privacy', this.privacyUrl);
    }
    get stateProps() {
        return Object.assign(Object.assign({}, this.getStateProps()), { tr: this.tr });
    }
    defaultFormStateWatcher() {
        this.defaultState = Object.assign({ password: '', email: '', agree: false }, this.defaultFormState);
    }
    isValidWatcher() {
        if (this.isValid) {
            this.blurred.agree = false;
        }
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    mounted() {
        var _a;
        if (this.formEl.value && this.focusInput) {
            (_a = this.formEl.value.querySelector(`input[name="email"]`)) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }
};
__decorate([
    Prop({ type: Object, default: () => ({}) })
], EmailChangeForm.prototype, "stepState", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], EmailChangeForm.prototype, "defaultFormState", void 0);
__decorate([
    Prop(String)
], EmailChangeForm.prototype, "companyId", void 0);
__decorate([
    Prop(Boolean)
], EmailChangeForm.prototype, "dark", void 0);
__decorate([
    Prop(Boolean)
], EmailChangeForm.prototype, "focusInput", void 0);
__decorate([
    Prop(String)
], EmailChangeForm.prototype, "buttonText", void 0);
__decorate([
    Prop(String)
], EmailChangeForm.prototype, "emailPlaceholder", void 0);
__decorate([
    Prop(String)
], EmailChangeForm.prototype, "termsUrl", void 0);
__decorate([
    Prop(String)
], EmailChangeForm.prototype, "privacyUrl", void 0);
__decorate([
    Prop(String)
], EmailChangeForm.prototype, "captchaInputName", void 0);
__decorate([
    Ref('formEl')
], EmailChangeForm.prototype, "formEl", void 0);
__decorate([
    Watch('defaultFormState')
], EmailChangeForm.prototype, "defaultFormStateWatcher", null);
__decorate([
    Watch('isValid')
], EmailChangeForm.prototype, "isValidWatcher", null);
EmailChangeForm = __decorate([
    Component({
        components: {
            SubmitGoButton: __vue_component__$Y,
            InputError: __vue_component__$R,
            I18n,
        },
        directives: {
            checkbox: vCheckbox,
        },
    })
], EmailChangeForm);
var script$4 = EmailChangeForm;

const __vue_script__$4 = script$4;
var __vue_render__$4 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "sl-one-component" }, [
    _c(
      "div",
      { staticClass: "dark-wrapper", class: [_vm.dark ? "dark" : ""] },
      [
        _c("div", { staticClass: "email-signup-form" }, [
          _c(
            "div",
            { staticClass: "email-signup-form__header" },
            [_vm._t("header")],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "email-signup-form__form" },
            [
              _vm._t(
                "form",
                [
                  _c(
                    "form",
                    {
                      ref: "formEl",
                      attrs: { action: "", method: "POST", autocomplete: "on" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault();
                          return _vm.onSubmit($event)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "email-signup-form__field email-signup-form__field--email mb-4 w-[300px] mx-auto max-w-full",
                        },
                        [
                          _vm._t(
                            "emailInput",
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.email,
                                    expression: "form.email",
                                  },
                                ],
                                staticClass:
                                  "sl-form-control theme-dark w-full",
                                attrs: {
                                  type: "text",
                                  name: "email",
                                  autocomplete: "off",
                                  placeholder: _vm.tr.emailPlaceholder,
                                },
                                domProps: { value: _vm.form.email },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "email",
                                        $event.target.value
                                      );
                                    },
                                    _vm.handleFieldChange,
                                  ],
                                  blur: _vm.handleFieldBlur,
                                },
                              }),
                              _vm._v(" "),
                              _c("InputError", {
                                attrs: {
                                  dirty:
                                    _vm.dirty.email &&
                                    _vm.blurred.email &&
                                    !!_vm.formErrors.email,
                                  text: _vm.formErrors.email,
                                },
                              }),
                            ],
                            null,
                            _vm.stateProps
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "email-signup-form__field email-signup-form__field--agree mb-6 w-[495px] mx-auto max-w-full",
                        },
                        [
                          _vm._t(
                            "agreeInput",
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "cursor-pointer font-normal flex items-start text-dark-5 dark:text-light-1",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.agree,
                                        expression: "form.agree",
                                      },
                                      {
                                        name: "checkbox",
                                        rawName: "v-checkbox",
                                      },
                                    ],
                                    staticClass: "mr-2 sl-checkbox mt-1",
                                    attrs: { type: "checkbox", name: "agree" },
                                    domProps: {
                                      value: true,
                                      checked: Array.isArray(_vm.form.agree)
                                        ? _vm._i(_vm.form.agree, true) > -1
                                        : _vm.form.agree,
                                    },
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$a = _vm.form.agree,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false;
                                          if (Array.isArray($$a)) {
                                            var $$v = true,
                                              $$i = _vm._i($$a, $$v);
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.form,
                                                  "agree",
                                                  $$a.concat([$$v])
                                                );
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.form,
                                                  "agree",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                );
                                            }
                                          } else {
                                            _vm.$set(_vm.form, "agree", $$c);
                                          }
                                        },
                                        _vm.handleFieldChange,
                                      ],
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("I18n", {
                                    attrs: {
                                      message: _vm.t(
                                        "emailChangeForm.agreeText"
                                      ),
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "terms",
                                        fn: function (text) {
                                          return [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "font-medium underline",
                                                attrs: {
                                                  target: "_blank",
                                                  href: _vm.computedTermsUrl,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(text) +
                                                    "\n                      "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "privacy",
                                        fn: function (text) {
                                          return [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "font-medium underline",
                                                attrs: {
                                                  target: "_blank",
                                                  href: _vm.computedPrivacyUrl,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(text) +
                                                    "\n                      "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("InputError", {
                                attrs: {
                                  dirty:
                                    _vm.dirty.agree &&
                                    _vm.blurred.agree &&
                                    !!_vm.formErrors.agree,
                                  text: _vm.formErrors.agree,
                                },
                              }),
                            ],
                            null,
                            _vm.stateProps
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "email-signup-form__captcha" },
                        [_vm._t("captcha", null, null, _vm.stateProps)],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "email-signup-form__button w-[300px] mx-auto max-w-full",
                        },
                        [
                          _vm._t(
                            "button",
                            [
                              _c(
                                "SubmitGoButton",
                                {
                                  attrs: {
                                    disabled: _vm.isSubmitting || !_vm.isValid,
                                    loading: _vm.isSubmitting,
                                    type: "submit",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.tr.buttonText) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ],
                            null,
                            _vm.stateProps
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "email-signup-form__footer" },
            [_vm._t("footer", null, null, _vm.stateProps)],
            2
          ),
        ]),
      ]
    ),
  ])
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;
  const __vue_inject_styles__$4 = undefined;
  const __vue_scope_id__$4 = undefined;
  const __vue_module_identifier__$4 = undefined;
  const __vue_is_functional_template__$4 = false;
  const __vue_component__$4 = normalizeComponent(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    undefined,
    undefined,
    undefined
  );

let VerifyNewEmailCard = class VerifyNewEmailCard extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "stepState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "defaultState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "focusInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "verify", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "hasSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
    setErrorMessage(msg) {
        this.errorMessage = msg;
    }
    setHasSuccess(bool) {
        this.hasSuccess = bool;
    }
    handleXhrError(err, fallback) {
        if (err.data.code === 'email_verification_required') {
            this.$emit('validate', 'email');
            this.setErrorMessage(this.t('connectCard.connect.emailRequired'));
        }
        else if (err.data.code === 'token_required') {
            this.$emit('validate', 'tfa');
            this.setErrorMessage(this.t('connectCard.connect.tfaRequired'));
        }
        else if (err.data.code === 'age_gate_required') {
            this.$emit('validate', 'age');
            this.setErrorMessage(this.t('connectCard.connect.ageRequired'));
        }
        else {
            fallback(err);
        }
    }
    defaultVerify(_a) {
        var { email: to_email, password } = _a, other = __rest(_a, ["email", "password"]);
        return __awaiter(this, void 0, void 0, function* () {
            return feSdk__default.api.user.requestChangeEmail(Object.assign(Object.assign({}, other), { password, to_email }));
        });
    }
    onSubmit(form) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setErrorMessage('');
            const method = typeof this.verify === 'function' ? this.verify : this.defaultVerify;
            try {
                const response = yield method(form);
                this.onSuccess(form, response);
            }
            catch (err) {
                if (err instanceof ApiError) {
                    this.handleXhrError(err, (e) => {
                        throw e;
                    });
                }
            }
            return null;
        });
    }
    onSuccess(data, response) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setErrorMessage('');
            const payload = {
                data,
                response: response,
            };
            if (typeof this.success === 'function') {
                yield this.success(payload);
            }
            else {
                this.$emit('step:success', payload);
                this.setHasSuccess(true);
                setTimeout(() => this.setHasSuccess(false), 4000);
            }
        });
    }
    onError(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.error === 'function') {
                yield this.error(msg);
            }
            else {
                this.setErrorMessage(msg);
                this.$emit('step:error', msg);
            }
        });
    }
    get stateProps() {
        return {
            company: this.company,
            errorMessage: this.errorMessage,
            hasSuccess: this.hasSuccess,
            setErrorMessage: this.setErrorMessage,
            setHasSuccess: this.setHasSuccess,
            onSuccess: this.onSuccess,
            onError: this.onError,
            onSubmit: this.onSubmit,
        };
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    get tr() {
        return {
            title: this.title || this.t('verifyNewEmailCard.title'),
            lead: this.lead || this.t('verifyNewEmailCard.lead'),
        };
    }
};
__decorate([
    Prop(Object)
], VerifyNewEmailCard.prototype, "stepState", void 0);
__decorate([
    Prop(Object)
], VerifyNewEmailCard.prototype, "defaultState", void 0);
__decorate([
    Prop(Boolean)
], VerifyNewEmailCard.prototype, "dark", void 0);
__decorate([
    Prop(String)
], VerifyNewEmailCard.prototype, "title", void 0);
__decorate([
    Prop(String)
], VerifyNewEmailCard.prototype, "lead", void 0);
__decorate([
    Prop(Boolean)
], VerifyNewEmailCard.prototype, "focusInput", void 0);
__decorate([
    Prop(Function)
], VerifyNewEmailCard.prototype, "verify", void 0);
__decorate([
    Prop(Function)
], VerifyNewEmailCard.prototype, "success", void 0);
__decorate([
    Prop(Function)
], VerifyNewEmailCard.prototype, "error", void 0);
VerifyNewEmailCard = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            CheckCircle: __vue_component__$W,
            EmailChangeForm: __vue_component__$4,
            Card: __vue_component__$S,
        },
    })
], VerifyNewEmailCard);
var script$3 = VerifyNewEmailCard;

const __vue_script__$3 = script$3;
var __vue_render__$3 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    {
      staticClass: "verify-email-change-card",
      attrs: {
        "company-id": _vm.companyId,
        dark: _vm.dark,
        "error-message": _vm.errorMessage,
        title: _vm.tr.title,
        lead: _vm.tr.lead,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "logo",
            fn: function () {
              return [_vm._t("logo", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [_vm._t("title", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "lead",
            fn: function () {
              return [_vm._t("lead", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [_vm._t("error", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "verify-email-change-card__img" },
        [
          _vm._t(
            "img",
            [
              _c("div", { staticClass: "-mt-2 pb-6 text-center" }, [
                _c("img", {
                  staticClass: "inline-block mx-auto",
                  attrs: {
                    src: "https://cdn.streamlabs.com/static/imgs/library/slone/ultra-brand-icons-v2.png",
                    alt: "Ultra Plan Brands",
                  },
                }),
              ]),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "verify-email-change-card__form relative" },
        [
          _vm._t(
            "form",
            [
              _c("EmailChangeForm", {
                attrs: {
                  "company-id": _vm.companyId,
                  "default-form-state": _vm.defaultState,
                  "step-state": _vm.stepState,
                  "focus-input": _vm.focusInput,
                  submit: _vm.onSubmit,
                },
                on: {
                  "verify:error": _vm.onError,
                  reset: function ($event) {
                    return _vm.setErrorMessage("")
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "captcha",
                      fn: function (formState) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "verify-email-change-card__captcha",
                            },
                            [_vm._t("formCaptcha", null, null, formState)],
                            2
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            null,
            _vm.stateProps
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "verify-email-change-card__success" },
            [
              _vm._t(
                "success",
                [
                  _c(
                    "Alert",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasSuccess,
                          expression: "hasSuccess",
                        },
                      ],
                      staticClass:
                        "absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center p-5",
                      attrs: { bg: "bg-white", color: "text-emerald-900" },
                    },
                    [
                      _c("div", { staticClass: "flex items-center text-lg" }, [
                        _c(
                          "div",
                          { staticClass: "mr-2" },
                          [
                            _c("check-circle", {
                              staticClass: "block",
                              attrs: { size: 28 },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.t("verifyNewEmailCard.successText")) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;
  const __vue_inject_styles__$3 = undefined;
  const __vue_scope_id__$3 = undefined;
  const __vue_module_identifier__$3 = undefined;
  const __vue_is_functional_template__$3 = false;
  const __vue_component__$3 = normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    undefined,
    undefined,
    undefined
  );

let VerifyNewEmailOwnershipCard = class VerifyNewEmailOwnershipCard extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "stepState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "buttonText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showBackBtn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "requestOnInit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "submit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "hasSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "defaultSubmit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (_a) => {
                var { email: to_email } = _a, other = __rest(_a, ["email"]);
                return feSdk__default.api.user.confirmChangeEmail(Object.assign(Object.assign({}, other), { to_email }));
            }
        });
    }
    setErrorMessage(msg) {
        this.errorMessage = msg;
    }
    setHasSuccess(bool) {
        this.hasSuccess = bool;
    }
    onClickBack() {
        this.$emit('back');
    }
    getPayloadData(form) {
        return {
            password: this.stepState.password,
            email: this.stepState.email,
            code: form.code,
        };
    }
    requestNewCode(_a) {
        var { email: to_email, password } = _a, other = __rest(_a, ["email", "password"]);
        return __awaiter(this, void 0, void 0, function* () {
            return feSdk__default.api.user.requestChangeEmail(Object.assign(Object.assign({}, other), { password, to_email }));
        });
    }
    onRequestNewCode() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestNewCode(Object.assign(Object.assign({}, this.stepState), { agree: false }));
        });
    }
    onSubmit(form) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setErrorMessage('');
            const method = typeof this.submit === 'function' ? this.submit : this.defaultSubmit;
            try {
                const data = this.getPayloadData(form);
                const response = yield method(data);
                this.onSuccess(data, response);
            }
            catch (err) {
                if (err instanceof ApiError) {
                    this.handleXhrError(err, (e) => {
                        throw e;
                    });
                }
            }
        });
    }
    onSuccess(data, response) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = {
                data,
                response,
            };
            if (typeof this.success === 'function') {
                yield this.success(payload);
            }
            else {
                this.$emit('step:success', payload);
                this.setHasSuccess(true);
                setTimeout(() => this.setHasSuccess(false), 4000);
            }
        });
    }
    handleXhrError(err, fallback) {
        if (err.data.code === 'email_verification_required') {
            this.$emit('validate', 'email');
            this.setErrorMessage(this.t('connectCard.connect.emailRequired'));
        }
        else if (err.data.code === 'token_required') {
            this.$emit('validate', 'tfa');
            this.setErrorMessage(this.t('connectCard.connect.tfaRequired'));
        }
        else if (err.data.code === 'age_gate_required') {
            this.$emit('validate', 'age');
            this.setErrorMessage(this.t('connectCard.connect.ageRequired'));
        }
        else {
            fallback(err);
        }
    }
    onError(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.error === 'function') {
                yield this.error(msg);
            }
            else {
                this.setErrorMessage(msg);
                this.$emit('step:error', msg);
            }
        });
    }
    get tr() {
        return {
            title: this.title || this.t('verifyNewEmailOwnershipCard.title'),
            lead: this.lead || this.t('verifyNewEmailOwnershipCard.lead'),
            buttonText: this.buttonText || this.t('verifyNewEmailOwnershipCard.buttonText'),
            codePlaceholder: this.t('verifyNewEmailOwnershipCard.codePlaceholder'),
        };
    }
    get defaultContext() {
        return {
            email: this.stepState.email,
            tfa: false,
        };
    }
    get stateProps() {
        return {
            company: this.company,
            errorMessage: this.errorMessage,
            hasSuccess: this.hasSuccess,
            setErrorMessage: this.setErrorMessage,
            setHasSuccess: this.setHasSuccess,
            onSuccess: this.onSuccess,
            onError: this.onError,
            getPayloadData: this.getPayloadData,
            defaultContext: this.defaultContext,
            onSubmit: this.onSubmit,
        };
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
};
__decorate([
    Prop(Object)
], VerifyNewEmailOwnershipCard.prototype, "stepState", void 0);
__decorate([
    Prop(Boolean)
], VerifyNewEmailOwnershipCard.prototype, "dark", void 0);
__decorate([
    Prop(String)
], VerifyNewEmailOwnershipCard.prototype, "title", void 0);
__decorate([
    Prop(String)
], VerifyNewEmailOwnershipCard.prototype, "lead", void 0);
__decorate([
    Prop(String)
], VerifyNewEmailOwnershipCard.prototype, "buttonText", void 0);
__decorate([
    Prop(Boolean)
], VerifyNewEmailOwnershipCard.prototype, "showBackBtn", void 0);
__decorate([
    Prop(Boolean)
], VerifyNewEmailOwnershipCard.prototype, "requestOnInit", void 0);
__decorate([
    Prop(Function)
], VerifyNewEmailOwnershipCard.prototype, "submit", void 0);
__decorate([
    Prop(Function)
], VerifyNewEmailOwnershipCard.prototype, "success", void 0);
__decorate([
    Prop(Function)
], VerifyNewEmailOwnershipCard.prototype, "error", void 0);
VerifyNewEmailOwnershipCard = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            CheckCircle: __vue_component__$W,
            VerifyEmailForm: __vue_component__$e,
            Card: __vue_component__$S,
        },
    })
], VerifyNewEmailOwnershipCard);
var script$2 = VerifyNewEmailOwnershipCard;

const __vue_script__$2 = script$2;
var __vue_render__$2 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    {
      staticClass: "verify-email-ownership-card",
      attrs: {
        "company-id": _vm.companyId,
        dark: _vm.dark,
        "error-message": _vm.errorMessage,
        title: _vm.tr.title,
        lead: _vm.tr.lead,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "logo",
            fn: function () {
              return [_vm._t("logo", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [_vm._t("title", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "lead",
            fn: function () {
              return [_vm._t("lead", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [_vm._t("error", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [_vm._t("footer", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "verify-email-ownership-card__form relative" },
        [
          _vm._t(
            "form",
            [
              _c("VerifyEmailForm", {
                attrs: {
                  dark: _vm.dark,
                  "show-back-btn": false,
                  "default-context": _vm.defaultContext,
                  "email-disabled": true,
                  "request-on-init": _vm.requestOnInit,
                  request: _vm.onRequestNewCode,
                  submit: _vm.onSubmit,
                  "button-text": _vm.tr.buttonText,
                  "code-placeholder": _vm.tr.codePlaceholder,
                },
                on: {
                  "verify:error": _vm.onError,
                  reset: function ($event) {
                    return _vm.setErrorMessage("")
                  },
                },
              }),
            ],
            null,
            _vm.stateProps
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "verify-email-ownership-card__success" },
            [
              _vm._t(
                "success",
                [
                  _c(
                    "Alert",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasSuccess,
                          expression: "hasSuccess",
                        },
                      ],
                      staticClass:
                        "absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center p-5",
                      attrs: { bg: "bg-white", color: "text-emerald-900" },
                    },
                    [
                      _c("div", { staticClass: "flex items-center text-lg" }, [
                        _c(
                          "div",
                          { staticClass: "mr-2" },
                          [
                            _c("check-circle", {
                              staticClass: "block",
                              attrs: { size: 28 },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.t("verifyNewEmailOwnershipCard.successText")
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "verify-email-ownership-card__back" },
        [
          _vm._t(
            "back",
            [
              _vm.showBackBtn
                ? _c("div", { staticClass: "pt-6 text-center" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-sm sl-btn-link-dark-5 underline",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault();
                            return _vm.onClickBack($event)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.t("verifyNewEmailOwnershipCard.back")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;
  const __vue_inject_styles__$2 = undefined;
  const __vue_scope_id__$2 = undefined;
  const __vue_module_identifier__$2 = undefined;
  const __vue_is_functional_template__$2 = false;
  const __vue_component__$2 = normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

let VerifyTfaCard = class VerifyTfaCard extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "stepState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showBackBtn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "submit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "hasSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "defaultSubmit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => {
                return feSdk__default.api.auth.checkTfa(data.tfa_code, data.remember);
            }
        });
        Object.defineProperty(this, "getSubmitData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => {
                return Object.assign(Object.assign({}, data), this.stepState);
            }
        });
    }
    setErrorMessage(msg) {
        this.errorMessage = msg;
    }
    setHasSuccess(bool) {
        this.hasSuccess = bool;
    }
    onSubmit(form) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setErrorMessage('');
            const method = typeof this.submit === 'function' ? this.submit : this.defaultSubmit;
            try {
                const data = this.getSubmitData(form);
                const response = yield method(data);
                this.onSuccess({
                    data,
                    response,
                });
            }
            catch (err) {
                if (err instanceof ApiError) {
                    this.handleXhrError(err, (e) => {
                        throw e;
                    });
                }
            }
        });
    }
    onSuccess(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.success === 'function') {
                yield this.success(data);
                return;
            }
            this.$emit('step:success', data);
            this.setHasSuccess(true);
            setTimeout(() => this.setHasSuccess(false), 4000);
        });
    }
    handleXhrError(err, fallback) {
        if (err.data.code === 'email_verification_required') {
            this.$emit('validate', 'email');
            this.setErrorMessage(this.t('connectCard.connect.emailRequired'));
        }
        else if (err.data.code === 'token_required') {
            this.$emit('validate', 'tfa');
            this.setErrorMessage(this.t('connectCard.connect.tfaRequired'));
        }
        else if (err.data.code === 'age_gate_required') {
            this.$emit('validate', 'age');
            this.setErrorMessage(this.t('connectCard.connect.ageRequired'));
        }
        else {
            fallback(err);
        }
    }
    onError(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.error === 'function') {
                yield this.error(msg);
            }
            else {
                this.setErrorMessage(msg);
                this.$emit('step:error', msg);
            }
        });
    }
    onClickBack() {
        this.$emit('back');
    }
    get defaultFormState() {
        return {
            remember: true,
            email: this.stepState.email,
        };
    }
    get tr() {
        return {
            title: this.title || this.t('verifyTfaCard.title'),
            lead: this.lead || this.t('verifyTfaCard.lead'),
            codePlaceholder: this.t('verifyTfaCard.codePlaceholder'),
            buttonText: this.t('verifyTfaCard.buttonText'),
        };
    }
    get stateProps() {
        return {
            company: this.company,
            errorMessage: this.errorMessage,
            hasSuccess: this.hasSuccess,
            setErrorMessage: this.setErrorMessage,
            setHasSuccess: this.setHasSuccess,
            onSuccess: this.onSuccess,
            onSubmit: this.onSubmit,
            onError: this.onError,
            defaultFormState: this.defaultFormState,
            getSubmitData: this.getSubmitData,
        };
    }
    beforeMount() {
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
};
__decorate([
    Prop(Object)
], VerifyTfaCard.prototype, "stepState", void 0);
__decorate([
    Prop(Boolean)
], VerifyTfaCard.prototype, "dark", void 0);
__decorate([
    Prop(Boolean)
], VerifyTfaCard.prototype, "showBackBtn", void 0);
__decorate([
    Prop(String)
], VerifyTfaCard.prototype, "title", void 0);
__decorate([
    Prop(String)
], VerifyTfaCard.prototype, "lead", void 0);
__decorate([
    Prop(Function)
], VerifyTfaCard.prototype, "submit", void 0);
__decorate([
    Prop(Function)
], VerifyTfaCard.prototype, "success", void 0);
__decorate([
    Prop(Function)
], VerifyTfaCard.prototype, "error", void 0);
VerifyTfaCard = __decorate([
    Component({
        components: {
            Alert: __vue_component__$X,
            CheckCircle: __vue_component__$W,
            CheckTfaForm: __vue_component__$H,
            Card: __vue_component__$S,
        },
    })
], VerifyTfaCard);
var script$1 = VerifyTfaCard;

const __vue_script__$1 = script$1;
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Card",
    {
      staticClass: "check-tfa-card",
      attrs: {
        "company-id": _vm.companyId,
        dark: _vm.dark,
        "error-message": _vm.errorMessage,
        title: _vm.tr.title,
        lead: _vm.tr.lead,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "logo",
            fn: function () {
              return [_vm._t("logo", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [_vm._t("title", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "lead",
            fn: function () {
              return [_vm._t("lead", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "error",
            fn: function () {
              return [_vm._t("error", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [_vm._t("footer", null, null, _vm.stateProps)]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "verify-tfa-sl-card__form relative" },
        [
          _vm._t(
            "form",
            [
              _c("CheckTfaForm", {
                attrs: {
                  dark: _vm.dark,
                  "tfa-code-placeholder": _vm.tr.codePlaceholder,
                  "button-text": _vm.tr.buttonText,
                  "default-form-state": _vm.defaultFormState,
                  submit: _vm.onSubmit,
                },
                on: {
                  "step:error": _vm.onError,
                  reset: function ($event) {
                    return _vm.setErrorMessage("")
                  },
                },
              }),
            ],
            null,
            _vm.stateProps
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "verify-tfa-sl-card__success" },
            [
              _vm._t(
                "success",
                [
                  _c(
                    "Alert",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasSuccess,
                          expression: "hasSuccess",
                        },
                      ],
                      staticClass:
                        "absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center p-5",
                      attrs: { bg: "bg-white", color: "text-emerald-900" },
                    },
                    [
                      _c("div", { staticClass: "flex items-center text-lg" }, [
                        _c(
                          "div",
                          { staticClass: "mr-2" },
                          [
                            _c("CheckCircle", {
                              staticClass: "block",
                              attrs: { size: 28 },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.t("verifyTfaCard.successText")) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                null,
                _vm.stateProps
              ),
            ],
            2
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "verify-tfa-sl-card__back text-center" },
        [
          _vm._t(
            "back",
            [
              _vm.showBackBtn
                ? _c("div", { staticClass: "pt-6" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-sm sl-btn-link-dark-5 underline",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault();
                            return _vm.onClickBack($event)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.t("verifyTfaCard.back")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            null,
            _vm.stateProps
          ),
        ],
        2
      ),
    ]
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;
  const __vue_inject_styles__$1 = undefined;
  const __vue_scope_id__$1 = undefined;
  const __vue_module_identifier__$1 = undefined;
  const __vue_is_functional_template__$1 = false;
  const __vue_component__$1 = normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

let ChangeEmailWizard = class ChangeEmailWizard extends mixins(BaseMixin$1, CompanyMixin$1) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "dark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "authUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "step", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'password'
        });
        Object.defineProperty(this, "stepsOrdered", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ['password', 'email', 'confirm']
        });
        Object.defineProperty(this, "wizardState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                password: '',
                email: '',
                code: '',
            }
        });
        Object.defineProperty(this, "stepsComplete", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                password: false,
                email: false,
                confirm: false,
            }
        });
    }
    setStep(s) {
        this.step = s;
        this.clearGreaterOrEqualSteps(s);
    }
    clearGreaterOrEqualSteps(s) {
        if (s === 'tfa') {
            return false;
        }
        const index = this.stepsOrdered.indexOf(s);
        for (let i = index; i < this.stepsOrdered.length - 1; i++) {
            const step = this.stepsOrdered[i];
            if (step === 'password') {
                this.wizardState.password = '';
                this.stepsComplete.password = false;
            }
            else if (step === 'email') {
                this.wizardState.email = '';
                this.stepsComplete.email = false;
            }
            else if (step === 'confirm') {
                this.wizardState.code = '';
                this.stepsComplete.confirm = false;
            }
        }
    }
    getNextStep() {
        let nextStep = 'email';
        for (let i = 0; i < this.stepsOrdered.length; i++) {
            const step = this.stepsOrdered[i];
            if (!this.stepsComplete[step]) {
                nextStep = step;
                break;
            }
        }
        return nextStep;
    }
    onStep1Success(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.wizardState.password = data.data.password;
            this.stepsComplete.password = true;
            this.$emit('step', 'password', data);
            this.setStep('email');
        });
    }
    onStep2Success(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.wizardState.email = data.data.email;
            this.stepsComplete.email = true;
            this.$emit('step', 'email', data);
            this.setStep('confirm');
        });
    }
    onStep3Success(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.stepsComplete.confirm = true;
            if (this.authUser) {
                this.authUser.email = data.data.email;
            }
            this.$emit('step', 'confirm', data);
            this.onCompleteWizard();
        });
    }
    on2faStepSuccess(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.$emit('step', 'tfa', data);
            let nextStep = this.getNextStep();
            if (nextStep === 'password' && this.wizardState.password) {
                this.stepsComplete.password = true;
                nextStep = this.getNextStep();
            }
            this.setStep(nextStep);
        });
    }
    onValidationError(type) {
        if (type === 'tfa') {
            if (this.step === 'tfa') {
                throw new Error('Already on 2FA step. What are you doing?');
            }
            this.setStep('tfa');
        }
        else {
            throw new Error('Validation error. Unrecognized error type: ' + type);
        }
    }
    onUpdateUser(updatedUser, formData) {
        this.authUser = updatedUser;
        if (formData) {
            this.wizardState.password = formData.password;
        }
    }
    onCompleteWizard() {
        this.$emit('success', this.authUser);
        setTimeout(() => {
            this.setStep('password');
        }, 4000);
    }
    onBackToEmail() {
        this.setStep('email');
    }
    onBackFromTfa() {
        if (this.stepsComplete.confirm) {
            return this.setStep('confirm');
        }
        if (this.stepsComplete.email) {
            return this.setStep('email');
        }
        this.setStep('password');
    }
    loadAuthUser() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.authUser = yield feSdk__default.api.user.getAuthUser();
            }
            catch (err) {
            }
        });
    }
    get stateProps() {
        return {
            authUser: this.authUser,
            step: this.step,
            wizardState: this.wizardState,
            stepsComplete: this.stepsComplete,
            onCompleteWizard: this.onCompleteWizard,
            onBackToEmail: this.onBackToEmail,
            onBackFromTfa: this.onBackFromTfa,
            onUpdateUser: this.onUpdateUser,
            getNextStep: this.getNextStep,
            onStep1Success: this.onStep1Success,
            onStep2Success: this.onStep2Success,
            onStep3Success: this.onStep3Success,
            on2faStepSuccess: this.on2faStepSuccess,
            onValidationError: this.onValidationError,
        };
    }
    userWatcher() {
        if (this.user) {
            this.authUser = this.user;
        }
    }
    beforeMount() {
        if (this.user) {
            this.authUser = this.user;
        }
        const c = new ComponentStateGetter(this, 'stateProps');
        this.$emit('register:state', c);
    }
    mounted() {
        if (!this.user) {
            this.loadAuthUser();
        }
    }
};
__decorate([
    Prop(Boolean)
], ChangeEmailWizard.prototype, "dark", void 0);
__decorate([
    Prop(Object)
], ChangeEmailWizard.prototype, "user", void 0);
__decorate([
    Watch('user', { deep: true })
], ChangeEmailWizard.prototype, "userWatcher", null);
ChangeEmailWizard = __decorate([
    Component({
        components: {
            VerifyPasswordCard: __vue_component__$5,
            VerifyNewEmailCard: __vue_component__$3,
            VerifyNewEmailOwnershipCard: __vue_component__$2,
            VerifyTfaCard: __vue_component__$1,
        },
    })
], ChangeEmailWizard);
var script = ChangeEmailWizard;

const __vue_script__ = script;
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "change-email-wizard wizard" }, [
    _vm.step === "password"
      ? _c(
          "div",
          { staticClass: "wizard__step wizard__step--1" },
          [
            _vm._t(
              "step_1",
              [
                _c("VerifyPasswordCard", {
                  attrs: {
                    dark: _vm.dark,
                    "company-id": _vm.companyId,
                    user: _vm.authUser,
                  },
                  on: {
                    user: _vm.onUpdateUser,
                    "step:success": _vm.onStep1Success,
                    validate: _vm.onValidationError,
                  },
                }),
              ],
              null,
              _vm.stateProps
            ),
          ],
          2
        )
      : _vm.step === "email"
      ? _c(
          "div",
          { staticClass: "wizard__step wizard__step--2" },
          [
            _vm._t(
              "step_2",
              [
                _c("VerifyNewEmailCard", {
                  attrs: {
                    dark: _vm.dark,
                    "company-id": _vm.companyId,
                    "step-state": _vm.wizardState,
                    user: _vm.authUser,
                  },
                  on: {
                    user: _vm.onUpdateUser,
                    "step:success": _vm.onStep2Success,
                    validate: _vm.onValidationError,
                  },
                }),
              ],
              null,
              _vm.stateProps
            ),
          ],
          2
        )
      : _vm.step === "confirm"
      ? _c(
          "div",
          { staticClass: "wizard__step wizard__step--3" },
          [
            _vm._t(
              "step_3",
              [
                _c("VerifyNewEmailOwnershipCard", {
                  attrs: {
                    dark: _vm.dark,
                    "company-id": _vm.companyId,
                    "step-state": _vm.wizardState,
                  },
                  on: {
                    "step:success": _vm.onStep3Success,
                    validate: _vm.onValidationError,
                    back: _vm.onBackToEmail,
                  },
                }),
              ],
              null,
              _vm.stateProps
            ),
          ],
          2
        )
      : _vm.step === "tfa"
      ? _c(
          "div",
          { staticClass: "wizard__step wizard__step--tfa" },
          [
            _vm._t(
              "step_tfa",
              [
                _c("VerifyTfaCard", {
                  attrs: {
                    dark: _vm.dark,
                    "company-id": _vm.companyId,
                    "step-state": _vm.wizardState,
                  },
                  on: {
                    "step:success": _vm.on2faStepSuccess,
                    validate: _vm.onValidationError,
                    back: _vm.onBackFromTfa,
                  },
                }),
              ],
              null,
              _vm.stateProps
            ),
          ],
          2
        )
      : _vm._e(),
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
  const __vue_inject_styles__ = undefined;
  const __vue_scope_id__ = undefined;
  const __vue_module_identifier__ = undefined;
  const __vue_is_functional_template__ = false;
  const __vue_component__ = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export { LoginCardStateProxy as $, __vue_component__ as A, __vue_component__$5 as B, __vue_component__$3 as C, __vue_component__$2 as D, __vue_component__$1 as E, __vue_component__$4 as F, __vue_component__$P as G, __vue_component__$J as H, __vue_component__$H as I, __vue_component__$n as J, __vue_component__$h as K, __vue_component__$q as L, __vue_component__$p as M, __vue_component__$j as N, __vue_component__$e as O, AgeGateFormStateProxy as P, ChangePasswordCardProxy as Q, CheckTfaCardProxy as R, SUPPORTED_LANGUAGES as S, ConnectCardStateProxy as T, ConnectUpgradeCardProxy as U, ConnectConfirmCardProxy as V, ConnectUpgradeConfirmCardProxy as W, ConnectOneClickStateProxy as X, CreateTfaCardStateProxy as Y, ForgotPasswordCardProxy as Z, __vue_component__$$ as _, __vue_component__$_ as a, LoginSourcesCardProxy as a0, RemoveTfaCardProxy as a1, SignupCardStateProxy as a2, SignupSourcesCardProxy as a3, VerifyEmailCardProxy as a4, ServicesDropdownProxy as a5, UltraCheckoutCardStateProxy as a6, UltraCheckoutBannerStateProxy as a7, ChangePasswordFormProxy as a8, CheckTfaFormStateProxy as a9, EmailLoginScopedStateProxy as aa, EmailSignupScopedStateProxy as ab, ForgotPasswordFormStateProxy as ac, ResetPasswordFormProxy as ad, RemoveTfaFormStateProxy as ae, VerifyEmailFormProxy as af, ChangeEmailWizardProxy as ag, VerifyPasswordCardStateProxy as ah, VerifyNewEmailCardStateProxy as ai, VerifyNewEmailOwnershipCardProxy as aj, VerifyTfaCardProxy as ak, EmailChangeScopedStateProxy as al, componentConnect as am, componentOpenView as an, browser$1 as b, componentDefaults as c, __vue_component__$Z as d, __vue_component__$Y as e, __vue_component__$N as f, global$1 as g, __vue_component__$I as h, __vue_component__$G as i, __vue_component__$D as j, __vue_component__$C as k, __vue_component__$B as l, __vue_component__$A as m, __vue_component__$x as n, __vue_component__$r as o, __vue_component__$o as p, __vue_component__$l as q, __vue_component__$k as r, __vue_component__$i as s, __vue_component__$g as t, __vue_component__$f as u, vueI18nService as v, __vue_component__$d as w, __vue_component__$9 as x, __vue_component__$7 as y, __vue_component__$6 as z };
//# sourceMappingURL=library.es2.js.map
